// Drawing Tools — i18n dictionary for Indian languages.
// Easy to extend: add { code, label, flag } to LANGUAGES and a new block to `dict`.
// Missing translations gracefully fall back to English via `t()`.
export const LANGUAGES = [
  // Original 10
  { code: "en", label: "English",   flag: "🇬🇧" },
  { code: "hi", label: "हिन्दी",     flag: "🇮🇳" },
  { code: "bn", label: "বাংলা",     flag: "🇮🇳" },
  { code: "ta", label: "தமிழ்",     flag: "🇮🇳" },
  { code: "te", label: "తెలుగు",    flag: "🇮🇳" },
  { code: "mr", label: "मराठी",     flag: "🇮🇳" },
  { code: "gu", label: "ગુજરાતી",   flag: "🇮🇳" },
  { code: "kn", label: "ಕನ್ನಡ",     flag: "🇮🇳" },
  { code: "ml", label: "മലയാളം",   flag: "🇮🇳" },
  { code: "pa", label: "ਪੰਜਾਬੀ",    flag: "🇮🇳" },
  // 13 added — AI generation goes through fully in each script; UI text uses the
  // existing `t()` fallback to English where a native string isn't yet provided.
  { code: "ur", label: "اردو",       flag: "🇮🇳" },
  { code: "or", label: "ଓଡ଼ିଆ",      flag: "🇮🇳" },
  { code: "as", label: "অসমীয়া",     flag: "🇮🇳" },
  { code: "kok", label: "कोंकणी",    flag: "🇮🇳" },
  { code: "sa", label: "संस्कृतम्",   flag: "🇮🇳" },
  { code: "mai", label: "मैथिली",    flag: "🇮🇳" },
  { code: "ne", label: "नेपाली",     flag: "🇳🇵" },
  { code: "sd", label: "سنڌي",       flag: "🇮🇳" },
  { code: "ks", label: "कॉशुर",      flag: "🇮🇳" },
  { code: "brx", label: "बड़ो",       flag: "🇮🇳" },
  { code: "doi", label: "डोगरी",     flag: "🇮🇳" },
  { code: "mni", label: "মণিপুরী",   flag: "🇮🇳" },
  { code: "sat", label: "ᱥᱟᱱᱛᱟᱲᱤ",   flag: "🇮🇳" },
];

const dict = {
  en: {
    app_name: "Drawing Tools",
    tagline: "Inspires you to draw!",
    enter_phone: "Enter your phone number",
    phone_placeholder: "10-digit mobile",
    send_otp: "Send OTP",
    enter_otp: "Enter the 6-digit OTP",
    verify: "Verify & Login",
    resend_otp: "Resend OTP",
    change_number: "Change number",
    free_label: "FREE",
    paid_label: "₹",
    blueprint: "Blueprint",
    blueprint_desc: "Create outline first",
    pencil: "Pencil Sketch",
    pencil_desc: "Make a beautiful pencil sketch",
    story: "My Story",
    story_desc: "Create a comic story",
    wallet: "Wallet",
    recharge_wallet: "Recharge wallet",
    recharge_methods: "UPI · Cards · Netbanking · Wallets",
    pay_prefix: "Pay",
    processing: "Processing…",
    recharge_unavailable: "Recharge temporarily unavailable",
    free_credit_title: "{amount} free credit",
    free_credit_desc: "We gave you {amount} free wallet credit — once per phone number.",
    recent_recharges: "Recent recharges",
    gallery: "Gallery",
    take_photo: "Take Photo",
    retake: "Retake",
    use_photo: "Use this photo",
    generating: "Creating magic...",
    almost_there: "Almost there!",
    download: "Download",
    share: "Share",
    share_whatsapp: "WhatsApp",
    share_email: "Email",
    copy_link: "Copy Link",
    back: "Back",
    logout: "Logout",
    your_creations: "Your Creations",
    no_creations: "No creations yet. Start drawing!",
    insufficient_balance: "Not enough balance",
    rate_limited: "Take a break! Try again later.",
    welcome: "Welcome!",
    home: "Home",
    language: "Language",
    balance: "Balance",
    create: "Create",
    platform_name: "Saral Eye",
    platform_tagline: "Making the Ocean of Learning Simple",
    module_drawing_title: "Drawing Tools",
    module_drawing_desc: "Draw, Color & Imagine",
    module_language_title: "Language Tools",
    module_language_desc: "Learn Every Subject",
    module_math_title: "Math Tools",
    module_math_desc: "Learn, Solve & Improve",
    mind_master_title: "Mind Master",
    mind_master_desc: "Meditate, Breathe & Center",
    mind_master_audio_start: "Play Sound",
    mind_master_audio_stop: "Pause Sound",
    mind_master_back: "Back",
    life_intro_heading: "Give a few seconds to find yourself",
    privacy_policy: "Privacy Policy",
    install_app: "Install App",
    app_installs: "App Installs",
    coming_soon: "Coming soon",
    open_now: "Open",
    make_another: "Make another",
    upload_from_gallery: "Upload from gallery",
    math_tagline: "Snap a math problem, get a hint or a full solution.",
    math_hint: "Hint",
    math_hint_desc: "A friendly nudge in your language with audio",
    math_solution: "Solution",
    math_solution_desc: "Full step-by-step notebook-style answer",

    share_confirm_prompt: "Did you share the message on WhatsApp?",
    share_confirm_yes: "Yes, I shared it",
    share_confirm_no: "Not yet",

    help_a_friend: "Help a Friend",
    help_a_friend_intro: "Sharing is caring — invite a friend to learn with you.",
    help_a_friend_msg_greeting: "Let's learn together!",
    help_a_friend_msg_body: "I'm using Saral Eye for study. You can join too:",
    help_a_friend_msg_tagline: "Learn • Grow • Help Others",
    share_on_whatsapp: "Share on WhatsApp",
    share_helper_line: "Every share = one student helped",
    join_sahaj_path: "Join Sahaj Path",
    sahaj_path_hint: "A friendly study support group on WhatsApp",
    level_blaze: "Level Blaze",
    helped_label: "Helped",
    level_student: "Student",
    level_helper: "Helper",
    level_supporter: "Supporter",
    level_mentor: "Mentor",
    level_champion: "Champion",
    progress_line: "You helped {n} students • {remain} more to become {next}",
    progress_line_top: "You helped {n} students. Champion status — thank you!",
    helped_toast_progress: "You helped {n} students • {remain} more to become {next}",
    helped_toast_simple: "You helped {n} students. Thank you!",

    share_balance_title: "Share Balance",
    share_balance_desc: "Send some wallet money to a friend",
    share_recipient_phone: "Recipient mobile number",
    share_phone_placeholder: "e.g. 9876543210",
    share_amount: "Amount to share",
    share_send_btn: "Send",
    share_success: "Sent {amount} to {phone}",
    share_recipient_invalid: "Please enter a valid recipient mobile number",
    share_invalid_amount: "Please enter a valid amount greater than zero",
    share_insufficient_balance: "You don't have enough balance",

    hourglass_view: "Hourglass View",
    hourglass_exit: "Exit",

    colour_guide: "Colour Guide",
    colour_guide_desc: "Learn where the light, shadow & colour order go on your sketch",
    cg_coloring_order: "Coloring Order",
    cg_step_1_title: "Background",
    cg_step_1_desc: "Light colors, Low contrast",
    cg_step_2_title: "Distant Objects",
    cg_step_2_desc: "Cool colors, Soft contrast",
    cg_step_3_title: "Ground",
    cg_step_3_desc: "Natural base colors",
    cg_step_4_title: "Main Subject",
    cg_step_4_desc: "Rich colors, High contrast",
    cg_step_5_title: "Other Large Objects",
    cg_step_5_desc: "Balanced mid-tones",
    cg_step_6_title: "Details & Highlights",
    cg_step_6_desc: "Fine details, Bright highlights",
    cg_note_heading: "Note",
    cg_note_1: "The main subject is outlined in red.",
    cg_note_2: "Use darker shades in the blue-marked shadow areas.",

    math_mental: "Mental Math",
    math_mental_desc: "Listen to a shopping problem and pick the right answer",
    mm_start_practice: "Start Practice",
    mm_replay_audio: "Replay Audio",
    mm_choose_answer: "Choose the correct answer",
    mm_correct: "Correct! Well done.",
    mm_wrong: "Not quite. Try again!",
    mm_practice_another: "Practice Another",
    mm_back: "Back",
    mm_home: "Home",
    mm_generating: "Preparing your question...",
    mm_focus_now: "Focus and listen carefully",
    mm_intro: "Real-life shopping puzzles for mental math practice",
    use_cropped_area: "Use this area",
    another_problem: "Another problem",
    hint_label: "Here's a hint",
    audio_hint_label: "Tap play to hear the hint",
    audio_unavailable: "Audio not available — please try again later.",
    generating_hint: "Generating Hint...",
    generating_solution: "Generating Solution...",
    generating_summary: "Generating Summary...",
    generating_mcq: "Generating Quiz...",
    language_tagline: "Snap a passage and get a quick summary or quiz.",
    lang_summary: "Summary",
    lang_summary_desc: "An easy summary in your language, with audio",
    lang_mcq: "Quiz",
    lang_mcq_desc: "Fun multiple-choice questions with instant feedback",
    pick_age_group: "Pick your age group",
    age_6_10: "6–10 years",
    age_10_14: "10–14 years",
    age_14_18: "14–18 years",
    age_18_plus: "18+ years",
    summary_label: "Here's a quick summary",
    audio_summary_label: "Tap play to hear the summary",
    no_content_title: "We couldn't find any passage.",
    no_content_desc: "Aim the camera at text — a story, lesson or passage.",
    question: "Question",
    multi_select_hint: "More than one answer can be correct.",
    mcq_submit: "Check answer",
    mcq_next: "Next question",
    mcq_see_score: "See my score",
    mcq_correct: "Correct! 🎉",
    mcq_wrong: "Not quite. Try the next one!",
    mcq_correct_feedback: "Nice — you got the full set right.",
    mcq_wrong_feedback: "The highlighted option(s) are the correct answer.",
    mcq_done_title: "Great effort!",
    mcq_all_correct: "Perfect score!",
    your_score: "Your score",
    no_math_found_title: "We couldn't find a math problem.",
    no_math_found_desc: "Make sure the problem is in focus inside the crop area.",
    lang_check_answer: "Answer Check",
    lang_check_answer_desc: "Snap a written question paper — get marks, ticks & proper answers",
    lang_learn_nature: "Learn from Nature",
    lang_learn_nature_desc: "Snap a nature scene — pick up short lessons in Science, Life & more",
    generating_learn_nature: "Finding lessons from nature...",
    nature_lessons_label: "Lessons from nature",
    generating_check_answer: "Checking your answers...",
    no_paper_found_title: "We couldn't find a question paper.",
    no_paper_found_desc: "Aim the camera at a written question paper with student answers.",
    lang_speech_mentor: "Speech Mentor",
    lang_speech_mentor_desc: "Friendly AI mentor for speaking better.",
    speech_mentor_tap_to_record: "Tap the mic and start speaking",
    speech_mentor_tap_to_stop: "Tap to stop",
    speech_mentor_recording: "Listening...",
    speech_mentor_analyzing: "Analyzing your speech...",
    speech_mentor_your_speech: "Your speech",
    speech_mentor_mic_denied: "Microphone permission denied",
    speech_mentor_mic_unsupported: "Microphone not supported on this device",
    learn_another: "Learn Another",
    try_another: "Try Another",
    check_another: "Check Another",
    practice_again: "Practice Again",
    speech_mentor_play_welcome: "Tap to hear welcome",
    daily_reflection: "Daily Reflection",
    daily_reflection_desc: "A 1-minute daily check-in for your inner growth",
    dr_start: "Start",
    dr_loading: "Preparing your reflection...",
    dr_question_of: "Question {n} of {total}",
    dr_your_answer: "Your answer",
    dr_best_answer: "Best answer",
    dr_lesson: "Lesson",
    dr_growth_score: "Daily Growth Score",
    dr_encouragement_high: "Wonderful! You're on the path of daily growth.",
    dr_encouragement_mid: "Great effort! A little reflection every day builds a strong mind.",
    dr_encouragement_low: "Every reflection is a step forward. Keep growing!",
    dr_next: "Next",
    dr_finish: "See my score",
    dr_try_again: "Reflect again",
    dr_listen: "Listen",
    coloring: "Coloring",
    coloring_desc: "Turn any drawing into art — Oil Pastel, Watercolor & more",
    coloring_choose_style: "Choose a coloring style",
    coloring_style_oil_pastel: "Oil Pastel",
    coloring_style_watercolor: "Watercolor",
    coloring_style_graphite_shade: "Graphite Shade",
    coloring_style_color_pencil_shade: "Color Pencil Shade",
    coloring_style_oil_paint: "Oil Paint",
    time_master: "Time Master",
    time_master_desc: "How fast should you finish? Race against the ideal time.",
    time_master_class: "Class",
    time_master_subject: "Subject",
    time_master_marks: "Marks",
    time_master_ideal: "Ideal Time",
    time_master_elapsed: "Your Time",
    time_master_start: "Start Timer",
    time_master_stop: "Stop Timer",
    time_master_pick_class: "Pick class",
    time_master_pick_subject: "Pick subject",
    time_master_pick_marks: "Pick marks",
    time_master_subj_numerical: "Numerical",
    time_master_subj_science: "Science",
    time_master_subj_technical: "Technical",
    time_master_subj_social: "Social",
    time_master_subj_language: "Language",
    time_master_subj_other: "Other",
  },
  hi: {
    app_name: "ड्रॉइंग टूल्स",
    tagline: "आपको चित्र बनाने के लिए प्रेरित करे!",
    enter_phone: "अपना मोबाइल नंबर डालें",
    phone_placeholder: "10 अंकों का मोबाइल",
    send_otp: "OTP भेजें",
    enter_otp: "6 अंकों का OTP डालें",
    verify: "वेरिफाई करें",
    resend_otp: "OTP दोबारा भेजें",
    change_number: "नंबर बदलें",
    free_label: "मुफ्त",
    paid_label: "₹",
    blueprint: "ब्लूप्रिंट",
    blueprint_desc: "पहले रूपरेखा बनाएं",
    pencil: "पेंसिल स्केच",
    pencil_desc: "सुंदर पेंसिल स्केच बनाएं",
    story: "मेरी कहानी",
    story_desc: "एक कॉमिक कहानी बनाएं",
    wallet: "वॉलेट",
    recharge_wallet: "वॉलेट रीचार्ज करें",
    recharge_methods: "UPI · कार्ड · नेटबैंकिंग · वॉलेट",
    pay_prefix: "भुगतान करें",
    processing: "प्रोसेस हो रहा है…",
    recharge_unavailable: "रीचार्ज अभी उपलब्ध नहीं है",
    free_credit_title: "{amount} फ्री क्रेडिट",
    free_credit_desc: "हमने आपको {amount} फ्री वॉलेट क्रेडिट दिया है — एक फ़ोन नंबर पर एक बार।",
    recent_recharges: "हाल के रीचार्ज",
    gallery: "गैलरी",
    take_photo: "फोटो लें",
    retake: "फिर से लें",
    use_photo: "यह फोटो इस्तेमाल करें",
    generating: "जादू हो रहा है...",
    almost_there: "बस थोड़ा और!",
    download: "डाउनलोड",
    share: "शेयर",
    share_whatsapp: "व्हाट्सएप",
    share_email: "ईमेल",
    copy_link: "लिंक कॉपी करें",
    back: "वापस",
    logout: "लॉगआउट",
    your_creations: "आपकी रचनाएं",
    no_creations: "अभी कोई रचना नहीं। चलिए शुरू करें!",
    insufficient_balance: "बैलेंस कम है",
    rate_limited: "थोड़ा आराम करें! बाद में कोशिश करें।",
    welcome: "स्वागत है!",
    home: "होम",
    language: "भाषा",
    balance: "बैलेंस",
    create: "बनाएं",
    platform_name: "सरल आई",
    platform_tagline: "सीखने के महासागर को सरल बनाते हुए",
    module_drawing_title: "ड्रॉइंग टूल्स",
    module_drawing_desc: "बनाओ, रंगो और कल्पना करो",
    module_language_title: "भाषा टूल्स",
    module_language_desc: "हर विषय सीखो",
    module_math_title: "गणित टूल्स",
    module_math_desc: "सीखो, हल करो और आगे बढ़ो",
    mind_master_title: "माइंड मास्टर",
    mind_master_desc: "ध्यान करो, साँस लो और शांत हो",
    mind_master_audio_start: "ध्वनि चलाओ",
    mind_master_audio_stop: "ध्वनि रोको",
    mind_master_back: "वापस",
    life_intro_heading: "कुछ पल खुद को पहचानने में बिताओ",
    privacy_policy: "गोपनीयता नीति",
    install_app: "ऐप इंस्टॉल करें",
    app_installs: "ऐप इंस्टॉल",
    coming_soon: "जल्द आ रहा है",
    open_now: "खोलें",
    make_another: "एक और बनाएं",
    upload_from_gallery: "गैलरी से अपलोड करें",
    math_tagline: "गणित का सवाल खींचो — हिंट या पूरा हल पाओ।",
    math_hint: "हिंट",
    math_hint_desc: "तुम्हारी भाषा में आसान संकेत, ऑडियो के साथ",
    math_solution: "हल",
    math_solution_desc: "नोटबुक जैसा पूरा कदम-दर-कदम हल",

    share_confirm_prompt: "क्या आपने संदेश व्हाट्सएप पर भेज दिया?",
    share_confirm_yes: "हाँ, मैंने भेजा",
    share_confirm_no: "अभी नहीं",

    help_a_friend: "मित्र की मदद करो",
    help_a_friend_intro: "साझा करना ही देखभाल है — दोस्त को साथ पढ़ने के लिए बुलाओ।",
    help_a_friend_msg_greeting: "आओ साथ मिलकर सीखें!",
    help_a_friend_msg_body: "मैं पढ़ाई के लिए सरल आई का उपयोग कर रहा हूँ। आप भी जुड़ें:",
    help_a_friend_msg_tagline: "सीखो • बढ़ो • मदद करो",
    share_on_whatsapp: "व्हाट्सएप पर शेयर करें",
    share_helper_line: "हर शेयर = एक विद्यार्थी की मदद",
    join_sahaj_path: "सहज पाठ जॉइन करें",
    sahaj_path_hint: "व्हाट्सएप पर मित्रवत अध्ययन सहायता समूह",
    level_blaze: "लेवल ब्लेज़",
    helped_label: "मदद की",
    level_student: "छात्र",
    level_helper: "सहायक",
    level_supporter: "समर्थक",
    level_mentor: "गुरु",
    level_champion: "चैंपियन",
    progress_line: "आपने {n} विद्यार्थियों की मदद की • {next} बनने में {remain} और",
    progress_line_top: "आपने {n} विद्यार्थियों की मदद की। चैंपियन — धन्यवाद!",
    helped_toast_progress: "अब {n} की मदद हुई • {next} बनने में {remain} और",
    helped_toast_simple: "आपने {n} विद्यार्थियों की मदद की। धन्यवाद!",

    share_balance_title: "बैलेंस शेयर करें",
    share_balance_desc: "दोस्त को थोड़ा वॉलेट पैसा भेजें",
    share_recipient_phone: "प्राप्तकर्ता का मोबाइल नंबर",
    share_phone_placeholder: "जैसे 9876543210",
    share_amount: "भेजने की राशि",
    share_send_btn: "भेजें",
    share_success: "{phone} को {amount} भेजा गया",
    share_recipient_invalid: "मान्य मोबाइल नंबर डालें",
    share_invalid_amount: "शून्य से बड़ी सही राशि डालें",
    share_insufficient_balance: "आपके पास पर्याप्त बैलेंस नहीं है",

    hourglass_view: "बालू घड़ी दृश्य",
    hourglass_exit: "बाहर जाएँ",

    colour_guide: "रंग गाइड",
    colour_guide_desc: "अपनी स्केच पर रोशनी, छाया और रंग का क्रम सीखें",
    cg_coloring_order: "रंग भरने का क्रम",
    cg_step_1_title: "पृष्ठभूमि",
    cg_step_1_desc: "हल्के रंग, कम कंट्रास्ट",
    cg_step_2_title: "दूर की वस्तुएँ",
    cg_step_2_desc: "ठंडे रंग, हल्का कंट्रास्ट",
    cg_step_3_title: "ज़मीन",
    cg_step_3_desc: "प्राकृतिक बेस रंग",
    cg_step_4_title: "मुख्य विषय",
    cg_step_4_desc: "गहरे रंग, ज़्यादा कंट्रास्ट",
    cg_step_5_title: "अन्य बड़ी वस्तुएँ",
    cg_step_5_desc: "संतुलित मध्यम-टोन",
    cg_step_6_title: "विवरण और हाइलाइट",
    cg_step_6_desc: "बारीक विवरण, चमकदार हाइलाइट",
    cg_note_heading: "टिप्पणी",
    cg_note_1: "मुख्य विषय की रूपरेखा लाल रंग में है।",
    cg_note_2: "नीले छाया वाले क्षेत्रों में गहरे रंग लगाएँ।",

    math_mental: "मेंटल मैथ",
    math_mental_desc: "खरीदारी की कहानी सुनो और सही जवाब चुनो",
    mm_start_practice: "अभ्यास शुरू करो",
    mm_replay_audio: "फिर से सुनो",
    mm_choose_answer: "सही उत्तर चुनो",
    mm_correct: "सही जवाब! शाबाश।",
    mm_wrong: "गलत! फिर से सोचो।",
    mm_practice_another: "एक और सवाल",
    mm_back: "वापस",
    mm_home: "होम",
    mm_generating: "तुम्हारा सवाल तैयार हो रहा है...",
    mm_focus_now: "ध्यान से सुनो",
    mm_intro: "मेंटल मैथ के लिए असली-जीवन की खरीदारी वाली पहेलियाँ",
    use_cropped_area: "यह हिस्सा इस्तेमाल करो",
    another_problem: "नया सवाल",
    hint_label: "यह रहा एक हिंट",
    audio_hint_label: "हिंट सुनने के लिए प्ले दबाओ",
    audio_unavailable: "ऑडियो उपलब्ध नहीं — बाद में कोशिश करें।",
    no_math_found_title: "गणित का सवाल नहीं मिला।",
    no_math_found_desc: "क्रॉप एरिया में सवाल साफ़ दिखाओ।",
    generating_hint: "हिंट बना रहे हैं...",
    generating_solution: "हल बना रहे हैं...",
    generating_summary: "सारांश बना रहे हैं...",
    generating_mcq: "क्विज़ बना रहे हैं...",
    language_tagline: "पाठ को कैमरे में लो — सारांश या क्विज़ पाओ।",
    lang_summary: "सारांश",
    lang_summary_desc: "तुम्हारी भाषा में आसान सारांश, ऑडियो के साथ",
    lang_mcq: "क्विज़",
    lang_mcq_desc: "मज़ेदार बहुविकल्पीय सवाल, तुरंत फीडबैक",
    pick_age_group: "अपना आयु वर्ग चुनो",
    age_6_10: "6–10 साल",
    age_10_14: "10–14 साल",
    age_14_18: "14–18 साल",
    age_18_plus: "18+ साल",
    summary_label: "यह रहा एक छोटा सारांश",
    audio_summary_label: "सुनने के लिए प्ले दबाओ",
    no_content_title: "कोई पाठ नहीं मिला।",
    no_content_desc: "कैमरा किसी कहानी, पाठ या लेख पर रखो।",
    question: "सवाल",
    multi_select_hint: "एक से ज़्यादा जवाब सही हो सकते हैं।",
    mcq_submit: "जवाब जाँचो",
    mcq_next: "अगला सवाल",
    mcq_see_score: "मेरा स्कोर देखो",
    mcq_correct: "सही! 🎉",
    mcq_wrong: "गलत हो गया। अगला कोशिश करो!",
    mcq_correct_feedback: "बहुत बढ़िया — पूरे सही जवाब दिए।",
    mcq_wrong_feedback: "हरे रंग वाले विकल्प सही जवाब हैं।",
    mcq_done_title: "शाबाश!",
    mcq_all_correct: "सब सही!",
    your_score: "तुम्हारा स्कोर",
    lang_check_answer: "उत्तर जांच",
    lang_check_answer_desc: "लिखी हुई आन्सर शीट की तस्वीर लें — नंबर, सही/गलत और सही उत्तर पाएं",
    lang_learn_nature: "प्रकृति से सीखो",
    lang_learn_nature_desc: "प्रकृति की तस्वीर लो — विज्ञान, जीवन और कई विषयों के छोटे सबक पाओ",
    generating_learn_nature: "प्रकृति से सबक ढूंढ रहे हैं...",
    nature_lessons_label: "प्रकृति से सबक",
    generating_check_answer: "उत्तर जांच रहे हैं...",
    no_paper_found_title: "उत्तर पत्रिका नहीं मिली।",
    no_paper_found_desc: "कैमरे को छात्र के उत्तरों वाली प्रश्न पत्रिका पर रखें।",
    lang_speech_mentor: "स्पीच मेंटर",
    lang_speech_mentor_desc: "अच्छा बोलने में मदद करने वाला दोस्ताना AI गुरु।",
    speech_mentor_tap_to_record: "माइक दबाओ और बोलना शुरू करो",
    speech_mentor_tap_to_stop: "रुकने के लिए दबाओ",
    speech_mentor_recording: "सुन रहे हैं...",
    speech_mentor_analyzing: "तुम्हारी बात समझ रहे हैं...",
    speech_mentor_your_speech: "तुम्हारी बात",
    speech_mentor_mic_denied: "माइक की अनुमति नहीं मिली",
    speech_mentor_mic_unsupported: "इस डिवाइस पर माइक उपलब्ध नहीं है",
    learn_another: "और सीखें",
    try_another: "फिर से करें",
    check_another: "और जांचें",
    practice_again: "फिर अभ्यास करें",
    speech_mentor_play_welcome: "स्वागत सुनने के लिए दबाएँ",
    daily_reflection: "रोज़ का चिंतन",
    daily_reflection_desc: "अपनी अंदरूनी बढ़त के लिए 1 मिनट की रोज़ की जाँच",
    dr_start: "शुरू करें",
    dr_loading: "आपका चिंतन तैयार हो रहा है...",
    dr_question_of: "प्रश्न {n} / {total}",
    dr_your_answer: "आपका उत्तर",
    dr_best_answer: "सबसे अच्छा उत्तर",
    dr_lesson: "सीख",
    dr_growth_score: "आज का ग्रोथ स्कोर",
    dr_encouragement_high: "बहुत बढ़िया! आप हर दिन आगे बढ़ रहे हैं।",
    dr_encouragement_mid: "अच्छी कोशिश! रोज़ थोड़ा चिंतन मन को मज़बूत बनाता है।",
    dr_encouragement_low: "हर चिंतन एक कदम आगे है। बढ़ते रहो!",
    dr_next: "आगे",
    dr_finish: "मेरा स्कोर देखें",
    dr_try_again: "फिर से चिंतन करें",
    dr_listen: "सुनें",
    coloring: "रंग भरना",
    coloring_desc: "अपनी ड्रॉइंग को कला बनाओ — तेल पेस्टल, वॉटर कलर और भी",
    coloring_choose_style: "रंग शैली चुनो",
    coloring_style_oil_pastel: "तेल पेस्टल",
    coloring_style_watercolor: "जल रंग",
    coloring_style_graphite_shade: "पेंसिल शेड",
    coloring_style_color_pencil_shade: "रंगीन पेंसिल",
    coloring_style_oil_paint: "तेल रंग",
    time_master: "समय स्वामी",
    time_master_desc: "कितनी जल्दी खत्म करना है? आदर्श समय से मुकाबला करो।",
    time_master_class: "कक्षा",
    time_master_subject: "विषय",
    time_master_marks: "अंक",
    time_master_ideal: "आदर्श समय",
    time_master_elapsed: "तुम्हारा समय",
    time_master_start: "टाइमर शुरू",
    time_master_stop: "टाइमर बंद",
    time_master_pick_class: "कक्षा चुनो",
    time_master_pick_subject: "विषय चुनो",
    time_master_pick_marks: "अंक चुनो",
    time_master_subj_numerical: "संख्यात्मक",
    time_master_subj_science: "विज्ञान",
    time_master_subj_technical: "तकनीकी",
    time_master_subj_social: "सामाजिक",
    time_master_subj_language: "भाषा",
    time_master_subj_other: "अन्य",
  },
  bn: {
    app_name: "ড্রয়িং টুলস",
    tagline: "তোমাকে আঁকতে অনুপ্রাণিত করে!",
    enter_phone: "তোমার মোবাইল নম্বর দাও",
    phone_placeholder: "১০ সংখ্যার মোবাইল",
    send_otp: "OTP পাঠাও",
    enter_otp: "৬ সংখ্যার OTP দাও",
    verify: "যাচাই করো",
    resend_otp: "OTP আবার পাঠাও",
    change_number: "নম্বর বদলাও",
    free_label: "ফ্রি",
    paid_label: "₹",
    blueprint: "ব্লুপ্রিন্ট",
    blueprint_desc: "প্রথমে রূপরেখা আঁকো",
    pencil: "পেন্সিল স্কেচ",
    pencil_desc: "সুন্দর পেন্সিল স্কেচ বানাও",
    story: "আমার গল্প",
    story_desc: "একটি কমিক গল্প তৈরি করো",
    wallet: "ওয়ালেট",
    recharge_wallet: "ওয়ালেট রিচার্জ করো",
    recharge_methods: "UPI · কার্ড · নেটব্যাঙ্কিং · ওয়ালেট",
    pay_prefix: "পে করো",
    processing: "প্রসেস হচ্ছে…",
    recharge_unavailable: "রিচার্জ এখন উপলব্ধ নয়",
    free_credit_title: "{amount} ফ্রি ক্রেডিট",
    free_credit_desc: "আমরা তোমাকে {amount} ফ্রি ওয়ালেট ক্রেডিট দিয়েছি — এক ফোন নম্বরে একবার।",
    recent_recharges: "সাম্প্রতিক রিচার্জ",
    gallery: "গ্যালারি",
    take_photo: "ছবি তোলো",
    retake: "আবার তোলো",
    use_photo: "এই ছবিটা নাও",
    generating: "জাদু হচ্ছে...",
    almost_there: "প্রায় শেষ!",
    download: "ডাউনলোড",
    share: "শেয়ার",
    share_whatsapp: "হোয়াটসঅ্যাপ",
    share_email: "ইমেল",
    copy_link: "লিংক কপি",
    back: "ফিরে যাও",
    logout: "লগআউট",
    your_creations: "তোমার সৃষ্টি",
    no_creations: "এখনো কিছু নেই। চলো শুরু করি!",
    insufficient_balance: "ব্যালেন্স কম",
    rate_limited: "একটু বিশ্রাম নাও! পরে আবার চেষ্টা করো।",
    welcome: "স্বাগতম!",
    home: "হোম",
    language: "ভাষা",
    balance: "ব্যালেন্স",
    create: "বানাও",
    platform_name: "সরল আই",
    platform_tagline: "শেখার মহাসাগরকে সহজ করে তোলা",
    module_drawing_title: "ড্রয়িং টুলস",
    module_drawing_desc: "আঁকো, রঙ করো ও কল্পনা করো",
    module_language_title: "ভাষা টুলস",
    module_language_desc: "প্রতিটি বিষয় শেখো",
    module_math_title: "গণিত টুলস",
    module_math_desc: "শেখো, সমাধান করো ও উন্নতি করো",
    mind_master_title: "মাইন্ড মাস্টার",
    mind_master_desc: "ধ্যান করো, শ্বাস নাও ও শান্ত হও",
    mind_master_audio_start: "শব্দ চালাও",
    mind_master_audio_stop: "শব্দ থামাও",
    mind_master_back: "ফিরে যাও",
    life_intro_heading: "নিজেকে চিনতে কিছু মুহূর্ত দাও",
    privacy_policy: "গোপনীয়তা নীতি",
    install_app: "অ্যাপ ইনস্টল করুন",
    app_installs: "অ্যাপ ইনস্টল",
    coming_soon: "শীঘ্রই আসছে",
    open_now: "খোলো",
    make_another: "আরেকটি বানাও",
    upload_from_gallery: "গ্যালারি থেকে আপলোড",
    math_tagline: "অঙ্কের প্রশ্ন তোলো — হিন্ট বা পুরো সমাধান পাও।",
    math_hint: "হিন্ট",
    math_hint_desc: "তোমার ভাষায় সহজ ইশারা, অডিও সহ",
    math_solution: "সমাধান",
    math_solution_desc: "খাতার মতো ধাপে ধাপে পুরো উত্তর",

    share_confirm_prompt: "আপনি কি হোয়াটসঅ্যাপে বার্তাটি পাঠিয়েছেন?",
    share_confirm_yes: "হ্যাঁ, পাঠিয়েছি",
    share_confirm_no: "এখনও নয়",

    help_a_friend: "বন্ধুকে সাহায্য করো",
    help_a_friend_intro: "শেয়ার করা মানে যত্ন — বন্ধুকে একসাথে শিখতে ডাকো।",
    help_a_friend_msg_greeting: "চলো একসাথে শিখি!",
    help_a_friend_msg_body: "আমি পড়াশোনার জন্য সরল আই ব্যবহার করছি। তুমিও যোগ দিতে পারো:",
    help_a_friend_msg_tagline: "শেখো • বাড়ো • সাহায্য করো",
    share_on_whatsapp: "হোয়াটসঅ্যাপে শেয়ার করো",
    share_helper_line: "প্রতিটি শেয়ার = এক জন শিক্ষার্থীকে সাহায্য",
    join_sahaj_path: "সহজ পাঠে যোগ দাও",
    sahaj_path_hint: "হোয়াটসঅ্যাপে বন্ধুত্বপূর্ণ পড়াশোনার সহায়ক দল",
    level_blaze: "লেভেল ব্লেজ",
    helped_label: "সাহায্য",
    level_student: "ছাত্র",
    level_helper: "সহায়ক",
    level_supporter: "সমর্থক",
    level_mentor: "গুরু",
    level_champion: "চ্যাম্পিয়ন",
    progress_line: "তুমি {n} জন শিক্ষার্থীকে সাহায্য করেছ • {next} হতে আরও {remain}",
    progress_line_top: "তুমি {n} জনকে সাহায্য করেছ। চ্যাম্পিয়ন — ধন্যবাদ!",
    helped_toast_progress: "এখন {n} জনকে সাহায্য • {next} হতে আরও {remain}",
    helped_toast_simple: "তুমি {n} জনকে সাহায্য করেছ। ধন্যবাদ!",

    share_balance_title: "ব্যালেন্স শেয়ার",
    share_balance_desc: "বন্ধুকে কিছু ওয়ালেট টাকা পাঠান",
    share_recipient_phone: "প্রাপকের মোবাইল নম্বর",
    share_phone_placeholder: "যেমন 9876543210",
    share_amount: "শেয়ার করার পরিমাণ",
    share_send_btn: "পাঠান",
    share_success: "{phone}-এ {amount} পাঠানো হয়েছে",
    share_recipient_invalid: "সঠিক মোবাইল নম্বর দিন",
    share_invalid_amount: "শূন্যের বেশি সঠিক পরিমাণ দিন",
    share_insufficient_balance: "আপনার যথেষ্ট ব্যালেন্স নেই",

    hourglass_view: "বালিঘড়ি ভিউ",
    hourglass_exit: "প্রস্থান",

    colour_guide: "কালার গাইড",
    colour_guide_desc: "আঁকার উপর আলো, ছায়া ও রঙের ক্রম শিখুন",
    cg_coloring_order: "রঙ করার ক্রম",
    cg_step_1_title: "পটভূমি",
    cg_step_1_desc: "হালকা রঙ, কম কনট্রাস্ট",
    cg_step_2_title: "দূরের বস্তু",
    cg_step_2_desc: "শীতল রঙ, নরম কনট্রাস্ট",
    cg_step_3_title: "মাটি",
    cg_step_3_desc: "প্রাকৃতিক বেস রঙ",
    cg_step_4_title: "মূল বিষয়",
    cg_step_4_desc: "গাঢ় রঙ, উচ্চ কনট্রাস্ট",
    cg_step_5_title: "অন্যান্য বড় বস্তু",
    cg_step_5_desc: "সুষম মধ্য-টোন",
    cg_step_6_title: "বিশদ ও হাইলাইট",
    cg_step_6_desc: "সূক্ষ্ম বিশদ, উজ্জ্বল হাইলাইট",
    cg_note_heading: "নোট",
    cg_note_1: "মূল বিষয় লাল রঙে চিহ্নিত।",
    cg_note_2: "নীল ছায়া অঞ্চলে গাঢ় রঙ ব্যবহার করুন।",

    math_mental: "মেন্টাল ম্যাথ",
    math_mental_desc: "কেনাকাটার গল্প শোনো এবং সঠিক উত্তর বেছে নাও",
    mm_start_practice: "অনুশীলন শুরু করো",
    mm_replay_audio: "আবার শোনো",
    mm_choose_answer: "সঠিক উত্তর বেছে নাও",
    mm_correct: "সঠিক উত্তর! দারুণ।",
    mm_wrong: "ভুল হয়েছে! আবার ভাবো।",
    mm_practice_another: "আরেকটি প্রশ্ন",
    mm_back: "ফিরে যাও",
    mm_home: "হোম",
    mm_generating: "তোমার প্রশ্ন তৈরি হচ্ছে...",
    mm_focus_now: "মন দিয়ে শোনো",
    mm_intro: "মেন্টাল ম্যাথের জন্য বাস্তব জীবনের কেনাকাটার ধাঁধা",
    use_cropped_area: "এই অংশ ব্যবহার করো",
    another_problem: "অন্য প্রশ্ন",
    hint_label: "এই নাও একটা হিন্ট",
    audio_hint_label: "শুনতে চাও? প্লে বোতাম চাপো",
    audio_unavailable: "অডিও পাওয়া যাচ্ছে না — পরে চেষ্টা করো।",
    no_math_found_title: "অঙ্কের প্রশ্ন পাওয়া যায়নি।",
    no_math_found_desc: "ক্রপ এরিয়ায় প্রশ্ন স্পষ্ট রাখো।",
    generating_hint: "হিন্ট বানাচ্ছি...",
    generating_solution: "সমাধান বানাচ্ছি...",
    generating_summary: "সারসংক্ষেপ বানাচ্ছি...",
    generating_mcq: "কুইজ বানাচ্ছি...",
    language_tagline: "একটা পাঠ ছবি তোলো — সারসংক্ষেপ বা কুইজ পাও।",
    lang_summary: "সারসংক্ষেপ",
    lang_summary_desc: "তোমার ভাষায় সহজ সারসংক্ষেপ, অডিওসহ",
    lang_mcq: "কুইজ",
    lang_mcq_desc: "মজার বহুনির্বাচনী প্রশ্ন, সঙ্গে সঙ্গে ফিডব্যাক",
    pick_age_group: "তোমার বয়স গ্রুপ বাছো",
    age_6_10: "6–10 বছর",
    age_10_14: "10–14 বছর",
    age_14_18: "14–18 বছর",
    age_18_plus: "18+ বছর",
    summary_label: "এই নাও একটা ছোট সারসংক্ষেপ",
    audio_summary_label: "শুনতে চাও? প্লে চাপো",
    no_content_title: "কোনো পাঠ পাওয়া গেল না।",
    no_content_desc: "ক্যামেরা একটা গল্প, পাঠ বা প্রবন্ধে ধরো।",
    question: "প্রশ্ন",
    multi_select_hint: "একাধিক উত্তর সঠিক হতে পারে।",
    mcq_submit: "উত্তর দেখাও",
    mcq_next: "পরের প্রশ্ন",
    mcq_see_score: "আমার স্কোর দেখাও",
    mcq_correct: "ঠিক! 🎉",
    mcq_wrong: "এবার হয়নি। পরের প্রশ্নে চেষ্টা করো!",
    mcq_correct_feedback: "দারুণ — সব সঠিক উত্তর দিয়েছ।",
    mcq_wrong_feedback: "সবুজ বিকল্প গুলিই সঠিক উত্তর।",
    mcq_done_title: "চমৎকার চেষ্টা!",
    mcq_all_correct: "সব ঠিক!",
    your_score: "তোমার স্কোর",
    lang_check_answer: "উত্তর যাচাই",
    lang_check_answer_desc: "লেখা উত্তরপত্রের ছবি তুলুন — নম্বর, সঠিক/ভুল ও আদর্শ উত্তর পান",
    lang_learn_nature: "প্রকৃতি থেকে শেখো",
    lang_learn_nature_desc: "প্রকৃতির ছবি তোলো — বিজ্ঞান, জীবন ও আরও অনেক ছোট পাঠ পাও",
    generating_learn_nature: "প্রকৃতি থেকে পাঠ খুঁজছি...",
    nature_lessons_label: "প্রকৃতি থেকে পাঠ",
    generating_check_answer: "উত্তর যাচাই করা হচ্ছে...",
    no_paper_found_title: "প্রশ্নপত্র খুঁজে পাওয়া যায়নি।",
    no_paper_found_desc: "ছাত্রের উত্তর সহ প্রশ্নপত্রে ক্যামেরা ধরুন।",
    lang_speech_mentor: "স্পিচ মেন্টর",
    lang_speech_mentor_desc: "ভালো বলতে সাহায্য করা বন্ধুসুলভ AI মেন্টর।",
    speech_mentor_tap_to_record: "মাইক ছুঁয়ে বলা শুরু কর",
    speech_mentor_tap_to_stop: "থামাতে ট্যাপ কর",
    speech_mentor_recording: "শুনছি...",
    speech_mentor_analyzing: "তোমার কথা বিশ্লেষণ করছি...",
    speech_mentor_your_speech: "তোমার কথা",
    speech_mentor_mic_denied: "মাইকের অনুমতি পাওয়া যায়নি",
    speech_mentor_mic_unsupported: "এই ডিভাইসে মাইক নেই",
    learn_another: "আরেকটি শিখো",
    try_another: "আরেকটা করো",
    check_another: "আরেকটি যাচাই",
    practice_again: "আবার অনুশীলন কর",
    speech_mentor_play_welcome: "স্বাগত শুনতে ট্যাপ কর",
    daily_reflection: "প্রতিদিনের চিন্তন",
    daily_reflection_desc: "নিজের ভিতরের বৃদ্ধির জন্য ১ মিনিটের রোজকার চেক-ইন",
    dr_start: "শুরু করো",
    dr_loading: "তোমার চিন্তন প্রস্তুত হচ্ছে...",
    dr_question_of: "প্রশ্ন {n} / {total}",
    dr_your_answer: "তোমার উত্তর",
    dr_best_answer: "সেরা উত্তর",
    dr_lesson: "শিক্ষা",
    dr_growth_score: "আজকের গ্রোথ স্কোর",
    dr_encouragement_high: "চমৎকার! তুমি প্রতিদিন বেড়ে উঠছ।",
    dr_encouragement_mid: "দারুণ চেষ্টা! রোজ একটু চিন্তন মনকে দৃঢ় করে।",
    dr_encouragement_low: "প্রতিটি চিন্তনই এক ধাপ এগিয়ে। এগিয়ে চলো!",
    dr_next: "পরবর্তী",
    dr_finish: "আমার স্কোর দেখো",
    dr_try_again: "আবার চিন্তন করো",
    dr_listen: "শোনো",
    coloring: "রঙ করা",
    coloring_desc: "যেকোনো আঁকাকে শিল্পে রূপান্তর — অয়েল প্যাস্টেল, জলরঙ ও আরও",
    coloring_choose_style: "একটি রঙের শৈলী বেছে নাও",
    coloring_style_oil_pastel: "অয়েল প্যাস্টেল",
    coloring_style_watercolor: "জলরঙ",
    coloring_style_graphite_shade: "পেন্সিল শেড",
    coloring_style_color_pencil_shade: "রঙিন পেন্সিল",
    coloring_style_oil_paint: "তৈল রঙ",
    time_master: "টাইম মাস্টার",
    time_master_desc: "কত দ্রুত শেষ করবে? আদর্শ সময়ের সাথে দৌড় দাও।",
    time_master_class: "শ্রেণি",
    time_master_subject: "বিষয়",
    time_master_marks: "নম্বর",
    time_master_ideal: "আদর্শ সময়",
    time_master_elapsed: "তোমার সময়",
    time_master_start: "টাইমার চালু",
    time_master_stop: "টাইমার বন্ধ",
    time_master_pick_class: "শ্রেণি বাছো",
    time_master_pick_subject: "বিষয় বাছো",
    time_master_pick_marks: "নম্বর বাছো",
    time_master_subj_numerical: "সংখ্যা",
    time_master_subj_science: "বিজ্ঞান",
    time_master_subj_technical: "কারিগরি",
    time_master_subj_social: "সামাজিক",
    time_master_subj_language: "ভাষা",
    time_master_subj_other: "অন্যান্য",
  },
  ta: {
    app_name: "டிராயிங் டூல்ஸ்",
    tagline: "வரைய ஊக்குவிக்கிறது!",
    enter_phone: "உங்கள் தொலைபேசி எண்ணை உள்ளிடவும்",
    phone_placeholder: "10 இலக்க மொபைல்",
    send_otp: "OTP அனுப்பு",
    enter_otp: "6 இலக்க OTP-ஐ உள்ளிடவும்",
    verify: "சரிபார்த்து உள்நுழைக",
    resend_otp: "OTP-ஐ மீண்டும் அனுப்பு",
    change_number: "எண்ணை மாற்று",
    free_label: "இலவசம்",
    paid_label: "₹",
    blueprint: "ப்ளூபிரிண்ட்",
    blueprint_desc: "முதலில் வெளிக்கோடு வரை",
    pencil: "பென்சில் ஸ்கெட்ச்",
    pencil_desc: "அழகான பென்சில் ஓவியம் உருவாக்கு",
    story: "என் கதை",
    story_desc: "ஒரு காமிக் கதை உருவாக்கு",
    wallet: "பணப்பை",
    recharge_wallet: "வாலட் ரீசார்ஜ் செய்",
    recharge_methods: "UPI · கார்டு · நெட்பேங்கிங் · வாலட்",
    pay_prefix: "செலுத்து",
    processing: "செயலாக்கம் நடக்கிறது…",
    recharge_unavailable: "ரீசார்ஜ் தற்போது கிடைக்கவில்லை",
    free_credit_title: "{amount} இலவச கிரெடிட்",
    free_credit_desc: "உங்களுக்கு {amount} இலவச வாலட் கிரெடிட் வழங்கியுள்ளோம் — ஒரு ஃபோன் எண்ணுக்கு ஒருமுறை.",
    recent_recharges: "சமீபத்திய ரீசார்ஜ்கள்",
    gallery: "தொகுப்பு",
    take_photo: "புகைப்படம் எடு",
    retake: "மீண்டும் எடு",
    use_photo: "இந்த புகைப்படத்தைப் பயன்படுத்து",
    generating: "மந்திரம் நடக்கிறது...",
    almost_there: "கிட்டத்தட்ட முடிந்தது!",
    download: "பதிவிறக்கு",
    share: "பகிர்",
    share_whatsapp: "வாட்ஸ்ஆப்",
    share_email: "மின்னஞ்சல்",
    copy_link: "இணைப்பை நகலெடு",
    back: "திரும்பு",
    logout: "வெளியேறு",
    your_creations: "உங்கள் படைப்புகள்",
    no_creations: "இன்னும் படைப்புகள் இல்லை. வரைய ஆரம்பி!",
    insufficient_balance: "போதிய பணம் இல்லை",
    rate_limited: "சற்று இடைவெளி எடு! பிறகு முயற்சி செய்.",
    welcome: "வரவேற்கிறோம்!",
    home: "முகப்பு",
    language: "மொழி",
    balance: "இருப்பு",
    create: "உருவாக்கு",
    platform_name: "சரல் ஐ",
    platform_tagline: "கற்றல் என்னும் பெருங்கடலை எளிதாக்குகிறோம்",
    module_drawing_title: "டிராயிங் டூல்ஸ்",
    module_drawing_desc: "வரைக, வண்ணமிடு & கற்பனை செய்",
    module_language_title: "மொழி டூல்ஸ்",
    module_language_desc: "ஒவ்வொரு பாடத்தையும் கற்றுக்கொள்",
    module_math_title: "கணித டூல்ஸ்",
    module_math_desc: "கற்று, தீர்த்து & மேம்படு",
    mind_master_title: "மைண்ட் மாஸ்டர்",
    mind_master_desc: "தியானி, மூச்சு விடு & அமைதி",
    mind_master_audio_start: "ஒலி இயக்கு",
    mind_master_audio_stop: "ஒலி நிறுத்து",
    mind_master_back: "பின்",
    life_intro_heading: "உன்னை அறிய சில நொடிகள் கொடு",
    privacy_policy: "தனியுரிமைக் கொள்கை",
    install_app: "ஆப்-ஐ நிறுவவும்",
    app_installs: "ஆப் நிறுவல்கள்",
    coming_soon: "விரைவில் வரும்",
    open_now: "திற",
    make_another: "மற்றொன்று உருவாக்கு",
    upload_from_gallery: "தொகுப்பிலிருந்து பதிவேற்று",
    math_tagline: "கணக்கின் படத்தை எடு — குறிப்பு அல்லது முழு தீர்வு பெறு.",
    math_hint: "குறிப்பு",
    math_hint_desc: "உங்கள் மொழியில் எளிய குறிப்பு, ஆடியோவுடன்",
    math_solution: "தீர்வு",
    math_solution_desc: "புத்தக பாணியில் முழு படிநிலை தீர்வு",

    share_confirm_prompt: "வாட்ஸ்அப்பில் செய்தியை பகிர்ந்தீர்களா?",
    share_confirm_yes: "ஆம், பகிர்ந்தேன்",
    share_confirm_no: "இன்னும் இல்லை",

    help_a_friend: "நண்பருக்கு உதவு",
    help_a_friend_intro: "பகிர்வது கவனிப்பது — நண்பரையும் கூட்டி படிக்க அழை.",
    help_a_friend_msg_greeting: "ஒன்றாக கற்றுக்கொள்வோம்!",
    help_a_friend_msg_body: "நான் படிப்பிற்கு Saral Eye பயன்படுத்துகிறேன். நீயும் இணைந்துகொள்:",
    help_a_friend_msg_tagline: "கற்றல் • வளர்ச்சி • உதவி",
    share_on_whatsapp: "வாட்ஸ்அப்பில் பகிர்",
    share_helper_line: "ஒவ்வொரு பகிர்வும் = ஒரு மாணவருக்கு உதவி",
    join_sahaj_path: "சஹஜ் பாட-தில் இணை",
    sahaj_path_hint: "வாட்ஸ்அப்பில் நட்பான கல்வி ஆதரவு குழு",
    level_blaze: "லெவல் ப்ளேஸ்",
    helped_label: "உதவினேன்",
    level_student: "மாணவர்",
    level_helper: "உதவியாளர்",
    level_supporter: "ஆதரவாளர்",
    level_mentor: "வழிகாட்டி",
    level_champion: "சாம்பியன்",
    progress_line: "{n} மாணவர்களுக்கு உதவினீர் • {next} ஆக மேலும் {remain}",
    progress_line_top: "{n} மாணவர்களுக்கு உதவினீர். சாம்பியன் — நன்றி!",
    helped_toast_progress: "இப்போது {n} மாணவர்கள் • {next} ஆக மேலும் {remain}",
    helped_toast_simple: "{n} மாணவர்களுக்கு உதவினீர். நன்றி!",

    share_balance_title: "பற்று பங்கிடு",
    share_balance_desc: "நண்பருக்கு வாலட் பணம் அனுப்பு",
    share_recipient_phone: "பெறுநர் மொபைல் எண்",
    share_phone_placeholder: "எ.கா. 9876543210",
    share_amount: "பங்கிட வேண்டிய தொகை",
    share_send_btn: "அனுப்பு",
    share_success: "{phone}-க்கு {amount} அனுப்பப்பட்டது",
    share_recipient_invalid: "சரியான மொபைல் எண்ணை உள்ளிடு",
    share_invalid_amount: "பூஜ்யத்தை விட அதிக சரியான தொகை உள்ளிடு",
    share_insufficient_balance: "போதுமான பற்று இல்லை",

    hourglass_view: "மணல் கடிகார காட்சி",
    hourglass_exit: "வெளியேறு",

    colour_guide: "வண்ண வழிகாட்டி",
    colour_guide_desc: "உங்கள் ஓவியத்தில் ஒளி, நிழல் மற்றும் வண்ண வரிசை கற்க",
    cg_coloring_order: "வண்ண வரிசை",
    cg_step_1_title: "பின்னணி",
    cg_step_1_desc: "இளம் வண்ணம், குறைந்த மாறுபாடு",
    cg_step_2_title: "தூர பொருள்கள்",
    cg_step_2_desc: "குளிர் வண்ணம், மென்மையான மாறுபாடு",
    cg_step_3_title: "தரை",
    cg_step_3_desc: "இயற்கை அடிப்படை வண்ணம்",
    cg_step_4_title: "பிரதான பொருள்",
    cg_step_4_desc: "செழிப்பான வண்ணம், அதிக மாறுபாடு",
    cg_step_5_title: "மற்ற பெரிய பொருள்கள்",
    cg_step_5_desc: "சமநிலை நடு-தொனிகள்",
    cg_step_6_title: "விவரங்கள் & ஹைலைட்",
    cg_step_6_desc: "நுணுக்கம், பிரகாசமான ஹைலைட்",
    cg_note_heading: "குறிப்பு",
    cg_note_1: "பிரதான பொருள் சிவப்பு கோட்டில் குறிக்கப்பட்டுள்ளது.",
    cg_note_2: "நீல நிழல் பகுதிகளில் அடர் வண்ணம் பயன்படுத்தவும்.",

    math_mental: "மென்டல் மேத்",
    math_mental_desc: "ஷாப்பிங் கதையை கேட்டு சரியான பதிலை தேர்வு செய்",
    mm_start_practice: "பயிற்சி தொடங்கு",
    mm_replay_audio: "மீண்டும் கேளு",
    mm_choose_answer: "சரியான பதிலை தேர்ந்தெடு",
    mm_correct: "சரி! அற்புதம்.",
    mm_wrong: "தவறு! மறுபடியும் முயற்சி செய்.",
    mm_practice_another: "மற்றொரு கேள்வி",
    mm_back: "பின்",
    mm_home: "வீடு",
    mm_generating: "உங்கள் கேள்வி தயாராகிறது...",
    mm_focus_now: "கவனமாக கேளு",
    mm_intro: "மென்டல் மேத் பயிற்சிக்கான உண்மையான வாழ்க்கை ஷாப்பிங் புதிர்கள்",
    use_cropped_area: "இந்த பகுதியை பயன்படுத்து",
    another_problem: "மற்றொரு கேள்வி",
    hint_label: "இதோ ஒரு குறிப்பு",
    audio_hint_label: "கேட்க Play பொத்தானை அழுத்து",
    audio_unavailable: "ஆடியோ கிடைக்கவில்லை — பின்னர் முயற்சிக்கவும்.",
    no_math_found_title: "கணக்கு கேள்வி கிடைக்கவில்லை.",
    no_math_found_desc: "Crop பகுதியில் கேள்வி தெளிவாக இருக்கட்டும்.",
    generating_hint: "குறிப்பு உருவாகிறது...",
    generating_solution: "தீர்வு உருவாகிறது...",
    generating_summary: "சுருக்கம் உருவாகிறது...",
    generating_mcq: "வினாடி வினா உருவாகிறது...",
    language_tagline: "ஒரு பத்தியின் படத்தை எடு — சுருக்கம் அல்லது வினாடி வினா பெறு.",
    lang_summary: "சுருக்கம்",
    lang_summary_desc: "உன் மொழியில் எளிய சுருக்கம், ஆடியோவுடன்",
    lang_mcq: "வினாடி வினா",
    lang_mcq_desc: "வேடிக்கையான பல தேர்வு கேள்விகள், உடனடி பின்னூட்டம்",
    pick_age_group: "உன் வயது குழுவை தேர்வு செய்",
    age_6_10: "6–10 வயது",
    age_10_14: "10–14 வயது",
    age_14_18: "14–18 வயது",
    age_18_plus: "18+ வயது",
    summary_label: "இதோ ஒரு குறுகிய சுருக்கம்",
    audio_summary_label: "கேட்க Play அழுத்து",
    no_content_title: "எந்த பத்தியும் கிடைக்கவில்லை.",
    no_content_desc: "கேமராவை ஒரு கதை, பாடம் அல்லது பத்தியில் காட்டு.",
    question: "கேள்வி",
    multi_select_hint: "ஒன்றுக்கு மேற்பட்ட பதில் சரியாக இருக்கலாம்.",
    mcq_submit: "பதிலை சரிபார்",
    mcq_next: "அடுத்த கேள்வி",
    mcq_see_score: "என் மதிப்பெண்ணைப் பார்",
    mcq_correct: "சரி! 🎉",
    mcq_wrong: "தவறு. அடுத்தது முயற்சி செய்!",
    mcq_correct_feedback: "அருமை — அனைத்தும் சரியாக இருக்கிறது.",
    mcq_wrong_feedback: "பச்சை விருப்பங்களே சரியான பதில்.",
    mcq_done_title: "அருமையான முயற்சி!",
    mcq_all_correct: "சரியான மதிப்பெண்!",
    your_score: "உன் மதிப்பெண்",
    lang_check_answer: "விடை சரிபார்ப்பு",
    lang_check_answer_desc: "எழுதிய விடைத்தாளின் படம் எடுங்கள் — மதிப்பெண், சரி/தவறு மற்றும் சரியான பதில்",
    lang_learn_nature: "இயற்கையிலிருந்து கற்று",
    lang_learn_nature_desc: "இயற்கை காட்சியை படம் எடு — அறிவியல், வாழ்க்கை என பல பாடங்கள் பெறு",
    generating_learn_nature: "இயற்கையிலிருந்து பாடங்களை தேடுகிறோம்...",
    nature_lessons_label: "இயற்கையிலிருந்து பாடங்கள்",
    generating_check_answer: "விடைகளை சரிபார்க்கிறோம்...",
    no_paper_found_title: "கேள்வித்தாள் கிடைக்கவில்லை.",
    no_paper_found_desc: "மாணவர் பதில் உள்ள கேள்வித்தாளில் கேமராவை வைக்கவும்.",
    lang_speech_mentor: "பேச்சு வழிகாட்டி",
    lang_speech_mentor_desc: "நன்றாக பேச உதவும் நட்பான AI வழிகாட்டி.",
    speech_mentor_tap_to_record: "மைக்கை தட்டி பேசத் தொடங்கு",
    speech_mentor_tap_to_stop: "நிறுத்த தட்டு",
    speech_mentor_recording: "கேட்கிறேன்...",
    speech_mentor_analyzing: "உன் பேச்சை பகுப்பாய்வு செய்கிறேன்...",
    speech_mentor_your_speech: "உன் பேச்சு",
    speech_mentor_mic_denied: "மைக்கிற்கு அனுமதி மறுக்கப்பட்டது",
    speech_mentor_mic_unsupported: "இந்த சாதனத்தில் மைக் இல்லை",
    learn_another: "மேலும் கற்க",
    try_another: "மீண்டும் முயற்சி",
    check_another: "மேலும் சரிபார்",
    practice_again: "மீண்டும் பயிற்சி",
    speech_mentor_play_welcome: "வரவேற்பைக் கேட்க தட்டு",
    daily_reflection: "தினசரி சிந்தனை",
    daily_reflection_desc: "உள் வளர்ச்சிக்கான 1 நிமிட தினசரி பரிசோதனை",
    dr_start: "தொடங்கு",
    dr_loading: "உங்கள் சிந்தனை தயாராகிறது...",
    dr_question_of: "கேள்வி {n} / {total}",
    dr_your_answer: "உங்கள் பதில்",
    dr_best_answer: "சிறந்த பதில்",
    dr_lesson: "பாடம்",
    dr_growth_score: "இன்றைய வளர்ச்சி மதிப்பெண்",
    dr_encouragement_high: "அற்புதம்! நீங்கள் தினமும் வளர்கிறீர்கள்.",
    dr_encouragement_mid: "நல்ல முயற்சி! தினசரி சிந்தனை மனதை வலிமையாக்கும்.",
    dr_encouragement_low: "ஒவ்வொரு சிந்தனையும் ஒரு படி முன்னேற்றம். தொடர்ந்து வளருங்கள்!",
    dr_next: "அடுத்து",
    dr_finish: "எனது மதிப்பெண்",
    dr_try_again: "மீண்டும் சிந்தி",
    dr_listen: "கேளுங்கள்",
    coloring: "வண்ணமிடல்",
    coloring_desc: "எந்த வரைபடத்தையும் கலையாக்கு — ஆயில் பேஸ்டல், நீர் வண்ணம், மேலும்",
    coloring_choose_style: "ஒரு வண்ண பாணியை தேர்வு செய்",
    coloring_style_oil_pastel: "எண்ணெய் பேஸ்டல்",
    coloring_style_watercolor: "நீர் வண்ணம்",
    coloring_style_graphite_shade: "பென்சில் நிழல்",
    coloring_style_color_pencil_shade: "வண்ண பென்சில்",
    coloring_style_oil_paint: "எண்ணெய் ஓவியம்",
    time_master: "நேர மாஸ்டர்",
    time_master_desc: "எத்தனை வேகமாக முடிக்கலாம்? சிறந்த நேரத்துடன் போட்டியிடு.",
    time_master_class: "வகுப்பு",
    time_master_subject: "பாடம்",
    time_master_marks: "மதிப்பெண்",
    time_master_ideal: "சிறந்த நேரம்",
    time_master_elapsed: "உன் நேரம்",
    time_master_start: "டைமர் தொடங்கு",
    time_master_stop: "டைமர் நிறுத்து",
    time_master_pick_class: "வகுப்பு தேர்வு",
    time_master_pick_subject: "பாடம் தேர்வு",
    time_master_pick_marks: "மதிப்பெண் தேர்வு",
    time_master_subj_numerical: "எண் சார்ந்த",
    time_master_subj_science: "அறிவியல்",
    time_master_subj_technical: "தொழில்நுட்பம்",
    time_master_subj_social: "சமூகம்",
    time_master_subj_language: "மொழி",
    time_master_subj_other: "மற்றவை",
  },
  te: {
    app_name: "డ్రాయింగ్ టూల్స్",
    tagline: "గీయడానికి ప్రేరేపిస్తుంది!",
    enter_phone: "మీ ఫోన్ నంబర్ నమోదు చేయండి",
    phone_placeholder: "10 అంకెల మొబైల్",
    send_otp: "OTP పంపండి",
    enter_otp: "6 అంకెల OTP నమోదు చేయండి",
    verify: "ధృవీకరించి లాగిన్",
    resend_otp: "OTP మళ్లీ పంపండి",
    change_number: "నంబర్ మార్చండి",
    free_label: "ఉచితం",
    paid_label: "₹",
    blueprint: "బ్లూప్రింట్",
    blueprint_desc: "మొదట రూపురేఖ గీయండి",
    pencil: "పెన్సిల్ స్కెచ్",
    pencil_desc: "అందమైన పెన్సిల్ స్కెచ్ సృష్టించండి",
    story: "నా కథ",
    story_desc: "ఒక కామిక్ కథను సృష్టించండి",
    wallet: "వాలెట్",
    recharge_wallet: "వాలెట్ రీచార్జ్ చేయండి",
    recharge_methods: "UPI · కార్డ్‌లు · నెట్‌బ్యాంకింగ్ · వాలెట్",
    pay_prefix: "చెల్లించండి",
    processing: "ప్రాసెస్ అవుతోంది…",
    recharge_unavailable: "రీచార్జ్ ప్రస్తుతం అందుబాటులో లేదు",
    free_credit_title: "{amount} ఉచిత క్రెడిట్",
    free_credit_desc: "మీకు {amount} ఉచిత వాలెట్ క్రెడిట్ ఇచ్చాము — ఒక ఫోన్ నంబర్‌కి ఒకసారి.",
    recent_recharges: "ఇటీవలి రీచార్జ్‌లు",
    gallery: "గ్యాలరీ",
    take_photo: "ఫోటో తీయండి",
    retake: "మళ్లీ తీయండి",
    use_photo: "ఈ ఫోటోను ఉపయోగించండి",
    generating: "మాయ జరుగుతోంది...",
    almost_there: "దాదాపు అయిపోయింది!",
    download: "డౌన్‌లోడ్",
    share: "షేర్",
    share_whatsapp: "వాట్సాప్",
    share_email: "ఇమెయిల్",
    copy_link: "లింక్ కాపీ చేయండి",
    back: "వెనుకకు",
    logout: "లాగౌట్",
    your_creations: "మీ సృష్టులు",
    no_creations: "ఇంకా సృష్టులు లేవు. గీయడం ప్రారంభించండి!",
    insufficient_balance: "సరిపోని బ్యాలెన్స్",
    rate_limited: "కొంత విశ్రాంతి తీసుకోండి! తరువాత ప్రయత్నించండి.",
    welcome: "స్వాగతం!",
    home: "హోమ్",
    language: "భాష",
    balance: "బ్యాలెన్స్",
    create: "సృష్టించండి",
    platform_name: "సరళ్ ఐ",
    platform_tagline: "నేర్చుకోవడం అనే మహాసముద్రాన్ని సరళంగా చేస్తున్నాం",
    module_drawing_title: "డ్రాయింగ్ టూల్స్",
    module_drawing_desc: "గీయండి, రంగులేయండి & ఊహించండి",
    module_language_title: "భాష టూల్స్",
    module_language_desc: "ప్రతి సబ్జెక్ట్ నేర్చుకోండి",
    module_math_title: "గణిత టూల్స్",
    module_math_desc: "నేర్చుకోండి, పరిష్కరించండి & మెరుగుపడండి",
    mind_master_title: "మైండ్ మాస్టర్",
    mind_master_desc: "ధ్యానించండి, శ్వాస & శాంతి",
    mind_master_audio_start: "శబ్దం ప్లే",
    mind_master_audio_stop: "శబ్దం ఆపు",
    mind_master_back: "వెనుకకు",
    life_intro_heading: "మిమ్మల్ని మీరు తెలుసుకోవడానికి కొద్ది క్షణాలు ఇవ్వండి",
    privacy_policy: "గోప్యతా విధానం",
    install_app: "యాప్ ఇన్‌స్టాల్ చేయండి",
    app_installs: "యాప్ ఇన్‌స్టాల్‌లు",
    coming_soon: "త్వరలో వస్తోంది",
    open_now: "తెరవండి",
    make_another: "మరొకటి తయారు చేయండి",
    upload_from_gallery: "గ్యాలరీ నుండి అప్‌లోడ్ చేయండి",
    math_tagline: "మ్యాథ్ సమస్యను ఫోటో తీయండి — హింట్ లేదా పూర్తి సొల్యూషన్ పొందండి.",
    math_hint: "హింట్",
    math_hint_desc: "మీ భాషలో సులభమైన సూచన, ఆడియోతో",
    math_solution: "సొల్యూషన్",
    math_solution_desc: "నోట్‌బుక్ స్టైల్‌లో పూర్తి దశల వారీ సమాధానం",

    share_confirm_prompt: "వాట్సాప్‌లో సందేశం షేర్ చేశారా?",
    share_confirm_yes: "అవును, షేర్ చేశాను",
    share_confirm_no: "ఇంకా లేదు",

    help_a_friend: "మిత్రుడికి సహాయం",
    help_a_friend_intro: "పంచుకోవడం అంటే ప్రేమ — స్నేహితుడిని కూడా చదవడానికి పిలవండి.",
    help_a_friend_msg_greeting: "మనం కలిసి నేర్చుకుందాం!",
    help_a_friend_msg_body: "నేను చదువుకు Saral Eye ఉపయోగిస్తున్నాను. మీరూ చేరండి:",
    help_a_friend_msg_tagline: "నేర్చుకో • ఎదుగు • సహాయం చేయి",
    share_on_whatsapp: "వాట్సాప్‌లో షేర్ చేయండి",
    share_helper_line: "ప్రతి షేర్ = ఒక విద్యార్థికి సహాయం",
    join_sahaj_path: "సహజ పాఠంలో చేరండి",
    sahaj_path_hint: "వాట్సాప్‌లో స్నేహపూర్వక అధ్యయన సహాయక సమూహం",
    level_blaze: "లెవెల్ బ్లేజ్",
    helped_label: "సహాయం",
    level_student: "విద్యార్థి",
    level_helper: "సహాయకుడు",
    level_supporter: "మద్దతుదారు",
    level_mentor: "మార్గదర్శి",
    level_champion: "ఛాంపియన్",
    progress_line: "మీరు {n} మంది విద్యార్థులకు సహాయం చేశారు • {next} కావడానికి మరో {remain}",
    progress_line_top: "మీరు {n} మందికి సహాయం చేశారు. ఛాంపియన్ — ధన్యవాదాలు!",
    helped_toast_progress: "ఇప్పుడు {n} మందికి సహాయం • {next} కావడానికి మరో {remain}",
    helped_toast_simple: "మీరు {n} మందికి సహాయం చేశారు. ధన్యవాదాలు!",

    share_balance_title: "బ్యాలెన్స్ షేర్",
    share_balance_desc: "స్నేహితుడికి కొంత వాలెట్ డబ్బు పంపండి",
    share_recipient_phone: "గ్రహీత మొబైల్ నంబర్",
    share_phone_placeholder: "ఉదా. 9876543210",
    share_amount: "పంపవలసిన మొత్తం",
    share_send_btn: "పంపండి",
    share_success: "{phone}కు {amount} పంపబడింది",
    share_recipient_invalid: "సరైన మొబైల్ నంబర్ నమోదు చేయండి",
    share_invalid_amount: "సున్నా కంటే ఎక్కువ సరైన మొత్తం నమోదు చేయండి",
    share_insufficient_balance: "మీ వద్ద తగినంత బ్యాలెన్స్ లేదు",

    hourglass_view: "ఇసుక గడియారం వీక్షణ",
    hourglass_exit: "నిష్క్రమించండి",

    colour_guide: "కలర్ గైడ్",
    colour_guide_desc: "మీ చిత్రంపై కాంతి, నీడ & రంగుల క్రమాన్ని నేర్చుకోండి",
    cg_coloring_order: "రంగుల క్రమం",
    cg_step_1_title: "నేపథ్యం",
    cg_step_1_desc: "తేలిక రంగులు, తక్కువ కాంట్రాస్ట్",
    cg_step_2_title: "దూరపు వస్తువులు",
    cg_step_2_desc: "చల్లని రంగులు, మృదువైన కాంట్రాస్ట్",
    cg_step_3_title: "నేల",
    cg_step_3_desc: "సహజ బేస్ రంగులు",
    cg_step_4_title: "ప్రధాన విషయం",
    cg_step_4_desc: "గాఢ రంగులు, హై కాంట్రాస్ట్",
    cg_step_5_title: "ఇతర పెద్ద వస్తువులు",
    cg_step_5_desc: "సమతుల్య మధ్య-టోన్‌లు",
    cg_step_6_title: "వివరాలు & హైలైట్",
    cg_step_6_desc: "సూక్ష్మ వివరాలు, ప్రకాశవంతమైన హైలైట్",
    cg_note_heading: "గమనిక",
    cg_note_1: "ప్రధాన విషయం ఎరుపు రేఖతో గుర్తించబడింది.",
    cg_note_2: "నీలం నీడ ప్రాంతాలలో గాఢ రంగులు ఉపయోగించండి.",

    math_mental: "మెంటల్ మ్యాత్",
    math_mental_desc: "షాపింగ్ కథ వినండి, సరైన సమాధానం ఎంచుకోండి",
    mm_start_practice: "అభ్యాసం ప్రారంభించండి",
    mm_replay_audio: "మళ్లీ వినండి",
    mm_choose_answer: "సరైన సమాధానం ఎంచుకోండి",
    mm_correct: "సరైనది! బాగుంది.",
    mm_wrong: "తప్పు! మళ్లీ ప్రయత్నించండి.",
    mm_practice_another: "మరో ప్రశ్న",
    mm_back: "వెనుకకు",
    mm_home: "హోమ్",
    mm_generating: "మీ ప్రశ్న సిద్ధమవుతోంది...",
    mm_focus_now: "శ్రద్ధగా వినండి",
    mm_intro: "మెంటల్ మ్యాత్ ప్రాక్టీస్ కోసం నిజ జీవిత షాపింగ్ పజిల్స్",
    use_cropped_area: "ఈ భాగాన్ని వాడండి",
    another_problem: "మరో సమస్య",
    hint_label: "ఇదిగో ఒక హింట్",
    audio_hint_label: "వినడానికి Play నొక్కండి",
    audio_unavailable: "ఆడియో అందుబాటులో లేదు — తరువాత ప్రయత్నించండి.",
    no_math_found_title: "మ్యాథ్ సమస్య కనిపించలేదు.",
    no_math_found_desc: "Crop ఏరియాలో సమస్య స్పష్టంగా ఉండనివ్వండి.",
    generating_hint: "హింట్ తయారవుతోంది...",
    generating_solution: "సొల్యూషన్ తయారవుతోంది...",
    generating_summary: "సారాంశం తయారవుతోంది...",
    generating_mcq: "క్విజ్ తయారవుతోంది...",
    language_tagline: "ఒక పాఠం ఫోటో తీయండి — సారాంశం లేదా క్విజ్ పొందండి.",
    lang_summary: "సారాంశం",
    lang_summary_desc: "మీ భాషలో సులభమైన సారాంశం, ఆడియోతో",
    lang_mcq: "క్విజ్",
    lang_mcq_desc: "ఆహ్లాదకరమైన బహుళ ఎంపిక ప్రశ్నలు, తక్షణ ఫీడ్‌బ్యాక్",
    pick_age_group: "మీ వయస్సు సమూహాన్ని ఎంచుకోండి",
    age_6_10: "6–10 సంవత్సరాలు",
    age_10_14: "10–14 సంవత్సరాలు",
    age_14_18: "14–18 సంవత్సరాలు",
    age_18_plus: "18+ సంవత్సరాలు",
    summary_label: "ఇదిగో ఒక చిన్న సారాంశం",
    audio_summary_label: "వినడానికి Play నొక్కండి",
    no_content_title: "ఎటువంటి పాఠం దొరకలేదు.",
    no_content_desc: "కెమెరాను ఒక కథ, పాఠం లేదా వ్యాసం వైపు ఉంచండి.",
    question: "ప్రశ్న",
    multi_select_hint: "ఒకటి కంటే ఎక్కువ సరైన సమాధానాలు ఉండవచ్చు.",
    mcq_submit: "సమాధానం తనిఖీ చేయి",
    mcq_next: "తదుపరి ప్రశ్న",
    mcq_see_score: "నా స్కోర్ చూడు",
    mcq_correct: "సరైనది! 🎉",
    mcq_wrong: "తప్పు. తర్వాతిది ప్రయత్నించు!",
    mcq_correct_feedback: "బాగా చేశావు — అన్నీ సరిగ్గా ఎంచుకున్నావు.",
    mcq_wrong_feedback: "ఆకుపచ్చ ఎంపికలే సరైన సమాధానం.",
    mcq_done_title: "చక్కని ప్రయత్నం!",
    mcq_all_correct: "సంపూర్ణ స్కోర్!",
    your_score: "నీ స్కోర్",
    lang_check_answer: "సమాధాన తనిఖీ",
    lang_check_answer_desc: "రాసిన సమాధాన పత్రిక ఫోటో తీయండి — మార్కులు, సరి/తప్పు & సరైన సమాధానాలు",
    lang_learn_nature: "ప్రకృతి నుండి నేర్చుకో",
    lang_learn_nature_desc: "ప్రకృతి దృశ్యం ఫోటో తీయండి — విజ్ఞానం, జీవితం & మరిన్ని చిన్న పాఠాలు",
    generating_learn_nature: "ప్రకృతి నుండి పాఠాలు వెతుకుతున్నాం...",
    nature_lessons_label: "ప్రకృతి పాఠాలు",
    generating_check_answer: "సమాధానాలు తనిఖీ చేస్తున్నాము...",
    no_paper_found_title: "ప్రశ్నపత్రం కనుగొనబడలేదు.",
    no_paper_found_desc: "విద్యార్థి సమాధానాలు ఉన్న ప్రశ్నపత్రంపై కెమెరా పెట్టండి.",
    lang_speech_mentor: "స్పీచ్ మెంటర్",
    lang_speech_mentor_desc: "బాగా మాట్లాడటానికి సాయపడే స్నేహపూర్వక AI మెంటర్.",
    speech_mentor_tap_to_record: "మైక్ నొక్కి మాట్లాడటం మొదలుపెట్టు",
    speech_mentor_tap_to_stop: "ఆపడానికి నొక్కు",
    speech_mentor_recording: "వింటున్నాను...",
    speech_mentor_analyzing: "మీ ప్రసంగాన్ని విశ్లేషిస్తున్నాను...",
    speech_mentor_your_speech: "మీ ప్రసంగం",
    speech_mentor_mic_denied: "మైక్ అనుమతి నిరాకరించబడింది",
    speech_mentor_mic_unsupported: "ఈ పరికరంలో మైక్ లేదు",
    learn_another: "మరొకటి నేర్చుకో",
    try_another: "మళ్లీ ప్రయత్నించు",
    check_another: "మరొకటి తనిఖీ",
    practice_again: "మళ్లీ సాధన చేయి",
    speech_mentor_play_welcome: "స్వాగతం వినడానికి నొక్కు",
    daily_reflection: "రోజువారీ ఆత్మ చింతన",
    daily_reflection_desc: "అంతర్గత ఎదుగుదల కోసం 1-నిమిష రోజువారీ చెక్-ఇన్",
    dr_start: "మొదలుపెట్టండి",
    dr_loading: "మీ చింతన సిద్ధమవుతోంది...",
    dr_question_of: "ప్రశ్న {n} / {total}",
    dr_your_answer: "మీ సమాధానం",
    dr_best_answer: "ఉత్తమ సమాధానం",
    dr_lesson: "పాఠం",
    dr_growth_score: "నేటి గ్రోత్ స్కోర్",
    dr_encouragement_high: "అద్భుతం! మీరు రోజురోజుకూ ఎదుగుతున్నారు.",
    dr_encouragement_mid: "మంచి ప్రయత్నం! ప్రతి రోజూ కొంత చింతన మనస్సును బలపరుస్తుంది.",
    dr_encouragement_low: "ప్రతి చింతన ఒక ముందడుగు. ఎదుగుతూ ఉండండి!",
    dr_next: "తర్వాత",
    dr_finish: "నా స్కోర్ చూడండి",
    dr_try_again: "మళ్ళీ చింతన",
    dr_listen: "వినండి",
    coloring: "రంగులు వేయడం",
    coloring_desc: "ఏ డ్రాయింగ్‌నైనా కళగా మార్చు — ఆయిల్ పేస్టల్, వాటర్‌కలర్ & మరిన్ని",
    coloring_choose_style: "రంగు శైలిని ఎంచుకోండి",
    coloring_style_oil_pastel: "ఆయిల్ పేస్టల్",
    coloring_style_watercolor: "వాటర్‌కలర్",
    coloring_style_graphite_shade: "పెన్సిల్ షేడ్",
    coloring_style_color_pencil_shade: "రంగుల పెన్సిల్",
    coloring_style_oil_paint: "ఆయిల్ పెయింట్",
    time_master: "టైమ్ మాస్టర్",
    time_master_desc: "ఎంత వేగంగా ముగించాలి? ఆదర్శ సమయంతో పోటీ పడు.",
    time_master_class: "తరగతి",
    time_master_subject: "సబ్జెక్ట్",
    time_master_marks: "మార్కులు",
    time_master_ideal: "ఆదర్శ సమయం",
    time_master_elapsed: "నీ సమయం",
    time_master_start: "టైమర్ మొదలు",
    time_master_stop: "టైమర్ ఆపు",
    time_master_pick_class: "తరగతి ఎంచుకో",
    time_master_pick_subject: "సబ్జెక్ట్ ఎంచుకో",
    time_master_pick_marks: "మార్కులు ఎంచుకో",
    time_master_subj_numerical: "సంఖ్యాత్మక",
    time_master_subj_science: "సైన్స్",
    time_master_subj_technical: "సాంకేతిక",
    time_master_subj_social: "సామాజిక",
    time_master_subj_language: "భాష",
    time_master_subj_other: "ఇతర",
  },
  mr: {
    app_name: "ड्रॉइंग टूल्स",
    tagline: "तुम्हाला चित्र काढण्यास प्रेरित करते!",
    enter_phone: "तुमचा फोन नंबर टाका",
    phone_placeholder: "10 अंकी मोबाइल",
    send_otp: "OTP पाठवा",
    enter_otp: "6 अंकी OTP टाका",
    verify: "पडताळणी करा",
    resend_otp: "OTP पुन्हा पाठवा",
    change_number: "नंबर बदला",
    free_label: "मोफत",
    paid_label: "₹",
    blueprint: "ब्लूप्रिंट",
    blueprint_desc: "आधी रूपरेखा काढा",
    pencil: "पेन्सिल स्केच",
    pencil_desc: "सुंदर पेन्सिल स्केच बनवा",
    story: "माझी गोष्ट",
    story_desc: "एक कॉमिक कथा तयार करा",
    wallet: "वॉलेट",
    recharge_wallet: "वॉलेट रीचार्ज करा",
    recharge_methods: "UPI · कार्ड · नेटबँकिंग · वॉलेट",
    pay_prefix: "पेमेंट करा",
    processing: "प्रक्रिया सुरू आहे…",
    recharge_unavailable: "रीचार्ज सध्या उपलब्ध नाही",
    free_credit_title: "{amount} मोफत क्रेडिट",
    free_credit_desc: "आम्ही तुम्हाला {amount} मोफत वॉलेट क्रेडिट दिले आहे — एका फोन नंबरवर एकदाच.",
    recent_recharges: "अलीकडील रीचार्ज",
    gallery: "गॅलरी",
    take_photo: "फोटो काढा",
    retake: "पुन्हा काढा",
    use_photo: "हा फोटो वापरा",
    generating: "जादू चालू आहे...",
    almost_there: "जवळजवळ झालं!",
    download: "डाउनलोड",
    share: "शेअर",
    share_whatsapp: "व्हॉट्सअ‍ॅप",
    share_email: "ईमेल",
    copy_link: "लिंक कॉपी करा",
    back: "मागे",
    logout: "लॉगआउट",
    your_creations: "तुमच्या निर्मिती",
    no_creations: "अजून काही नाही. चला सुरुवात करूया!",
    insufficient_balance: "बॅलन्स कमी आहे",
    rate_limited: "थोडी विश्रांती घ्या! नंतर पुन्हा प्रयत्न करा.",
    welcome: "स्वागत आहे!",
    home: "होम",
    language: "भाषा",
    balance: "बॅलन्स",
    create: "तयार करा",
    platform_name: "सरल आय",
    platform_tagline: "शिकण्याचा महासागर सोपा करत आहोत",
    module_drawing_title: "ड्रॉइंग टूल्स",
    module_drawing_desc: "काढा, रंगवा आणि कल्पना करा",
    module_language_title: "भाषा टूल्स",
    module_language_desc: "प्रत्येक विषय शिका",
    module_math_title: "गणित टूल्स",
    module_math_desc: "शिका, सोडवा आणि सुधारा",
    mind_master_title: "माइंड मास्टर",
    mind_master_desc: "ध्यान, श्वास आणि शांतता",
    mind_master_audio_start: "ध्वनी सुरू",
    mind_master_audio_stop: "ध्वनी थांबवा",
    mind_master_back: "मागे",
    life_intro_heading: "स्वतःला ओळखण्यासाठी काही क्षण द्या",
    privacy_policy: "गोपनीयता धोरण",
    install_app: "अ‍ॅप इन्स्टॉल करा",
    app_installs: "अ‍ॅप इन्स्टॉल",
    coming_soon: "लवकरच येत आहे",
    open_now: "उघडा",
    make_another: "आणखी एक बनवा",
    upload_from_gallery: "गॅलरीतून अपलोड करा",
    math_tagline: "गणिताचा प्रश्न टिपा — हिंट किंवा संपूर्ण उत्तर मिळवा.",
    math_hint: "हिंट",
    math_hint_desc: "तुमच्या भाषेत सोपा संकेत, ऑडिओसह",
    math_solution: "उत्तर",
    math_solution_desc: "वहीसारखं पूर्ण पायरी-दर-पायरी उत्तर",

    share_confirm_prompt: "तुम्ही व्हॉट्सअॅपवर संदेश शेअर केला का?",
    share_confirm_yes: "होय, केला",
    share_confirm_no: "आत्ता नाही",

    help_a_friend: "मित्राला मदत करा",
    help_a_friend_intro: "शेअर करणे म्हणजे प्रेम — मित्रालाही सोबत शिकायला बोलवा.",
    help_a_friend_msg_greeting: "चला एकत्र शिकूया!",
    help_a_friend_msg_body: "मी अभ्यासासाठी Saral Eye वापरतो. तुम्हीही सामील व्हा:",
    help_a_friend_msg_tagline: "शिका • वाढा • मदत करा",
    share_on_whatsapp: "व्हॉट्सअॅपवर शेअर करा",
    share_helper_line: "प्रत्येक शेअर = एक विद्यार्थ्याला मदत",
    join_sahaj_path: "सहज पाठ मध्ये सामील व्हा",
    sahaj_path_hint: "व्हॉट्सअॅपवर मैत्रीपूर्ण अभ्यास सहाय्य गट",
    level_blaze: "लेव्हल ब्लेझ",
    helped_label: "मदत केली",
    level_student: "विद्यार्थी",
    level_helper: "सहायक",
    level_supporter: "समर्थक",
    level_mentor: "मार्गदर्शक",
    level_champion: "चॅम्पियन",
    progress_line: "तुम्ही {n} विद्यार्थ्यांना मदत केली • {next} होण्यासाठी आणखी {remain}",
    progress_line_top: "तुम्ही {n} जणांना मदत केली. चॅम्पियन — धन्यवाद!",
    helped_toast_progress: "आता {n} जणांना मदत • {next} होण्यासाठी आणखी {remain}",
    helped_toast_simple: "तुम्ही {n} विद्यार्थ्यांना मदत केली. धन्यवाद!",

    share_balance_title: "बॅलन्स शेअर",
    share_balance_desc: "मित्राला काही वॉलेट पैसे पाठवा",
    share_recipient_phone: "प्राप्तकर्त्याचा मोबाईल नंबर",
    share_phone_placeholder: "उदा. 9876543210",
    share_amount: "पाठवायची रक्कम",
    share_send_btn: "पाठवा",
    share_success: "{phone}ला {amount} पाठवले",
    share_recipient_invalid: "वैध मोबाईल नंबर टाका",
    share_invalid_amount: "शून्यापेक्षा जास्त वैध रक्कम टाका",
    share_insufficient_balance: "तुमच्याकडे पुरेसा बॅलन्स नाही",

    hourglass_view: "बालू घड्याळ दृश्य",
    hourglass_exit: "बाहेर पडा",

    colour_guide: "कलर मार्गदर्शक",
    colour_guide_desc: "स्केचवर प्रकाश, सावली आणि रंगक्रम शिका",
    cg_coloring_order: "रंग भरण्याचा क्रम",
    cg_step_1_title: "पार्श्वभूमी",
    cg_step_1_desc: "फिकट रंग, कमी कॉन्ट्रास्ट",
    cg_step_2_title: "दूरच्या वस्तू",
    cg_step_2_desc: "थंड रंग, मऊ कॉन्ट्रास्ट",
    cg_step_3_title: "जमीन",
    cg_step_3_desc: "नैसर्गिक बेस रंग",
    cg_step_4_title: "मुख्य विषय",
    cg_step_4_desc: "गडद रंग, उच्च कॉन्ट्रास्ट",
    cg_step_5_title: "इतर मोठ्या वस्तू",
    cg_step_5_desc: "समतोल मध्यम-टोन",
    cg_step_6_title: "तपशील आणि हायलाइट",
    cg_step_6_desc: "बारीक तपशील, तेजस्वी हायलाइट",
    cg_note_heading: "टीप",
    cg_note_1: "मुख्य विषयाची रूपरेषा लाल आहे.",
    cg_note_2: "निळ्या सावली भागांत गडद रंग वापरा.",

    math_mental: "मेंटल मॅथ",
    math_mental_desc: "खरेदीची गोष्ट ऐका आणि योग्य उत्तर निवडा",
    mm_start_practice: "सराव सुरू करा",
    mm_replay_audio: "पुन्हा ऐका",
    mm_choose_answer: "योग्य उत्तर निवडा",
    mm_correct: "बरोबर! छान.",
    mm_wrong: "चूक! पुन्हा प्रयत्न करा.",
    mm_practice_another: "आणखी एक प्रश्न",
    mm_back: "मागे",
    mm_home: "होम",
    mm_generating: "तुमचा प्रश्न तयार होत आहे...",
    mm_focus_now: "लक्ष देऊन ऐका",
    mm_intro: "मेंटल मॅथ सरावासाठी खरी खरेदीची कोडी",
    use_cropped_area: "हा भाग वापरा",
    another_problem: "नवीन प्रश्न",
    hint_label: "हा बघा एक हिंट",
    audio_hint_label: "ऐकण्यासाठी Play दाबा",
    audio_unavailable: "ऑडिओ उपलब्ध नाही — नंतर प्रयत्न करा.",
    no_math_found_title: "गणिताचा प्रश्न सापडला नाही.",
    no_math_found_desc: "Crop भागात प्रश्न स्पष्ट ठेवा.",
    generating_hint: "हिंट तयार होत आहे...",
    generating_solution: "उत्तर तयार होत आहे...",
    generating_summary: "सारांश तयार होत आहे...",
    generating_mcq: "क्विझ तयार होत आहे...",
    language_tagline: "एखादा परिच्छेद टिपा — सारांश किंवा क्विझ मिळवा.",
    lang_summary: "सारांश",
    lang_summary_desc: "तुमच्या भाषेत सोपा सारांश, ऑडिओसह",
    lang_mcq: "क्विझ",
    lang_mcq_desc: "मजेशीर बहुपर्यायी प्रश्न, झटपट प्रतिसाद",
    pick_age_group: "तुमचा वयोगट निवडा",
    age_6_10: "6–10 वर्षे",
    age_10_14: "10–14 वर्षे",
    age_14_18: "14–18 वर्षे",
    age_18_plus: "18+ वर्षे",
    summary_label: "हा बघा एक छोटा सारांश",
    audio_summary_label: "ऐकण्यासाठी Play दाबा",
    no_content_title: "कोणताही परिच्छेद सापडला नाही.",
    no_content_desc: "कॅमेरा एखाद्या गोष्ट, पाठ किंवा परिच्छेदावर ठेवा.",
    question: "प्रश्न",
    multi_select_hint: "एकापेक्षा जास्त उत्तरे योग्य असू शकतात.",
    mcq_submit: "उत्तर तपासा",
    mcq_next: "पुढील प्रश्न",
    mcq_see_score: "माझा स्कोअर पाहा",
    mcq_correct: "बरोबर! 🎉",
    mcq_wrong: "बरोबर नाही. पुढील प्रयत्न करा!",
    mcq_correct_feedback: "छान — सर्व बरोबर निवडले.",
    mcq_wrong_feedback: "हिरव्या रंगातील पर्याय हे योग्य उत्तर आहे.",
    mcq_done_title: "उत्तम प्रयत्न!",
    mcq_all_correct: "पूर्ण स्कोअर!",
    your_score: "तुझा स्कोअर",
    lang_check_answer: "उत्तर तपासणी",
    lang_check_answer_desc: "लिहिलेल्या उत्तरपत्रिकेचा फोटो घ्या — गुण, बरोबर/चूक व आदर्श उत्तरे मिळवा",
    lang_learn_nature: "निसर्गातून शिका",
    lang_learn_nature_desc: "निसर्गाचा फोटो घ्या — विज्ञान, जीवन आणि आणखी छोटे धडे मिळवा",
    generating_learn_nature: "निसर्गातून धडे शोधत आहोत...",
    nature_lessons_label: "निसर्गातील धडे",
    generating_check_answer: "उत्तरे तपासत आहोत...",
    no_paper_found_title: "प्रश्नपत्रिका सापडली नाही.",
    no_paper_found_desc: "कॅमेरा विद्यार्थ्याची उत्तरे असलेल्या प्रश्नपत्रिकेवर ठेवा.",
    lang_speech_mentor: "स्पीच मेंटर",
    lang_speech_mentor_desc: "छान बोलण्यास मदत करणारा मैत्रीपूर्ण AI मार्गदर्शक.",
    speech_mentor_tap_to_record: "माइक टॅप कर आणि बोलायला सुरुवात कर",
    speech_mentor_tap_to_stop: "थांबण्यासाठी टॅप कर",
    speech_mentor_recording: "ऐकतोय...",
    speech_mentor_analyzing: "तुझ्या बोलण्याचे विश्लेषण करतोय...",
    speech_mentor_your_speech: "तुझं बोलणं",
    speech_mentor_mic_denied: "माइकची परवानगी नाकारली",
    speech_mentor_mic_unsupported: "या डिव्हाइसवर माइक नाही",
    learn_another: "आणखी शिका",
    try_another: "पुन्हा प्रयत्न",
    check_another: "आणखी तपासा",
    practice_again: "पुन्हा सराव करा",
    speech_mentor_play_welcome: "स्वागत ऐकण्यासाठी टॅप कर",
    daily_reflection: "रोजची चिंतन",
    daily_reflection_desc: "आतल्या वाढीसाठी १ मिनिटाचे रोजचे चिंतन",
    dr_start: "सुरू करा",
    dr_loading: "तुमचे चिंतन तयार होत आहे...",
    dr_question_of: "प्रश्न {n} / {total}",
    dr_your_answer: "तुमचे उत्तर",
    dr_best_answer: "उत्तम उत्तर",
    dr_lesson: "धडा",
    dr_growth_score: "आजचा ग्रोथ स्कोर",
    dr_encouragement_high: "छान! तुम्ही रोज पुढे जात आहात.",
    dr_encouragement_mid: "चांगला प्रयत्न! रोज थोडे चिंतन मन बळकट करते.",
    dr_encouragement_low: "प्रत्येक चिंतन एक पाऊल पुढे. वाढत रहा!",
    dr_next: "पुढे",
    dr_finish: "माझा स्कोर पहा",
    dr_try_again: "पुन्हा चिंतन",
    dr_listen: "ऐका",
    coloring: "रंगकाम",
    coloring_desc: "कोणतेही चित्र कलाकृती बनवा — ऑयल पेस्टल, वॉटरकलर व अधिक",
    coloring_choose_style: "रंग शैली निवडा",
    coloring_style_oil_pastel: "ऑयल पेस्टल",
    coloring_style_watercolor: "वॉटरकलर",
    coloring_style_graphite_shade: "पेन्सिल छाया",
    coloring_style_color_pencil_shade: "रंगीत पेन्सिल",
    coloring_style_oil_paint: "तैल चित्र",
    time_master: "वेळ मास्टर",
    time_master_desc: "किती लवकर पूर्ण करशील? आदर्श वेळेशी शर्यत लाव.",
    time_master_class: "इयत्ता",
    time_master_subject: "विषय",
    time_master_marks: "गुण",
    time_master_ideal: "आदर्श वेळ",
    time_master_elapsed: "तुझा वेळ",
    time_master_start: "टाइमर सुरू",
    time_master_stop: "टाइमर बंद",
    time_master_pick_class: "इयत्ता निवडा",
    time_master_pick_subject: "विषय निवडा",
    time_master_pick_marks: "गुण निवडा",
    time_master_subj_numerical: "संख्यात्मक",
    time_master_subj_science: "विज्ञान",
    time_master_subj_technical: "तांत्रिक",
    time_master_subj_social: "सामाजिक",
    time_master_subj_language: "भाषा",
    time_master_subj_other: "इतर",
  },
  gu: {
    app_name: "ડ્રોઇંગ ટૂલ્સ",
    tagline: "તમને ચિત્ર બનાવવા પ્રેરિત કરે છે!",
    enter_phone: "તમારો ફોન નંબર દાખલ કરો",
    phone_placeholder: "10 અંકનો મોબાઇલ",
    send_otp: "OTP મોકલો",
    enter_otp: "6 અંકનો OTP દાખલ કરો",
    verify: "ચકાસો અને લોગિન",
    resend_otp: "OTP ફરી મોકલો",
    change_number: "નંબર બદલો",
    free_label: "મફત",
    paid_label: "₹",
    blueprint: "બ્લુપ્રિન્ટ",
    blueprint_desc: "પહેલા રૂપરેખા બનાવો",
    pencil: "પેન્સિલ સ્કેચ",
    pencil_desc: "સુંદર પેન્સિલ સ્કેચ બનાવો",
    story: "મારી વાર્તા",
    story_desc: "એક કૉમિક વાર્તા બનાવો",
    wallet: "વોલેટ",
    recharge_wallet: "વૉલેટ રીચાર્જ કરો",
    recharge_methods: "UPI · કાર્ડ · નેટબેન્કિંગ · વૉલેટ",
    pay_prefix: "ચૂકવો",
    processing: "પ્રક્રિયા થઈ રહી છે…",
    recharge_unavailable: "રીચાર્જ હાલમાં ઉપલબ્ધ નથી",
    free_credit_title: "{amount} મફત ક્રેડિટ",
    free_credit_desc: "અમે તમને {amount} મફત વૉલેટ ક્રેડિટ આપ્યું છે — એક ફોન નંબર પર એકવાર.",
    recent_recharges: "તાજેતરના રીચાર્જ",
    gallery: "ગેલેરી",
    take_photo: "ફોટો લો",
    retake: "ફરી લો",
    use_photo: "આ ફોટો વાપરો",
    generating: "જાદુ થઈ રહ્યો છે...",
    almost_there: "લગભગ થઈ ગયું!",
    download: "ડાઉનલોડ",
    share: "શેર",
    share_whatsapp: "વોટ્સએપ",
    share_email: "ઇમેઇલ",
    copy_link: "લિંક કોપી કરો",
    back: "પાછા",
    logout: "લોગઆઉટ",
    your_creations: "તમારી રચનાઓ",
    no_creations: "હજુ સુધી કંઈ નથી. ચાલો શરૂ કરીએ!",
    insufficient_balance: "બેલેન્સ ઓછું છે",
    rate_limited: "થોડો આરામ કરો! પછી ફરી પ્રયાસ કરો.",
    welcome: "સ્વાગત છે!",
    home: "હોમ",
    language: "ભાષા",
    balance: "બેલેન્સ",
    create: "બનાવો",
    platform_name: "સરલ આઇ",
    platform_tagline: "શીખવાના મહાસાગરને સરળ બનાવીએ છીએ",
    module_drawing_title: "ડ્રોઇંગ ટૂલ્સ",
    module_drawing_desc: "દોરો, રંગ કરો અને કલ્પના કરો",
    module_language_title: "ભાષા ટૂલ્સ",
    module_language_desc: "દરેક વિષય શીખો",
    module_math_title: "ગણિત ટૂલ્સ",
    module_math_desc: "શીખો, ઉકેલો અને સુધારો",
    mind_master_title: "માઇન્ડ માસ્ટર",
    mind_master_desc: "ધ્યાન, શ્વાસ અને શાંતિ",
    mind_master_audio_start: "ધ્વનિ ચલાવો",
    mind_master_audio_stop: "ધ્વનિ રોકો",
    mind_master_back: "પાછળ",
    life_intro_heading: "પોતાને ઓળખવા થોડી ક્ષણો આપો",
    privacy_policy: "ગોપનીયતા નીતિ",
    install_app: "એપ ઇન્સ્ટોલ કરો",
    app_installs: "એપ ઇન્સ્ટોલ",
    coming_soon: "જલ્દી આવી રહ્યું છે",
    open_now: "ખોલો",
    make_another: "બીજું બનાવો",
    upload_from_gallery: "ગેલેરીમાંથી અપલોડ કરો",
    math_tagline: "ગણિતનો સવાલ ફોટો કરો — હિન્ટ કે પૂરો ઉકેલ મેળવો.",
    math_hint: "હિન્ટ",
    math_hint_desc: "તમારી ભાષામાં સરળ ઈશારો, ઑડિઓ સાથે",
    math_solution: "ઉકેલ",
    math_solution_desc: "નોટબુક જેવો સંપૂર્ણ પગલા-દર-પગલા ઉકેલ",

    share_confirm_prompt: "શું તમે વૉટ્સએપ પર સંદેશ શેર કર્યો?",
    share_confirm_yes: "હા, શેર કર્યો",
    share_confirm_no: "હજુ નહીં",

    help_a_friend: "મિત્રને મદદ કરો",
    help_a_friend_intro: "શેર કરવું એટલે કાળજી — મિત્રને પણ ભણવા બોલાવો.",
    help_a_friend_msg_greeting: "ચાલો સાથે શીખીએ!",
    help_a_friend_msg_body: "હું ભણવા માટે Saral Eye વાપરું છું. તમે પણ જોડાઓ:",
    help_a_friend_msg_tagline: "શીખો • વધો • મદદ કરો",
    share_on_whatsapp: "વૉટ્સએપ પર શેર કરો",
    share_helper_line: "દરેક શેર = એક વિદ્યાર્થીને મદદ",
    join_sahaj_path: "સહજ પાઠમાં જોડાઓ",
    sahaj_path_hint: "વૉટ્સએપ પર મૈત્રીપૂર્ણ અભ્યાસ સહાય જૂથ",
    level_blaze: "લેવલ બ્લેઝ",
    helped_label: "મદદ કરી",
    level_student: "વિદ્યાર્થી",
    level_helper: "સહાયક",
    level_supporter: "સમર્થક",
    level_mentor: "માર્ગદર્શક",
    level_champion: "ચેમ્પિયન",
    progress_line: "તમે {n} વિદ્યાર્થીઓને મદદ કરી • {next} બનવા વધુ {remain}",
    progress_line_top: "તમે {n}ને મદદ કરી. ચેમ્પિયન — આભાર!",
    helped_toast_progress: "હવે {n}ને મદદ • {next} બનવા વધુ {remain}",
    helped_toast_simple: "તમે {n} વિદ્યાર્થીઓને મદદ કરી. આભાર!",

    share_balance_title: "બેલેન્સ શેર",
    share_balance_desc: "મિત્રને થોડું વૉલેટ મની મોકલો",
    share_recipient_phone: "પ્રાપ્તકર્તાનો મોબાઇલ નંબર",
    share_phone_placeholder: "દા.ત. 9876543210",
    share_amount: "શેર કરવાની રકમ",
    share_send_btn: "મોકલો",
    share_success: "{phone}ને {amount} મોકલવામાં આવ્યા",
    share_recipient_invalid: "માન્ય મોબાઇલ નંબર દાખલ કરો",
    share_invalid_amount: "શૂન્યથી વધુ માન્ય રકમ દાખલ કરો",
    share_insufficient_balance: "તમારી પાસે પૂરતું બેલેન્સ નથી",

    hourglass_view: "રેતી ઘડિયાળ દૃશ્ય",
    hourglass_exit: "બહાર નીકળો",

    colour_guide: "કલર ગાઈડ",
    colour_guide_desc: "તમારા સ્કેચ પર પ્રકાશ, છાયા અને રંગ ક્રમ શીખો",
    cg_coloring_order: "રંગ ભરવાનો ક્રમ",
    cg_step_1_title: "પૃષ્ઠભૂમિ",
    cg_step_1_desc: "હળવા રંગ, ઓછો કોન્ટ્રાસ્ટ",
    cg_step_2_title: "દૂરની વસ્તુઓ",
    cg_step_2_desc: "ઠંડા રંગ, નરમ કોન્ટ્રાસ્ટ",
    cg_step_3_title: "જમીન",
    cg_step_3_desc: "કુદરતી બેઝ રંગ",
    cg_step_4_title: "મુખ્ય વિષય",
    cg_step_4_desc: "ઘાટા રંગ, ઉચ્ચ કોન્ટ્રાસ્ટ",
    cg_step_5_title: "અન્ય મોટી વસ્તુઓ",
    cg_step_5_desc: "સંતુલિત મધ્યમ ટોન",
    cg_step_6_title: "વિગત અને હાઈલાઈટ",
    cg_step_6_desc: "સૂક્ષ્મ વિગત, તેજસ્વી હાઈલાઈટ",
    cg_note_heading: "નોંધ",
    cg_note_1: "મુખ્ય વિષય લાલ રંગમાં આઉટલાઈન છે.",
    cg_note_2: "વાદળી છાયા વિસ્તારોમાં ઘાટા શેડ વાપરો.",

    math_mental: "મેન્ટલ મેથ",
    math_mental_desc: "ખરીદીની વાર્તા સાંભળો અને સાચો જવાબ પસંદ કરો",
    mm_start_practice: "અભ્યાસ શરૂ કરો",
    mm_replay_audio: "ફરીથી સાંભળો",
    mm_choose_answer: "સાચો જવાબ પસંદ કરો",
    mm_correct: "સાચું! સરસ.",
    mm_wrong: "ખોટું! ફરી પ્રયત્ન કરો.",
    mm_practice_another: "બીજો પ્રશ્ન",
    mm_back: "પાછળ",
    mm_home: "હોમ",
    mm_generating: "તમારો પ્રશ્ન તૈયાર થાય છે...",
    mm_focus_now: "ધ્યાનથી સાંભળો",
    mm_intro: "મેન્ટલ મેથ પ્રેક્ટિસ માટે વાસ્તવિક ખરીદીના કોયડા",
    use_cropped_area: "આ ભાગ વાપરો",
    another_problem: "બીજો સવાલ",
    hint_label: "આ રહ્યો એક હિન્ટ",
    audio_hint_label: "સાંભળવા માટે Play દબાવો",
    audio_unavailable: "ઑડિઓ ઉપલબ્ધ નથી — પછી ફરી પ્રયત્ન કરો.",
    no_math_found_title: "ગણિતનો સવાલ મળ્યો નથી.",
    no_math_found_desc: "Crop વિસ્તારમાં સવાલ સ્પષ્ટ રાખો.",
    generating_hint: "હિન્ટ બની રહ્યો છે...",
    generating_solution: "ઉકેલ બની રહ્યો છે...",
    generating_summary: "સારાંશ બની રહ્યો છે...",
    generating_mcq: "ક્વિઝ બની રહી છે...",
    language_tagline: "પેસેજનો ફોટો કરો — સારાંશ કે ક્વિઝ મેળવો.",
    lang_summary: "સારાંશ",
    lang_summary_desc: "તમારી ભાષામાં સરળ સારાંશ, ઑડિઓ સાથે",
    lang_mcq: "ક્વિઝ",
    lang_mcq_desc: "મજેદાર બહુ-પસંદગીના પ્રશ્નો, તરત જ પ્રતિસાદ",
    pick_age_group: "તમારી વય જૂથ પસંદ કરો",
    age_6_10: "6–10 વર્ષ",
    age_10_14: "10–14 વર્ષ",
    age_14_18: "14–18 વર્ષ",
    age_18_plus: "18+ વર્ષ",
    summary_label: "આ રહ્યો એક નાનો સારાંશ",
    audio_summary_label: "સાંભળવા Play દબાવો",
    no_content_title: "કોઈ પેસેજ મળ્યો નથી.",
    no_content_desc: "કેમેરા વાર્તા, પાઠ કે પેસેજ પર રાખો.",
    question: "પ્રશ્ન",
    multi_select_hint: "એક કરતાં વધુ જવાબ સાચા હોઈ શકે.",
    mcq_submit: "જવાબ તપાસો",
    mcq_next: "આગળનો પ્રશ્ન",
    mcq_see_score: "મારો સ્કોર જુઓ",
    mcq_correct: "સાચું! 🎉",
    mcq_wrong: "આ વખતે નહીં. આગળ પ્રયત્ન કરો!",
    mcq_correct_feedback: "વાહ — બધા સાચા જવાબ આપ્યા.",
    mcq_wrong_feedback: "લીલા વિકલ્પો જ સાચા જવાબ છે.",
    mcq_done_title: "સરસ પ્રયત્ન!",
    mcq_all_correct: "પૂરા સ્કોર!",
    your_score: "તારો સ્કોર",
    lang_check_answer: "જવાબ તપાસ",
    lang_check_answer_desc: "લખેલી ઉત્તરપત્રિકાનો ફોટો લો — ગુણ, સાચું/ખોટું અને આદર્શ જવાબો મેળવો",
    lang_learn_nature: "પ્રકૃતિ પાસેથી શીખો",
    lang_learn_nature_desc: "પ્રકૃતિનો ફોટો લો — વિજ્ઞાન, જીવન અને બીજા વિષયોના નાના પાઠ મેળવો",
    generating_learn_nature: "પ્રકૃતિમાંથી પાઠ શોધીએ છીએ...",
    nature_lessons_label: "પ્રકૃતિમાંથી પાઠ",
    generating_check_answer: "જવાબ તપાસી રહ્યા છીએ...",
    no_paper_found_title: "પ્રશ્નપત્ર મળ્યું નથી.",
    no_paper_found_desc: "વિદ્યાર્થીના જવાબો સાથેના પ્રશ્નપત્ર પર કેમેરા રાખો.",
    lang_speech_mentor: "સ્પીચ મેન્ટર",
    lang_speech_mentor_desc: "સારું બોલવામાં મદદ કરતો મૈત્રીપૂર્ણ AI માર્ગદર્શક.",
    speech_mentor_tap_to_record: "માઈક ટૅપ કરી બોલવાનું શરૂ કરો",
    speech_mentor_tap_to_stop: "રોકવા માટે ટૅપ કરો",
    speech_mentor_recording: "સાંભળી રહ્યાં છીએ...",
    speech_mentor_analyzing: "તમારી વાત તપાસી રહ્યાં છીએ...",
    speech_mentor_your_speech: "તમારી વાત",
    speech_mentor_mic_denied: "માઈકની પરવાનગી નકારાયી",
    speech_mentor_mic_unsupported: "આ ડિવાઇસ પર માઈક ઉપલબ્ધ નથી",
    learn_another: "બીજું શીખો",
    try_another: "ફરી પ્રયત્ન",
    check_another: "બીજું તપાસો",
    practice_again: "ફરી અભ્યાસ કરો",
    speech_mentor_play_welcome: "સ્વાગત સાંભળવા ટૅપ કરો",
    daily_reflection: "રોજિંદું ચિંતન",
    daily_reflection_desc: "અંતરની વૃદ્ધિ માટે 1-મિનિટનું રોજિંદું ચેક-ઇન",
    dr_start: "શરૂ કરો",
    dr_loading: "તમારું ચિંતન તૈયાર થઈ રહ્યું છે...",
    dr_question_of: "પ્રશ્ન {n} / {total}",
    dr_your_answer: "તમારો જવાબ",
    dr_best_answer: "શ્રેષ્ઠ જવાબ",
    dr_lesson: "પાઠ",
    dr_growth_score: "આજનો ગ્રોથ સ્કોર",
    dr_encouragement_high: "શાનદાર! તમે રોજ આગળ વધી રહ્યા છો.",
    dr_encouragement_mid: "સારો પ્રયાસ! રોજ થોડું ચિંતન મનને મજબૂત બનાવે છે.",
    dr_encouragement_low: "દરેક ચિંતન એક પગલું આગળ છે. વૃદ્ધિ ચાલુ રાખો!",
    dr_next: "આગળ",
    dr_finish: "મારો સ્કોર જુઓ",
    dr_try_again: "ફરી ચિંતન",
    dr_listen: "સાંભળો",
    coloring: "રંગ ભરવો",
    coloring_desc: "કોઈપણ ચિત્રને કળામાં ફેરવો — ઓઇલ પેસ્ટલ, વોટરકલર અને વધુ",
    coloring_choose_style: "રંગ શૈલી પસંદ કરો",
    coloring_style_oil_pastel: "ઓઇલ પેસ્ટલ",
    coloring_style_watercolor: "વોટરકલર",
    coloring_style_graphite_shade: "પેન્સિલ છાયા",
    coloring_style_color_pencil_shade: "રંગીન પેન્સિલ",
    coloring_style_oil_paint: "તૈલ ચિત્ર",
    time_master: "ટાઈમ માસ્ટર",
    time_master_desc: "કેટલી ઝડપી પૂરું કરી શકે? આદર્શ સમય સાથે સ્પર્ધા કર.",
    time_master_class: "ધોરણ",
    time_master_subject: "વિષય",
    time_master_marks: "ગુણ",
    time_master_ideal: "આદર્શ સમય",
    time_master_elapsed: "તારો સમય",
    time_master_start: "ટાઈમર શરૂ",
    time_master_stop: "ટાઈમર બંધ",
    time_master_pick_class: "ધોરણ પસંદ કરો",
    time_master_pick_subject: "વિષય પસંદ કરો",
    time_master_pick_marks: "ગુણ પસંદ કરો",
    time_master_subj_numerical: "સંખ્યાત્મક",
    time_master_subj_science: "વિજ્ઞાન",
    time_master_subj_technical: "તકનીકી",
    time_master_subj_social: "સામાજિક",
    time_master_subj_language: "ભાષા",
    time_master_subj_other: "અન્ય",
  },
  kn: {
    app_name: "ಡ್ರಾಯಿಂಗ್ ಟೂಲ್ಸ್",
    tagline: "ಚಿತ್ರ ಬಿಡಿಸಲು ಪ್ರೇರೇಪಿಸುತ್ತದೆ!",
    enter_phone: "ನಿಮ್ಮ ಫೋನ್ ಸಂಖ್ಯೆ ನಮೂದಿಸಿ",
    phone_placeholder: "10 ಅಂಕಿಯ ಮೊಬೈಲ್",
    send_otp: "OTP ಕಳುಹಿಸಿ",
    enter_otp: "6 ಅಂಕಿಯ OTP ನಮೂದಿಸಿ",
    verify: "ಪರಿಶೀಲಿಸಿ ಲಾಗಿನ್",
    resend_otp: "OTP ಮತ್ತೆ ಕಳುಹಿಸಿ",
    change_number: "ಸಂಖ್ಯೆ ಬದಲಾಯಿಸಿ",
    free_label: "ಉಚಿತ",
    paid_label: "₹",
    blueprint: "ಬ್ಲೂಪ್ರಿಂಟ್",
    blueprint_desc: "ಮೊದಲು ರೂಪರೇಖೆ ರಚಿಸಿ",
    pencil: "ಪೆನ್ಸಿಲ್ ಸ್ಕೆಚ್",
    pencil_desc: "ಸುಂದರವಾದ ಪೆನ್ಸಿಲ್ ಸ್ಕೆಚ್ ಮಾಡಿ",
    story: "ನನ್ನ ಕಥೆ",
    story_desc: "ಒಂದು ಕಾಮಿಕ್ ಕಥೆಯನ್ನು ರಚಿಸಿ",
    wallet: "ವಾಲೆಟ್",
    recharge_wallet: "ವಾಲೆಟ್ ರೀಚಾರ್ಜ್ ಮಾಡಿ",
    recharge_methods: "UPI · ಕಾರ್ಡ್ · ನೆಟ್‌ಬ್ಯಾಂಕಿಂಗ್ · ವಾಲೆಟ್",
    pay_prefix: "ಪಾವತಿಸಿ",
    processing: "ಪ್ರಕ್ರಿಯೆಗೊಳಿಸಲಾಗುತ್ತಿದೆ…",
    recharge_unavailable: "ರೀಚಾರ್ಜ್ ಪ್ರಸ್ತುತ ಲಭ್ಯವಿಲ್ಲ",
    free_credit_title: "{amount} ಉಚಿತ ಕ್ರೆಡಿಟ್",
    free_credit_desc: "ನಾವು ನಿಮಗೆ {amount} ಉಚಿತ ವಾಲೆಟ್ ಕ್ರೆಡಿಟ್ ನೀಡಿದ್ದೇವೆ — ಪ್ರತಿ ಫೋನ್ ಸಂಖ್ಯೆಗೆ ಒಮ್ಮೆ.",
    recent_recharges: "ಇತ್ತೀಚಿನ ರೀಚಾರ್ಜ್‌ಗಳು",
    gallery: "ಗ್ಯಾಲರಿ",
    take_photo: "ಫೋಟೋ ತೆಗೆಯಿರಿ",
    retake: "ಮತ್ತೆ ತೆಗೆಯಿರಿ",
    use_photo: "ಈ ಫೋಟೋ ಬಳಸಿ",
    generating: "ಮಂತ್ರ ಕೆಲಸ ಮಾಡುತ್ತಿದೆ...",
    almost_there: "ಬಹುತೇಕ ಮುಗಿಯಿತು!",
    download: "ಡೌನ್‌ಲೋಡ್",
    share: "ಹಂಚಿಕೊಳ್ಳಿ",
    share_whatsapp: "ವಾಟ್ಸಾಪ್",
    share_email: "ಇಮೇಲ್",
    copy_link: "ಲಿಂಕ್ ನಕಲಿಸಿ",
    back: "ಹಿಂದೆ",
    logout: "ಲಾಗ್‌ಔಟ್",
    your_creations: "ನಿಮ್ಮ ಸೃಷ್ಟಿಗಳು",
    no_creations: "ಇನ್ನೂ ಯಾವುದೂ ಇಲ್ಲ. ಪ್ರಾರಂಭಿಸೋಣ!",
    insufficient_balance: "ಸಾಕಷ್ಟು ಬ್ಯಾಲೆನ್ಸ್ ಇಲ್ಲ",
    rate_limited: "ಸ್ವಲ್ಪ ವಿಶ್ರಾಂತಿ ತೆಗೆದುಕೊಳ್ಳಿ! ನಂತರ ಪ್ರಯತ್ನಿಸಿ.",
    welcome: "ಸ್ವಾಗತ!",
    home: "ಮುಖಪುಟ",
    language: "ಭಾಷೆ",
    balance: "ಬ್ಯಾಲೆನ್ಸ್",
    create: "ರಚಿಸಿ",
    platform_name: "ಸರಳ್ ಐ",
    platform_tagline: "ಕಲಿಕೆಯ ಸಾಗರವನ್ನು ಸರಳಗೊಳಿಸುತ್ತಿದ್ದೇವೆ",
    module_drawing_title: "ಡ್ರಾಯಿಂಗ್ ಟೂಲ್ಸ್",
    module_drawing_desc: "ಬಿಡಿಸಿ, ಬಣ್ಣಬಳಿಯಿರಿ ಮತ್ತು ಕಲ್ಪಿಸಿ",
    module_language_title: "ಭಾಷಾ ಟೂಲ್ಸ್",
    module_language_desc: "ಎಲ್ಲಾ ವಿಷಯಗಳನ್ನೂ ಕಲಿಯಿರಿ",
    module_math_title: "ಗಣಿತ ಟೂಲ್ಸ್",
    module_math_desc: "ಕಲಿಯಿರಿ, ಪರಿಹರಿಸಿ ಮತ್ತು ಉತ್ತಮಗೊಳ್ಳಿ",
    mind_master_title: "ಮೈಂಡ್ ಮಾಸ್ಟರ್",
    mind_master_desc: "ಧ್ಯಾನ, ಉಸಿರು ಮತ್ತು ಶಾಂತಿ",
    mind_master_audio_start: "ಧ್ವನಿ ಪ್ಲೇ",
    mind_master_audio_stop: "ಧ್ವನಿ ನಿಲ್ಲಿಸಿ",
    mind_master_back: "ಹಿಂದೆ",
    life_intro_heading: "ನಿಮ್ಮನ್ನು ಅರಿತುಕೊಳ್ಳಲು ಕೆಲವು ಕ್ಷಣಗಳನ್ನು ಕೊಡಿ",
    privacy_policy: "ಗೌಪ್ಯತಾ ನೀತಿ",
    install_app: "ಆ್ಯಪ್ ಇನ್‌ಸ್ಟಾಲ್ ಮಾಡಿ",
    app_installs: "ಆ್ಯಪ್ ಇನ್‌ಸ್ಟಾಲ್‌ಗಳು",
    coming_soon: "ಶೀಘ್ರದಲ್ಲೇ ಬರಲಿದೆ",
    open_now: "ತೆರೆಯಿರಿ",
    make_another: "ಮತ್ತೊಂದು ಮಾಡಿ",
    upload_from_gallery: "ಗ್ಯಾಲರಿಯಿಂದ ಅಪ್‌ಲೋಡ್ ಮಾಡಿ",
    math_tagline: "ಗಣಿತ ಸಮಸ್ಯೆಯ ಫೋಟೋ ತೆಗೆ — ಸುಳಿವು ಅಥವಾ ಪೂರ್ಣ ಪರಿಹಾರ ಪಡೆ.",
    math_hint: "ಸುಳಿವು",
    math_hint_desc: "ನಿಮ್ಮ ಭಾಷೆಯಲ್ಲಿ ಸುಲಭ ಸುಳಿವು, ಆಡಿಯೋ ಸಹಿತ",
    math_solution: "ಪರಿಹಾರ",
    math_solution_desc: "ನೋಟ್‌ಬುಕ್ ಶೈಲಿಯ ಸಂಪೂರ್ಣ ಹಂತ-ಹಂತದ ಉತ್ತರ",

    share_confirm_prompt: "ವಾಟ್ಸ್‌ಆಪ್‌ನಲ್ಲಿ ಸಂದೇಶ ಹಂಚಿಕೊಂಡಿದ್ದೀರಾ?",
    share_confirm_yes: "ಹೌದು, ಹಂಚಿದೆ",
    share_confirm_no: "ಇನ್ನೂ ಇಲ್ಲ",

    help_a_friend: "ಸ್ನೇಹಿತರಿಗೆ ಸಹಾಯ",
    help_a_friend_intro: "ಹಂಚಿಕೊಳ್ಳುವುದೇ ಪ್ರೀತಿ — ಸ್ನೇಹಿತರನ್ನೂ ಕಲಿಯಲು ಕರೆಯಿರಿ.",
    help_a_friend_msg_greeting: "ನಾವು ಒಟ್ಟಿಗೆ ಕಲಿಯೋಣ!",
    help_a_friend_msg_body: "ನಾನು ಅಧ್ಯಯನಕ್ಕೆ Saral Eye ಬಳಸುತ್ತಿದ್ದೇನೆ. ನೀವೂ ಸೇರಿ:",
    help_a_friend_msg_tagline: "ಕಲಿ • ಬೆಳೆ • ಸಹಾಯ",
    share_on_whatsapp: "ವಾಟ್ಸ್‌ಆಪ್‌ನಲ್ಲಿ ಹಂಚಿ",
    share_helper_line: "ಪ್ರತಿ ಹಂಚಿಕೆ = ಒಬ್ಬ ವಿದ್ಯಾರ್ಥಿಗೆ ಸಹಾಯ",
    join_sahaj_path: "ಸಹಜ ಪಾಠ ಸೇರಿ",
    sahaj_path_hint: "ವಾಟ್ಸ್‌ಆಪ್‌ನಲ್ಲಿ ಸ್ನೇಹಪೂರ್ವಕ ಅಧ್ಯಯನ ಬೆಂಬಲ ಗುಂಪು",
    level_blaze: "ಲೆವೆಲ್ ಬ್ಲೇಜ್",
    helped_label: "ಸಹಾಯ",
    level_student: "ವಿದ್ಯಾರ್ಥಿ",
    level_helper: "ಸಹಾಯಕ",
    level_supporter: "ಬೆಂಬಲಿಗ",
    level_mentor: "ಮಾರ್ಗದರ್ಶಿ",
    level_champion: "ಚಾಂಪಿಯನ್",
    progress_line: "ನೀವು {n} ವಿದ್ಯಾರ್ಥಿಗಳಿಗೆ ಸಹಾಯ ಮಾಡಿದ್ದೀರಿ • {next} ಆಗಲು ಇನ್ನೂ {remain}",
    progress_line_top: "ನೀವು {n} ಮಂದಿಗೆ ಸಹಾಯ ಮಾಡಿದ್ದೀರಿ. ಚಾಂಪಿಯನ್ — ಧನ್ಯವಾದಗಳು!",
    helped_toast_progress: "ಈಗ {n} ಮಂದಿಗೆ ಸಹಾಯ • {next} ಆಗಲು ಇನ್ನೂ {remain}",
    helped_toast_simple: "ನೀವು {n} ವಿದ್ಯಾರ್ಥಿಗಳಿಗೆ ಸಹಾಯ ಮಾಡಿದ್ದೀರಿ. ಧನ್ಯವಾದಗಳು!",

    share_balance_title: "ಬ್ಯಾಲೆನ್ಸ್ ಹಂಚಿಕೊಳ್ಳಿ",
    share_balance_desc: "ಸ್ನೇಹಿತರಿಗೆ ಸ್ವಲ್ಪ ವಾಲೆಟ್ ಹಣ ಕಳುಹಿಸಿ",
    share_recipient_phone: "ಸ್ವೀಕರಿಸುವವರ ಮೊಬೈಲ್ ಸಂಖ್ಯೆ",
    share_phone_placeholder: "ಉದಾ. 9876543210",
    share_amount: "ಹಂಚಿಕೊಳ್ಳುವ ಮೊತ್ತ",
    share_send_btn: "ಕಳುಹಿಸಿ",
    share_success: "{phone}ಗೆ {amount} ಕಳುಹಿಸಲಾಗಿದೆ",
    share_recipient_invalid: "ಮಾನ್ಯ ಮೊಬೈಲ್ ಸಂಖ್ಯೆ ನಮೂದಿಸಿ",
    share_invalid_amount: "ಶೂನ್ಯಕ್ಕಿಂತ ಹೆಚ್ಚಿನ ಮಾನ್ಯ ಮೊತ್ತ ನಮೂದಿಸಿ",
    share_insufficient_balance: "ನಿಮ್ಮಲ್ಲಿ ಸಾಕಷ್ಟು ಬ್ಯಾಲೆನ್ಸ್ ಇಲ್ಲ",

    hourglass_view: "ಮರಳು ಗಡಿಯಾರ ನೋಟ",
    hourglass_exit: "ನಿರ್ಗಮಿಸಿ",

    colour_guide: "ಬಣ್ಣ ಮಾರ್ಗದರ್ಶಿ",
    colour_guide_desc: "ನಿಮ್ಮ ಚಿತ್ರದಲ್ಲಿ ಬೆಳಕು, ನೆರಳು ಮತ್ತು ಬಣ್ಣಗಳ ಕ್ರಮವನ್ನು ಕಲಿಯಿರಿ",
    cg_coloring_order: "ಬಣ್ಣ ಹಚ್ಚುವ ಕ್ರಮ",
    cg_step_1_title: "ಹಿನ್ನಲೆ",
    cg_step_1_desc: "ಹಗುರ ಬಣ್ಣ, ಕಡಿಮೆ ವ್ಯತ್ಯಾಸ",
    cg_step_2_title: "ದೂರದ ವಸ್ತುಗಳು",
    cg_step_2_desc: "ತಂಪು ಬಣ್ಣ, ಮೃದು ವ್ಯತ್ಯಾಸ",
    cg_step_3_title: "ನೆಲ",
    cg_step_3_desc: "ನೈಸರ್ಗಿಕ ಬೇಸ್ ಬಣ್ಣಗಳು",
    cg_step_4_title: "ಪ್ರಮುಖ ವಿಷಯ",
    cg_step_4_desc: "ಗಾಢ ಬಣ್ಣ, ಹೆಚ್ಚಿನ ವ್ಯತ್ಯಾಸ",
    cg_step_5_title: "ಇತರ ದೊಡ್ಡ ವಸ್ತುಗಳು",
    cg_step_5_desc: "ಸಮತೋಲನ ಮಧ್ಯಮ-ಟೋನ್",
    cg_step_6_title: "ವಿವರ ಮತ್ತು ಹೈಲೈಟ್",
    cg_step_6_desc: "ಸೂಕ್ಷ್ಮ ವಿವರ, ಪ್ರಕಾಶಮಾನ ಹೈಲೈಟ್",
    cg_note_heading: "ಗಮನಿಸಿ",
    cg_note_1: "ಪ್ರಮುಖ ವಿಷಯವನ್ನು ಕೆಂಪು ಗೆರೆಯಲ್ಲಿ ಗುರುತಿಸಲಾಗಿದೆ.",
    cg_note_2: "ನೀಲಿ ನೆರಳು ಪ್ರದೇಶಗಳಲ್ಲಿ ಗಾಢ ಶೇಡ್ ಬಳಸಿ.",

    math_mental: "ಮೆಂಟಲ್ ಮ್ಯಾತ್",
    math_mental_desc: "ಶಾಪಿಂಗ್ ಕಥೆ ಆಲಿಸಿ ಸರಿಯಾದ ಉತ್ತರ ಆರಿಸಿ",
    mm_start_practice: "ಅಭ್ಯಾಸ ಪ್ರಾರಂಭಿಸಿ",
    mm_replay_audio: "ಮತ್ತೆ ಆಲಿಸಿ",
    mm_choose_answer: "ಸರಿಯಾದ ಉತ್ತರ ಆರಿಸಿ",
    mm_correct: "ಸರಿ! ಚೆನ್ನಾಗಿದೆ.",
    mm_wrong: "ತಪ್ಪು! ಮತ್ತೆ ಪ್ರಯತ್ನಿಸಿ.",
    mm_practice_another: "ಮತ್ತೊಂದು ಪ್ರಶ್ನೆ",
    mm_back: "ಹಿಂದೆ",
    mm_home: "ಹೋಮ್",
    mm_generating: "ನಿಮ್ಮ ಪ್ರಶ್ನೆ ಸಿದ್ಧವಾಗುತ್ತಿದೆ...",
    mm_focus_now: "ಗಮನವಿಟ್ಟು ಆಲಿಸಿ",
    mm_intro: "ಮೆಂಟಲ್ ಮ್ಯಾತ್ ಅಭ್ಯಾಸಕ್ಕಾಗಿ ನಿಜ ಜೀವನದ ಶಾಪಿಂಗ್ ಒಗಟುಗಳು",
    use_cropped_area: "ಈ ಭಾಗವನ್ನು ಬಳಸಿ",
    another_problem: "ಮತ್ತೊಂದು ಪ್ರಶ್ನೆ",
    hint_label: "ಇಲ್ಲಿ ಒಂದು ಸುಳಿವು",
    audio_hint_label: "ಕೇಳಲು Play ಒತ್ತಿ",
    audio_unavailable: "ಆಡಿಯೋ ಲಭ್ಯವಿಲ್ಲ — ನಂತರ ಪ್ರಯತ್ನಿಸಿ.",
    no_math_found_title: "ಗಣಿತ ಪ್ರಶ್ನೆ ಸಿಗಲಿಲ್ಲ.",
    no_math_found_desc: "Crop ಪ್ರದೇಶದಲ್ಲಿ ಪ್ರಶ್ನೆ ಸ್ಪಷ್ಟವಾಗಿರಲಿ.",
    generating_hint: "ಸುಳಿವು ತಯಾರಾಗುತ್ತಿದೆ...",
    generating_solution: "ಪರಿಹಾರ ತಯಾರಾಗುತ್ತಿದೆ...",
    generating_summary: "ಸಾರಾಂಶ ತಯಾರಾಗುತ್ತಿದೆ...",
    generating_mcq: "ಕ್ವಿಜ್ ತಯಾರಾಗುತ್ತಿದೆ...",
    language_tagline: "ಒಂದು ಪಠ್ಯದ ಫೋಟೋ ತೆಗೆ — ಸಾರಾಂಶ ಅಥವಾ ಕ್ವಿಜ್ ಪಡೆ.",
    lang_summary: "ಸಾರಾಂಶ",
    lang_summary_desc: "ನಿಮ್ಮ ಭಾಷೆಯಲ್ಲಿ ಸುಲಭ ಸಾರಾಂಶ, ಆಡಿಯೋ ಸಹಿತ",
    lang_mcq: "ಕ್ವಿಜ್",
    lang_mcq_desc: "ಮೋಜಿನ ಬಹುಆಯ್ಕೆ ಪ್ರಶ್ನೆಗಳು, ತಕ್ಷಣದ ಫೀಡ್‌ಬ್ಯಾಕ್",
    pick_age_group: "ನಿಮ್ಮ ವಯಸ್ಸಿನ ಗುಂಪು ಆಯ್ಕೆಮಾಡಿ",
    age_6_10: "6–10 ವರ್ಷಗಳು",
    age_10_14: "10–14 ವರ್ಷಗಳು",
    age_14_18: "14–18 ವರ್ಷಗಳು",
    age_18_plus: "18+ ವರ್ಷಗಳು",
    summary_label: "ಇಲ್ಲಿ ಒಂದು ಸಣ್ಣ ಸಾರಾಂಶ",
    audio_summary_label: "ಕೇಳಲು Play ಒತ್ತಿ",
    no_content_title: "ಯಾವುದೇ ಪಠ್ಯ ಸಿಗಲಿಲ್ಲ.",
    no_content_desc: "ಕ್ಯಾಮೆರಾ ಒಂದು ಕಥೆ, ಪಾಠ ಅಥವಾ ಪಠ್ಯದ ಮೇಲೆ ಇಡಿ.",
    question: "ಪ್ರಶ್ನೆ",
    multi_select_hint: "ಒಂದಕ್ಕಿಂತ ಹೆಚ್ಚು ಉತ್ತರ ಸರಿಯಾಗಿರಬಹುದು.",
    mcq_submit: "ಉತ್ತರ ಪರಿಶೀಲಿಸಿ",
    mcq_next: "ಮುಂದಿನ ಪ್ರಶ್ನೆ",
    mcq_see_score: "ನನ್ನ ಸ್ಕೋರ್ ನೋಡಿ",
    mcq_correct: "ಸರಿ! 🎉",
    mcq_wrong: "ಸರಿಯಾಗಿಲ್ಲ. ಮುಂದಿನದನ್ನು ಪ್ರಯತ್ನಿಸಿ!",
    mcq_correct_feedback: "ಚೆನ್ನಾಗಿದೆ — ಎಲ್ಲವೂ ಸರಿಯಾಗಿದೆ.",
    mcq_wrong_feedback: "ಹಸಿರು ಬಣ್ಣದ ಆಯ್ಕೆಗಳೇ ಸರಿಯಾದ ಉತ್ತರ.",
    mcq_done_title: "ಉತ್ತಮ ಪ್ರಯತ್ನ!",
    mcq_all_correct: "ಪರಿಪೂರ್ಣ ಸ್ಕೋರ್!",
    your_score: "ನಿನ್ನ ಸ್ಕೋರ್",
    lang_check_answer: "ಉತ್ತರ ಪರಿಶೀಲನೆ",
    lang_check_answer_desc: "ಬರೆದ ಉತ್ತರ ಪತ್ರಿಕೆಯ ಫೋಟೋ ತೆಗೆಯಿರಿ — ಅಂಕ, ಸರಿ/ತಪ್ಪು ಮತ್ತು ಸರಿಯಾದ ಉತ್ತರ",
    lang_learn_nature: "ಪ್ರಕೃತಿಯಿಂದ ಕಲಿಯಿರಿ",
    lang_learn_nature_desc: "ಪ್ರಕೃತಿಯ ಫೋಟೋ ತೆಗೆಯಿರಿ — ವಿಜ್ಞಾನ, ಜೀವನ ಮತ್ತು ಇತರೆ ವಿಷಯಗಳ ಚಿಕ್ಕ ಪಾಠಗಳು",
    generating_learn_nature: "ಪ್ರಕೃತಿಯಿಂದ ಪಾಠ ಹುಡುಕುತ್ತಿದ್ದೇವೆ...",
    nature_lessons_label: "ಪ್ರಕೃತಿ ಪಾಠಗಳು",
    generating_check_answer: "ಉತ್ತರಗಳನ್ನು ಪರಿಶೀಲಿಸುತ್ತಿದ್ದೇವೆ...",
    no_paper_found_title: "ಪ್ರಶ್ನೆ ಪತ್ರಿಕೆ ಸಿಗಲಿಲ್ಲ.",
    no_paper_found_desc: "ವಿದ್ಯಾರ್ಥಿಯ ಉತ್ತರಗಳಿರುವ ಪ್ರಶ್ನೆ ಪತ್ರಿಕೆಯ ಮೇಲೆ ಕ್ಯಾಮೆರಾ ಇಡಿ.",
    lang_speech_mentor: "ಸ್ಪೀಚ್ ಮೆಂಟರ್",
    lang_speech_mentor_desc: "ಚೆನ್ನಾಗಿ ಮಾತನಾಡಲು ಸಹಾಯ ಮಾಡುವ ಸ್ನೇಹಪೂರ್ವಕ AI ಮೆಂಟರ್.",
    speech_mentor_tap_to_record: "ಮೈಕ್ ಟ್ಯಾಪ್ ಮಾಡಿ ಮಾತನಾಡಲು ಪ್ರಾರಂಭಿಸಿ",
    speech_mentor_tap_to_stop: "ನಿಲ್ಲಿಸಲು ಟ್ಯಾಪ್ ಮಾಡಿ",
    speech_mentor_recording: "ಕೇಳುತ್ತಿದ್ದೇನೆ...",
    speech_mentor_analyzing: "ನಿಮ್ಮ ಮಾತನ್ನು ವಿಶ್ಲೇಷಿಸುತ್ತಿದ್ದೇನೆ...",
    speech_mentor_your_speech: "ನಿಮ್ಮ ಮಾತು",
    speech_mentor_mic_denied: "ಮೈಕ್ ಅನುಮತಿ ನಿರಾಕರಿಸಲಾಗಿದೆ",
    speech_mentor_mic_unsupported: "ಈ ಸಾಧನದಲ್ಲಿ ಮೈಕ್ ಇಲ್ಲ",
    learn_another: "ಇನ್ನೊಂದು ಕಲಿ",
    try_another: "ಮತ್ತೆ ಪ್ರಯತ್ನಿಸು",
    check_another: "ಇನ್ನೊಂದು ಪರಿಶೀಲಿಸಿ",
    practice_again: "ಮತ್ತೆ ಅಭ್ಯಾಸ ಮಾಡಿ",
    speech_mentor_play_welcome: "ಸ್ವಾಗತ ಕೇಳಲು ಟ್ಯಾಪ್ ಮಾಡಿ",
    daily_reflection: "ದೈನಂದಿನ ಚಿಂತನೆ",
    daily_reflection_desc: "ಆಂತರಿಕ ಬೆಳವಣಿಗೆಗಾಗಿ 1-ನಿಮಿಷದ ದೈನಂದಿನ ಚೆಕ್-ಇನ್",
    dr_start: "ಪ್ರಾರಂಭಿಸಿ",
    dr_loading: "ನಿಮ್ಮ ಚಿಂತನೆ ಸಿದ್ಧವಾಗುತ್ತಿದೆ...",
    dr_question_of: "ಪ್ರಶ್ನೆ {n} / {total}",
    dr_your_answer: "ನಿಮ್ಮ ಉತ್ತರ",
    dr_best_answer: "ಅತ್ಯುತ್ತಮ ಉತ್ತರ",
    dr_lesson: "ಪಾಠ",
    dr_growth_score: "ಇಂದಿನ ಬೆಳವಣಿಗೆ ಅಂಕ",
    dr_encouragement_high: "ಅದ್ಭುತ! ನೀವು ದಿನದಿನಕ್ಕೂ ಬೆಳೆಯುತ್ತಿದ್ದೀರಿ.",
    dr_encouragement_mid: "ಒಳ್ಳೆ ಪ್ರಯತ್ನ! ದಿನದ ಚಿಂತನೆ ಮನಸ್ಸನ್ನು ದೃಢಗೊಳಿಸುತ್ತದೆ.",
    dr_encouragement_low: "ಪ್ರತಿ ಚಿಂತನೆಯೂ ಒಂದು ಹೆಜ್ಜೆ. ಬೆಳೆಯುತ್ತಿರಿ!",
    dr_next: "ಮುಂದೆ",
    dr_finish: "ನನ್ನ ಅಂಕ ನೋಡು",
    dr_try_again: "ಮತ್ತೆ ಚಿಂತನೆ",
    dr_listen: "ಆಲಿಸಿ",
    coloring: "ಬಣ್ಣ ತುಂಬಿಸು",
    coloring_desc: "ಯಾವುದೇ ಚಿತ್ರವನ್ನು ಕಲೆಯನ್ನಾಗಿ ಮಾಡು — ಆಯಿಲ್ ಪೇಸ್ಟಲ್, ವಾಟರ್ ಕಲರ್ & ಇನ್ನಷ್ಟು",
    coloring_choose_style: "ಬಣ್ಣ ಶೈಲಿ ಆಯ್ಕೆಮಾಡಿ",
    coloring_style_oil_pastel: "ಆಯಿಲ್ ಪೇಸ್ಟಲ್",
    coloring_style_watercolor: "ವಾಟರ್ ಕಲರ್",
    coloring_style_graphite_shade: "ಪೆನ್ಸಿಲ್ ಛಾಯೆ",
    coloring_style_color_pencil_shade: "ವರ್ಣ ಪೆನ್ಸಿಲ್",
    coloring_style_oil_paint: "ಆಯಿಲ್ ಪೇಂಟ್",
    time_master: "ಟೈಮ್ ಮಾಸ್ಟರ್",
    time_master_desc: "ಎಷ್ಟು ವೇಗವಾಗಿ ಮುಗಿಸಬಲ್ಲೆ? ಆದರ್ಶ ಸಮಯದೊಂದಿಗೆ ಸ್ಪರ್ಧಿಸಿ.",
    time_master_class: "ತರಗತಿ",
    time_master_subject: "ವಿಷಯ",
    time_master_marks: "ಅಂಕಗಳು",
    time_master_ideal: "ಆದರ್ಶ ಸಮಯ",
    time_master_elapsed: "ನಿನ್ನ ಸಮಯ",
    time_master_start: "ಟೈಮರ್ ಪ್ರಾರಂಭಿಸಿ",
    time_master_stop: "ಟೈಮರ್ ನಿಲ್ಲಿಸಿ",
    time_master_pick_class: "ತರಗತಿ ಆಯ್ಕೆ",
    time_master_pick_subject: "ವಿಷಯ ಆಯ್ಕೆ",
    time_master_pick_marks: "ಅಂಕ ಆಯ್ಕೆ",
    time_master_subj_numerical: "ಸಂಖ್ಯಾತ್ಮಕ",
    time_master_subj_science: "ವಿಜ್ಞಾನ",
    time_master_subj_technical: "ತಾಂತ್ರಿಕ",
    time_master_subj_social: "ಸಾಮಾಜಿಕ",
    time_master_subj_language: "ಭಾಷೆ",
    time_master_subj_other: "ಇತರೆ",
  },
  ml: {
    app_name: "ഡ്രോയിംഗ് ടൂൾസ്",
    tagline: "വരയ്ക്കാൻ പ്രേരിപ്പിക്കുന്നു!",
    enter_phone: "നിങ്ങളുടെ ഫോൺ നമ്പർ നൽകുക",
    phone_placeholder: "10 അക്ക മൊബൈൽ",
    send_otp: "OTP അയയ്ക്കുക",
    enter_otp: "6 അക്ക OTP നൽകുക",
    verify: "പരിശോധിച്ച് ലോഗിൻ",
    resend_otp: "OTP വീണ്ടും അയയ്ക്കുക",
    change_number: "നമ്പർ മാറ്റുക",
    free_label: "സൗജന്യം",
    paid_label: "₹",
    blueprint: "ബ്ലൂപ്രിന്റ്",
    blueprint_desc: "ആദ്യം രൂപരേഖ വരയ്ക്കുക",
    pencil: "പെൻസിൽ സ്കെച്ച്",
    pencil_desc: "മനോഹരമായ പെൻസിൽ സ്കെച്ച് നിർമിക്കുക",
    story: "എന്റെ കഥ",
    story_desc: "ഒരു കോമിക് കഥ സൃഷ്ടിക്കൂ",
    wallet: "വാലറ്റ്",
    recharge_wallet: "വാലറ്റ് റീചാർജ് ചെയ്യൂ",
    recharge_methods: "UPI · കാർഡ് · നെറ്റ്‌ബാങ്കിംഗ് · വാലറ്റ്",
    pay_prefix: "പണം അടയ്ക്കൂ",
    processing: "പ്രോസസ്സ് ചെയ്യുന്നു…",
    recharge_unavailable: "റീചാർജ് ഇപ്പോൾ ലഭ്യമല്ല",
    free_credit_title: "{amount} സൗജന്യ ക്രെഡിറ്റ്",
    free_credit_desc: "നിങ്ങൾക്ക് {amount} സൗജന്യ വാലറ്റ് ക്രെഡിറ്റ് നൽകി — ഒരു ഫോൺ നമ്പറിന് ഒരു തവണ.",
    recent_recharges: "സമീപകാല റീചാർജുകൾ",
    gallery: "ഗാലറി",
    take_photo: "ഫോട്ടോ എടുക്കുക",
    retake: "വീണ്ടും എടുക്കുക",
    use_photo: "ഈ ഫോട്ടോ ഉപയോഗിക്കുക",
    generating: "മാന്ത്രികം നടക്കുന്നു...",
    almost_there: "ഏതാണ്ട് കഴിഞ്ഞു!",
    download: "ഡൗൺലോഡ്",
    share: "പങ്കിടുക",
    share_whatsapp: "വാട്സ്ആപ്പ്",
    share_email: "ഇമെയിൽ",
    copy_link: "ലിങ്ക് കോപ്പി ചെയ്യുക",
    back: "തിരികെ",
    logout: "ലോഗൗട്ട്",
    your_creations: "നിങ്ങളുടെ സൃഷ്ടികൾ",
    no_creations: "ഇതുവരെ ഒന്നുമില്ല. തുടങ്ങാം!",
    insufficient_balance: "ബാലൻസ് മതിയാകുന്നില്ല",
    rate_limited: "അൽപ്പം വിശ്രമിക്കൂ! പിന്നീട് വീണ്ടും ശ്രമിക്കുക.",
    welcome: "സ്വാഗതം!",
    home: "ഹോം",
    language: "ഭാഷ",
    balance: "ബാലൻസ്",
    create: "നിർമിക്കുക",
    platform_name: "സരൾ ഐ",
    platform_tagline: "പഠനത്തിന്റെ മഹാസമുദ്രത്തെ ലളിതമാക്കുന്നു",
    module_drawing_title: "ഡ്രോയിംഗ് ടൂൾസ്",
    module_drawing_desc: "വരയ്ക്കൂ, നിറം കൊടുക്കൂ & സങ്കൽപ്പിക്കൂ",
    module_language_title: "ഭാഷാ ടൂൾസ്",
    module_language_desc: "എല്ലാ വിഷയവും പഠിക്കൂ",
    module_math_title: "ഗണിത ടൂൾസ്",
    module_math_desc: "പഠിക്കൂ, പരിഹരിക്കൂ & മെച്ചപ്പെടൂ",
    mind_master_title: "മൈൻഡ് മാസ്റ്റർ",
    mind_master_desc: "ധ്യാനം, ശ്വാസം & ശാന്തി",
    mind_master_audio_start: "ശബ്ദം പ്ലേ",
    mind_master_audio_stop: "ശബ്ദം നിർത്തുക",
    mind_master_back: "തിരികെ",
    life_intro_heading: "സ്വയം തിരിച്ചറിയാൻ കുറച്ച് നിമിഷങ്ങൾ നൽകുക",
    privacy_policy: "സ്വകാര്യതാ നയം",
    install_app: "ആപ്പ് ഇൻസ്റ്റാൾ ചെയ്യൂ",
    app_installs: "ആപ്പ് ഇൻസ്റ്റാളുകൾ",
    coming_soon: "ഉടൻ വരുന്നു",
    open_now: "തുറക്കുക",
    make_another: "മറ്റൊന്ന് ഉണ്ടാക്കുക",
    upload_from_gallery: "ഗാലറിയിൽ നിന്ന് അപ്‌ലോഡ് ചെയ്യുക",
    math_tagline: "കണക്ക് ചോദ്യം ഫോട്ടോ എടുക്കൂ — സൂചന അല്ലെങ്കിൽ പൂർണ്ണ ഉത്തരം നേടൂ.",
    math_hint: "സൂചന",
    math_hint_desc: "നിങ്ങളുടെ ഭാഷയിൽ എളുപ്പ സൂചന, ഓഡിയോയോടെ",
    math_solution: "ഉത്തരം",
    math_solution_desc: "നോട്ടുബുക്ക് ശൈലിയിൽ പൂർണ്ണ ഘട്ടം-ഘട്ടം ഉത്തരം",

    share_confirm_prompt: "വാട്ട്‌സാപ്പിൽ സന്ദേശം പങ്കുവെച്ചോ?",
    share_confirm_yes: "അതെ, പങ്കുവെച്ചു",
    share_confirm_no: "ഇപ്പോൾ അല്ല",

    help_a_friend: "സുഹൃത്തിനെ സഹായിക്കൂ",
    help_a_friend_intro: "പങ്കുവയ്ക്കുക എന്നാൽ കരുതൽ — സുഹൃത്തിനെയും ഒപ്പം പഠിക്കാൻ ക്ഷണിക്കൂ.",
    help_a_friend_msg_greeting: "നമുക്ക് ഒരുമിച്ച് പഠിക്കാം!",
    help_a_friend_msg_body: "ഞാൻ പഠനത്തിന് Saral Eye ഉപയോഗിക്കുന്നു. നിങ്ങളും ചേരൂ:",
    help_a_friend_msg_tagline: "പഠിക്കൂ • വളരൂ • സഹായിക്കൂ",
    share_on_whatsapp: "വാട്ട്‌സാപ്പിൽ പങ്കിടൂ",
    share_helper_line: "ഓരോ പങ്കിടലും = ഒരു വിദ്യാർത്ഥിക്ക് സഹായം",
    join_sahaj_path: "സഹജ പാഠം ചേരൂ",
    sahaj_path_hint: "വാട്ട്‌സാപ്പിൽ സൗഹൃദ പഠന സഹായ ഗ്രൂപ്പ്",
    level_blaze: "ലെവൽ ബ്ലേസ്",
    helped_label: "സഹായിച്ചു",
    level_student: "വിദ്യാർത്ഥി",
    level_helper: "സഹായി",
    level_supporter: "പിന്തുണക്കാരൻ",
    level_mentor: "മാർഗദർശി",
    level_champion: "ചാമ്പ്യൻ",
    progress_line: "നീ {n} വിദ്യാർത്ഥികളെ സഹായിച്ചു • {next} ആകാൻ ഇനി {remain}",
    progress_line_top: "നീ {n} പേരെ സഹായിച്ചു. ചാമ്പ്യൻ — നന്ദി!",
    helped_toast_progress: "ഇപ്പോൾ {n} പേരെ സഹായിച്ചു • {next} ആകാൻ ഇനി {remain}",
    helped_toast_simple: "നീ {n} വിദ്യാർത്ഥികളെ സഹായിച്ചു. നന്ദി!",

    share_balance_title: "ബാലൻസ് ഷെയർ",
    share_balance_desc: "സുഹൃത്തിന് കുറച്ച് വാലറ്റ് പണം അയക്കൂ",
    share_recipient_phone: "സ്വീകർത്താവിന്റെ മൊബൈൽ നമ്പർ",
    share_phone_placeholder: "ഉദാ. 9876543210",
    share_amount: "അയക്കേണ്ട തുക",
    share_send_btn: "അയക്കൂ",
    share_success: "{phone}-ലേക്ക് {amount} അയച്ചു",
    share_recipient_invalid: "സാധുവായ മൊബൈൽ നമ്പർ നൽകൂ",
    share_invalid_amount: "പൂജ്യത്തിനു മുകളിലുള്ള സാധുവായ തുക നൽകൂ",
    share_insufficient_balance: "നിന്റെ കയ്യിൽ മതിയായ ബാലൻസ് ഇല്ല",

    hourglass_view: "മണൽ ഘടികാര കാഴ്ച",
    hourglass_exit: "പുറത്തുകടക്കൂ",

    colour_guide: "കളർ ഗൈഡ്",
    colour_guide_desc: "നിന്റെ ചിത്രത്തിൽ വെളിച്ചം, നിഴൽ, നിറങ്ങളുടെ ക്രമം പഠിക്കൂ",
    cg_coloring_order: "നിറം കൊടുക്കുന്ന ക്രമം",
    cg_step_1_title: "പശ്ചാത്തലം",
    cg_step_1_desc: "ഇളം നിറങ്ങൾ, കുറഞ്ഞ കോൺട്രാസ്റ്റ്",
    cg_step_2_title: "ദൂരെയുള്ള വസ്തുക്കൾ",
    cg_step_2_desc: "തണുത്ത നിറങ്ങൾ, മൃദു കോൺട്രാസ്റ്റ്",
    cg_step_3_title: "നിലം",
    cg_step_3_desc: "സ്വാഭാവിക ബേസ് നിറങ്ങൾ",
    cg_step_4_title: "മുഖ്യ വിഷയം",
    cg_step_4_desc: "കടും നിറങ്ങൾ, ഉയർന്ന കോൺട്രാസ്റ്റ്",
    cg_step_5_title: "മറ്റ് വലിയ വസ്തുക്കൾ",
    cg_step_5_desc: "സന്തുലിത മധ്യ-ടോൺ",
    cg_step_6_title: "വിശദാംശങ്ങൾ & ഹൈലൈറ്റ്",
    cg_step_6_desc: "സൂക്ഷ്മ വിശദാംശം, തിളക്കമുള്ള ഹൈലൈറ്റ്",
    cg_note_heading: "ശ്രദ്ധിക്കൂ",
    cg_note_1: "മുഖ്യ വിഷയം ചുവന്ന വരയിൽ അടയാളപ്പെടുത്തിയിരിക്കുന്നു.",
    cg_note_2: "നീല നിഴൽ പ്രദേശങ്ങളിൽ കടും ഷേഡുകൾ ഉപയോഗിക്കൂ.",

    math_mental: "മെന്റൽ മാത്ത്",
    math_mental_desc: "ഷോപ്പിംഗ് കഥ കേട്ട് ശരിയായ ഉത്തരം തിരഞ്ഞെടുക്കൂ",
    mm_start_practice: "പരിശീലനം തുടങ്ങൂ",
    mm_replay_audio: "വീണ്ടും കേൾക്കൂ",
    mm_choose_answer: "ശരിയായ ഉത്തരം തിരഞ്ഞെടുക്കൂ",
    mm_correct: "ശരി! മിടുക്കാ.",
    mm_wrong: "തെറ്റ്! വീണ്ടും ശ്രമിക്കൂ.",
    mm_practice_another: "മറ്റൊരു ചോദ്യം",
    mm_back: "പിന്നോട്ട്",
    mm_home: "ഹോം",
    mm_generating: "നിന്റെ ചോദ്യം തയ്യാറാകുന്നു...",
    mm_focus_now: "ശ്രദ്ധയോടെ കേൾക്കൂ",
    mm_intro: "മെന്റൽ മാത്ത് പ്രാക്ടീസിനുള്ള യഥാർത്ഥ ജീവിത ഷോപ്പിംഗ് പസിലുകൾ",
    use_cropped_area: "ഈ ഭാഗം ഉപയോഗിക്കൂ",
    another_problem: "മറ്റൊരു ചോദ്യം",
    hint_label: "ഇതാ ഒരു സൂചന",
    audio_hint_label: "കേൾക്കാൻ Play അമർത്തുക",
    audio_unavailable: "ഓഡിയോ ലഭ്യമല്ല — പിന്നീട് ശ്രമിക്കുക.",
    no_math_found_title: "കണക്ക് ചോദ്യം കണ്ടെത്തിയില്ല.",
    no_math_found_desc: "Crop ഭാഗത്ത് ചോദ്യം വ്യക്തമായിരിക്കട്ടെ.",
    generating_hint: "സൂചന തയ്യാറാക്കുന്നു...",
    generating_solution: "ഉത്തരം തയ്യാറാക്കുന്നു...",
    generating_summary: "സംഗ്രഹം തയ്യാറാക്കുന്നു...",
    generating_mcq: "ക്വിസ് തയ്യാറാക്കുന്നു...",
    language_tagline: "ഒരു ഖണ്ഡികയുടെ ഫോട്ടോ എടുക്കൂ — സംഗ്രഹം അല്ലെങ്കിൽ ക്വിസ് നേടൂ.",
    lang_summary: "സംഗ്രഹം",
    lang_summary_desc: "നിങ്ങളുടെ ഭാഷയിൽ എളുപ്പ സംഗ്രഹം, ഓഡിയോയോടെ",
    lang_mcq: "ക്വിസ്",
    lang_mcq_desc: "രസകരമായ ബഹുമുഖ ചോദ്യങ്ങൾ, തൽക്ഷണ പ്രതികരണം",
    pick_age_group: "നിങ്ങളുടെ പ്രായ വിഭാഗം തിരഞ്ഞെടുക്കൂ",
    age_6_10: "6–10 വയസ്സ്",
    age_10_14: "10–14 വയസ്സ്",
    age_14_18: "14–18 വയസ്സ്",
    age_18_plus: "18+ വയസ്സ്",
    summary_label: "ഇതാ ഒരു ചെറിയ സംഗ്രഹം",
    audio_summary_label: "കേൾക്കാൻ Play അമർത്തുക",
    no_content_title: "പാഠഭാഗം കണ്ടെത്തിയില്ല.",
    no_content_desc: "ക്യാമറ ഒരു കഥ, പാഠം അല്ലെങ്കിൽ ഖണ്ഡികയിലേക്ക് വയ്ക്കൂ.",
    question: "ചോദ്യം",
    multi_select_hint: "ഒന്നിലധികം ഉത്തരം ശരിയാകാം.",
    mcq_submit: "ഉത്തരം പരിശോധിക്കൂ",
    mcq_next: "അടുത്ത ചോദ്യം",
    mcq_see_score: "എന്റെ സ്കോർ കാണൂ",
    mcq_correct: "ശരി! 🎉",
    mcq_wrong: "ഇത് ശരിയല്ല. അടുത്തത് ശ്രമിക്കൂ!",
    mcq_correct_feedback: "നന്നായി — എല്ലാം ശരിയായി.",
    mcq_wrong_feedback: "പച്ച നിറത്തിലുള്ളവയാണ് ശരിയായ ഉത്തരം.",
    mcq_done_title: "മികച്ച ശ്രമം!",
    mcq_all_correct: "പൂർണ്ണ സ്കോർ!",
    your_score: "നിന്റെ സ്കോർ",
    lang_check_answer: "ഉത്തര പരിശോധന",
    lang_check_answer_desc: "എഴുതിയ ഉത്തരക്കടലാസിന്റെ ഫോട്ടോ എടുക്കൂ — മാർക്ക്, ശരി/തെറ്റ് ഉത്തരങ്ങൾ",
    lang_learn_nature: "പ്രകൃതിയിൽ നിന്ന് പഠിക്കൂ",
    lang_learn_nature_desc: "പ്രകൃതി ദൃശ്യത്തിന്റെ ഫോട്ടോ എടുക്കൂ — ശാസ്ത്രം, ജീവിതം കൂടുതൽ പാഠങ്ങൾ",
    generating_learn_nature: "പ്രകൃതിയിൽ നിന്ന് പാഠങ്ങൾ കണ്ടെത്തുന്നു...",
    nature_lessons_label: "പ്രകൃതി പാഠങ്ങൾ",
    generating_check_answer: "ഉത്തരങ്ങൾ പരിശോധിക്കുന്നു...",
    no_paper_found_title: "ചോദ്യപേപ്പർ കണ്ടെത്താൻ കഴിഞ്ഞില്ല.",
    no_paper_found_desc: "വിദ്യാർത്ഥിയുടെ ഉത്തരങ്ങളുള്ള ചോദ്യപേപ്പറിലേക്ക് ക്യാമറ വയ്ക്കുക.",
    lang_speech_mentor: "സ്പീച്ച് മെന്റർ",
    lang_speech_mentor_desc: "മികച്ചു സംസാരിക്കാൻ സഹായിക്കുന്ന സൗഹൃദ AI മെന്റർ.",
    speech_mentor_tap_to_record: "മൈക്ക് ടാപ്പ് ചെയ്ത് സംസാരിക്കാൻ തുടങ്ങൂ",
    speech_mentor_tap_to_stop: "നിർത്താൻ ടാപ്പ് ചെയ്യൂ",
    speech_mentor_recording: "കേൾക്കുന്നു...",
    speech_mentor_analyzing: "നിങ്ങളുടെ സംസാരം വിശകലനം ചെയ്യുന്നു...",
    speech_mentor_your_speech: "നിങ്ങളുടെ സംസാരം",
    speech_mentor_mic_denied: "മൈക്ക് അനുമതി നിഷേധിച്ചു",
    speech_mentor_mic_unsupported: "ഈ ഉപകരണത്തിൽ മൈക്ക് ലഭ്യമല്ല",
    learn_another: "വേറൊന്ന് പഠിക്കൂ",
    try_another: "വീണ്ടും ശ്രമിക്കൂ",
    check_another: "വേറൊന്ന് പരിശോധിക്കൂ",
    practice_again: "വീണ്ടും പരിശീലിക്കൂ",
    speech_mentor_play_welcome: "സ്വാഗതം കേൾക്കാൻ ടാപ്പ് ചെയ്യൂ",
    daily_reflection: "ദിവസേനയുള്ള ചിന്തന",
    daily_reflection_desc: "അകത്തുള്ള വളർച്ചയ്ക്കായി 1 മിനിറ്റ് ദിവസേനയുള്ള ചെക്ക്-ഇൻ",
    dr_start: "തുടങ്ങുക",
    dr_loading: "നിങ്ങളുടെ ചിന്തന ഒരുങ്ങുന്നു...",
    dr_question_of: "ചോദ്യം {n} / {total}",
    dr_your_answer: "നിങ്ങളുടെ ഉത്തരം",
    dr_best_answer: "മികച്ച ഉത്തരം",
    dr_lesson: "പാഠം",
    dr_growth_score: "ഇന്നത്തെ വളർച്ചാ സ്കോർ",
    dr_encouragement_high: "അതി മനോഹരം! നിങ്ങൾ ദിനംപ്രതി വളരുന്നു.",
    dr_encouragement_mid: "നല്ല ശ്രമം! ദിവസേനയുള്ള ചിന്തന മനസ്സിനെ ബലപ്പെടുത്തുന്നു.",
    dr_encouragement_low: "എല്ലാ ചിന്തനയും ഒരു ചുവടുവയ്പ്പ്. തുടരൂ!",
    dr_next: "അടുത്തത്",
    dr_finish: "എന്റെ സ്കോർ കാണുക",
    dr_try_again: "വീണ്ടും ചിന്തന",
    dr_listen: "കേൾക്കുക",
    coloring: "നിറം കൊടുക്കൽ",
    coloring_desc: "ഏത് ചിത്രവും കലയാക്കൂ — ഓയിൽ പേസ്റ്റൽ, വാട്ടർകളർ & കൂടുതൽ",
    coloring_choose_style: "നിറ ശൈലി തിരഞ്ഞെടുക്കൂ",
    coloring_style_oil_pastel: "ഓയിൽ പേസ്റ്റൽ",
    coloring_style_watercolor: "വാട്ടർകളർ",
    coloring_style_graphite_shade: "പെൻസിൽ ഷെയ്ഡ്",
    coloring_style_color_pencil_shade: "കളർ പെൻസിൽ",
    coloring_style_oil_paint: "ഓയിൽ പെയിന്റ്",
    time_master: "ടൈം മാസ്റ്റർ",
    time_master_desc: "എത്ര വേഗം തീർക്കാം? ആദർശ സമയവുമായി മത്സരിക്കൂ.",
    time_master_class: "ക്ലാസ്സ്",
    time_master_subject: "വിഷയം",
    time_master_marks: "മാർക്ക്",
    time_master_ideal: "ആദർശ സമയം",
    time_master_elapsed: "നിന്റെ സമയം",
    time_master_start: "ടൈമർ ആരംഭിക്കൂ",
    time_master_stop: "ടൈമർ നിർത്തൂ",
    time_master_pick_class: "ക്ലാസ്സ് തിരഞ്ഞെടുക്കൂ",
    time_master_pick_subject: "വിഷയം തിരഞ്ഞെടുക്കൂ",
    time_master_pick_marks: "മാർക്ക് തിരഞ്ഞെടുക്കൂ",
    time_master_subj_numerical: "സംഖ്യാ",
    time_master_subj_science: "ശാസ്ത്രം",
    time_master_subj_technical: "സാങ്കേതികം",
    time_master_subj_social: "സാമൂഹികം",
    time_master_subj_language: "ഭാഷ",
    time_master_subj_other: "മറ്റുള്ളവ",
  },
  pa: {
    app_name: "ਡਰਾਇੰਗ ਟੂਲਜ਼",
    tagline: "ਤੁਹਾਨੂੰ ਚਿੱਤਰ ਬਣਾਉਣ ਲਈ ਪ੍ਰੇਰਿਤ ਕਰਦਾ ਹੈ!",
    enter_phone: "ਆਪਣਾ ਫ਼ੋਨ ਨੰਬਰ ਭਰੋ",
    phone_placeholder: "10 ਅੰਕਾਂ ਦਾ ਮੋਬਾਈਲ",
    send_otp: "OTP ਭੇਜੋ",
    enter_otp: "6 ਅੰਕਾਂ ਦਾ OTP ਭਰੋ",
    verify: "ਤਸਦੀਕ ਕਰੋ",
    resend_otp: "OTP ਮੁੜ ਭੇਜੋ",
    change_number: "ਨੰਬਰ ਬਦਲੋ",
    free_label: "ਮੁਫ਼ਤ",
    paid_label: "₹",
    blueprint: "ਬਲੂਪ੍ਰਿੰਟ",
    blueprint_desc: "ਪਹਿਲਾਂ ਰੂਪਰੇਖਾ ਬਣਾਓ",
    pencil: "ਪੈਨਸਿਲ ਸਕੈਚ",
    pencil_desc: "ਸੁੰਦਰ ਪੈਨਸਿਲ ਸਕੈਚ ਬਣਾਓ",
    story: "ਮੇਰੀ ਕਹਾਣੀ",
    story_desc: "ਇੱਕ ਕਾਮਿਕ ਕਹਾਣੀ ਬਣਾਓ",
    wallet: "ਵਾਲਿਟ",
    recharge_wallet: "ਵਾਲਿਟ ਰੀਚਾਰਜ ਕਰੋ",
    recharge_methods: "UPI · ਕਾਰਡ · ਨੈੱਟਬੈਂਕਿੰਗ · ਵਾਲਿਟ",
    pay_prefix: "ਭੁਗਤਾਨ ਕਰੋ",
    processing: "ਪ੍ਰਕਿਰਿਆ ਚੱਲ ਰਹੀ ਹੈ…",
    recharge_unavailable: "ਰੀਚਾਰਜ ਇਸ ਸਮੇਂ ਉਪਲਬਧ ਨਹੀਂ",
    free_credit_title: "{amount} ਮੁਫ਼ਤ ਕ੍ਰੈਡਿਟ",
    free_credit_desc: "ਅਸੀਂ ਤੁਹਾਨੂੰ {amount} ਮੁਫ਼ਤ ਵਾਲਿਟ ਕ੍ਰੈਡਿਟ ਦਿੱਤਾ ਹੈ — ਇੱਕ ਫ਼ੋਨ ਨੰਬਰ ’ਤੇ ਇੱਕ ਵਾਰ।",
    recent_recharges: "ਹਾਲੀਆ ਰੀਚਾਰਜ",
    gallery: "ਗੈਲਰੀ",
    take_photo: "ਫੋਟੋ ਖਿੱਚੋ",
    retake: "ਮੁੜ ਖਿੱਚੋ",
    use_photo: "ਇਹ ਫੋਟੋ ਵਰਤੋ",
    generating: "ਜਾਦੂ ਹੋ ਰਿਹਾ ਹੈ...",
    almost_there: "ਲਗਭਗ ਹੋ ਗਿਆ!",
    download: "ਡਾਊਨਲੋਡ",
    share: "ਸ਼ੇਅਰ",
    share_whatsapp: "ਵਟਸਐਪ",
    share_email: "ਈਮੇਲ",
    copy_link: "ਲਿੰਕ ਕਾਪੀ ਕਰੋ",
    back: "ਵਾਪਸ",
    logout: "ਲੌਗਆਊਟ",
    your_creations: "ਤੁਹਾਡੀਆਂ ਰਚਨਾਵਾਂ",
    no_creations: "ਅਜੇ ਕੁਝ ਨਹੀਂ। ਚਲੋ ਸ਼ੁਰੂ ਕਰੀਏ!",
    insufficient_balance: "ਬੈਲੈਂਸ ਘੱਟ ਹੈ",
    rate_limited: "ਥੋੜ੍ਹਾ ਆਰਾਮ ਕਰੋ! ਬਾਅਦ ਵਿੱਚ ਮੁੜ ਕੋਸ਼ਿਸ਼ ਕਰੋ।",
    welcome: "ਸੁਆਗਤ ਹੈ!",
    home: "ਹੋਮ",
    language: "ਭਾਸ਼ਾ",
    balance: "ਬੈਲੈਂਸ",
    create: "ਬਣਾਓ",
    platform_name: "ਸਰਲ ਆਈ",
    platform_tagline: "ਸਿੱਖਣ ਦੇ ਸਾਗਰ ਨੂੰ ਸਰਲ ਬਣਾਉਂਦੇ ਹੋਏ",
    module_drawing_title: "ਡਰਾਇੰਗ ਟੂਲਜ਼",
    module_drawing_desc: "ਬਣਾਓ, ਰੰਗ ਕਰੋ ਤੇ ਕਲਪਨਾ ਕਰੋ",
    module_language_title: "ਭਾਸ਼ਾ ਟੂਲਜ਼",
    module_language_desc: "ਹਰ ਵਿਸ਼ਾ ਸਿੱਖੋ",
    module_math_title: "ਗਣਿਤ ਟੂਲਜ਼",
    module_math_desc: "ਸਿੱਖੋ, ਹੱਲ ਕਰੋ ਤੇ ਸੁਧਾਰੋ",
    mind_master_title: "ਮਾਈਂਡ ਮਾਸਟਰ",
    mind_master_desc: "ਧਿਆਨ, ਸਾਹ ਤੇ ਸ਼ਾਂਤੀ",
    mind_master_audio_start: "ਆਵਾਜ਼ ਚਲਾਓ",
    mind_master_audio_stop: "ਆਵਾਜ਼ ਰੋਕੋ",
    mind_master_back: "ਵਾਪਸ",
    life_intro_heading: "ਆਪਣੇ ਆਪ ਨੂੰ ਪਛਾਣਨ ਲਈ ਕੁਝ ਪਲ ਦਿਓ",
    privacy_policy: "ਪਰਾਈਵੇਸੀ ਨੀਤੀ",
    install_app: "ਐਪ ਇੰਸਟਾਲ ਕਰੋ",
    app_installs: "ਐਪ ਇੰਸਟਾਲ",
    coming_soon: "ਜਲਦੀ ਆ ਰਿਹਾ ਹੈ",
    open_now: "ਖੋਲ੍ਹੋ",
    make_another: "ਇੱਕ ਹੋਰ ਬਣਾਓ",
    upload_from_gallery: "ਗੈਲਰੀ ਤੋਂ ਅਪਲੋਡ ਕਰੋ",
    math_tagline: "ਗਣਿਤ ਦਾ ਸਵਾਲ ਫੋਟੋ ਕਰੋ — ਹਿੰਟ ਜਾਂ ਪੂਰਾ ਹੱਲ ਪਾਓ।",
    math_hint: "ਹਿੰਟ",
    math_hint_desc: "ਤੁਹਾਡੀ ਭਾਸ਼ਾ ਵਿੱਚ ਆਸਾਨ ਇਸ਼ਾਰਾ, ਆਡੀਓ ਨਾਲ",
    math_solution: "ਹੱਲ",
    math_solution_desc: "ਨੋਟਬੁੱਕ ਵਾਂਗ ਪੂਰਾ ਕਦਮ-ਦਰ-ਕਦਮ ਹੱਲ",

    share_confirm_prompt: "ਕੀ ਤੁਸੀਂ ਵਟਸਐਪ 'ਤੇ ਸੁਨੇਹਾ ਸਾਂਝਾ ਕੀਤਾ?",
    share_confirm_yes: "ਹਾਂ, ਸਾਂਝਾ ਕੀਤਾ",
    share_confirm_no: "ਹਾਲੇ ਨਹੀਂ",

    help_a_friend: "ਦੋਸਤ ਦੀ ਮਦਦ ਕਰੋ",
    help_a_friend_intro: "ਸਾਂਝਾ ਕਰਨਾ ਹੀ ਪਿਆਰ — ਦੋਸਤ ਨੂੰ ਵੀ ਪੜ੍ਹਨ ਲਈ ਬੁਲਾਓ।",
    help_a_friend_msg_greeting: "ਆਓ ਇਕੱਠੇ ਸਿੱਖੀਏ!",
    help_a_friend_msg_body: "ਮੈਂ ਪੜ੍ਹਾਈ ਲਈ Saral Eye ਵਰਤ ਰਿਹਾ ਹਾਂ। ਤੁਸੀਂ ਵੀ ਜੁੜੋ:",
    help_a_friend_msg_tagline: "ਸਿੱਖੋ • ਵਧੋ • ਮਦਦ ਕਰੋ",
    share_on_whatsapp: "ਵਟਸਐਪ 'ਤੇ ਸਾਂਝਾ ਕਰੋ",
    share_helper_line: "ਹਰ ਸਾਂਝ = ਇੱਕ ਵਿਦਿਆਰਥੀ ਦੀ ਮਦਦ",
    join_sahaj_path: "ਸਹਿਜ ਪਾਠ ਵਿੱਚ ਸ਼ਾਮਲ ਹੋਵੋ",
    sahaj_path_hint: "ਵਟਸਐਪ 'ਤੇ ਦੋਸਤਾਨਾ ਸਟੱਡੀ ਸਪੋਰਟ ਗਰੁੱਪ",
    level_blaze: "ਲੈਵਲ ਬਲੇਜ਼",
    helped_label: "ਮਦਦ ਕੀਤੀ",
    level_student: "ਵਿਦਿਆਰਥੀ",
    level_helper: "ਸਹਾਇਕ",
    level_supporter: "ਸਮਰਥਕ",
    level_mentor: "ਮਾਰਗਦਰਸ਼ਕ",
    level_champion: "ਚੈਂਪੀਅਨ",
    progress_line: "ਤੁਸੀਂ {n} ਵਿਦਿਆਰਥੀਆਂ ਦੀ ਮਦਦ ਕੀਤੀ • {next} ਬਣਨ ਲਈ ਹੋਰ {remain}",
    progress_line_top: "ਤੁਸੀਂ {n} ਦੀ ਮਦਦ ਕੀਤੀ। ਚੈਂਪੀਅਨ — ਧੰਨਵਾਦ!",
    helped_toast_progress: "ਹੁਣ {n} ਦੀ ਮਦਦ • {next} ਬਣਨ ਲਈ ਹੋਰ {remain}",
    helped_toast_simple: "ਤੁਸੀਂ {n} ਵਿਦਿਆਰਥੀਆਂ ਦੀ ਮਦਦ ਕੀਤੀ। ਧੰਨਵਾਦ!",

    share_balance_title: "ਬੈਲੈਂਸ ਸਾਂਝਾ ਕਰੋ",
    share_balance_desc: "ਦੋਸਤ ਨੂੰ ਕੁਝ ਵਾਲੇਟ ਪੈਸੇ ਭੇਜੋ",
    share_recipient_phone: "ਪ੍ਰਾਪਤਕਰਤਾ ਦਾ ਮੋਬਾਈਲ ਨੰਬਰ",
    share_phone_placeholder: "ਜਿਵੇਂ 9876543210",
    share_amount: "ਭੇਜਣ ਵਾਲੀ ਰਕਮ",
    share_send_btn: "ਭੇਜੋ",
    share_success: "{phone} ਨੂੰ {amount} ਭੇਜਿਆ",
    share_recipient_invalid: "ਸਹੀ ਮੋਬਾਈਲ ਨੰਬਰ ਦਰਜ ਕਰੋ",
    share_invalid_amount: "ਸਿਫ਼ਰ ਤੋਂ ਵੱਧ ਸਹੀ ਰਕਮ ਦਰਜ ਕਰੋ",
    share_insufficient_balance: "ਤੁਹਾਡੇ ਕੋਲ ਪੂਰਾ ਬੈਲੈਂਸ ਨਹੀਂ ਹੈ",

    hourglass_view: "ਰੇਤ ਘੜੀ ਦ੍ਰਿਸ਼",
    hourglass_exit: "ਬਾਹਰ ਜਾਓ",

    colour_guide: "ਰੰਗ ਗਾਈਡ",
    colour_guide_desc: "ਆਪਣੇ ਸਕੈਚ 'ਤੇ ਰੌਸ਼ਨੀ, ਪਰਛਾਵਾਂ ਅਤੇ ਰੰਗ ਦਾ ਕ੍ਰਮ ਸਿੱਖੋ",
    cg_coloring_order: "ਰੰਗ ਭਰਨ ਦਾ ਕ੍ਰਮ",
    cg_step_1_title: "ਪਿਛੋਕੜ",
    cg_step_1_desc: "ਹਲਕੇ ਰੰਗ, ਘੱਟ ਕਾਂਟ੍ਰਾਸਟ",
    cg_step_2_title: "ਦੂਰ ਦੀਆਂ ਵਸਤੂਆਂ",
    cg_step_2_desc: "ਠੰਡੇ ਰੰਗ, ਨਰਮ ਕਾਂਟ੍ਰਾਸਟ",
    cg_step_3_title: "ਜ਼ਮੀਨ",
    cg_step_3_desc: "ਕੁਦਰਤੀ ਬੇਸ ਰੰਗ",
    cg_step_4_title: "ਮੁੱਖ ਵਿਸ਼ਾ",
    cg_step_4_desc: "ਗੂੜ੍ਹੇ ਰੰਗ, ਉੱਚ ਕਾਂਟ੍ਰਾਸਟ",
    cg_step_5_title: "ਹੋਰ ਵੱਡੀਆਂ ਵਸਤੂਆਂ",
    cg_step_5_desc: "ਸੰਤੁਲਿਤ ਮੱਧ-ਟੋਨ",
    cg_step_6_title: "ਵੇਰਵੇ ਤੇ ਹਾਈਲਾਈਟ",
    cg_step_6_desc: "ਬਰੀਕ ਵੇਰਵੇ, ਚਮਕਦਾਰ ਹਾਈਲਾਈਟ",
    cg_note_heading: "ਨੋਟ",
    cg_note_1: "ਮੁੱਖ ਵਿਸ਼ੇ ਦੀ ਰੂਪਰੇਖਾ ਲਾਲ ਰੰਗ ਵਿੱਚ ਹੈ।",
    cg_note_2: "ਨੀਲੇ ਪਰਛਾਵੇਂ ਵਾਲੇ ਖੇਤਰਾਂ ਵਿੱਚ ਗੂੜ੍ਹੇ ਸ਼ੇਡ ਵਰਤੋ।",

    math_mental: "ਮੈਂਟਲ ਮੈਥ",
    math_mental_desc: "ਖਰੀਦਦਾਰੀ ਦੀ ਕਹਾਣੀ ਸੁਣੋ ਅਤੇ ਸਹੀ ਜਵਾਬ ਚੁਣੋ",
    mm_start_practice: "ਅਭਿਆਸ ਸ਼ੁਰੂ ਕਰੋ",
    mm_replay_audio: "ਦੁਬਾਰਾ ਸੁਣੋ",
    mm_choose_answer: "ਸਹੀ ਜਵਾਬ ਚੁਣੋ",
    mm_correct: "ਸਹੀ! ਵਧੀਆ.",
    mm_wrong: "ਗਲਤ! ਦੁਬਾਰਾ ਕੋਸ਼ਿਸ਼ ਕਰੋ.",
    mm_practice_another: "ਹੋਰ ਸਵਾਲ",
    mm_back: "ਪਿੱਛੇ",
    mm_home: "ਹੋਮ",
    mm_generating: "ਤੁਹਾਡਾ ਸਵਾਲ ਤਿਆਰ ਹੋ ਰਿਹਾ ਹੈ...",
    mm_focus_now: "ਧਿਆਨ ਨਾਲ ਸੁਣੋ",
    mm_intro: "ਮੈਂਟਲ ਮੈਥ ਅਭਿਆਸ ਲਈ ਅਸਲ ਖਰੀਦਦਾਰੀ ਦੀਆਂ ਬੁਝਾਰਤਾਂ",
    use_cropped_area: "ਇਹ ਹਿੱਸਾ ਵਰਤੋ",
    another_problem: "ਨਵਾਂ ਸਵਾਲ",
    hint_label: "ਆਹ ਲਓ ਇੱਕ ਹਿੰਟ",
    audio_hint_label: "ਸੁਣਨ ਲਈ Play ਦਬਾਓ",
    audio_unavailable: "ਆਡੀਓ ਉਪਲਬਧ ਨਹੀਂ — ਬਾਅਦ ਵਿੱਚ ਕੋਸ਼ਿਸ਼ ਕਰੋ।",
    no_math_found_title: "ਗਣਿਤ ਦਾ ਸਵਾਲ ਨਹੀਂ ਮਿਲਿਆ।",
    no_math_found_desc: "Crop ਏਰੀਆ ਵਿੱਚ ਸਵਾਲ ਸਾਫ਼ ਰੱਖੋ।",
    generating_hint: "ਹਿੰਟ ਬਣ ਰਿਹਾ ਹੈ...",
    generating_solution: "ਹੱਲ ਬਣ ਰਿਹਾ ਹੈ...",
    generating_summary: "ਸਾਰ ਬਣ ਰਿਹਾ ਹੈ...",
    generating_mcq: "ਕਵਿਜ਼ ਬਣ ਰਹੀ ਹੈ...",
    language_tagline: "ਇੱਕ ਪੈਰਾ ਫੋਟੋ ਕਰੋ — ਸਾਰ ਜਾਂ ਕਵਿਜ਼ ਪਾਓ।",
    lang_summary: "ਸਾਰ",
    lang_summary_desc: "ਤੁਹਾਡੀ ਭਾਸ਼ਾ ਵਿੱਚ ਆਸਾਨ ਸਾਰ, ਆਡੀਓ ਨਾਲ",
    lang_mcq: "ਕਵਿਜ਼",
    lang_mcq_desc: "ਮਜ਼ੇਦਾਰ ਬਹੁ-ਚੋਣਵੇਂ ਸਵਾਲ, ਤੁਰੰਤ ਜਵਾਬ",
    pick_age_group: "ਆਪਣਾ ਉਮਰ ਸਮੂਹ ਚੁਣੋ",
    age_6_10: "6–10 ਸਾਲ",
    age_10_14: "10–14 ਸਾਲ",
    age_14_18: "14–18 ਸਾਲ",
    age_18_plus: "18+ ਸਾਲ",
    summary_label: "ਆਹ ਲਓ ਇੱਕ ਛੋਟਾ ਸਾਰ",
    audio_summary_label: "ਸੁਣਨ ਲਈ Play ਦਬਾਓ",
    no_content_title: "ਕੋਈ ਪੈਰਾ ਨਹੀਂ ਮਿਲਿਆ।",
    no_content_desc: "ਕੈਮਰਾ ਕਿਸੇ ਕਹਾਣੀ, ਪਾਠ ਜਾਂ ਪੈਰੇ ਉੱਤੇ ਰੱਖੋ।",
    question: "ਸਵਾਲ",
    multi_select_hint: "ਇੱਕ ਤੋਂ ਵੱਧ ਜਵਾਬ ਸਹੀ ਹੋ ਸਕਦੇ ਹਨ।",
    mcq_submit: "ਜਵਾਬ ਚੈੱਕ ਕਰੋ",
    mcq_next: "ਅਗਲਾ ਸਵਾਲ",
    mcq_see_score: "ਮੇਰਾ ਸਕੋਰ ਵੇਖੋ",
    mcq_correct: "ਸਹੀ! 🎉",
    mcq_wrong: "ਇਸ ਵਾਰ ਨਹੀਂ। ਅਗਲਾ ਕੋਸ਼ਿਸ਼ ਕਰੋ!",
    mcq_correct_feedback: "ਵਾਹ — ਸਾਰੇ ਸਹੀ ਜਵਾਬ ਦਿੱਤੇ।",
    mcq_wrong_feedback: "ਹਰੇ ਰੰਗ ਵਾਲੇ ਵਿਕਲਪ ਹੀ ਸਹੀ ਜਵਾਬ ਹਨ।",
    mcq_done_title: "ਸ਼ਾਨਦਾਰ ਕੋਸ਼ਿਸ਼!",
    mcq_all_correct: "ਪੂਰਾ ਸਕੋਰ!",
    your_score: "ਤੇਰਾ ਸਕੋਰ",
    lang_check_answer: "ਜਵਾਬ ਜਾਂਚ",
    lang_check_answer_desc: "ਲਿਖੀ ਉੱਤਰ ਸ਼ੀਟ ਦੀ ਫੋਟੋ ਲਓ — ਅੰਕ, ਠੀਕ/ਗਲਤ ਅਤੇ ਸਹੀ ਜਵਾਬ",
    lang_learn_nature: "ਕੁਦਰਤ ਤੋਂ ਸਿੱਖੋ",
    lang_learn_nature_desc: "ਕੁਦਰਤੀ ਦ੍ਰਿਸ਼ ਦੀ ਫੋਟੋ ਲਓ — ਸਾਇੰਸ, ਜੀਵਨ ਅਤੇ ਹੋਰ ਵਿਸ਼ਿਆਂ ਦੇ ਸਬਕ",
    generating_learn_nature: "ਕੁਦਰਤ ਤੋਂ ਸਬਕ ਲੱਭ ਰਹੇ ਹਾਂ...",
    nature_lessons_label: "ਕੁਦਰਤ ਦੇ ਸਬਕ",
    generating_check_answer: "ਜਵਾਬ ਜਾਂਚ ਰਹੇ ਹਾਂ...",
    no_paper_found_title: "ਪ੍ਰਸ਼ਨ ਪੱਤਰ ਨਹੀਂ ਮਿਲਿਆ।",
    no_paper_found_desc: "ਕੈਮਰਾ ਵਿਦਿਆਰਥੀ ਦੇ ਜਵਾਬਾਂ ਵਾਲੇ ਪ੍ਰਸ਼ਨ ਪੱਤਰ ਉੱਪਰ ਰੱਖੋ।",
    lang_speech_mentor: "ਸਪੀਚ ਮੈਂਟਰ",
    lang_speech_mentor_desc: "ਚੰਗੀ ਤਰ੍ਹਾਂ ਬੋਲਣ ਵਿੱਚ ਮਦਦ ਕਰਦਾ ਦੋਸਤਾਨਾ AI ਗੁਰੂ।",
    speech_mentor_tap_to_record: "ਮਾਈਕ ਟੈਪ ਕਰੋ ਅਤੇ ਬੋਲਣਾ ਸ਼ੁਰੂ ਕਰੋ",
    speech_mentor_tap_to_stop: "ਰੋਕਣ ਲਈ ਟੈਪ ਕਰੋ",
    speech_mentor_recording: "ਸੁਣ ਰਹੇ ਹਾਂ...",
    speech_mentor_analyzing: "ਤੁਹਾਡੀ ਬੋਲੀ ਦਾ ਵਿਸ਼ਲੇਸ਼ਣ ਕਰ ਰਹੇ ਹਾਂ...",
    speech_mentor_your_speech: "ਤੁਹਾਡੀ ਬੋਲੀ",
    speech_mentor_mic_denied: "ਮਾਈਕ ਦੀ ਇਜਾਜ਼ਤ ਨਹੀਂ ਮਿਲੀ",
    speech_mentor_mic_unsupported: "ਇਸ ਡਿਵਾਈਸ 'ਤੇ ਮਾਈਕ ਨਹੀਂ ਹੈ",
    learn_another: "ਹੋਰ ਸਿੱਖੋ",
    try_another: "ਦੁਬਾਰਾ ਕਰੋ",
    check_another: "ਹੋਰ ਜਾਂਚੋ",
    practice_again: "ਦੁਬਾਰਾ ਅਭਿਆਸ ਕਰੋ",
    speech_mentor_play_welcome: "ਸੁਆਗਤ ਸੁਣਨ ਲਈ ਟੈਪ ਕਰੋ",
    daily_reflection: "ਰੋਜ਼ਾਨਾ ਚਿੰਤਨ",
    daily_reflection_desc: "ਅੰਦਰਲੇ ਵਿਕਾਸ ਲਈ 1-ਮਿੰਟ ਦਾ ਰੋਜ਼ਾਨਾ ਚੈੱਕ-ਇਨ",
    dr_start: "ਸ਼ੁਰੂ ਕਰੋ",
    dr_loading: "ਤੁਹਾਡਾ ਚਿੰਤਨ ਤਿਆਰ ਹੋ ਰਿਹਾ ਹੈ...",
    dr_question_of: "ਸਵਾਲ {n} / {total}",
    dr_your_answer: "ਤੁਹਾਡਾ ਜਵਾਬ",
    dr_best_answer: "ਸਭ ਤੋਂ ਵਧੀਆ ਜਵਾਬ",
    dr_lesson: "ਸਬਕ",
    dr_growth_score: "ਅੱਜ ਦਾ ਗਰੋਥ ਸਕੋਰ",
    dr_encouragement_high: "ਵਾਹ! ਤੁਸੀਂ ਰੋਜ਼ ਵੱਧ ਰਹੇ ਹੋ।",
    dr_encouragement_mid: "ਵਧੀਆ ਕੋਸ਼ਿਸ਼! ਰੋਜ਼ ਥੋੜ੍ਹਾ ਚਿੰਤਨ ਮਨ ਨੂੰ ਮਜ਼ਬੂਤ ਬਣਾਉਂਦਾ ਹੈ।",
    dr_encouragement_low: "ਹਰ ਚਿੰਤਨ ਇੱਕ ਕਦਮ ਅੱਗੇ ਹੈ। ਵਧਦੇ ਰਹੋ!",
    dr_next: "ਅੱਗੇ",
    dr_finish: "ਮੇਰਾ ਸਕੋਰ ਵੇਖੋ",
    dr_try_again: "ਫਿਰ ਚਿੰਤਨ",
    dr_listen: "ਸੁਣੋ",
    coloring: "ਰੰਗਾਈ",
    coloring_desc: "ਕਿਸੇ ਵੀ ਚਿੱਤਰ ਨੂੰ ਕਲਾ ਬਣਾਓ — ਆਇਲ ਪੇਸਟਲ, ਵਾਟਰ ਕਲਰ ਅਤੇ ਹੋਰ",
    coloring_choose_style: "ਰੰਗ ਸ਼ੈਲੀ ਚੁਣੋ",
    coloring_style_oil_pastel: "ਆਇਲ ਪੇਸਟਲ",
    coloring_style_watercolor: "ਵਾਟਰ ਕਲਰ",
    coloring_style_graphite_shade: "ਪੈਨਸਿਲ ਸ਼ੇਡ",
    coloring_style_color_pencil_shade: "ਰੰਗਦਾਰ ਪੈਨਸਿਲ",
    coloring_style_oil_paint: "ਆਇਲ ਪੇਂਟ",
    time_master: "ਟਾਈਮ ਮਾਸਟਰ",
    time_master_desc: "ਕਿੰਨੀ ਜਲਦੀ ਪੂਰਾ ਕਰੋਗੇ? ਆਦਰਸ਼ ਸਮੇਂ ਨਾਲ ਮੁਕਾਬਲਾ ਕਰੋ।",
    time_master_class: "ਜਮਾਤ",
    time_master_subject: "ਵਿਸ਼ਾ",
    time_master_marks: "ਅੰਕ",
    time_master_ideal: "ਆਦਰਸ਼ ਸਮਾਂ",
    time_master_elapsed: "ਤੁਹਾਡਾ ਸਮਾਂ",
    time_master_start: "ਟਾਈਮਰ ਸ਼ੁਰੂ",
    time_master_stop: "ਟਾਈਮਰ ਬੰਦ",
    time_master_pick_class: "ਜਮਾਤ ਚੁਣੋ",
    time_master_pick_subject: "ਵਿਸ਼ਾ ਚੁਣੋ",
    time_master_pick_marks: "ਅੰਕ ਚੁਣੋ",
    time_master_subj_numerical: "ਸੰਖਿਆਤਮਕ",
    time_master_subj_science: "ਵਿਗਿਆਨ",
    time_master_subj_technical: "ਤਕਨੀਕੀ",
    time_master_subj_social: "ਸਮਾਜਿਕ",
    time_master_subj_language: "ਭਾਸ਼ਾ",
    time_master_subj_other: "ਹੋਰ",
  },
  ur: {
    app_name: "ڈرائنگ ٹولز",
    tagline: "آپ کو تصویر بنانے کی تحریک دے!",
    enter_phone: "اپنا موبائل نمبر درج کریں",
    phone_placeholder: "10 ہندسوں کا موبائل",
    send_otp: "OTP بھیجیں",
    enter_otp: "6 ہندسوں کا OTP درج کریں",
    verify: "تصدیق کریں",
    resend_otp: "OTP دوبارہ بھیجیں",
    change_number: "نمبر تبدیل کریں",
    free_label: "مفت",
    paid_label: "₹",
    blueprint: "بلیو پرنٹ",
    blueprint_desc: "پہلے خاکہ بنائیں",
    pencil: "پنسل اسکیچ",
    pencil_desc: "ایک خوبصورت پنسل اسکیچ بنائیں",
    story: "میری کہانی",
    story_desc: "ایک کامک کہانی بنائیں",
    wallet: "والیٹ",
    recharge_wallet: "والٹ ری چارج کریں",
    recharge_methods: "UPI · کارڈز · نیٹ بینکنگ · والٹ",
    pay_prefix: "ادائیگی کریں",
    processing: "پروسیس ہو رہا ہے…",
    recharge_unavailable: "ری چارج فی الحال دستیاب نہیں",
    free_credit_title: "{amount} مفت کریڈٹ",
    free_credit_desc: "ہم نے آپ کو {amount} مفت والٹ کریڈٹ دیا ہے — ایک فون نمبر پر ایک بار۔",
    recent_recharges: "حالیہ ری چارج",
    gallery: "گیلری",
    take_photo: "تصویر لیں",
    retake: "دوبارہ لیں",
    use_photo: "یہ تصویر استعمال کریں",
    generating: "جادو ہو رہا ہے...",
    almost_there: "تقریباً ہو گیا!",
    download: "ڈاؤن لوڈ",
    share: "شیئر کریں",
    share_whatsapp: "واٹس ایپ",
    share_email: "ای میل",
    copy_link: "لنک کاپی کریں",
    back: "واپس",
    logout: "لاگ آؤٹ",
    your_creations: "آپ کی تخلیقات",
    no_creations: "ابھی کوئی تخلیق نہیں۔ بنانا شروع کریں!",
    insufficient_balance: "بیلنس کم ہے",
    rate_limited: "تھوڑا آرام کریں! بعد میں دوبارہ کوشش کریں۔",
    welcome: "خوش آمدید!",
    home: "ہوم",
    language: "زبان",
    balance: "بیلنس",
    create: "تخلیق کریں",
    platform_name: "سرل آئی",
    platform_tagline: "علم کے سمندر کو آسان بناتے ہوئے",
    module_drawing_title: "ڈرائنگ ٹولز",
    module_drawing_desc: "بنائیں، رنگ کریں اور تخیل کریں",
    module_language_title: "زبان کے ٹولز",
    module_language_desc: "ہر مضمون سیکھیں",
    module_math_title: "ریاضی کے ٹولز",
    module_math_desc: "سیکھیں، حل کریں اور بہتر بنیں",
    mind_master_title: "مائنڈ ماسٹر",
    mind_master_desc: "مراقبہ، سانس اور سکون",
    mind_master_audio_start: "آواز چلائیں",
    mind_master_audio_stop: "آواز روکیں",
    mind_master_back: "واپس",
    life_intro_heading: "خود کو پہچاننے کے لیے چند لمحے دیں",
    privacy_policy: "پرائیویسی پالیسی",
    install_app: "ایپ انسٹال کریں",
    app_installs: "ایپ انسٹال",
    coming_soon: "جلد آ رہا ہے",
    open_now: "کھولیں",
    make_another: "ایک اور بنائیں",
    upload_from_gallery: "گیلری سے اپ لوڈ کریں",
    math_tagline: "ریاضی کے سوال کی تصویر لیں — اشارہ یا مکمل حل پائیں۔",
    math_hint: "اشارہ",
    math_hint_desc: "آپ کی زبان میں آسان اشارہ، آڈیو کے ساتھ",
    math_solution: "حل",
    math_solution_desc: "نوٹ بک طرز پر مکمل قدم بہ قدم حل",

    share_confirm_prompt: "کیا آپ نے واٹس ایپ پر پیغام شیئر کیا؟",
    share_confirm_yes: "ہاں، شیئر کیا",
    share_confirm_no: "ابھی نہیں",

    help_a_friend: "دوست کی مدد کریں",
    help_a_friend_intro: "شیئر کرنا خیال ہے — دوست کو بھی ساتھ پڑھنے بلائیں۔",
    help_a_friend_msg_greeting: "آئیں مل کر سیکھیں!",
    help_a_friend_msg_body: "میں پڑھائی کے لیے Saral Eye استعمال کر رہا ہوں۔ آپ بھی جڑیں:",
    help_a_friend_msg_tagline: "سیکھیں • بڑھیں • مدد کریں",
    share_on_whatsapp: "واٹس ایپ پر شیئر کریں",
    share_helper_line: "ہر شیئر = ایک طالب علم کی مدد",
    join_sahaj_path: "سہج پاٹھ میں شامل ہوں",
    sahaj_path_hint: "واٹس ایپ پر مہربان مطالعہ سپورٹ گروپ",
    level_blaze: "لیول بلیز",
    helped_label: "مدد کی",
    level_student: "طالب علم",
    level_helper: "معاون",
    level_supporter: "حمایتی",
    level_mentor: "رہنما",
    level_champion: "چیمپیئن",
    progress_line: "آپ نے {n} طلبا کی مدد کی • {next} بننے کے لیے {remain} اور",
    progress_line_top: "آپ نے {n} کی مدد کی۔ چیمپیئن — شکریہ!",
    helped_toast_progress: "اب {n} کی مدد • {next} بننے کے لیے {remain} اور",
    helped_toast_simple: "آپ نے {n} طلبا کی مدد کی۔ شکریہ!",

    share_balance_title: "بیلنس شیئر",
    share_balance_desc: "دوست کو کچھ والٹ پیسے بھیجیں",
    share_recipient_phone: "وصول کنندہ کا موبائل نمبر",
    share_phone_placeholder: "مثلاً 9876543210",
    share_amount: "بھیجنے کی رقم",
    share_send_btn: "بھیجیں",
    share_success: "{phone} کو {amount} بھیجا گیا",
    share_recipient_invalid: "درست موبائل نمبر درج کریں",
    share_invalid_amount: "صفر سے زیادہ درست رقم درج کریں",
    share_insufficient_balance: "آپ کے پاس کافی بیلنس نہیں ہے",

    hourglass_view: "ریت گھڑی منظر",
    hourglass_exit: "باہر جائیں",

    colour_guide: "کلر گائیڈ",
    colour_guide_desc: "اپنی سکیچ پر روشنی، سایہ اور رنگ کی ترتیب سیکھیں",
    cg_coloring_order: "رنگ بھرنے کی ترتیب",
    cg_step_1_title: "پس منظر",
    cg_step_1_desc: "ہلکے رنگ، کم کنٹراسٹ",
    cg_step_2_title: "دور کی چیزیں",
    cg_step_2_desc: "ٹھنڈے رنگ، نرم کنٹراسٹ",
    cg_step_3_title: "زمین",
    cg_step_3_desc: "قدرتی بنیادی رنگ",
    cg_step_4_title: "بنیادی موضوع",
    cg_step_4_desc: "گہرے رنگ، اونچا کنٹراسٹ",
    cg_step_5_title: "دیگر بڑی چیزیں",
    cg_step_5_desc: "متوازن درمیانی ٹون",
    cg_step_6_title: "تفصیلات اور ہائی لائٹ",
    cg_step_6_desc: "باریک تفصیل، روشن ہائی لائٹ",
    cg_note_heading: "نوٹ",
    cg_note_1: "بنیادی موضوع کو سرخ لکیر سے واضح کیا گیا ہے۔",
    cg_note_2: "نیلے سایہ والے حصوں میں گہرے شیڈ استعمال کریں۔",

    math_mental: "مینٹل میتھ",
    math_mental_desc: "خریداری کی کہانی سنیں اور صحیح جواب چنیں",
    mm_start_practice: "مشق شروع کریں",
    mm_replay_audio: "دوبارہ سنیں",
    mm_choose_answer: "صحیح جواب چنیں",
    mm_correct: "درست! بہت خوب.",
    mm_wrong: "غلط! دوبارہ کوشش کریں.",
    mm_practice_another: "ایک اور سوال",
    mm_back: "واپس",
    mm_home: "ہوم",
    mm_generating: "آپ کا سوال تیار ہو رہا ہے...",
    mm_focus_now: "غور سے سنیں",
    mm_intro: "مینٹل میتھ کی مشق کے لیے حقیقی خریداری کی پہیلیاں",
    use_cropped_area: "یہ حصہ استعمال کریں",
    another_problem: "نیا سوال",
    hint_label: "یہ رہا ایک اشارہ",
    audio_hint_label: "سننے کے لیے Play دبائیں",
    audio_unavailable: "آڈیو دستیاب نہیں — بعد میں دوبارہ کوشش کریں۔",
    generating_hint: "اشارہ تیار ہو رہا ہے...",
    generating_solution: "حل تیار ہو رہا ہے...",
    generating_summary: "خلاصہ تیار ہو رہا ہے...",
    generating_mcq: "کوئز تیار ہو رہی ہے...",
    language_tagline: "ایک اقتباس کی تصویر لیں — خلاصہ یا کوئز پائیں۔",
    lang_summary: "خلاصہ",
    lang_summary_desc: "آپ کی زبان میں آسان خلاصہ، آڈیو کے ساتھ",
    lang_mcq: "کوئز",
    lang_mcq_desc: "مزیدار کثیر انتخابی سوالات، فوری فیڈ بیک",
    pick_age_group: "اپنی عمر کا گروپ منتخب کریں",
    age_6_10: "6–10 سال",
    age_10_14: "10–14 سال",
    age_14_18: "14–18 سال",
    age_18_plus: "18+ سال",
    summary_label: "یہ رہا ایک مختصر خلاصہ",
    audio_summary_label: "سننے کے لیے Play دبائیں",
    no_content_title: "کوئی اقتباس نہیں ملا۔",
    no_content_desc: "کیمرا کسی کہانی، سبق یا اقتباس پر رکھیں۔",
    question: "سوال",
    multi_select_hint: "ایک سے زیادہ جواب درست ہو سکتے ہیں۔",
    mcq_submit: "جواب چیک کریں",
    mcq_next: "اگلا سوال",
    mcq_see_score: "میرا اسکور دیکھیں",
    mcq_correct: "درست! 🎉",
    mcq_wrong: "اس بار نہیں۔ اگلے کی کوشش کریں!",
    mcq_correct_feedback: "بہت خوب — تمام درست جواب دیے۔",
    mcq_wrong_feedback: "سبز رنگ کے انتخاب ہی درست جواب ہیں۔",
    mcq_done_title: "زبردست کوشش!",
    mcq_all_correct: "مکمل اسکور!",
    your_score: "آپ کا اسکور",
    no_math_found_title: "ریاضی کا سوال نہیں ملا۔",
    no_math_found_desc: "کرپ ایریا میں سوال واضح رکھیں۔",
    lang_check_answer: "جواب چیک",
    lang_check_answer_desc: "لکھی ہوئی جواب شیٹ کی تصویر لیں — نمبر، صحیح/غلط اور درست جوابات پائیں",
    lang_learn_nature: "فطرت سے سیکھو",
    lang_learn_nature_desc: "کسی قدرتی منظر کی تصویر لیں — سائنس، زندگی اور مزید مضامین کے چھوٹے سبق",
    generating_learn_nature: "فطرت سے سبق تلاش کر رہے ہیں...",
    nature_lessons_label: "فطرت کے سبق",
    generating_check_answer: "جوابات چیک کر رہے ہیں...",
    no_paper_found_title: "سوالی پرچہ نہیں ملا۔",
    no_paper_found_desc: "کیمرا طالب علم کے جوابات والے سوالی پرچے پر رکھیں۔",
    lang_speech_mentor: "اسپیچ مینٹر",
    lang_speech_mentor_desc: "بہتر بولنے میں مدد کرنے والا دوستانہ AI مینٹر۔",
    speech_mentor_tap_to_record: "مائیک دبائیں اور بولنا شروع کریں",
    speech_mentor_tap_to_stop: "روکنے کے لیے دبائیں",
    speech_mentor_recording: "سن رہے ہیں...",
    speech_mentor_analyzing: "آپ کی گفتگو کا تجزیہ ہو رہا ہے...",
    speech_mentor_your_speech: "آپ کی گفتگو",
    speech_mentor_mic_denied: "مائیک کی اجازت نہیں ملی",
    speech_mentor_mic_unsupported: "اس ڈیوائس پر مائیک دستیاب نہیں",
    learn_another: "اور سیکھیں",
    try_another: "دوبارہ کریں",
    check_another: "اور چیک کریں",
    practice_again: "دوبارہ مشق کریں",
    speech_mentor_play_welcome: "خیرمقدم سننے کے لیے دبائیں",
    daily_reflection: "روزانہ کا غور",
    daily_reflection_desc: "اندرونی ترقی کے لیے 1-منٹ کا روزانہ چیک-ان",
    dr_start: "شروع کریں",
    dr_loading: "آپ کا غور تیار ہو رہا ہے...",
    dr_question_of: "سوال {n} / {total}",
    dr_your_answer: "آپ کا جواب",
    dr_best_answer: "بہترین جواب",
    dr_lesson: "سبق",
    dr_growth_score: "آج کا گروتھ اسکور",
    dr_encouragement_high: "شاندار! آپ ہر روز آگے بڑھ رہے ہیں۔",
    dr_encouragement_mid: "اچھی کوشش! روزانہ تھوڑا غور ذہن کو مضبوط بناتا ہے۔",
    dr_encouragement_low: "ہر غور ایک قدم آگے ہے۔ بڑھتے رہیں!",
    dr_next: "اگلا",
    dr_finish: "میرا اسکور دیکھیں",
    dr_try_again: "دوبارہ غور کریں",
    dr_listen: "سنیں",
    coloring: "رنگ کاری",
    coloring_desc: "کسی بھی ڈرائنگ کو فن میں بدلیں — آئل پیسٹل، واٹر کلر اور زیادہ",
    coloring_choose_style: "رنگ کا انداز چنیں",
    coloring_style_oil_pastel: "آئل پیسٹل",
    coloring_style_watercolor: "واٹر کلر",
    coloring_style_graphite_shade: "پنسل شیڈ",
    coloring_style_color_pencil_shade: "رنگین پنسل",
    coloring_style_oil_paint: "آئل پینٹ",
    time_master: "ٹائم ماسٹر",
    time_master_desc: "کتنی جلدی ختم کرو گے؟ آئیڈیل وقت سے مقابلہ کرو۔",
    time_master_class: "جماعت",
    time_master_subject: "مضمون",
    time_master_marks: "نمبر",
    time_master_ideal: "آئیڈیل وقت",
    time_master_elapsed: "تمہارا وقت",
    time_master_start: "ٹائمر شروع",
    time_master_stop: "ٹائمر بند",
    time_master_pick_class: "جماعت چنیں",
    time_master_pick_subject: "مضمون چنیں",
    time_master_pick_marks: "نمبر چنیں",
    time_master_subj_numerical: "عددی",
    time_master_subj_science: "سائنس",
    time_master_subj_technical: "تکنیکی",
    time_master_subj_social: "سماجی",
    time_master_subj_language: "زبان",
    time_master_subj_other: "دیگر",
  },
  or: {
    app_name: "ଡ୍ରଇଂ ଟୁଲ୍ସ",
    tagline: "ଚିତ୍ର ଅଙ୍କିବାକୁ ପ୍ରେରଣା ଦିଏ!",
    enter_phone: "ଆପଣଙ୍କର ମୋବାଇଲ ନମ୍ବର ଲେଖନ୍ତୁ",
    phone_placeholder: "୧୦-ଅଙ୍କୀୟ ମୋବାଇଲ",
    send_otp: "OTP ପଠାନ୍ତୁ",
    enter_otp: "୬-ଅଙ୍କୀୟ OTP ଲେଖନ୍ତୁ",
    verify: "ଯାଞ୍ଚ କରନ୍ତୁ",
    resend_otp: "OTP ପୁନଃ ପଠାନ୍ତୁ",
    change_number: "ନମ୍ବର ବଦଳାନ୍ତୁ",
    free_label: "ମାଗଣା",
    paid_label: "₹",
    blueprint: "ବ୍ଲୁ ପ୍ରିଣ୍ଟ",
    blueprint_desc: "ପ୍ରଥମେ ରୂପରେଖା ତିଆରି କରନ୍ତୁ",
    pencil: "ପେନ୍‌ସିଲ ସ୍କେଚ",
    pencil_desc: "ସୁନ୍ଦର ପେନ୍‌ସିଲ ସ୍କେଚ ତିଆରି କରନ୍ତୁ",
    story: "ମୋର କାହାଣୀ",
    story_desc: "ଏକ କମିକ ଗଳ୍ପ ତିଆରି କର",
    wallet: "ୱାଲେଟ",
    recharge_wallet: "ୱାଲେଟ ରିଚାର୍ଜ କର",
    recharge_methods: "UPI · କାର୍ଡ · ନେଟବ୍ୟାଙ୍କିଙ୍ଗ · ୱାଲେଟ",
    pay_prefix: "ପେ କର",
    processing: "ପ୍ରକ୍ରିୟା ଚାଲୁଛି…",
    recharge_unavailable: "ରିଚାର୍ଜ ବର୍ତ୍ତମାନ ଉପଲବ୍ଧ ନାହିଁ",
    free_credit_title: "{amount} ମାଗଣା କ୍ରେଡିଟ",
    free_credit_desc: "ଆମେ ଆପଣଙ୍କୁ {amount} ମାଗଣା ୱାଲେଟ କ୍ରେଡିଟ ଦେଇଛୁ — ଏକ ଫୋନ ନମ୍ବରକୁ ଥରେ।",
    recent_recharges: "ସାମ୍ପ୍ରତିକ ରିଚାର୍ଜ",
    gallery: "ଗ୍ୟାଲେରୀ",
    take_photo: "ଫଟୋ ନିଅନ୍ତୁ",
    retake: "ପୁନଃ ନିଅନ୍ତୁ",
    use_photo: "ଏହି ଫଟୋ ବ୍ୟବହାର କରନ୍ତୁ",
    generating: "ଯାଦୁ ସୃଷ୍ଟି ହେଉଛି...",
    almost_there: "ପ୍ରାୟ ଶେଷ!",
    download: "ଡାଉନଲୋଡ",
    share: "ସେୟାର କରନ୍ତୁ",
    share_whatsapp: "ୱାଟସ୍‌ଆପ",
    share_email: "ଇମେଲ",
    copy_link: "ଲିଙ୍କ କପି କରନ୍ତୁ",
    back: "ପଛକୁ",
    logout: "ଲଗ ଆଉଟ",
    your_creations: "ଆପଣଙ୍କ ସୃଷ୍ଟି",
    no_creations: "ଏବେ କୌଣସି ସୃଷ୍ଟି ନାହିଁ। ଆରମ୍ଭ କରନ୍ତୁ!",
    insufficient_balance: "ପର୍ଯ୍ୟାପ୍ତ ବ୍ୟାଲାନ୍ସ ନାହିଁ",
    rate_limited: "ଟିକିଏ ବିଶ୍ରାମ ନିଅନ୍ତୁ! ପରେ ଚେଷ୍ଟା କରନ୍ତୁ।",
    welcome: "ସ୍ୱାଗତ!",
    home: "ହୋମ",
    language: "ଭାଷା",
    balance: "ବ୍ୟାଲାନ୍ସ",
    create: "ସୃଷ୍ଟି କରନ୍ତୁ",
    platform_name: "ସରଳ ଆଇ",
    platform_tagline: "ଶିକ୍ଷାର ମହାସାଗରକୁ ସରଳ କରୁଛୁ",
    module_drawing_title: "ଡ୍ରଇଂ ଟୁଲ୍ସ",
    module_drawing_desc: "ଆଙ୍କ, ରଙ୍ଗ ଦିଅ ଓ କଳ୍ପନା କର",
    module_language_title: "ଭାଷା ଟୁଲ୍ସ",
    module_language_desc: "ପ୍ରତ୍ୟେକ ବିଷୟ ଶିଖ",
    module_math_title: "ଗଣିତ ଟୁଲ୍ସ",
    module_math_desc: "ଶିଖ, ସମାଧାନ କର ଓ ଉନ୍ନତ ହୁଅ",
    mind_master_title: "ମାଇଣ୍ଡ ମାଷ୍ଟର",
    mind_master_desc: "ଧ୍ୟାନ, ନିଶ୍ୱାସ ଓ ଶାନ୍ତି",
    mind_master_audio_start: "ଶବ୍ଦ ଚଲାନ୍ତୁ",
    mind_master_audio_stop: "ଶବ୍ଦ ବନ୍ଦ କରନ୍ତୁ",
    mind_master_back: "ପଛକୁ",
    life_intro_heading: "ନିଜକୁ ଜାଣିବା ପାଇଁ କିଛି କ୍ଷଣ ଦିଅ",
    privacy_policy: "ଗୋପନୀୟତା ନୀତି",
    install_app: "ଆପ ଇନ୍‌ଷ୍ଟଲ କରନ୍ତୁ",
    app_installs: "ଆପ ଇନ୍‌ଷ୍ଟଲ",
    coming_soon: "ଶୀଘ୍ର ଆସୁଛି",
    open_now: "ଖୋଲନ୍ତୁ",
    make_another: "ଆଉ ଗୋଟିଏ ତିଆରି କରନ୍ତୁ",
    upload_from_gallery: "ଗ୍ୟାଲେରୀରୁ ଅପଲୋଡ କରନ୍ତୁ",
    math_tagline: "ଗଣିତ ସମସ୍ୟାର ଫଟୋ ନିଅନ୍ତୁ — ସୂତ୍ର ବା ସମ୍ପୂର୍ଣ୍ଣ ସମାଧାନ ପାଆନ୍ତୁ।",
    math_hint: "ସୂତ୍ର",
    math_hint_desc: "ଆପଣଙ୍କ ଭାଷାରେ ସରଳ ସୂତ୍ର, ଅଡିଓ ସହ",
    math_solution: "ସମାଧାନ",
    math_solution_desc: "ନୋଟ୍‌ବୁକ ଶୈଳୀରେ ସମ୍ପୂର୍ଣ୍ଣ ପଦକ୍ଷେପ ସମାଧାନ",

    share_confirm_prompt: "ଆପଣ ୱାଟ୍ସଆପ୍‌ରେ ବାର୍ତ୍ତା ସେୟାର କରିଛନ୍ତି କି?",
    share_confirm_yes: "ହଁ, ସେୟାର କରିଛି",
    share_confirm_no: "ଏବେ ନୁହେଁ",

    help_a_friend: "ସାଙ୍ଗକୁ ସାହାଯ୍ୟ କରନ୍ତୁ",
    help_a_friend_intro: "ଅଂଶୀଦାର ଅର୍ଥ ଯତ୍ନ — ସାଙ୍ଗକୁ ମଧ୍ୟ ଏକାଠି ପଢ଼ିବାକୁ ଡାକନ୍ତୁ।",
    help_a_friend_msg_greeting: "ଆସନ୍ତୁ ଏକାଠି ଶିଖିବା!",
    help_a_friend_msg_body: "ମୁଁ ପାଠ ପାଇଁ Saral Eye ବ୍ୟବହାର କରୁଛି। ଆପଣ ମଧ୍ୟ ଯୋଡ଼ି ହୁଅନ୍ତୁ:",
    help_a_friend_msg_tagline: "ଶିଖ • ବଢ • ସାହାଯ୍ୟ",
    share_on_whatsapp: "ୱାଟ୍ସଆପ୍‌ରେ ସେୟାର କରନ୍ତୁ",
    share_helper_line: "ପ୍ରତି ସେୟାର = ଏକ ଛାତ୍ରକୁ ସାହାଯ୍ୟ",
    join_sahaj_path: "ସହଜ ପାଠରେ ଯୋଗଦିଅନ୍ତୁ",
    sahaj_path_hint: "ୱାଟ୍ସଆପ୍‌ରେ ମିଳନଶୀଳ ପାଠ ସହାୟ ଗୋଷ୍ଠୀ",
    level_blaze: "ଲେଭେଲ୍ ବ୍ଲେଜ୍",
    helped_label: "ସାହାଯ୍ୟ",
    level_student: "ଛାତ୍ର",
    level_helper: "ସହାୟକ",
    level_supporter: "ସମର୍ଥକ",
    level_mentor: "ମାର୍ଗଦର୍ଶୀ",
    level_champion: "ଚାମ୍ପିଅନ",
    progress_line: "ଆପଣ {n} ଛାତ୍ରଙ୍କୁ ସାହାଯ୍ୟ କରିଛନ୍ତି • {next} ହେବାକୁ ଆଉ {remain}",
    progress_line_top: "ଆପଣ {n} ଙ୍କୁ ସାହାଯ୍ୟ କରିଛନ୍ତି। ଚାମ୍ପିଅନ — ଧନ୍ୟବାଦ!",
    helped_toast_progress: "ବର୍ତ୍ତମାନ {n} ଙ୍କୁ ସାହାଯ୍ୟ • {next} ହେବାକୁ ଆଉ {remain}",
    helped_toast_simple: "ଆପଣ {n} ଛାତ୍ରଙ୍କୁ ସାହାଯ୍ୟ କରିଛନ୍ତି। ଧନ୍ୟବାଦ!",

    share_balance_title: "ବ୍ୟାଲାନ୍ସ ସେୟାର",
    share_balance_desc: "ସାଙ୍ଗକୁ କିଛି ୱାଲେଟ ଟଙ୍କା ପଠାନ୍ତୁ",
    share_recipient_phone: "ପାଇବା ବ୍ୟକ୍ତିଙ୍କ ମୋବାଇଲ ନମ୍ବର",
    share_phone_placeholder: "ଉଦା. 9876543210",
    share_amount: "ପଠାଇବାର ପରିମାଣ",
    share_send_btn: "ପଠାନ୍ତୁ",
    share_success: "{phone}କୁ {amount} ପଠାଗଲା",
    share_recipient_invalid: "ସଠିକ୍ ମୋବାଇଲ ନମ୍ବର ଦିଅନ୍ତୁ",
    share_invalid_amount: "ଶୂନ୍ୟଠାରୁ ଅଧିକ ସଠିକ୍ ପରିମାଣ ଦିଅନ୍ତୁ",
    share_insufficient_balance: "ଆପଣଙ୍କର ଯଥେଷ୍ଟ ବ୍ୟାଲାନ୍ସ ନାହିଁ",

    hourglass_view: "ବାଲି ଘଡ଼ି ଦୃଶ୍ୟ",
    hourglass_exit: "ପ୍ରସ୍ଥାନ",

    colour_guide: "ରଙ୍ଗ ଗାଇଡ୍",
    colour_guide_desc: "ତୁମ ଅଙ୍କନରେ ଆଲୋକ, ଛାୟା ଓ ରଙ୍ଗ କ୍ରମ ଶିଖ",
    cg_coloring_order: "ରଙ୍ଗ କରିବା କ୍ରମ",
    cg_step_1_title: "ପୃଷ୍ଠଭୂମି",
    cg_step_1_desc: "ହାଲୁକା ରଙ୍ଗ, କମ୍ କଣ୍ଟ୍ରାଷ୍ଟ",
    cg_step_2_title: "ଦୂର ବସ୍ତୁ",
    cg_step_2_desc: "ଥଣ୍ଡା ରଙ୍ଗ, କୋମଳ କଣ୍ଟ୍ରାଷ୍ଟ",
    cg_step_3_title: "ଭୂମି",
    cg_step_3_desc: "ପ୍ରାକୃତିକ ବେସ ରଙ୍ଗ",
    cg_step_4_title: "ମୁଖ୍ୟ ବିଷୟ",
    cg_step_4_desc: "ଗାଢ଼ ରଙ୍ଗ, ଉଚ୍ଚ କଣ୍ଟ୍ରାଷ୍ଟ",
    cg_step_5_title: "ଅନ୍ୟ ବଡ଼ ବସ୍ତୁ",
    cg_step_5_desc: "ସନ୍ତୁଳିତ ମଧ୍ୟ-ଟୋନ",
    cg_step_6_title: "ବିବରଣୀ ଓ ହାଇଲାଇଟ୍",
    cg_step_6_desc: "ସୂକ୍ଷ୍ମ ବିବରଣୀ, ଉଜ୍ଜ୍ୱଳ ହାଇଲାଇଟ୍",
    cg_note_heading: "ଟୀକା",
    cg_note_1: "ମୁଖ୍ୟ ବିଷୟ ଲାଲ ରେଖାରେ ଚିହ୍ନଟ ହୋଇଛି।",
    cg_note_2: "ନୀଳ ଛାୟା ଅଞ୍ଚଳରେ ଗାଢ଼ ସେଡ଼ ବ୍ୟବହାର କର।",

    math_mental: "ମେଣ୍ଟାଲ ମ୍ୟାଥ",
    math_mental_desc: "କିଣିବାର କାହାଣୀ ଶୁଣ ଏବଂ ସଠିକ ଉତ୍ତର ବାଛ",
    mm_start_practice: "ଅଭ୍ୟାସ ଆରମ୍ଭ କର",
    mm_replay_audio: "ପୁଣି ଶୁଣ",
    mm_choose_answer: "ସଠିକ ଉତ୍ତର ବାଛ",
    mm_correct: "ଠିକ୍! ବହୁତ ଭଲ.",
    mm_wrong: "ଭୁଲ! ପୁଣି ଚେଷ୍ଟା କର.",
    mm_practice_another: "ଆଉ ଏକ ପ୍ରଶ୍ନ",
    mm_back: "ପଛକୁ",
    mm_home: "ହୋମ୍",
    mm_generating: "ତୁମର ପ୍ରଶ୍ନ ପ୍ରସ୍ତୁତ ହେଉଛି...",
    mm_focus_now: "ମନ ଦେଇ ଶୁଣ",
    mm_intro: "ମେଣ୍ଟାଲ ମ୍ୟାଥ ଅଭ୍ୟାସ ପାଇଁ ପ୍ରକୃତ କିଣିବାର ଧଡ଼ି",
    use_cropped_area: "ଏହି ଅଞ୍ଚଳ ବ୍ୟବହାର କରନ୍ତୁ",
    another_problem: "ଆଉ ଗୋଟିଏ ସମସ୍ୟା",
    hint_label: "ଏଠାରେ ଏକ ସୂତ୍ର",
    audio_hint_label: "ଶୁଣିବାକୁ Play ଦବାନ୍ତୁ",
    audio_unavailable: "ଅଡିଓ ଉପଲବ୍ଧ ନାହିଁ — ପରେ ଚେଷ୍ଟା କରନ୍ତୁ।",
    generating_hint: "ସୂତ୍ର ତିଆରି ହେଉଛି...",
    generating_solution: "ସମାଧାନ ତିଆରି ହେଉଛି...",
    generating_summary: "ସାରାଂଶ ତିଆରି ହେଉଛି...",
    generating_mcq: "କୁଇଜ ତିଆରି ହେଉଛି...",
    language_tagline: "ଗୋଟିଏ ପଠ୍ୟର ଫଟୋ ନିଅନ୍ତୁ — ସାରାଂଶ ବା କୁଇଜ ପାଆନ୍ତୁ।",
    lang_summary: "ସାରାଂଶ",
    lang_summary_desc: "ଆପଣଙ୍କ ଭାଷାରେ ସରଳ ସାରାଂଶ, ଅଡିଓ ସହ",
    lang_mcq: "କୁଇଜ",
    lang_mcq_desc: "ମଜାଳିଆ ବହୁ-ବିକଳ୍ପ ପ୍ରଶ୍ନ, ତୁରନ୍ତ ପ୍ରତିକ୍ରିୟା",
    pick_age_group: "ଆପଣଙ୍କ ବୟସ ବର୍ଗ ବାଛନ୍ତୁ",
    age_6_10: "୬–୧୦ ବର୍ଷ",
    age_10_14: "୧୦–୧୪ ବର୍ଷ",
    age_14_18: "୧୪–୧୮ ବର୍ଷ",
    age_18_plus: "୧୮+ ବର୍ଷ",
    summary_label: "ଏଠାରେ ଏକ ଛୋଟ ସାରାଂଶ",
    audio_summary_label: "ଶୁଣିବାକୁ Play ଦବାନ୍ତୁ",
    no_content_title: "କୌଣସି ପଠ୍ୟ ମିଳିଲା ନାହିଁ।",
    no_content_desc: "କ୍ୟାମେରା କୌଣସି କାହାଣୀ, ପାଠ ବା ପଠ୍ୟ ଉପରେ ରଖନ୍ତୁ।",
    question: "ପ୍ରଶ୍ନ",
    multi_select_hint: "ଏକାଧିକ ଉତ୍ତର ସଠିକ ହୋଇପାରେ।",
    mcq_submit: "ଉତ୍ତର ଯାଞ୍ଚ କରନ୍ତୁ",
    mcq_next: "ପରବର୍ତ୍ତୀ ପ୍ରଶ୍ନ",
    mcq_see_score: "ମୋର ସ୍କୋର ଦେଖନ୍ତୁ",
    mcq_correct: "ସଠିକ! 🎉",
    mcq_wrong: "ସଠିକ ନୁହେଁ। ପରବର୍ତ୍ତୀ ଚେଷ୍ଟା କରନ୍ତୁ!",
    mcq_correct_feedback: "ବାହାଃ — ସବୁ ସଠିକ ଉତ୍ତର ଦେଲେ।",
    mcq_wrong_feedback: "ସବୁଜ ବିକଳ୍ପଗୁଡ଼ିକ ସଠିକ ଉତ୍ତର।",
    mcq_done_title: "ଚମତ୍କାର ଚେଷ୍ଟା!",
    mcq_all_correct: "ସମ୍ପୂର୍ଣ୍ଣ ସ୍କୋର!",
    your_score: "ଆପଣଙ୍କ ସ୍କୋର",
    no_math_found_title: "ଗଣିତ ସମସ୍ୟା ମିଳିଲା ନାହିଁ।",
    no_math_found_desc: "କ୍ରପ ଅଞ୍ଚଳରେ ସମସ୍ୟା ସ୍ପଷ୍ଟ ରଖନ୍ତୁ।",
    lang_check_answer: "ଉତ୍ତର ଯାଞ୍ଚ",
    lang_check_answer_desc: "ଲେଖାଯାଇଥିବା ଉତ୍ତର ପତ୍ରର ଫଟୋ ନିଅନ୍ତୁ — ନମ୍ବର, ଠିକ୍/ଭୁଲ ଓ ସଠିକ୍ ଉତ୍ତର",
    lang_learn_nature: "ପ୍ରକୃତିରୁ ଶିଖ",
    lang_learn_nature_desc: "ପ୍ରକୃତିର ଫଟୋ ନିଅନ୍ତୁ — ବିଜ୍ଞାନ, ଜୀବନ ଓ ଅନ୍ୟ ବିଷୟର ଛୋଟ ପାଠ ପାଆନ୍ତୁ",
    generating_learn_nature: "ପ୍ରକୃତିରୁ ପାଠ ଖୋଜୁଛୁ...",
    nature_lessons_label: "ପ୍ରକୃତିରୁ ପାଠ",
    generating_check_answer: "ଉତ୍ତର ଯାଞ୍ଚ କରୁଛୁ...",
    no_paper_found_title: "ପ୍ରଶ୍ନ ପତ୍ର ମିଳିଲା ନାହିଁ।",
    no_paper_found_desc: "ଛାତ୍ର ଉତ୍ତର ଥିବା ପ୍ରଶ୍ନ ପତ୍ର ଉପରେ କ୍ୟାମେରା ରଖନ୍ତୁ।",
    lang_speech_mentor: "ସ୍ପିଚ୍ ମେଣ୍ଟର",
    lang_speech_mentor_desc: "ଭଲ କୁହିବାରେ ସାହାଯ୍ୟ କରୁଥିବା ବନ୍ଧୁତ୍ୱପୂର୍ଣ୍ଣ AI ମେଣ୍ଟର।",
    speech_mentor_tap_to_record: "ମାଇକ୍ ଟାପ୍ କରି କୁହନ୍ତୁ",
    speech_mentor_tap_to_stop: "ବନ୍ଦ କରିବାକୁ ଟାପ୍ କରନ୍ତୁ",
    speech_mentor_recording: "ଶୁଣୁଛୁ...",
    speech_mentor_analyzing: "ଆପଣଙ୍କ କଥାର ବିଶ୍ଳେଷଣ କରୁଛୁ...",
    speech_mentor_your_speech: "ଆପଣଙ୍କ କଥା",
    speech_mentor_mic_denied: "ମାଇକ୍ ଅନୁମତି ମିଳିଲା ନାହିଁ",
    speech_mentor_mic_unsupported: "ଏହି ଡିଭାଇସ୍‌ରେ ମାଇକ୍ ନାହିଁ",
    learn_another: "ଆଉ ଶିଖ",
    try_another: "ପୁଣି ଚେଷ୍ଟା",
    check_another: "ଆଉ ଯାଞ୍ଚ",
    practice_again: "ପୁଣି ଅଭ୍ୟାସ",
    speech_mentor_play_welcome: "ସ୍ୱାଗତ ଶୁଣିବାକୁ ଟାପ କରନ୍ତୁ",
    daily_reflection: "ଦୈନିକ ଚିନ୍ତନ",
    daily_reflection_desc: "ଆତ୍ମବିକାଶ ପାଇଁ ୧-ମିନଟ୍ ଦୈନିକ ଚିନ୍ତନ",
    dr_start: "ଆରମ୍ଭ କରନ୍ତୁ",
    dr_loading: "ଆପଣଙ୍କ ଚିନ୍ତନ ପ୍ରସ୍ତୁତ ହେଉଛି...",
    dr_question_of: "ପ୍ରଶ୍ନ {n} / {total}",
    dr_your_answer: "ଆପଣଙ୍କ ଉତ୍ତର",
    dr_best_answer: "ସର୍ବଶ୍ରେଷ୍ଠ ଉତ୍ତର",
    dr_lesson: "ଶିକ୍ଷା",
    dr_growth_score: "ଆଜିର ଗ୍ରୋଥ ସ୍କୋର",
    dr_encouragement_high: "ଅତି ସୁନ୍ଦର! ଆପଣ ପ୍ରତିଦିନ ଆଗକୁ ବଢୁଛନ୍ତି।",
    dr_encouragement_mid: "ଭଲ ପ୍ରୟାସ! ଦୈନିକ ଚିନ୍ତନ ମନକୁ ଦୃଢ କରେ।",
    dr_encouragement_low: "ପ୍ରତ୍ୟେକ ଚିନ୍ତନ ଏକ ପାହୁଣ୍ଡ। ବଢୁଥାନ୍ତୁ!",
    dr_next: "ପରବର୍ତ୍ତୀ",
    dr_finish: "ମୋ ସ୍କୋର ଦେଖ",
    dr_try_again: "ପୁନଃ ଚିନ୍ତନ",
    dr_listen: "ଶୁଣ",
    coloring: "ରଙ୍ଗ କରିବା",
    coloring_desc: "ଯେକୌଣସି ଅଙ୍କନକୁ କଳାରେ ପରିଣତ କର — ଅଏଲ ପେଷ୍ଟଲ, ଜଳ ରଙ୍ଗ ଓ ଅଧିକ",
    coloring_choose_style: "ଏକ ରଙ୍ଗ ଶୈଳୀ ବାଛନ୍ତୁ",
    coloring_style_oil_pastel: "ଅଏଲ ପେଷ୍ଟଲ",
    coloring_style_watercolor: "ଜଳ ରଙ୍ଗ",
    coloring_style_graphite_shade: "ପେନ୍ସିଲ ଛାୟା",
    coloring_style_color_pencil_shade: "ରଙ୍ଗୀନ ପେନ୍ସିଲ",
    coloring_style_oil_paint: "ଅଏଲ ପେଣ୍ଟ",
    time_master: "ଟାଇମ ମାଷ୍ଟର",
    time_master_desc: "କେତେ ଶୀଘ୍ର ଶେଷ କରିବ? ଆଦର୍ଶ ସମୟ ସହିତ ପ୍ରତିଯୋଗିତା କର।",
    time_master_class: "ଶ୍ରେଣୀ",
    time_master_subject: "ବିଷୟ",
    time_master_marks: "ମାର୍କ",
    time_master_ideal: "ଆଦର୍ଶ ସମୟ",
    time_master_elapsed: "ତୁମ ସମୟ",
    time_master_start: "ଟାଇମର ଆରମ୍ଭ",
    time_master_stop: "ଟାଇମର ବନ୍ଦ",
    time_master_pick_class: "ଶ୍ରେଣୀ ବାଛନ୍ତୁ",
    time_master_pick_subject: "ବିଷୟ ବାଛନ୍ତୁ",
    time_master_pick_marks: "ମାର୍କ ବାଛନ୍ତୁ",
    time_master_subj_numerical: "ସାଂଖ୍ୟିକ",
    time_master_subj_science: "ବିଜ୍ଞାନ",
    time_master_subj_technical: "ଯାନ୍ତ୍ରିକ",
    time_master_subj_social: "ସାମାଜିକ",
    time_master_subj_language: "ଭାଷା",
    time_master_subj_other: "ଅନ୍ୟାନ୍ୟ",
  },
  as: {
    app_name: "ড্ৰয়িং টুলছ",
    tagline: "ছবি অংকনত প্ৰেৰণা দিয়ক!",
    enter_phone: "আপোনাৰ মোবাইল নম্বৰ লিখক",
    phone_placeholder: "১০-অংকৰ মোবাইল",
    send_otp: "OTP পঠিয়াওক",
    enter_otp: "৬-অংকৰ OTP লিখক",
    verify: "পৰীক্ষা কৰক",
    resend_otp: "OTP পুনঃ পঠিয়াওক",
    change_number: "নম্বৰ সলনি কৰক",
    free_label: "বিনামূলীয়া",
    paid_label: "₹",
    blueprint: "ব্লুপ্ৰিণ্ট",
    blueprint_desc: "প্ৰথমে আউটলাইন বনাওক",
    pencil: "পেঞ্চিল স্কেচ",
    pencil_desc: "এক ধুনীয়া পেঞ্চিল স্কেচ বনাওক",
    story: "মোৰ কাহিনী",
    story_desc: "এখন কমিক কাহিনী তৈয়াৰ কৰক",
    wallet: "ৱালেট",
    recharge_wallet: "ৱালেট ৰিচাৰ্জ কৰক",
    recharge_methods: "UPI · কাৰ্ড · নেটব্যাংকিং · ৱালেট",
    pay_prefix: "আদায় কৰক",
    processing: "প্ৰক্ৰিয়াকৰণ হৈ আছে…",
    recharge_unavailable: "ৰিচাৰ্জ এতিয়া উপলব্ধ নহয়",
    free_credit_title: "{amount} বিনামূলীয়া ক্ৰেডিট",
    free_credit_desc: "আমি আপোনাক {amount} বিনামূলীয়া ৱালেট ক্ৰেডিট দিছোঁ — এটা ফোন নম্বৰত এবাৰ।",
    recent_recharges: "শেহতীয়া ৰিচাৰ্জ",
    gallery: "গেলেৰী",
    take_photo: "ফটো লওক",
    retake: "পুনৰ লওক",
    use_photo: "এই ফটো ব্যৱহাৰ কৰক",
    generating: "যাদু বনি আছে...",
    almost_there: "প্ৰায় হ'ল!",
    download: "ডাউনল'ড",
    share: "শ্বেয়াৰ কৰক",
    share_whatsapp: "হোৱাট্‌ছআপ",
    share_email: "ইমেইল",
    copy_link: "লিংক কপি কৰক",
    back: "পিছলৈ",
    logout: "লগ আউট",
    your_creations: "আপোনাৰ সৃষ্টি",
    no_creations: "এতিয়ালৈ কোনো সৃষ্টি নাই। আৰম্ভ কৰক!",
    insufficient_balance: "পৰ্যাপ্ত ব্যালেন্স নাই",
    rate_limited: "এটা বিৰতি লওক! পিছত চেষ্টা কৰক।",
    welcome: "স্বাগতম!",
    home: "হোম",
    language: "ভাষা",
    balance: "ব্যালেন্স",
    create: "সৃষ্টি কৰক",
    platform_name: "সৰল আই",
    platform_tagline: "শিকাৰ মহাসাগৰক সৰল কৰি তোলা",
    module_drawing_title: "ড্ৰয়িং টুলছ",
    module_drawing_desc: "আঁকক, ৰং কৰক আৰু কল্পনা কৰক",
    module_language_title: "ভাষা টুলছ",
    module_language_desc: "প্ৰতিটো বিষয় শিকক",
    module_math_title: "গণিত টুলছ",
    module_math_desc: "শিকক, সমাধান কৰক আৰু উন্নত কৰক",
    mind_master_title: "মাইণ্ড মাষ্টাৰ",
    mind_master_desc: "ধ্যান, উশাহ আৰু শান্তি",
    mind_master_audio_start: "ধ্বনি বজাওক",
    mind_master_audio_stop: "ধ্বনি বন্ধ কৰক",
    mind_master_back: "উভতি",
    life_intro_heading: "নিজকে চিনিবলৈ কেইটামান মুহূৰ্ত দিয়ক",
    privacy_policy: "গোপনীয়তা নীতি",
    install_app: "এপ ইনষ্টল কৰক",
    app_installs: "এপ ইনষ্টল",
    coming_soon: "অতি সোনকালে",
    open_now: "খোলক",
    make_another: "আৰু এটা বনাওক",
    upload_from_gallery: "গেলেৰীৰ পৰা আপলোড কৰক",
    math_tagline: "গণিতৰ সমস্যা ফটো তোলক — সংকেত বা সম্পূৰ্ণ সমাধান লওক।",
    math_hint: "সংকেত",
    math_hint_desc: "আপোনাৰ ভাষাত সহজ সংকেত, অডিঅ'ৰ সৈতে",
    math_solution: "সমাধান",
    math_solution_desc: "নোটবুক শৈলীত সম্পূৰ্ণ পদে পদে সমাধান",

    share_confirm_prompt: "আপুনি হোৱাটছএপত বাৰ্তা শ্বেয়াৰ কৰিলে নেকি?",
    share_confirm_yes: "হয়, কৰিলোঁ",
    share_confirm_no: "এতিয়াও নহয়",

    help_a_friend: "বন্ধুক সহায় কৰক",
    help_a_friend_intro: "শ্বেয়াৰ কৰা মানে যত্ন — বন্ধুকো একেলগে পঢ়িবলৈ মাতক।",
    help_a_friend_msg_greeting: "একেলগে শিকো!",
    help_a_friend_msg_body: "মই পঢ়াশোনাৰ বাবে Saral Eye ব্যৱহাৰ কৰোঁ। তুমিও যোগদান কৰা:",
    help_a_friend_msg_tagline: "শিকা • বাঢ়া • সহায় কৰা",
    share_on_whatsapp: "হোৱাটছএপত শ্বেয়াৰ কৰক",
    share_helper_line: "প্ৰতিটো শ্বেয়াৰ = এজন ছাত্ৰক সহায়",
    join_sahaj_path: "সহজ পাঠত যোগ দিয়ক",
    sahaj_path_hint: "হোৱাটছএপত বন্ধুত্বপূৰ্ণ অধ্যয়ন সহায়ক গোট",
    level_blaze: "লেভেল ব্লেজ",
    helped_label: "সহায় কৰিলে",
    level_student: "ছাত্ৰ",
    level_helper: "সহায়ক",
    level_supporter: "সমৰ্থক",
    level_mentor: "পথপ্ৰদৰ্শক",
    level_champion: "চেম্পিয়ন",
    progress_line: "আপুনি {n} ছাত্ৰক সহায় কৰিছে • {next} হ'বলৈ আৰু {remain}",
    progress_line_top: "আপুনি {n} জনক সহায় কৰিছে। চেম্পিয়ন — ধন্যবাদ!",
    helped_toast_progress: "এতিয়া {n} জনক সহায় • {next} হ'বলৈ আৰু {remain}",
    helped_toast_simple: "আপুনি {n} ছাত্ৰক সহায় কৰিছে। ধন্যবাদ!",

    share_balance_title: "বেলেঞ্চ শ্বেয়াৰ",
    share_balance_desc: "বন্ধুক কিছু ৱালেট টকা পঠিয়াওক",
    share_recipient_phone: "প্ৰাপকৰ মোবাইল নম্বৰ",
    share_phone_placeholder: "উদাঃ 9876543210",
    share_amount: "পঠাব লগা পৰিমাণ",
    share_send_btn: "পঠিয়াওক",
    share_success: "{phone}লৈ {amount} পঠিওৱা হ'ল",
    share_recipient_invalid: "শুদ্ধ মোবাইল নম্বৰ দিয়ক",
    share_invalid_amount: "শূন্যতকৈ অধিক শুদ্ধ পৰিমাণ দিয়ক",
    share_insufficient_balance: "আপোনাৰ যথেষ্ট বেলেঞ্চ নাই",

    hourglass_view: "বালিঘড়ী দৃশ্য",
    hourglass_exit: "প্ৰস্থান কৰক",

    colour_guide: "ৰং গাইড",
    colour_guide_desc: "আপোনাৰ অংকনত পোহৰ, ছাঁ আৰু ৰঙৰ ক্ৰম শিকক",
    cg_coloring_order: "ৰং কৰাৰ ক্ৰম",
    cg_step_1_title: "পটভূমি",
    cg_step_1_desc: "পাতল ৰং, কম কনট্ৰাস্ট",
    cg_step_2_title: "দূৰৰ বস্তু",
    cg_step_2_desc: "চেঁচা ৰং, কোমল কনট্ৰাস্ট",
    cg_step_3_title: "মাটি",
    cg_step_3_desc: "প্ৰাকৃতিক আধাৰ ৰং",
    cg_step_4_title: "মূখ্য বিষয়",
    cg_step_4_desc: "গাঢ় ৰং, উচ্চ কনট্ৰাস্ট",
    cg_step_5_title: "অন্য ডাঙৰ বস্তু",
    cg_step_5_desc: "সমতুল্য মধ্য-টোন",
    cg_step_6_title: "বিৱৰণ আৰু হাইলাইট",
    cg_step_6_desc: "সূক্ষ্ম বিৱৰণ, উজ্জ্বল হাইলাইট",
    cg_note_heading: "টোকা",
    cg_note_1: "মূখ্য বিষয়ৰ ৰেখা ৰঙা ৰঙত চিহ্নিত।",
    cg_note_2: "নীলা ছাঁ অঞ্চলত গাঢ় ছেড ব্যৱহাৰ কৰক।",

    math_mental: "মেণ্টেল মেথ",
    math_mental_desc: "কিনা-কটাৰ কাহিনী শুনক আৰু শুদ্ধ উত্তৰ বাছি লওক",
    mm_start_practice: "অভ্যাস আৰম্ভ কৰক",
    mm_replay_audio: "পুনৰ শুনক",
    mm_choose_answer: "শুদ্ধ উত্তৰ বাছি লওক",
    mm_correct: "শুদ্ধ! সুন্দৰ.",
    mm_wrong: "ভুল! পুনৰ চেষ্টা কৰক.",
    mm_practice_another: "আন এটা প্ৰশ্ন",
    mm_back: "পিছলৈ",
    mm_home: "হোম",
    mm_generating: "আপোনাৰ প্ৰশ্ন সাজু হৈ আছে...",
    mm_focus_now: "মন দি শুনক",
    mm_intro: "মেণ্টেল মেথ অভ্যাসৰ বাবে প্ৰকৃত কিনা-কটাৰ ধাঁধা",
    use_cropped_area: "এই অঞ্চল ব্যৱহাৰ কৰক",
    another_problem: "আন এটা সমস্যা",
    hint_label: "ইয়াত এটা সংকেত",
    audio_hint_label: "শুনিবলৈ Play টিপক",
    audio_unavailable: "অডিঅ' উপলব্ধ নাই — পিছত চেষ্টা কৰক।",
    generating_hint: "সংকেত তৈয়াৰ হৈ আছে...",
    generating_solution: "সমাধান তৈয়াৰ হৈ আছে...",
    generating_summary: "সাৰাংশ তৈয়াৰ হৈ আছে...",
    generating_mcq: "কুইজ তৈয়াৰ হৈ আছে...",
    language_tagline: "এটা প্যাছেজৰ ফটো লওক — সাৰাংশ বা কুইজ পাওক।",
    lang_summary: "সাৰাংশ",
    lang_summary_desc: "আপোনাৰ ভাষাত সহজ সাৰাংশ, অডিঅ'ৰ সৈতে",
    lang_mcq: "কুইজ",
    lang_mcq_desc: "ধুনীয়া বহু-বিকল্প প্ৰশ্ন, তৎকাল প্ৰতিক্ৰিয়া",
    pick_age_group: "আপোনাৰ বয়স গোট বাছনি কৰক",
    age_6_10: "৬–১০ বছৰ",
    age_10_14: "১০–১৪ বছৰ",
    age_14_18: "১৪–১৮ বছৰ",
    age_18_plus: "১৮+ বছৰ",
    summary_label: "ইয়াত এটা চমু সাৰাংশ",
    audio_summary_label: "শুনিবলৈ Play টিপক",
    no_content_title: "কোনো প্যাছেজ পোৱা নগ'ল।",
    no_content_desc: "কেমেৰা কোনো কাহিনী, পাঠ বা প্যাছেজত ৰাখক।",
    question: "প্ৰশ্ন",
    multi_select_hint: "এটাতকৈ অধিক উত্তৰ শুদ্ধ হ'ব পাৰে।",
    mcq_submit: "উত্তৰ পৰীক্ষা কৰক",
    mcq_next: "পৰৱৰ্তী প্ৰশ্ন",
    mcq_see_score: "মোৰ স্ক'ৰ চাওক",
    mcq_correct: "শুদ্ধ! 🎉",
    mcq_wrong: "এইবাৰ নহয়। পৰৱৰ্তীটো চেষ্টা কৰক!",
    mcq_correct_feedback: "চমৎকাৰ — সকলো শুদ্ধ উত্তৰ দিলে।",
    mcq_wrong_feedback: "সেউজীয়া বিকল্পসমূহেই শুদ্ধ উত্তৰ।",
    mcq_done_title: "চমৎকাৰ প্ৰচেষ্টা!",
    mcq_all_correct: "সম্পূৰ্ণ স্ক'ৰ!",
    your_score: "তোমাৰ স্ক'ৰ",
    no_math_found_title: "গণিতৰ সমস্যা পোৱা নগ'ল।",
    no_math_found_desc: "ক্ৰপ এৰিয়াত সমস্যা স্পষ্ট ৰাখক।",
    lang_check_answer: "উত্তৰ পৰীক্ষা",
    lang_check_answer_desc: "লিখা উত্তৰ-পত্ৰৰ ফটো লওক — নম্বৰ, শুদ্ধ/অশুদ্ধ আৰু সঠিক উত্তৰ",
    lang_learn_nature: "প্ৰকৃতিৰ পৰা শিকক",
    lang_learn_nature_desc: "প্ৰকৃতিৰ ফটো লওক — বিজ্ঞান, জীৱন আৰু অধিক বিষয়ৰ চুটি পাঠ পাওক",
    generating_learn_nature: "প্ৰকৃতিৰ পৰা পাঠ বিচাৰি আছোঁ...",
    nature_lessons_label: "প্ৰকৃতিৰ পাঠ",
    generating_check_answer: "উত্তৰ পৰীক্ষা কৰি আছোঁ...",
    no_paper_found_title: "প্ৰশ্নপত্ৰ পোৱা নগ'ল।",
    no_paper_found_desc: "ছাত্ৰৰ উত্তৰ থকা প্ৰশ্নপত্ৰৰ ওপৰত কেমেৰা ৰাখক।",
    lang_speech_mentor: "স্পিচ মেণ্ট’ৰ",
    lang_speech_mentor_desc: "ভালকৈ ক’ব পৰাত সহায় কৰা বন্ধুত্বপূৰ্ণ AI মেণ্ট’ৰ।",
    speech_mentor_tap_to_record: "মাইক টেপ কৰি ক'বলৈ আৰম্ভ কৰক",
    speech_mentor_tap_to_stop: "ৰখাবলৈ টেপ কৰক",
    speech_mentor_recording: "শুনি আছোঁ...",
    speech_mentor_analyzing: "আপোনাৰ কথাৰ বিশ্লেষণ কৰি আছোঁ...",
    speech_mentor_your_speech: "আপোনাৰ কথা",
    speech_mentor_mic_denied: "মাইকৰ অনুমতি পোৱা নগ'ল",
    speech_mentor_mic_unsupported: "এই ডিভাইচত মাইক নাই",
    learn_another: "আৰু শিকক",
    try_another: "আকৌ চেষ্টা",
    check_another: "আৰু পৰীক্ষা",
    practice_again: "আকৌ অভ্যাস",
    speech_mentor_play_welcome: "স্বাগতম শুনিবলৈ টেপ কৰক",
    daily_reflection: "দৈনন্দিন চিন্তন",
    daily_reflection_desc: "আভ্যন্তৰীণ বিকাশৰ বাবে ১-মিনিটৰ দৈনিক চেক-ইন",
    dr_start: "আৰম্ভ কৰক",
    dr_loading: "আপোনাৰ চিন্তন প্ৰস্তুত হৈ আছে...",
    dr_question_of: "প্ৰশ্ন {n} / {total}",
    dr_your_answer: "আপোনাৰ উত্তৰ",
    dr_best_answer: "শ্ৰেষ্ঠ উত্তৰ",
    dr_lesson: "শিক্ষা",
    dr_growth_score: "আজিৰ গ্ৰোথ স্কোৰ",
    dr_encouragement_high: "চমৎকাৰ! আপুনি প্ৰতিদিনে আগবাঢ়ি আছে।",
    dr_encouragement_mid: "ভাল প্ৰচেষ্টা! দৈনিক চিন্তন মনক দৃঢ় কৰে।",
    dr_encouragement_low: "প্ৰতিটো চিন্তন এখোজ আগবাঢ়ি। বৃদ্ধি হৈ থাকক!",
    dr_next: "পৰৱৰ্তী",
    dr_finish: "মোৰ স্কোৰ চাওক",
    dr_try_again: "আকৌ চিন্তন",
    dr_listen: "শুনক",
    coloring: "ৰং কৰা",
    coloring_desc: "যিকোনো আঁকাক শিল্পলৈ ৰূপান্তৰ কৰক — অইল পেষ্টেল, জল ৰং আৰু অধিক",
    coloring_choose_style: "এটা ৰঙৰ শৈলী বাছনি কৰক",
    coloring_style_oil_pastel: "অইল পেষ্টেল",
    coloring_style_watercolor: "জল ৰং",
    coloring_style_graphite_shade: "পেঞ্চিল ছাঁ",
    coloring_style_color_pencil_shade: "ৰঙীন পেঞ্চিল",
    coloring_style_oil_paint: "অইল পেইণ্ট",
    time_master: "টাইম মাষ্টাৰ",
    time_master_desc: "কিমান সোনকালে শেষ কৰিব পাৰা? আদৰ্শ সময়ৰ সৈতে প্ৰতিযোগিতা কৰা।",
    time_master_class: "শ্ৰেণী",
    time_master_subject: "বিষয়",
    time_master_marks: "নম্বৰ",
    time_master_ideal: "আদৰ্শ সময়",
    time_master_elapsed: "তোমাৰ সময়",
    time_master_start: "টাইমাৰ আৰম্ভ",
    time_master_stop: "টাইমাৰ বন্ধ",
    time_master_pick_class: "শ্ৰেণী বাছক",
    time_master_pick_subject: "বিষয় বাছক",
    time_master_pick_marks: "নম্বৰ বাছক",
    time_master_subj_numerical: "সাংখ্যিক",
    time_master_subj_science: "বিজ্ঞান",
    time_master_subj_technical: "কাৰিকৰী",
    time_master_subj_social: "সামাজিক",
    time_master_subj_language: "ভাষা",
    time_master_subj_other: "আন",
  },
  kok: {
    app_name: "ड्रॉइंग टूल्स",
    tagline: "तुमकां चित्र काडपाक प्रेरणा दिता!",
    enter_phone: "तुजो मोबायल नंबर भर",
    phone_placeholder: "१० आंकड्यांचो मोबायल",
    send_otp: "OTP धाड",
    enter_otp: "६ आंकड्यांचो OTP भर",
    verify: "तपासणी कर",
    resend_otp: "OTP परत धाड",
    change_number: "नंबर बदल",
    free_label: "फुकट",
    paid_label: "₹",
    blueprint: "ब्लूप्रिंट",
    blueprint_desc: "पयलीं रूपरेखा तयार कर",
    pencil: "पेन्सिल स्केच",
    pencil_desc: "एक सुंदर पेन्सिल स्केच तयार कर",
    story: "म्हजी कथा",
    story_desc: "एक कॉमिक कथा तयार करात",
    wallet: "वॉलेट",
    recharge_wallet: "वॉलेट रीचार्ज करात",
    recharge_methods: "UPI · कार्ड · नेटबँकिंग · वॉलेट",
    pay_prefix: "पावती करात",
    processing: "प्रक्रिया चलतां…",
    recharge_unavailable: "रीचार्ज सद्या उपलब्ध ना",
    free_credit_title: "{amount} फुकट क्रेडिट",
    free_credit_desc: "आमी तुका {amount} फुकट वॉलेट क्रेडिट दिला — एका फोन नंबराचेर एक फावटी.",
    recent_recharges: "अलीकडलेच रीचार्ज",
    gallery: "गॅलरी",
    take_photo: "फोटो काड",
    retake: "परत काड",
    use_photo: "हो फोटो वापर",
    generating: "जादू तयार जाता...",
    almost_there: "जवळ-जवळ जालें!",
    download: "डाऊनलोड",
    share: "शेअर कर",
    share_whatsapp: "व्हॉट्सॲप",
    share_email: "ईमेल",
    copy_link: "लिंक कॉपी कर",
    back: "फाटीं",
    logout: "लॉग आउट",
    your_creations: "तुजी निर्मिती",
    no_creations: "अजून निर्मिती ना. सुरू कर!",
    insufficient_balance: "पुरो शिल्लक ना",
    rate_limited: "थोडो विसांव घे! परत प्रयत्न कर.",
    welcome: "येवकार!",
    home: "घर",
    language: "भास",
    balance: "शिल्लक",
    create: "तयार कर",
    platform_name: "सरळ आय",
    platform_tagline: "शिकपाच्या दर्यायाक सादो करचें",
    module_drawing_title: "ड्रॉइंग टूल्स",
    module_drawing_desc: "काडात, रंगयात आनी कल्पना करात",
    module_language_title: "भास टूल्स",
    module_language_desc: "दर विशय शिका",
    module_math_title: "गणित टूल्स",
    module_math_desc: "शिका, सोडयात आनी सुदारात",
    mind_master_title: "माइंड मास्टर",
    mind_master_desc: "ध्यान, स्वास आनी शांती",
    mind_master_audio_start: "आवाज सुरू",
    mind_master_audio_stop: "आवाज बंद",
    mind_master_back: "फाटीं",
    life_intro_heading: "आपणाक वळखूपाक थोडे क्षण दिय्या",
    privacy_policy: "गुप्तताय धोरण",
    install_app: "ॲप इंस्टॉल कर",
    app_installs: "ॲप इंस्टॉल",
    coming_soon: "बेगीन येता",
    open_now: "उगड",
    make_another: "आनीक एक तयार कर",
    upload_from_gallery: "गॅलरीतल्यान अपलोड कर",
    math_tagline: "गणिताच्या प्रश्नाचो फोटो काड — संकेत वा पुरो उत्तर मेळय.",
    math_hint: "संकेत",
    math_hint_desc: "तुज्या भाशेंत सोपो संकेत, ऑडिओ वांगडा",
    math_solution: "उत्तर",
    math_solution_desc: "नोटबूक शैलीत पुरो पावल-पावल उत्तर",

    share_confirm_prompt: "तुमी व्हॉट्सएपेर संदेश वांटलो?",
    share_confirm_yes: "हांव, वांटलो",
    share_confirm_no: "आतां न्हय",

    help_a_friend: "इष्टाची कुमक करात",
    help_a_friend_intro: "वांटप म्हळ्यार काळजी — इष्टालाय एकठांय शिकपाक आपोवचें.",
    help_a_friend_msg_greeting: "आमी एकठांय शिकुयां!",
    help_a_friend_msg_body: "हांव अभ्यासाखातीर Saral Eye वापरतां. तुमीय जोडात:",
    help_a_friend_msg_tagline: "शिका • वाडात • कुमक करात",
    share_on_whatsapp: "व्हॉट्सएपेर वांटात",
    share_helper_line: "दर वांटप = एक विद्यार्थ्याक कुमक",
    join_sahaj_path: "सहज पाठाक जोडात",
    sahaj_path_hint: "व्हॉट्सएपेर मैत्रीपूर्ण अभ्यास आदार पंगड",
    level_blaze: "लेव्हल ब्लेझ",
    helped_label: "कुमक",
    level_student: "विद्यार्थी",
    level_helper: "आदारपी",
    level_supporter: "समर्थक",
    level_mentor: "मार्गदर्शक",
    level_champion: "चॅम्पियन",
    progress_line: "तुमी {n} विद्यार्थ्यांक कुमक केली • {next} जावंक अजून {remain}",
    progress_line_top: "तुमी {n} जाणांक कुमक केली. चॅम्पियन — देव बरें करूं!",
    helped_toast_progress: "आतां {n} जाणांक कुमक • {next} जावंक अजून {remain}",
    helped_toast_simple: "तुमी {n} विद्यार्थ्यांक कुमक केली. देव बरें करूं!",

    share_balance_title: "बॅलन्स शेअर",
    share_balance_desc: "इष्टाक थोडे वॉलेट पयशे धाडात",
    share_recipient_phone: "मेळपी वेवट्याचो मोबायल नंबर",
    share_phone_placeholder: "उदा. 9876543210",
    share_amount: "धाडपाची रक्कम",
    share_send_btn: "धाडात",
    share_success: "{phone}क {amount} धाडलें",
    share_recipient_invalid: "योग्य मोबायल नंबर घालात",
    share_invalid_amount: "शून्यापरस चड योग्य रक्कम घालात",
    share_insufficient_balance: "तुमकां पुरो बॅलन्स ना",

    hourglass_view: "बालू घड्याळ नदर",
    hourglass_exit: "बाहेर वच",

    colour_guide: "रंग मार्गदर्शक",
    colour_guide_desc: "तुजे रेखाचित्रावळींत उजवाड, सावली आनी रंगक्रम शिका",
    cg_coloring_order: "रंग भरपाचो क्रम",
    cg_step_1_title: "पाटभूंय",
    cg_step_1_desc: "फिकीर रंग, कमी कॉन्ट्रास्ट",
    cg_step_2_title: "पयशीलीं वस्तू",
    cg_step_2_desc: "थंड रंग, कोमल कॉन्ट्रास्ट",
    cg_step_3_title: "जमीन",
    cg_step_3_desc: "प्राकृतीक बेस रंग",
    cg_step_4_title: "मुख्य विशय",
    cg_step_4_desc: "गडद रंग, ऊंच कॉन्ट्रास्ट",
    cg_step_5_title: "आनीक व्हड वस्तू",
    cg_step_5_desc: "समतोल मध्यम-टोन",
    cg_step_6_title: "तपशीला आनी हायलायट",
    cg_step_6_desc: "बारीक तपशील, तेजस्वी हायलायट",
    cg_note_heading: "टीप",
    cg_note_1: "मुख्य विशयाची रूपरेखा तांबडी आसा.",
    cg_note_2: "निळे सावली भागांत गडद रंग वापर.",

    math_mental: "मेंटल मॅथ",
    math_mental_desc: "खरेदीची कथा आयका आनी बरोबर जाप निवडा",
    mm_start_practice: "अभ्यास सुरू करा",
    mm_replay_audio: "परत आयका",
    mm_choose_answer: "बरोबर जाप निवडा",
    mm_correct: "बरोबर! सुंदर.",
    mm_wrong: "चूक! परत यत्न करा.",
    mm_practice_another: "आनीक एक प्रश्न",
    mm_back: "फाटीं",
    mm_home: "होम",
    mm_generating: "तुजो प्रश्न तयार जायत आसा...",
    mm_focus_now: "लक्ष दिवन आयका",
    mm_intro: "मेंटल मॅथ अभ्यासाखातीर खर्‍या खरेदीचीं कोडीं",
    use_cropped_area: "हो वाठार वापर",
    another_problem: "आनीक एक प्रस्न",
    hint_label: "हांगा एक संकेत",
    audio_hint_label: "आयकूंक Play दाब",
    audio_unavailable: "ऑडिओ उपलब्ध ना — मागीर प्रयत्न कर.",
    generating_hint: "संकेत तयार जाता...",
    generating_solution: "उत्तर तयार जाता...",
    generating_summary: "सारांश तयार जाता...",
    generating_mcq: "क्विझ तयार जाता...",
    language_tagline: "उतार्‍याचो फोटो काड — सारांश वा क्विझ मेळय.",
    lang_summary: "सारांश",
    lang_summary_desc: "तुज्या भाशेंत सोपो सारांश, ऑडिओ वांगडा",
    lang_mcq: "क्विझ",
    lang_mcq_desc: "मजेशीर बहु-पर्यायी प्रस्न, झटपट प्रतिसाद",
    pick_age_group: "तुजो वयो गट निवड",
    age_6_10: "६–१० वर्सां",
    age_10_14: "१०–१४ वर्सां",
    age_14_18: "१४–१८ वर्सां",
    age_18_plus: "१८+ वर्सां",
    summary_label: "हांगा एक धाकटो सारांश",
    audio_summary_label: "आयकूंक Play दाब",
    no_content_title: "उतारो मेळूंक ना.",
    no_content_desc: "कॅमेरो कथा, धडो वा उतार्‍यार धर.",
    question: "प्रस्न",
    multi_select_hint: "एका परस चड जापो बरोबर आसूं शकतात.",
    mcq_submit: "जाप तपास",
    mcq_next: "फुडलो प्रस्न",
    mcq_see_score: "म्हजो स्कोअर पळय",
    mcq_correct: "बरोबर! 🎉",
    mcq_wrong: "ह्या खेपे ना. फुडलो प्रयत्न कर!",
    mcq_correct_feedback: "बरें — सगळें बरोबर निवडलें.",
    mcq_wrong_feedback: "पाचवे रंगातले पर्याय हीच बरोबर जाप.",
    mcq_done_title: "बरो प्रयत्न!",
    mcq_all_correct: "पुरो स्कोअर!",
    your_score: "तुजो स्कोअर",
    no_math_found_title: "गणिताचो प्रस्न मेळूंक ना.",
    no_math_found_desc: "क्रॉप वाठारांत प्रस्न स्पष्ट दवर.",
    lang_check_answer: "उत्तर तपासणी",
    lang_check_answer_desc: "बरयल्ल्या जवाब-पत्राचो फोटो काडात — गूण, बरोबर/चूक आनी सारकीं जबाबां मेळयात",
    lang_learn_nature: "प्रकृती कडल्यान शिका",
    lang_learn_nature_desc: "प्रकृतीचो फोटो घ्या — विज्ञान, जीवन आनी हेर विशयांचे धाकटे पाठ",
    generating_learn_nature: "प्रकृती कडल्यान पाठ सोदतां...",
    nature_lessons_label: "प्रकृतीचे पाठ",
    generating_check_answer: "जबाब तपासतां...",
    no_paper_found_title: "प्रस्न-पत्र मेळ्ळें ना.",
    no_paper_found_desc: "विद्यार्थ्याचीं जबाबां आसतलें प्रस्न-पत्र कॅमेऱ्या भितर हाडात.",
    lang_speech_mentor: "स्पीच मेंटर",
    lang_speech_mentor_desc: "बरें उलोवपाक मदत करपी इश्ट AI गुरू.",
    speech_mentor_tap_to_record: "माइक टॅप करून उलोवपाक सुरवात करात",
    speech_mentor_tap_to_stop: "थांबपाक टॅप करात",
    speech_mentor_recording: "आयकतां...",
    speech_mentor_analyzing: "तुजें उलोवप तपासतां...",
    speech_mentor_your_speech: "तुजें उलोवप",
    speech_mentor_mic_denied: "माइकाची परवानगी ना",
    speech_mentor_mic_unsupported: "ह्या डिव्हायसाचेर माइक ना",
    learn_another: "आनीक शिका",
    try_another: "परत करात",
    check_another: "आनीक तपासात",
    practice_again: "परत सराव करात",
    speech_mentor_play_welcome: "येवकार आयकपाक टॅप करात",
    daily_reflection: "दैनिक चिंतन",
    daily_reflection_desc: "अंतरीक विकासाखातीर 1-मिनट दैनिक चेक-इन",
    dr_start: "सुरू करात",
    dr_loading: "तुजें चिंतन तयार जायना...",
    dr_question_of: "प्रस्न {n} / {total}",
    dr_your_answer: "तुजें उत्तर",
    dr_best_answer: "बरें उत्तर",
    dr_lesson: "पाठ",
    dr_growth_score: "आयजचें ग्रोथ स्कोर",
    dr_encouragement_high: "बरो! तूं दर दिसा फुडें वता.",
    dr_encouragement_mid: "बरो यत्न! रोज चिंतन मन बळकट करता.",
    dr_encouragement_low: "दर एक चिंतन एक पावल फुडें. वाडत रवात!",
    dr_next: "फुडलो",
    dr_finish: "म्हजो स्कोर पळय",
    dr_try_again: "परतो चिंतन",
    dr_listen: "आयक",
    coloring: "रंग भरप",
    coloring_desc: "खंयचें चित्र कला बनयात — ऑयल पेस्टल, वॉटर कलर आनी अदीक",
    coloring_choose_style: "एक रंगाची शैली निवडात",
    coloring_style_oil_pastel: "ऑयल पेस्टल",
    coloring_style_watercolor: "वॉटर कलर",
    coloring_style_graphite_shade: "पेन्सिल सावळी",
    coloring_style_color_pencil_shade: "रंगीत पेन्सिल",
    coloring_style_oil_paint: "तेल रंग",
    time_master: "वेळ मास्टर",
    time_master_desc: "किती लवकर सोंपोवचें? आदर्श वेळाकडेन शर्त लाव.",
    time_master_class: "वर्ग",
    time_master_subject: "विशय",
    time_master_marks: "गूण",
    time_master_ideal: "आदर्श वेळ",
    time_master_elapsed: "तुजो वेळ",
    time_master_start: "टायमर सुरू",
    time_master_stop: "टायमर बंद",
    time_master_pick_class: "वर्ग निवडात",
    time_master_pick_subject: "विशय निवडात",
    time_master_pick_marks: "गूण निवडात",
    time_master_subj_numerical: "संख्यात्मक",
    time_master_subj_science: "विज्ञान",
    time_master_subj_technical: "तांत्रिक",
    time_master_subj_social: "सामाजीक",
    time_master_subj_language: "भास",
    time_master_subj_other: "हेर",
  },
  sa: {
    app_name: "रेखाचित्र-साधनानि",
    tagline: "त्वां रेखाचित्रं रचयितुं प्रेरयति!",
    enter_phone: "स्वकीयं चलभाषसङ्ख्यां लिखतु",
    phone_placeholder: "१० अङ्क-चलभाष-सङ्ख्या",
    send_otp: "OTP प्रेषयतु",
    enter_otp: "षडङ्क-OTP लिखतु",
    verify: "प्रमाणीकरोतु",
    resend_otp: "OTP पुनः प्रेषयतु",
    change_number: "सङ्ख्यां परिवर्तयतु",
    free_label: "निःशुल्कम्",
    paid_label: "₹",
    blueprint: "रूपरेखा",
    blueprint_desc: "प्रथमं रूपरेखां रचयतु",
    pencil: "पेन्सिल-रेखाचित्रम्",
    pencil_desc: "सुन्दरं पेन्सिल-रेखाचित्रं रचयतु",
    story: "मम कथा",
    story_desc: "एकं चित्रकथा रचयत",
    wallet: "वलेट्",
    recharge_wallet: "पर्सस्य पुनःपूरणम्",
    recharge_methods: "UPI · कार्ड · नेट्‍बङ्किङ्ग · पर्सम्",
    pay_prefix: "अर्पयतु",
    processing: "प्रक्रिया चलति…",
    recharge_unavailable: "पुनःपूरणं इदानीं न लभ्यते",
    free_credit_title: "{amount} निःशुल्कं क्रेडिट्",
    free_credit_desc: "वयं भवते {amount} निःशुल्कं पर्स-क्रेडिट् दत्तवन्तः — एकस्मै दूरभाषक्रमाङ्काय एकवारम्।",
    recent_recharges: "अद्यतनानि पुनःपूरणानि",
    gallery: "गैलरी",
    take_photo: "छायाचित्रं गृहाण",
    retake: "पुनः गृहाण",
    use_photo: "एतद् छायाचित्रं उपयुङ्ख्व",
    generating: "जादुः निर्मीयते...",
    almost_there: "प्रायः सम्पन्नम्!",
    download: "डाउनलोड्",
    share: "साझायतु",
    share_whatsapp: "व्हाट्सऍप्",
    share_email: "ईमेल्",
    copy_link: "लिङ्क् प्रतिलिप्यतु",
    back: "पुनः",
    logout: "निर्गच्छतु",
    your_creations: "भवतः सृष्टयः",
    no_creations: "अद्यापि सृष्टिः नास्ति। आरभस्व!",
    insufficient_balance: "पर्याप्तं शेषं नास्ति",
    rate_limited: "विरामं गृहाण! पश्चात् प्रयतस्व।",
    welcome: "स्वागतम्!",
    home: "गृहम्",
    language: "भाषा",
    balance: "शेषम्",
    create: "रचयतु",
    platform_name: "सरल आई",
    platform_tagline: "ज्ञानसागरं सरलं कुर्वाणाः",
    module_drawing_title: "रेखाचित्र-साधनानि",
    module_drawing_desc: "आलिख, वर्णय, कल्पयस्व",
    module_language_title: "भाषा-साधनानि",
    module_language_desc: "प्रतिविषयं शिक्ष",
    module_math_title: "गणित-साधनानि",
    module_math_desc: "शिक्ष, समाधानय, वर्धय",
    mind_master_title: "मनोनायकः",
    mind_master_desc: "ध्यानं, श्वासः, शान्तिः",
    mind_master_audio_start: "ध्वनिं चालय",
    mind_master_audio_stop: "ध्वनिं स्थगय",
    mind_master_back: "प्रत्यागच्छ",
    life_intro_heading: "आत्मानं ज्ञातुं कतिपयान् क्षणान् ददातु",
    privacy_policy: "गोपनीयता-नीतिः",
    install_app: "अनुप्रयोगं स्थापयतु",
    app_installs: "अनुप्रयोग-स्थापनानि",
    coming_soon: "शीघ्रम् आगच्छति",
    open_now: "उद्घाटयतु",
    make_another: "अपरं रचयतु",
    upload_from_gallery: "गैलरीतः अपलोड्यतु",
    math_tagline: "गणित-समस्यायाः छायाचित्रं गृहाण — सूचनां पूर्णं वा समाधानं प्राप्नोतु।",
    math_hint: "सूचना",
    math_hint_desc: "तव भाषायां सरल-सूचना, श्रव्य-सहिता",
    math_solution: "समाधानम्",
    math_solution_desc: "नोटबुक्-शैल्यां पूर्णं सोपान-सोपान-समाधानम्",

    share_confirm_prompt: "किं भवता व्हाट्सएप्-द्वारा सन्देशः प्रेषितः?",
    share_confirm_yes: "आम्, प्रेषितः",
    share_confirm_no: "अद्यापि न",

    help_a_friend: "मित्रस्य साहाय्यम्",
    help_a_friend_intro: "समाजनं स्नेहः — मित्रं सह अध्ययनाय आह्वयतु।",
    help_a_friend_msg_greeting: "आगच्छ, सहैव पठाम!",
    help_a_friend_msg_body: "अहं पठनाय Saral Eye प्रयुज्य। भवानपि योजयतु:",
    help_a_friend_msg_tagline: "पठ • वर्धस्व • साहाय्यं कुरु",
    share_on_whatsapp: "व्हाट्सएप्-द्वारा समाजयतु",
    share_helper_line: "एकैका समाजना = एकस्य छात्रस्य साहाय्यम्",
    join_sahaj_path: "सहज-पाठे योजयतु",
    sahaj_path_hint: "व्हाट्सएप्-द्वारा मित्रयुक्तः अध्ययनसमूहः",
    level_blaze: "स्तरः दीप्तः",
    helped_label: "साहाय्यम्",
    level_student: "छात्रः",
    level_helper: "साहाय्यकः",
    level_supporter: "समर्थकः",
    level_mentor: "मार्गदर्शकः",
    level_champion: "विजेता",
    progress_line: "भवता {n} छात्राणां साहाय्यं कृतम् • {next} भवितुम् अपरं {remain}",
    progress_line_top: "भवता {n} छात्राणां साहाय्यं कृतम्। विजेता — धन्यवादाः!",
    helped_toast_progress: "अधुना {n} छात्राणां साहाय्यम् • {next} भवितुम् अपरं {remain}",
    helped_toast_simple: "भवता {n} छात्राणां साहाय्यं कृतम्। धन्यवादाः!",

    share_balance_title: "अवशेषं वितरतु",
    share_balance_desc: "मित्राय किञ्चित् धनं प्रेषयतु",
    share_recipient_phone: "प्रापकस्य दूरभाषसंख्या",
    share_phone_placeholder: "यथा 9876543210",
    share_amount: "प्रेषणीयं मूल्यम्",
    share_send_btn: "प्रेषय",
    share_success: "{phone}ं प्रति {amount} प्रेषितम्",
    share_recipient_invalid: "उचितां दूरभाषसंख्यां प्रविशतु",
    share_invalid_amount: "शून्यात् अधिकं उचितं मूल्यं प्रविशतु",
    share_insufficient_balance: "पर्याप्तं धनं भवतः समीपे नास्ति",

    hourglass_view: "बालुकाघटी दृश्यम्",
    hourglass_exit: "निर्गमः",

    colour_guide: "वर्णनिर्देशिका",
    colour_guide_desc: "स्वीयचित्रे प्रकाशं छायां वर्णक्रमं च शिक्षतु",
    cg_coloring_order: "वर्णक्रमः",
    cg_step_1_title: "पृष्ठभूमिः",
    cg_step_1_desc: "मन्दवर्णाः, अल्पभेदः",
    cg_step_2_title: "दूरस्थवस्तूनि",
    cg_step_2_desc: "शीतवर्णाः, मृदुभेदः",
    cg_step_3_title: "भूमिः",
    cg_step_3_desc: "प्राकृतिकाधारवर्णाः",
    cg_step_4_title: "मुख्यविषयः",
    cg_step_4_desc: "गाढवर्णाः, उच्चभेदः",
    cg_step_5_title: "अन्यमहान्ति वस्तूनि",
    cg_step_5_desc: "समतुलितमध्यमवर्णाः",
    cg_step_6_title: "विवरणानि प्रकाशाश्च",
    cg_step_6_desc: "सूक्ष्मविवरणानि, तेजस्विनः प्रकाशाः",
    cg_note_heading: "टिप्पणी",
    cg_note_1: "मुख्यविषयस्य रेखा रक्तवर्णा अस्ति।",
    cg_note_2: "नीलच्छायाक्षेत्रेषु गाढवर्णाः प्रयुज्यन्ताम्।",

    math_mental: "मानसिकगणितम्",
    math_mental_desc: "क्रयस्य कथां शृणु सम्यक् उत्तरं च चिनु",
    mm_start_practice: "अभ्यासं आरभस्व",
    mm_replay_audio: "पुनः शृणु",
    mm_choose_answer: "सम्यक् उत्तरं चिनु",
    mm_correct: "सम्यक्! उत्तमम्.",
    mm_wrong: "अशुद्धम्! पुनः प्रयत्नं कुरु.",
    mm_practice_another: "अन्यः प्रश्नः",
    mm_back: "पुनरागमनम्",
    mm_home: "गृहम्",
    mm_generating: "तव प्रश्नः सज्जीभवति...",
    mm_focus_now: "एकाग्रतया शृणु",
    mm_intro: "मानसिकगणिताभ्यासाय वास्तविकक्रयप्रहेलिकाः",
    use_cropped_area: "एनं प्रदेशं उपयुङ्ख्व",
    another_problem: "अन्या समस्या",
    hint_label: "अत्र एका सूचना",
    audio_hint_label: "श्रवणाय Play नुदतु",
    audio_unavailable: "श्रव्यं नोपलब्धम् — पश्चात् प्रयतस्व।",
    generating_hint: "सूचना निर्मीयते...",
    generating_solution: "समाधानं निर्मीयते...",
    generating_summary: "सारांशः निर्मीयते...",
    generating_mcq: "क्विझ् निर्मीयते...",
    language_tagline: "पाठस्य छायाचित्रं गृहाण — सारांशं वा क्विझं प्राप्नोतु।",
    lang_summary: "सारांशः",
    lang_summary_desc: "तव भाषायां सरल-सारांशः, श्रव्य-सहितः",
    lang_mcq: "क्विझ्",
    lang_mcq_desc: "रोचक-बहु-विकल्प-प्रश्नाः, सद्यः प्रतिक्रिया",
    pick_age_group: "स्वकीयं वयो-वर्गं चिनुष्व",
    age_6_10: "६–१० वर्षाणि",
    age_10_14: "१०–१४ वर्षाणि",
    age_14_18: "१४–१८ वर्षाणि",
    age_18_plus: "१८+ वर्षाणि",
    summary_label: "अत्र एकः लघु-सारांशः",
    audio_summary_label: "श्रवणाय Play नुदतु",
    no_content_title: "कः अपि पाठः न प्राप्तः।",
    no_content_desc: "कैमरां कस्यापि कथा-पाठ-स्थाने धारयतु।",
    question: "प्रश्नः",
    multi_select_hint: "एकतोऽधिकाः उत्तराः सम्यक् भवितुम् अर्हन्ति।",
    mcq_submit: "उत्तरं परीक्षयतु",
    mcq_next: "अग्रिमः प्रश्नः",
    mcq_see_score: "मम अङ्कान् पश्यतु",
    mcq_correct: "सम्यक्! 🎉",
    mcq_wrong: "नैव। अग्रिमे प्रयतस्व!",
    mcq_correct_feedback: "उत्तमम् — सर्वाणि सम्यक् उत्तराणि दत्तानि।",
    mcq_wrong_feedback: "हरित-विकल्पाः एव सम्यक् उत्तराणि।",
    mcq_done_title: "उत्तम-प्रयासः!",
    mcq_all_correct: "पूर्णाङ्काः!",
    your_score: "तव अङ्काः",
    no_math_found_title: "गणित-समस्या न प्राप्ता।",
    no_math_found_desc: "क्रॉप-प्रदेशे समस्या स्पष्टा भवतु।",
    lang_check_answer: "उत्तर-परीक्षणम्",
    lang_check_answer_desc: "लिखितस्य उत्तर-पत्रस्य चित्रं स्वीकुरुत — अङ्काः, सम्यक्/असम्यक् सम्यगुत्तराणि च लभध्वम्",
    lang_learn_nature: "प्रकृतेः शिक्षय",
    lang_learn_nature_desc: "प्रकृतेः चित्रं गृह्णन्तु — विज्ञानं, जीवनम् इत्यादीनां लघुपाठाः",
    generating_learn_nature: "प्रकृतेः पाठाः अन्विष्यन्ते...",
    nature_lessons_label: "प्रकृतेः पाठाः",
    generating_check_answer: "उत्तराणि परीक्ष्यन्ते...",
    no_paper_found_title: "प्रश्न-पत्रं न प्राप्तम्।",
    no_paper_found_desc: "छात्रस्य उत्तरयुक्तं प्रश्न-पत्रं कैमरां प्रति योजयतु।",
    lang_speech_mentor: "वाक्-गुरुः",
    lang_speech_mentor_desc: "सम्यक् भाषणे साहाय्यं करोति सुहृत् AI-गुरुः।",
    speech_mentor_tap_to_record: "माइकं स्पृशतु भाषणं आरभताम्",
    speech_mentor_tap_to_stop: "विरामार्थं स्पृशतु",
    speech_mentor_recording: "श्रूयते...",
    speech_mentor_analyzing: "भवतः भाषणं विश्लिष्यते...",
    speech_mentor_your_speech: "भवतः भाषणम्",
    speech_mentor_mic_denied: "माइक-अनुमतिः न प्राप्ता",
    speech_mentor_mic_unsupported: "अस्मिन् यन्त्रे माइकः नास्ति",
    learn_another: "अन्यत् शिक्षतु",
    try_another: "पुनः यत्नः",
    check_another: "अन्यत् परीक्षतु",
    practice_again: "पुनः अभ्यासः",
    speech_mentor_play_welcome: "स्वागतं श्रोतुम् स्पृशतु",
    daily_reflection: "दैनिकं चिन्तनम्",
    daily_reflection_desc: "आन्तरिकवृद्ध्यर्थं १-निमिषात्मकं दैनिकं परीक्षणम्",
    dr_start: "आरभताम्",
    dr_loading: "भवतः चिन्तनं सिद्ध्यते...",
    dr_question_of: "प्रश्नः {n} / {total}",
    dr_your_answer: "भवतः उत्तरम्",
    dr_best_answer: "श्रेष्ठम् उत्तरम्",
    dr_lesson: "पाठः",
    dr_growth_score: "अद्य वृद्धि-अङ्कः",
    dr_encouragement_high: "साधु! भवान् प्रतिदिनं वर्धते।",
    dr_encouragement_mid: "उत्तमः यत्नः। प्रतिदिनं चिन्तनं मनसः बलं वर्धयति।",
    dr_encouragement_low: "प्रत्येकं चिन्तनं एकः पादः अग्रे। वर्धस्व!",
    dr_next: "अग्रे",
    dr_finish: "मम अङ्कं पश्य",
    dr_try_again: "पुनः चिन्तनम्",
    dr_listen: "श्रुणु",
    coloring: "वर्णलेपनम्",
    coloring_desc: "किमपि चित्रं कलायाः रूपेण परिणमयतु — तैल-वर्तिः, जल-वर्णः, अन्यच्च",
    coloring_choose_style: "एकं वर्ण-शैली चिनुत",
    coloring_style_oil_pastel: "तैल-वर्तिः",
    coloring_style_watercolor: "जल-वर्णः",
    coloring_style_graphite_shade: "लेखनी-छाया",
    coloring_style_color_pencil_shade: "वर्ण-लेखनी",
    coloring_style_oil_paint: "तैल-चित्रम्",
    time_master: "काल-नायकः",
    time_master_desc: "कतिं शीघ्रं समापयसि? आदर्श-कालेन सह स्पर्धस्व।",
    time_master_class: "कक्षा",
    time_master_subject: "विषयः",
    time_master_marks: "अङ्काः",
    time_master_ideal: "आदर्श-कालः",
    time_master_elapsed: "तव कालः",
    time_master_start: "कालमापन-आरम्भः",
    time_master_stop: "कालमापन-विरामः",
    time_master_pick_class: "कक्षां चिनुत",
    time_master_pick_subject: "विषयं चिनुत",
    time_master_pick_marks: "अङ्कान् चिनुत",
    time_master_subj_numerical: "सांख्यिकम्",
    time_master_subj_science: "विज्ञानम्",
    time_master_subj_technical: "प्रौद्योगिकी",
    time_master_subj_social: "सामाजिकम्",
    time_master_subj_language: "भाषा",
    time_master_subj_other: "अन्यत्",
  },
  mai: {
    app_name: "ड्रॉइंग टूल्स",
    tagline: "अहाँकेँ चित्र बनेबाक प्रेरणा देत!",
    enter_phone: "अपन मोबाइल नंबर लिखू",
    phone_placeholder: "१० अंकक मोबाइल",
    send_otp: "OTP पठाउ",
    enter_otp: "६ अंकक OTP लिखू",
    verify: "जाँच करू",
    resend_otp: "OTP पुनः पठाउ",
    change_number: "नंबर बदलू",
    free_label: "मुफ्त",
    paid_label: "₹",
    blueprint: "ब्लूप्रिंट",
    blueprint_desc: "पहिने रूपरेखा बनाउ",
    pencil: "पेंसिल स्केच",
    pencil_desc: "एक सुन्दर पेंसिल स्केच बनाउ",
    story: "हमर कथा",
    story_desc: "एक कॉमिक कथा बनाउ",
    wallet: "वॉलेट",
    recharge_wallet: "वॉलेट रिचार्ज करू",
    recharge_methods: "UPI · कार्ड · नेटबैंकिंग · वॉलेट",
    pay_prefix: "भुगतान करू",
    processing: "प्रक्रिया चलैत अछि…",
    recharge_unavailable: "रिचार्ज अखन उपलब्ध नहि",
    free_credit_title: "{amount} मुफ्त क्रेडिट",
    free_credit_desc: "हम अहाँकें {amount} मुफ्त वॉलेट क्रेडिट देलियै — एक फ़ोन नम्बर पर एक बेर।",
    recent_recharges: "हालक रिचार्ज",
    gallery: "गैलरी",
    take_photo: "फोटो लिअ",
    retake: "फेर लिअ",
    use_photo: "ई फोटो उपयोग करू",
    generating: "जादू बनि रहल अछि...",
    almost_there: "लगभग भऽ गेल!",
    download: "डाउनलोड",
    share: "साझा करू",
    share_whatsapp: "व्हाट्सऐप",
    share_email: "ईमेल",
    copy_link: "लिंक कॉपी करू",
    back: "पाछाँ",
    logout: "लॉग आउट",
    your_creations: "अहाँक रचना",
    no_creations: "अखन धरि कोनो रचना नहि। शुरू करू!",
    insufficient_balance: "पर्याप्त राशि नहि",
    rate_limited: "थोड़ बिश्राम लिअ! पाछाँ कोशिश करू।",
    welcome: "स्वागत अछि!",
    home: "होम",
    language: "भाषा",
    balance: "राशि",
    create: "बनाउ",
    platform_name: "सरल आई",
    platform_tagline: "सीखबाक महासागरकें सरल बनबैत",
    module_drawing_title: "ड्रॉइंग टूल्स",
    module_drawing_desc: "बनाउ, रंग दिअ आ कल्पना करू",
    module_language_title: "भाषा टूल्स",
    module_language_desc: "प्रत्येक विषय सीखू",
    module_math_title: "गणित टूल्स",
    module_math_desc: "सीखू, हल करू आ आगू बढू",
    mind_master_title: "माइंड मास्टर",
    mind_master_desc: "ध्यान, साँस आ शान्ति",
    mind_master_audio_start: "ध्वनि चलाऊ",
    mind_master_audio_stop: "ध्वनि रोकू",
    mind_master_back: "वापस",
    life_intro_heading: "अपन के चिन्हे मे किछु क्षण दिय",
    privacy_policy: "गोपनीयता नीति",
    install_app: "ऐप इंस्टॉल करू",
    app_installs: "ऐप इंस्टॉल",
    coming_soon: "जल्दी आबि रहल",
    open_now: "खोलू",
    make_another: "आर एक बनाउ",
    upload_from_gallery: "गैलरी सँ अपलोड करू",
    math_tagline: "गणित प्रश्नक फोटो लिअ — सङ्केत वा पूर्ण समाधान पाउ।",
    math_hint: "सङ्केत",
    math_hint_desc: "अहाँक भाषा मे सरल सङ्केत, ऑडियो सङ",
    math_solution: "समाधान",
    math_solution_desc: "नोटबुक शैली मे पूर्ण क्रमबद्ध समाधान",

    share_confirm_prompt: "की अहाँ व्हाट्सएप पर सन्देश शेयर केलहुँ?",
    share_confirm_yes: "हाँ, केलहुँ",
    share_confirm_no: "आब नहि",

    help_a_friend: "मित्रकेँ मदति करू",
    help_a_friend_intro: "बंटनाइ स्नेह अछि — मित्रकेँ सेहो सङ्ग पढ़बा लेल बजाउ।",
    help_a_friend_msg_greeting: "आउ मिल कऽ सीखू!",
    help_a_friend_msg_body: "हम पढ़ाइक लेल Saral Eye प्रयोग कऽ रहल छी। अहूँ जुड़ू:",
    help_a_friend_msg_tagline: "सीखू • बढ़ू • मदति करू",
    share_on_whatsapp: "व्हाट्सएप पर शेयर करू",
    share_helper_line: "प्रत्येक शेयर = एक छात्रक मदति",
    join_sahaj_path: "सहज पाठ में जुड़ू",
    sahaj_path_hint: "व्हाट्सएप पर मैत्रीपूर्ण पढ़ाइ सहायता समूह",
    level_blaze: "लेवल ब्लेज़",
    helped_label: "मदति भेल",
    level_student: "छात्र",
    level_helper: "सहायक",
    level_supporter: "समर्थक",
    level_mentor: "मार्गदर्शक",
    level_champion: "चैम्पियन",
    progress_line: "अहाँ {n} छात्रकेँ मदति केलहुँ • {next} बनबा में आर {remain}",
    progress_line_top: "अहाँ {n}केँ मदति केलहुँ। चैम्पियन — धन्यवाद!",
    helped_toast_progress: "आब {n}केँ मदति • {next} बनबा में आर {remain}",
    helped_toast_simple: "अहाँ {n} छात्रकेँ मदति केलहुँ। धन्यवाद!",

    share_balance_title: "बैलेंस शेयर",
    share_balance_desc: "मित्रकेँ किछु वॉलेटक टका पठाउ",
    share_recipient_phone: "प्राप्तकर्ताक मोबाइल नंबर",
    share_phone_placeholder: "जेना 9876543210",
    share_amount: "पठएबाक राशि",
    share_send_btn: "पठाउ",
    share_success: "{phone}केँ {amount} पठाओल गेल",
    share_recipient_invalid: "मान्य मोबाइल नंबर दिअ'",
    share_invalid_amount: "शून्य सँ अधिक मान्य राशि दिअ'",
    share_insufficient_balance: "अहाँक लग पर्याप्त बैलेंस नै अछि",

    hourglass_view: "बालू घड़ी दृश्य",
    hourglass_exit: "बाहर जाउ",

    colour_guide: "रंग गाइड",
    colour_guide_desc: "अपन आकृति पर रौशनी, छाया आ रंगक क्रम सीखू",
    cg_coloring_order: "रंग भरै के क्रम",
    cg_step_1_title: "पृष्ठभूमि",
    cg_step_1_desc: "हल्लुक रंग, कम कंट्रास्ट",
    cg_step_2_title: "दूरक वस्तु",
    cg_step_2_desc: "ठंढा रंग, नरम कंट्रास्ट",
    cg_step_3_title: "जमीन",
    cg_step_3_desc: "प्राकृतिक बेस रंग",
    cg_step_4_title: "मुख्य विषय",
    cg_step_4_desc: "गाढ़ रंग, तेज कंट्रास्ट",
    cg_step_5_title: "आर पैघ वस्तु",
    cg_step_5_desc: "संतुलित मध्यम-टोन",
    cg_step_6_title: "विवरण आ हाइलाइट",
    cg_step_6_desc: "सूक्ष्म विवरण, चमकैत हाइलाइट",
    cg_note_heading: "टीप",
    cg_note_1: "मुख्य विषयक रेखा लाल रंगमे अछि।",
    cg_note_2: "नील छायावला भागमे गाढ़ रंग लगाबू।",

    math_mental: "मेंटल मैथ",
    math_mental_desc: "खरीदारीक कथा सुनू आ सही उत्तर चुनू",
    mm_start_practice: "अभ्यास शुरू करू",
    mm_replay_audio: "फेर सुनू",
    mm_choose_answer: "सही उत्तर चुनू",
    mm_correct: "सही! नीक.",
    mm_wrong: "गलत! फेर सँ प्रयास करू.",
    mm_practice_another: "आर एकटा प्रश्न",
    mm_back: "पाछू",
    mm_home: "होम",
    mm_generating: "अहाँक प्रश्न तैयार भऽ रहल अछि...",
    mm_focus_now: "मन दऽ कऽ सुनू",
    mm_intro: "मेंटल मैथ अभ्यासक लेल वास्तविक खरीदारीक पहेली",
    use_cropped_area: "ई क्षेत्र उपयोग करू",
    another_problem: "आर एक प्रश्न",
    hint_label: "ई रहल एक सङ्केत",
    audio_hint_label: "सुनबा लेल Play दबाउ",
    audio_unavailable: "ऑडियो उपलब्ध नहि — पाछाँ कोशिश करू।",
    generating_hint: "सङ्केत बनि रहल...",
    generating_solution: "समाधान बनि रहल...",
    generating_summary: "सारांश बनि रहल...",
    generating_mcq: "क्विज बनि रहल...",
    language_tagline: "एक गद्यांशक फोटो लिअ — सारांश वा क्विज पाउ।",
    lang_summary: "सारांश",
    lang_summary_desc: "अहाँक भाषा मे सरल सारांश, ऑडियो सङ",
    lang_mcq: "क्विज",
    lang_mcq_desc: "मजेदार बहु-विकल्पी प्रश्न, तत्काल प्रतिक्रिया",
    pick_age_group: "अपन उमेर वर्ग चुनू",
    age_6_10: "६–१० साल",
    age_10_14: "१०–१४ साल",
    age_14_18: "१४–१८ साल",
    age_18_plus: "१८+ साल",
    summary_label: "ई रहल एक छोट सारांश",
    audio_summary_label: "सुनबा लेल Play दबाउ",
    no_content_title: "कोनो गद्यांश नहि भेटल।",
    no_content_desc: "कैमरा कोनो कथा, पाठ वा गद्यांश पर राखू।",
    question: "प्रश्न",
    multi_select_hint: "एक सँ अधिक उत्तर सही भऽ सकैत अछि।",
    mcq_submit: "उत्तर जाँचू",
    mcq_next: "अगिला प्रश्न",
    mcq_see_score: "हमर स्कोर देखू",
    mcq_correct: "सही! 🎉",
    mcq_wrong: "एहि बेर नहि। अगिला कोशिश करू!",
    mcq_correct_feedback: "उत्तम — सभ सही उत्तर देल।",
    mcq_wrong_feedback: "हरियर रंगक विकल्प सही उत्तर थिक।",
    mcq_done_title: "उत्तम प्रयास!",
    mcq_all_correct: "पूर्ण स्कोर!",
    your_score: "अहाँक स्कोर",
    no_math_found_title: "गणित प्रश्न नहि भेटल।",
    no_math_found_desc: "क्रॉप क्षेत्र मे प्रश्न स्पष्ट राखू।",
    lang_check_answer: "उत्तर जाँच",
    lang_check_answer_desc: "लिखल उत्तर-पत्र के फोटो लिअ — नम्बर, सही/गलत आ सही उत्तर पाउ",
    lang_learn_nature: "प्रकृति सँ सीखू",
    lang_learn_nature_desc: "प्रकृति के फोटो लिअ — विज्ञान, जीवन आ आर विषयक छोट पाठ पाउ",
    generating_learn_nature: "प्रकृति सँ पाठ ताकि रहल छी...",
    nature_lessons_label: "प्रकृति सँ पाठ",
    generating_check_answer: "उत्तर जाँचि रहल छी...",
    no_paper_found_title: "प्रश्न-पत्र नै भेटल।",
    no_paper_found_desc: "छात्र के उत्तर वाला प्रश्न-पत्र पर कैमरा राखू।",
    lang_speech_mentor: "स्पीच मेंटर",
    lang_speech_mentor_desc: "नीक बजबाक लेल सहायक मित्रवत AI गुरु।",
    speech_mentor_tap_to_record: "माइक दबाऊ आ बजनाइ शुरू करू",
    speech_mentor_tap_to_stop: "बंद करबाक लेल दबाऊ",
    speech_mentor_recording: "सुनि रहल छी...",
    speech_mentor_analyzing: "अहाँक बोली परखल जा रहल अछि...",
    speech_mentor_your_speech: "अहाँक बोली",
    speech_mentor_mic_denied: "माइक अनुमति नै भेटल",
    speech_mentor_mic_unsupported: "ई यंत्र में माइक नै अछि",
    learn_another: "आर सीखू",
    try_another: "फेर करू",
    check_another: "आर परखू",
    practice_again: "फेर अभ्यास करू",
    speech_mentor_play_welcome: "स्वागत सुनबाक लेल दबाऊ",
    daily_reflection: "दैनिक चिंतन",
    daily_reflection_desc: "भीतर्री विकास लेल १-मिनट दैनिक जाँच",
    dr_start: "प्रारंभ करू",
    dr_loading: "अहाँक चिंतन तैयार भ' रहल अछि...",
    dr_question_of: "प्रश्न {n} / {total}",
    dr_your_answer: "अहाँक उत्तर",
    dr_best_answer: "सर्वोत्तम उत्तर",
    dr_lesson: "सीख",
    dr_growth_score: "आजुक ग्रोथ स्कोर",
    dr_encouragement_high: "बहुत नीक! अहाँ रोज आगू बढ़ि रहल छी।",
    dr_encouragement_mid: "नीक प्रयास! रोज थोड़ चिंतन मन के मजगूत करैत अछि।",
    dr_encouragement_low: "प्रत्येक चिंतन एक कदम आगू। बढ़ैत रहू!",
    dr_next: "आगू",
    dr_finish: "हमर स्कोर देखू",
    dr_try_again: "फेर चिंतन",
    dr_listen: "सुनू",
    coloring: "रंग करब",
    coloring_desc: "कोनो चित्रकें कलामे बदलू — तेल पेस्टल, जलरंग आ अधिक",
    coloring_choose_style: "एक रंग शैली चुनू",
    coloring_style_oil_pastel: "तेल पेस्टल",
    coloring_style_watercolor: "जलरंग",
    coloring_style_graphite_shade: "पेन्सिल छाया",
    coloring_style_color_pencil_shade: "रंगीन पेन्सिल",
    coloring_style_oil_paint: "तेल रंग",
    time_master: "समय मास्टर",
    time_master_desc: "कतेक जल्दी समाप्त करब? आदर्श समयक संग होड़ लगाबू।",
    time_master_class: "कक्षा",
    time_master_subject: "विषय",
    time_master_marks: "अंक",
    time_master_ideal: "आदर्श समय",
    time_master_elapsed: "अहाँक समय",
    time_master_start: "टाइमर शुरू",
    time_master_stop: "टाइमर बंद",
    time_master_pick_class: "कक्षा चुनू",
    time_master_pick_subject: "विषय चुनू",
    time_master_pick_marks: "अंक चुनू",
    time_master_subj_numerical: "संख्यात्मक",
    time_master_subj_science: "विज्ञान",
    time_master_subj_technical: "तकनीकी",
    time_master_subj_social: "सामाजिक",
    time_master_subj_language: "भाषा",
    time_master_subj_other: "आन",
  },
  ne: {
    app_name: "ड्रइङ टुल्स",
    tagline: "तपाईंलाई चित्र बनाउन प्रेरणा दिन्छ!",
    enter_phone: "आफ्नो मोबाइल नम्बर लेख्नुहोस्",
    phone_placeholder: "१० अङ्कको मोबाइल",
    send_otp: "OTP पठाउनुहोस्",
    enter_otp: "६ अङ्कको OTP लेख्नुहोस्",
    verify: "प्रमाणित गर्नुहोस्",
    resend_otp: "OTP पुनः पठाउनुहोस्",
    change_number: "नम्बर परिवर्तन गर्नुहोस्",
    free_label: "नि:शुल्क",
    paid_label: "₹",
    blueprint: "ब्लुप्रिन्ट",
    blueprint_desc: "पहिले रूपरेखा बनाउनुहोस्",
    pencil: "पेन्सिल स्केच",
    pencil_desc: "एउटा राम्रो पेन्सिल स्केच बनाउनुहोस्",
    story: "मेरो कथा",
    story_desc: "एउटा कमिक कथा बनाउनुहोस्",
    wallet: "वालेट",
    recharge_wallet: "वालेट रिचार्ज गर्नुहोस्",
    recharge_methods: "UPI · कार्ड · नेटब्याङ्किङ · वालेट",
    pay_prefix: "भुक्तानी गर्नुहोस्",
    processing: "प्रक्रिया चलिरहेको छ…",
    recharge_unavailable: "रिचार्ज हाल उपलब्ध छैन",
    free_credit_title: "{amount} निःशुल्क क्रेडिट",
    free_credit_desc: "हामीले तपाईंलाई {amount} निःशुल्क वालेट क्रेडिट दिएका छौं — प्रति फोन नम्बर एक पटक।",
    recent_recharges: "हालैका रिचार्जहरू",
    gallery: "ग्यालेरी",
    take_photo: "फोटो लिनुहोस्",
    retake: "फेरि लिनुहोस्",
    use_photo: "यो फोटो प्रयोग गर्नुहोस्",
    generating: "जादु बन्दैछ...",
    almost_there: "लगभग पुग्यो!",
    download: "डाउनलोड",
    share: "साझा गर्नुहोस्",
    share_whatsapp: "ह्वाट्सऐप",
    share_email: "इमेल",
    copy_link: "लिङ्क कपी गर्नुहोस्",
    back: "फिर्ता",
    logout: "लग आउट",
    your_creations: "तपाईंका सिर्जना",
    no_creations: "अहिलेसम्म कुनै सिर्जना छैन। सुरु गर्नुहोस्!",
    insufficient_balance: "पर्याप्त मौज्दात छैन",
    rate_limited: "थोरै विश्राम लिनुहोस्! पछि फेरि प्रयास गर्नुहोस्।",
    welcome: "स्वागत छ!",
    home: "गृह",
    language: "भाषा",
    balance: "मौज्दात",
    create: "सिर्जना",
    platform_name: "सरल आई",
    platform_tagline: "सिकाइको महासागरलाई सरल बनाउँदै",
    module_drawing_title: "ड्रइङ टुल्स",
    module_drawing_desc: "कोर्नुहोस्, रङ्ग्याउनुहोस् र कल्पना गर्नुहोस्",
    module_language_title: "भाषा टुल्स",
    module_language_desc: "हरेक विषय सिक्नुहोस्",
    module_math_title: "गणित टुल्स",
    module_math_desc: "सिक्नुहोस्, समाधान गर्नुहोस् र सुधार गर्नुहोस्",
    mind_master_title: "माइन्ड मास्टर",
    mind_master_desc: "ध्यान, सास र शान्ति",
    mind_master_audio_start: "ध्वनि प्ले",
    mind_master_audio_stop: "ध्वनि रोक्नुहोस्",
    mind_master_back: "फिर्ता",
    life_intro_heading: "आफूलाई चिन्न केही क्षण दिनुहोस्",
    privacy_policy: "गोपनीयता नीति",
    install_app: "एप इन्स्टल गर्नुहोस्",
    app_installs: "एप इन्स्टल",
    coming_soon: "चाँडै आउँदै",
    open_now: "खोल्नुहोस्",
    make_another: "अर्को बनाउनुहोस्",
    upload_from_gallery: "ग्यालेरीबाट अपलोड गर्नुहोस्",
    math_tagline: "गणित समस्याको फोटो लिनुहोस् — सङ्केत वा पूर्ण समाधान पाउनुहोस्।",
    math_hint: "सङ्केत",
    math_hint_desc: "तपाईंको भाषामा सरल सङ्केत, अडियोसहित",
    math_solution: "समाधान",
    math_solution_desc: "नोटबुक शैलीमा पूर्ण चरणबद्ध समाधान",

    share_confirm_prompt: "के तपाईंले व्हाट्सएपमा सन्देश सेयर गर्नुभयो?",
    share_confirm_yes: "हो, गरेँ",
    share_confirm_no: "अझै छैन",

    help_a_friend: "साथीलाई मद्दत गर्नुहोस्",
    help_a_friend_intro: "बाँड्नु भनेको माया — साथीलाई पनि सँगै पढ्न बोलाउनुहोस्।",
    help_a_friend_msg_greeting: "आउनुहोस् सँगै सिकौँ!",
    help_a_friend_msg_body: "म पढ्नका लागि Saral Eye प्रयोग गर्दैछु। तपाईं पनि जोडिनुहोस्:",
    help_a_friend_msg_tagline: "सिक्नुहोस् • बढ्नुहोस् • मद्दत गर्नुहोस्",
    share_on_whatsapp: "व्हाट्सएपमा सेयर गर्नुहोस्",
    share_helper_line: "प्रत्येक सेयर = एक विद्यार्थीलाई मद्दत",
    join_sahaj_path: "सहज पाठमा जोडिनुहोस्",
    sahaj_path_hint: "व्हाट्सएपमा मैत्री पढाइ सहायता समूह",
    level_blaze: "लेवल ब्लेज",
    helped_label: "मद्दत गरियो",
    level_student: "विद्यार्थी",
    level_helper: "सहायक",
    level_supporter: "समर्थक",
    level_mentor: "मार्गदर्शक",
    level_champion: "च्याम्पियन",
    progress_line: "तपाईंले {n} विद्यार्थीलाई मद्दत गर्नुभयो • {next} बन्न थप {remain}",
    progress_line_top: "तपाईंले {n} जनालाई मद्दत गर्नुभयो। च्याम्पियन — धन्यवाद!",
    helped_toast_progress: "अब {n} जनालाई मद्दत • {next} बन्न थप {remain}",
    helped_toast_simple: "तपाईंले {n} विद्यार्थीलाई मद्दत गर्नुभयो। धन्यवाद!",

    share_balance_title: "बालेन्स सेयर",
    share_balance_desc: "साथीलाई केही वालेट पैसा पठाउनुहोस्",
    share_recipient_phone: "प्राप्तकर्ताको मोबाइल नम्बर",
    share_phone_placeholder: "उदा. 9876543210",
    share_amount: "पठाउने रकम",
    share_send_btn: "पठाउनुहोस्",
    share_success: "{phone}लाई {amount} पठाइयो",
    share_recipient_invalid: "मान्य मोबाइल नम्बर हाल्नुहोस्",
    share_invalid_amount: "शून्यभन्दा बढी मान्य रकम हाल्नुहोस्",
    share_insufficient_balance: "तपाईंसँग पर्याप्त बालेन्स छैन",

    hourglass_view: "बालु घडी दृश्य",
    hourglass_exit: "बाहिर निस्किनुहोस्",

    colour_guide: "रङ गाइड",
    colour_guide_desc: "आफ्नो स्केचमा उज्यालो, छाया र रङको क्रम सिक्नुहोस्",
    cg_coloring_order: "रङ भर्ने क्रम",
    cg_step_1_title: "पृष्ठभूमि",
    cg_step_1_desc: "हल्का रङ, कम कन्ट्रास्ट",
    cg_step_2_title: "टाढाका वस्तुहरू",
    cg_step_2_desc: "चिसो रङ, नरम कन्ट्रास्ट",
    cg_step_3_title: "जमिन",
    cg_step_3_desc: "प्राकृतिक आधार रङ",
    cg_step_4_title: "मुख्य विषय",
    cg_step_4_desc: "गहिरा रङ, उच्च कन्ट्रास्ट",
    cg_step_5_title: "अन्य ठूला वस्तु",
    cg_step_5_desc: "सन्तुलित मध्य-टोन",
    cg_step_6_title: "विवरण र हाइलाइट",
    cg_step_6_desc: "सूक्ष्म विवरण, चम्किलो हाइलाइट",
    cg_note_heading: "नोट",
    cg_note_1: "मुख्य विषय रातो रेखामा उल्लेखित छ।",
    cg_note_2: "निलो छायाँ क्षेत्रमा गहिरा रङ प्रयोग गर्नुहोस्।",

    math_mental: "मानसिक गणित",
    math_mental_desc: "किनमेलको कथा सुन्नुहोस् र सही उत्तर छान्नुहोस्",
    mm_start_practice: "अभ्यास सुरु गर्नुहोस्",
    mm_replay_audio: "फेरि सुन्नुहोस्",
    mm_choose_answer: "सही उत्तर छान्नुहोस्",
    mm_correct: "सही! राम्रो.",
    mm_wrong: "गलत! फेरि कोशिस गर्नुहोस्.",
    mm_practice_another: "अर्को प्रश्न",
    mm_back: "पछाडि",
    mm_home: "होम",
    mm_generating: "तपाईंको प्रश्न तयार हुँदैछ...",
    mm_focus_now: "ध्यान दिएर सुन्नुहोस्",
    mm_intro: "मानसिक गणित अभ्यासका लागि वास्तविक किनमेलका पहेलीहरू",
    use_cropped_area: "यो क्षेत्र प्रयोग गर्नुहोस्",
    another_problem: "अर्को समस्या",
    hint_label: "यो हो एक सङ्केत",
    audio_hint_label: "सुन्नका लागि Play थिच्नुहोस्",
    audio_unavailable: "अडियो उपलब्ध छैन — पछि फेरि प्रयास गर्नुहोस्।",
    generating_hint: "सङ्केत तयार हुँदैछ...",
    generating_solution: "समाधान तयार हुँदैछ...",
    generating_summary: "सारांश तयार हुँदैछ...",
    generating_mcq: "क्विज तयार हुँदैछ...",
    language_tagline: "अनुच्छेदको फोटो लिनुहोस् — सारांश वा क्विज पाउनुहोस्।",
    lang_summary: "सारांश",
    lang_summary_desc: "तपाईंको भाषामा सरल सारांश, अडियोसहित",
    lang_mcq: "क्विज",
    lang_mcq_desc: "रमाइला बहु-विकल्प प्रश्नहरू, तुरुन्तै प्रतिक्रिया",
    pick_age_group: "आफ्नो उमेर समूह छनोट गर्नुहोस्",
    age_6_10: "६–१० वर्ष",
    age_10_14: "१०–१४ वर्ष",
    age_14_18: "१४–१८ वर्ष",
    age_18_plus: "१८+ वर्ष",
    summary_label: "यो हो एक छोटो सारांश",
    audio_summary_label: "सुन्नका लागि Play थिच्नुहोस्",
    no_content_title: "कुनै अनुच्छेद भेटिएन।",
    no_content_desc: "क्यामेरालाई कथा, पाठ वा अनुच्छेदमा राख्नुहोस्।",
    question: "प्रश्न",
    multi_select_hint: "एक भन्दा बढी उत्तर सही हुन सक्छन्।",
    mcq_submit: "उत्तर जाँच्नुहोस्",
    mcq_next: "अर्को प्रश्न",
    mcq_see_score: "मेरो स्कोर हेर्नुहोस्",
    mcq_correct: "सही! 🎉",
    mcq_wrong: "यो पटक होइन। अर्कोको प्रयास गर्नुहोस्!",
    mcq_correct_feedback: "बढ़िया — सबै सही उत्तर दिनुभयो।",
    mcq_wrong_feedback: "हरियो रङका विकल्प नै सही उत्तर हुन्।",
    mcq_done_title: "उत्कृष्ट प्रयास!",
    mcq_all_correct: "पूर्ण स्कोर!",
    your_score: "तपाईंको स्कोर",
    no_math_found_title: "गणित समस्या भेटिएन।",
    no_math_found_desc: "क्रप क्षेत्रमा समस्या स्पष्ट राख्नुहोस्।",
    lang_check_answer: "उत्तर जाँच",
    lang_check_answer_desc: "लेखिएको उत्तर-पुस्तिकाको फोटो खिच्नुहोस् — अङ्क, सही/गलत र सही उत्तर पाउनुहोस्",
    lang_learn_nature: "प्रकृतिबाट सिक्नुहोस्",
    lang_learn_nature_desc: "प्रकृतिको फोटो खिच्नुहोस् — विज्ञान, जीवन र अरू विषयका छोटा पाठ",
    generating_learn_nature: "प्रकृतिबाट पाठ खोज्दै छौं...",
    nature_lessons_label: "प्रकृतिका पाठ",
    generating_check_answer: "उत्तरहरू जाँच गर्दैछौं...",
    no_paper_found_title: "प्रश्न-पत्र भेटिएन।",
    no_paper_found_desc: "विद्यार्थीको उत्तर भएको प्रश्न-पत्रमा क्यामेरा राख्नुहोस्।",
    lang_speech_mentor: "स्पिच मेन्टर",
    lang_speech_mentor_desc: "राम्रो बोल्न मद्दत गर्ने साथीले जस्तो AI मेन्टर।",
    speech_mentor_tap_to_record: "माइक थिचेर बोल्न सुरु गर्नुहोस्",
    speech_mentor_tap_to_stop: "रोक्नको लागि थिच्नुहोस्",
    speech_mentor_recording: "सुनिरहेको छु...",
    speech_mentor_analyzing: "तपाईंको बोली विश्लेषण गर्दैछौं...",
    speech_mentor_your_speech: "तपाईंको बोली",
    speech_mentor_mic_denied: "माइकको अनुमति अस्वीकार भयो",
    speech_mentor_mic_unsupported: "यस उपकरणमा माइक उपलब्ध छैन",
    learn_another: "अर्को सिक्नुहोस्",
    try_another: "फेरि प्रयास",
    check_another: "अर्को जाँच",
    practice_again: "फेरि अभ्यास",
    speech_mentor_play_welcome: "स्वागत सुन्नका लागि थिच्नुहोस्",
    daily_reflection: "दैनिक चिन्तन",
    daily_reflection_desc: "आन्तरिक विकासका लागि १-मिनेटको दैनिक जाँच",
    dr_start: "सुरु गर्नुहोस्",
    dr_loading: "तपाईंको चिन्तन तयार हुँदैछ...",
    dr_question_of: "प्रश्न {n} / {total}",
    dr_your_answer: "तपाईंको उत्तर",
    dr_best_answer: "सर्वोत्तम उत्तर",
    dr_lesson: "पाठ",
    dr_growth_score: "आजको ग्रोथ स्कोर",
    dr_encouragement_high: "उत्कृष्ट! तपाईं प्रत्येक दिन बढिरहनुभएको छ।",
    dr_encouragement_mid: "राम्रो प्रयास! दैनिक चिन्तनले मनलाई बलियो बनाउँछ।",
    dr_encouragement_low: "प्रत्येक चिन्तन एक पाइला अगाडि। बढिरहनुहोस्!",
    dr_next: "अर्को",
    dr_finish: "मेरो स्कोर हेर्नुहोस्",
    dr_try_again: "पुनः चिन्तन",
    dr_listen: "सुन्नुहोस्",
    coloring: "रङ भर्ने",
    coloring_desc: "जुनसुकै चित्रलाई कला बनाउनुहोस् — तेल पेस्टल, जलरङ र अरू",
    coloring_choose_style: "एउटा रङ शैली छान्नुहोस्",
    coloring_style_oil_pastel: "तेल पेस्टल",
    coloring_style_watercolor: "जलरङ",
    coloring_style_graphite_shade: "पेन्सिल छाया",
    coloring_style_color_pencil_shade: "रङीन पेन्सिल",
    coloring_style_oil_paint: "तेल पेन्ट",
    time_master: "समय मास्टर",
    time_master_desc: "कति चाँडो सक्ने? आदर्श समयसँग प्रतिस्पर्धा गर्नुहोस्।",
    time_master_class: "कक्षा",
    time_master_subject: "विषय",
    time_master_marks: "अंक",
    time_master_ideal: "आदर्श समय",
    time_master_elapsed: "तपाईंको समय",
    time_master_start: "टाइमर सुरु",
    time_master_stop: "टाइमर रोक्नुहोस्",
    time_master_pick_class: "कक्षा छान्नुहोस्",
    time_master_pick_subject: "विषय छान्नुहोस्",
    time_master_pick_marks: "अंक छान्नुहोस्",
    time_master_subj_numerical: "संख्यात्मक",
    time_master_subj_science: "विज्ञान",
    time_master_subj_technical: "प्राविधिक",
    time_master_subj_social: "सामाजिक",
    time_master_subj_language: "भाषा",
    time_master_subj_other: "अन्य",
  },
  sd: {
    app_name: "ڊرائنگ ٽولز",
    tagline: "اوهان کي تصوير ٺاهڻ جي ترغيب ڏئي!",
    enter_phone: "پنھنجو موبائل نمبر لکو",
    phone_placeholder: "١٠ عددي موبائل",
    send_otp: "OTP موڪليو",
    enter_otp: "٦ عددي OTP لکو",
    verify: "تصديق ڪريو",
    resend_otp: "OTP ٻيهر موڪليو",
    change_number: "نمبر تبديل ڪريو",
    free_label: "مفت",
    paid_label: "₹",
    blueprint: "بليو پرنٽ",
    blueprint_desc: "پھريائين خاڪو ٺاھيو",
    pencil: "پينسل اسڪيچ",
    pencil_desc: "ھڪ سھڻو پينسل اسڪيچ ٺاھيو",
    story: "منهنجي ڪهاڻي",
    story_desc: "هڪ ڪامڪ ڪهاڻي ٺاهيو",
    wallet: "والٽ",
    recharge_wallet: "والٽ ريچارج ڪريو",
    recharge_methods: "UPI · ڪارڊ · نيٽ بينڪنگ · والٽ",
    pay_prefix: "ادائيگي ڪريو",
    processing: "پروسيس ٿي رهيو آهي…",
    recharge_unavailable: "ريچارج في الحال دستياب نه آهي",
    free_credit_title: "{amount} مفت ڪريڊٽ",
    free_credit_desc: "اسان توهان کي {amount} مفت والٽ ڪريڊٽ ڏنو آهي — هڪ فون نمبر تي هڪ ڀيرو.",
    recent_recharges: "تازو ريچارج",
    gallery: "گيلري",
    take_photo: "فوٽو وٺو",
    retake: "وري وٺو",
    use_photo: "ھي فوٽو استعمال ڪريو",
    generating: "جادو ٺھي رھيو آھي...",
    almost_there: "تقريباً ٿي ويو!",
    download: "ڊائون لوڊ",
    share: "شيئر ڪريو",
    share_whatsapp: "واٽس ايپ",
    share_email: "اي ميل",
    copy_link: "لنڪ ڪاپي ڪريو",
    back: "واپس",
    logout: "لاگ آئوٽ",
    your_creations: "اوهان جون تخليقون",
    no_creations: "اڃا تائين ڪا تخليق نه. شروع ڪريو!",
    insufficient_balance: "ڪافي بيلنس نه آهي",
    rate_limited: "ٿورو آرام ڪريو! بعد ۾ ڪوشش ڪريو۔",
    welcome: "خوش آمديد!",
    home: "گهر",
    language: "ٻولي",
    balance: "بيلنس",
    create: "ٺاھيو",
    platform_name: "سرل آئي",
    platform_tagline: "سکڻ جي سمنڊ کي آسان بڻائيندي",
    module_drawing_title: "ڊرائنگ ٽولز",
    module_drawing_desc: "ٺاهيو، رنگ ڪريو ۽ تخيل ڪريو",
    module_language_title: "ٻولي ٽولز",
    module_language_desc: "هر مضمون سکو",
    module_math_title: "رياضي ٽولز",
    module_math_desc: "سکو، حل ڪريو ۽ بهتر ٿيو",
    mind_master_title: "مائنڊ ماسٽر",
    mind_master_desc: "مراقبو، ساهه ۽ سڪون",
    mind_master_audio_start: "آواز هلايو",
    mind_master_audio_stop: "آواز روڪيو",
    mind_master_back: "واپس",
    life_intro_heading: "پاڻ کي سڃاڻڻ لاءِ ڪجهه لمحا ڏيو",
    privacy_policy: "رازداري پاليسي",
    install_app: "ايپ انسٽال ڪريو",
    app_installs: "ايپ انسٽال",
    coming_soon: "جلد اچي رھيو",
    open_now: "کوليو",
    make_another: "ٻيو ٺاھيو",
    upload_from_gallery: "گيلري مان اپ لوڊ ڪريو",
    math_tagline: "رياضي جي سوال جو فوٽو وٺو — اشارو يا مڪمل حل حاصل ڪريو۔",
    math_hint: "اشارو",
    math_hint_desc: "اوهان جي ٻولي ۾ آسان اشارو، آڊيو سان",
    math_solution: "حل",
    math_solution_desc: "نوٽ بوڪ انداز ۾ مڪمل قدم به قدم حل",

    share_confirm_prompt: "ڇا توهان واٽس ايپ تي پيغام شيئر ڪيو؟",
    share_confirm_yes: "ها، ڪيو",
    share_confirm_no: "اڃا نه",

    help_a_friend: "دوست جي مدد ڪريو",
    help_a_friend_intro: "شيئر ڪرڻ خيال آهي — دوست کي به ساڻ پڙهڻ لاءِ سڏيو.",
    help_a_friend_msg_greeting: "اچو گڏجي سکون!",
    help_a_friend_msg_body: "مان پڙهائيءَ لاءِ Saral Eye استعمال ڪريان ٿو. توهان به ملي وڃو:",
    help_a_friend_msg_tagline: "سکو • وڌو • مدد ڪريو",
    share_on_whatsapp: "واٽس ايپ تي شيئر ڪريو",
    share_helper_line: "هر شيئر = هڪ شاگرد جي مدد",
    join_sahaj_path: "سهج پاٺ ۾ شامل ٿيو",
    sahaj_path_hint: "واٽس ايپ تي دوستانه پڙهائي سپورٽ گروپ",
    level_blaze: "ليول بليز",
    helped_label: "مدد ڪئي",
    level_student: "شاگرد",
    level_helper: "مددگار",
    level_supporter: "همدرد",
    level_mentor: "رهنما",
    level_champion: "چيمپيئن",
    progress_line: "توهان {n} شاگردن جي مدد ڪئي • {next} ٿيڻ لاءِ اڃا {remain}",
    progress_line_top: "توهان {n} جي مدد ڪئي. چيمپيئن — مهرباني!",
    helped_toast_progress: "هاڻي {n} جي مدد • {next} ٿيڻ لاءِ اڃا {remain}",
    helped_toast_simple: "توهان {n} شاگردن جي مدد ڪئي. مهرباني!",

    share_balance_title: "بيلنس شيئر ڪريو",
    share_balance_desc: "دوست کي ٿورا والٽ پيسا موڪليو",
    share_recipient_phone: "وصول ڪندڙ جو موبائل نمبر",
    share_phone_placeholder: "مثال 9876543210",
    share_amount: "موڪلڻ جي رقم",
    share_send_btn: "موڪليو",
    share_success: "{phone} کي {amount} موڪليو ويو",
    share_recipient_invalid: "درست موبائل نمبر داخل ڪريو",
    share_invalid_amount: "صفر کان وڌيڪ درست رقم داخل ڪريو",
    share_insufficient_balance: "توهان وٽ ڪافي بيلنس ناهي",

    hourglass_view: "ريتيءَ گھڙيءَ جو منظر",
    hourglass_exit: "ٻاهر نڪرو",

    colour_guide: "ڪلر گائيڊ",
    colour_guide_desc: "پنهنجي خاڪي تي روشني، پاڇو ۽ رنگن جو ترتيب سکو",
    cg_coloring_order: "رنگ ڀرڻ جو ترتيب",
    cg_step_1_title: "پس منظر",
    cg_step_1_desc: "هلڪا رنگ، ٿورو ڪنٽراسٽ",
    cg_step_2_title: "پري وارا شيون",
    cg_step_2_desc: "ٿڌا رنگ، نرم ڪنٽراسٽ",
    cg_step_3_title: "زمين",
    cg_step_3_desc: "قدرتي بنيادي رنگ",
    cg_step_4_title: "بنيادي موضوع",
    cg_step_4_desc: "گھاٽا رنگ، وڏو ڪنٽراسٽ",
    cg_step_5_title: "ٻيا وڏا شيون",
    cg_step_5_desc: "متوازن وچولا رنگ",
    cg_step_6_title: "تفصيل ۽ هاءِ لائيٽ",
    cg_step_6_desc: "باريڪ تفصيل، چمڪدار هاءِ لائيٽ",
    cg_note_heading: "نوٽ",
    cg_note_1: "بنيادي موضوع کي ڳاڙهي لڪير سان نمايان ڪيو ويو آهي.",
    cg_note_2: "نيري پاڇي وارن حصن ۾ گھاٽا شيڊ استعمال ڪريو.",

    math_mental: "مينٽل ميٿ",
    math_mental_desc: "خريداري جي ڪهاڻي ٻڌو ۽ صحيح جواب چونڊيو",
    mm_start_practice: "مشق شروع ڪريو",
    mm_replay_audio: "ٻيهر ٻڌو",
    mm_choose_answer: "صحيح جواب چونڊيو",
    mm_correct: "درست! سٺو.",
    mm_wrong: "غلط! ٻيهر ڪوشش ڪريو.",
    mm_practice_another: "ٻيو سوال",
    mm_back: "واپس",
    mm_home: "گھر",
    mm_generating: "توهان جو سوال تيار ٿي رهيو آهي...",
    mm_focus_now: "ڌيان سان ٻڌو",
    mm_intro: "مينٽل ميٿ جي مشق لاءِ اصلي خريداري جون پروليون",
    use_cropped_area: "ھي ايريا استعمال ڪريو",
    another_problem: "ٻيو سوال",
    hint_label: "ھي ھڪ اشارو",
    audio_hint_label: "ٻڌڻ لاءِ Play دٻايو",
    audio_unavailable: "آڊيو دستياب نه — بعد ۾ ڪوشش ڪريو۔",
    generating_hint: "اشارو تيار ٿي رھيو آھي...",
    generating_solution: "حل تيار ٿي رھيو آھي...",
    generating_summary: "خلاصو تيار ٿي رھيو آھي...",
    generating_mcq: "ڪوئز تيار ٿي رھي آھي...",
    language_tagline: "پاسيج جو فوٽو وٺو — خلاصو يا ڪوئز حاصل ڪريو۔",
    lang_summary: "خلاصو",
    lang_summary_desc: "اوهان جي ٻولي ۾ آسان خلاصو، آڊيو سان",
    lang_mcq: "ڪوئز",
    lang_mcq_desc: "مزيدار ڪثيرالانتخاب سوال، فوري فيڊ بيڪ",
    pick_age_group: "پنھنجو عمر گروپ چونڊيو",
    age_6_10: "٦–١٠ سال",
    age_10_14: "١٠–١٤ سال",
    age_14_18: "١٤–١٨ سال",
    age_18_plus: "١٨+ سال",
    summary_label: "ھي ھڪ مختصر خلاصو",
    audio_summary_label: "ٻڌڻ لاءِ Play دٻايو",
    no_content_title: "ڪو پاسيج نه مليو۔",
    no_content_desc: "ڪئميرا ڪهاڻي، سبق يا پاسيج تي رکو۔",
    question: "سوال",
    multi_select_hint: "ھڪ کان وڌيڪ جواب صحيح ٿي سگھن ٿا۔",
    mcq_submit: "جواب چيڪ ڪريو",
    mcq_next: "ايندڙ سوال",
    mcq_see_score: "منهنجو اسڪور ڏسو",
    mcq_correct: "صحيح! 🎉",
    mcq_wrong: "ھن ڀيري نه. ايندڙ جي ڪوشش ڪريو!",
    mcq_correct_feedback: "شاباش — سڀ صحيح جواب ڏنا۔",
    mcq_wrong_feedback: "سائي رنگ وارا اختيار ئي صحيح جواب آھن۔",
    mcq_done_title: "زبردست ڪوشش!",
    mcq_all_correct: "مڪمل اسڪور!",
    your_score: "اوهان جو اسڪور",
    no_math_found_title: "رياضي جو سوال نه مليو۔",
    no_math_found_desc: "ڪراپ ايريا ۾ سوال صاف رکو۔",
    lang_check_answer: "جواب چيڪ",
    lang_check_answer_desc: "لکيل جواب پني جي تصوير وٺو — مارڪس، صحيح/غلط ۽ صحيح جواب پائي",
    lang_learn_nature: "فطرت مان سکو",
    lang_learn_nature_desc: "فطري منظر جي تصوير وٺو — سائنس، زندگي ۽ ٻين موضوعن جا ننڍا سبق",
    generating_learn_nature: "فطرت مان سبق ڳوليون ٿا...",
    nature_lessons_label: "فطرت جا سبق",
    generating_check_answer: "جواب چيڪ ڪري رهيا آھيون...",
    no_paper_found_title: "سوال پنو نه مليو.",
    no_paper_found_desc: "ڪيمرا شاگرد جي جوابن وارن سوال پنن تي رکو.",
    lang_speech_mentor: "اسپيچ مينٽر",
    lang_speech_mentor_desc: "بهتر ڳالهائڻ ۾ مدد ڪندڙ دوستاڻو AI مينٽر.",
    speech_mentor_tap_to_record: "مائيڪ ٽيپ ڪريو ۽ ڳالهائڻ شروع ڪريو",
    speech_mentor_tap_to_stop: "روڪڻ لاءِ ٽيپ ڪريو",
    speech_mentor_recording: "ٻڌي رهيا آهيون...",
    speech_mentor_analyzing: "توهان جي ڳالهه جو تجزيو ٿي رهيو آهي...",
    speech_mentor_your_speech: "توهان جي ڳالهه",
    speech_mentor_mic_denied: "مائيڪ جي اجازت نه ملي",
    speech_mentor_mic_unsupported: "هن ڊوائس تي مائيڪ نه آهي",
    learn_another: "ٻيو سکو",
    try_another: "وري ڪريو",
    check_another: "ٻيو چيڪ ڪريو",
    practice_again: "وري مشق ڪريو",
    speech_mentor_play_welcome: "سواگت ٻڌڻ لاءِ ٽيپ ڪريو",
    daily_reflection: "روزاني غور",
    daily_reflection_desc: "اندروني ترقيءَ لاءِ 1-منٽ روزاني چيڪ ان",
    dr_start: "شروع ڪريو",
    dr_loading: "توهان جو غور تيار ٿي رهيو آهي...",
    dr_question_of: "سوال {n} / {total}",
    dr_your_answer: "توهان جو جواب",
    dr_best_answer: "بهترين جواب",
    dr_lesson: "سبق",
    dr_growth_score: "اڄوڪو گروٿ اسڪور",
    dr_encouragement_high: "زبردست! توهان روز اڳتي وڌي رهيا آهيو.",
    dr_encouragement_mid: "سٺي ڪوشش! روز ٿورو غور دماغ کي مضبوط ڪري ٿو.",
    dr_encouragement_low: "هر غور هڪ قدم اڳتي آهي. اڳتي وڌندا رهو!",
    dr_next: "اڳيون",
    dr_finish: "منهنجو اسڪور ڏسو",
    dr_try_again: "ٻيهر غور",
    dr_listen: "ٻڌو",
    coloring: "رنگ ڪرڻ",
    coloring_desc: "ڪنهن به ڊرائنگ کي فن ۾ تبديل ڪريو — آئل پيسٽل، واٽر ڪلر ۽ وڌيڪ",
    coloring_choose_style: "رنگ جو انداز چونڊيو",
    coloring_style_oil_pastel: "آئل پيسٽل",
    coloring_style_watercolor: "واٽر ڪلر",
    coloring_style_graphite_shade: "پينسل شيڊ",
    coloring_style_color_pencil_shade: "رنگين پينسل",
    coloring_style_oil_paint: "آئل پينٽ",
    time_master: "ٽائيم ماسٽر",
    time_master_desc: "ڪيتري جلدي پورو ڪندؤ؟ مثالي وقت سان مقابلو ڪريو.",
    time_master_class: "ڪلاس",
    time_master_subject: "مضمون",
    time_master_marks: "مارڪ",
    time_master_ideal: "مثالي وقت",
    time_master_elapsed: "توهان جو وقت",
    time_master_start: "ٽائمر شروع",
    time_master_stop: "ٽائمر بند",
    time_master_pick_class: "ڪلاس چونڊيو",
    time_master_pick_subject: "مضمون چونڊيو",
    time_master_pick_marks: "مارڪ چونڊيو",
    time_master_subj_numerical: "عددي",
    time_master_subj_science: "سائنس",
    time_master_subj_technical: "ٽيڪنيڪل",
    time_master_subj_social: "سماجي",
    time_master_subj_language: "ٻولي",
    time_master_subj_other: "ٻيا",
  },
  ks: {
    app_name: "ڈرائنگ ٹولز",
    tagline: "تۄہند پاٹھٕ تصویر بنانس منٛز پریرنا دیہ!",
    enter_phone: "پنُن موبائل نمبر لیکھیو",
    phone_placeholder: "١٠ ہندس موبائل",
    send_otp: "OTP سٔز",
    enter_otp: "٦ ہندس OTP لیکھیو",
    verify: "تصدیق کریو",
    resend_otp: "OTP دوبارٕ سٔز",
    change_number: "نمبر بدلایو",
    free_label: "مفت",
    paid_label: "₹",
    blueprint: "بلیو پرنٹ",
    blueprint_desc: "گۄڈٕ خاکہ بنایو",
    pencil: "پنسل سکیچ",
    pencil_desc: "اکھ خوبصورت پنسل سکیچ بنایو",
    story: "میٚن کہانی",
    story_desc: "اَکھ کامِک کَتھا بَنٲوِو",
    wallet: "والٹ",
    recharge_wallet: "والَٹ رِچارٕج کَرِو",
    recharge_methods: "UPI · کارڈس · نؠٹ بٲنکِنگ · والَٹ",
    pay_prefix: "اَدایَگی کَرِو",
    processing: "پروسٮ گَژھان چھُ…",
    recharge_unavailable: "رِچارٕج فی الحال میسر چھُ نہ",
    free_credit_title: "{amount} مُفت کریڈٹ",
    free_credit_desc: "اَسِہ چھِوہ توہِہٕ {amount} مُفت والَٹ کریڈٹ دِتمُت — اَکِس فون نَمبَرَس ہُنٛدِ اَکھ لَٹِ۔",
    recent_recharges: "نَو رِچارٕج",
    gallery: "گیلری",
    take_photo: "فوٹو ہیچھیو",
    retake: "دوبارٕ ہیچھیو",
    use_photo: "یہ فوٹو اِستعمال کریو",
    generating: "جادو بنُن چھُ...",
    almost_there: "تقریباً سرٕنزل!",
    download: "ڈاؤن لوڈ",
    share: "شیٔر کریو",
    share_whatsapp: "واٹس اپ",
    share_email: "ای میل",
    copy_link: "لنک کاپی کریو",
    back: "وٲپس",
    logout: "لاگ آؤٹ",
    your_creations: "تۄہنٛد تخلیقات",
    no_creations: "وُنی تام کانٛہہ تخلیق چھُنہٕ. شُروع کریو!",
    insufficient_balance: "بیلنس کم چھُ",
    rate_limited: "تہٕ آرام کریو! پتہٕ کوشش کریو۔",
    welcome: "خوش آمدید!",
    home: "گٔر",
    language: "زبان",
    balance: "بیلنس",
    create: "تخلیق",
    platform_name: "سرل آئی",
    platform_tagline: "ہیچَنُک سَمُنٛدَر ساسان بَنَوان",
    module_drawing_title: "ڈرائنگ ٹولز",
    module_drawing_desc: "بَنٲوِو، رَنٛگ کَرِو تہٕ خَیال کَرِو",
    module_language_title: "زبان ٹولز",
    module_language_desc: "ہَر مَضمون ہیچھو",
    module_math_title: "ریاضی ٹولز",
    module_math_desc: "ہیچھو، حَل کَرِو تہٕ بؠہتٔر بَنِو",
    mind_master_title: "مائنڈ ماسٹر",
    mind_master_desc: "مراقبہٕ، سانس تہٕ سکون",
    mind_master_audio_start: "آواز چالٲو",
    mind_master_audio_stop: "آواز روٚکِو",
    mind_master_back: "واپس",
    life_intro_heading: "پانَس پَزناوُن خٲطرٕ کینہہ لَمحہٕ دِیِو",
    privacy_policy: "پرائیویسی پالیسی",
    install_app: "ایپ انسٹال کریو",
    app_installs: "ایپ انسٹال",
    coming_soon: "جلد اَوُن چھُ",
    open_now: "کھولیو",
    make_another: "اَکھ بیٛاکھ بنایو",
    upload_from_gallery: "گیلری پیٹھٕ اپ لوڈ کریو",
    math_tagline: "ریاضی سوالُک فوٹو ہیچھیو — اشارہ یا مکمل حل حاصل کریو۔",
    math_hint: "اشارہ",
    math_hint_desc: "تۄہنٛد زبان منٛز سہل اشارہ، آڈیو ساتیٕ",
    math_solution: "حل",
    math_solution_desc: "نوٹ بک سٹائلس منٛز مکمل قدم بہ قدم حل",

    share_confirm_prompt: "کیازِ تُہٕ راوٕوٕ سَنٛدیش واٹس ایپَس منٛز؟",
    share_confirm_yes: "آ، راوٕوٕ",
    share_confirm_no: "وَنِہٕ نہٕ",

    help_a_friend: "دوستَس مَدَتھ کٔرِو",
    help_a_friend_intro: "شیٲر کَرُن چھُ خؠال — دوسٕتَس ہٕنٛدِس ساتھ پَران ٲنٕو۔",
    help_a_friend_msg_greeting: "آسِیو تِمَو ساتھِ سیٚکھو!",
    help_a_friend_msg_body: "بہٕ چھُس پَرَس بَہانَس منٛز Saral Eye استٕعمال کَران۔ تُہِیہِ رَلٕو:",
    help_a_friend_msg_tagline: "سیٚکھو • وَٲدِو • مَدَتھ کٔرِو",
    share_on_whatsapp: "واٹس ایپ منٛز شیٲر کٔرِو",
    share_helper_line: "پَرِتھ شیٲر = اَکِس تالِبَس مَدَتھ",
    join_sahaj_path: "سَہَج پاٹھ منٛز رَلٕو",
    sahaj_path_hint: "واٹس ایپَس منٛز دوستانہٕ پَرَنُک گٔروپ",
    level_blaze: "لیٚوَل بلیز",
    helped_label: "مَدَتھ",
    level_student: "طٲلِب عِلم",
    level_helper: "مَدَتگار",
    level_supporter: "حَمایَتی",
    level_mentor: "رَہنُما",
    level_champion: "چیٚمپیَن",
    progress_line: "تُہٕ کوٚر {n} طٲلِبَن مَدَتھ • {next} بَنَنَس بَاپَتھ ہیٚنٛز {remain}",
    progress_line_top: "تُہٕ کوٚر {n} کُنہٕ مَدَتھ۔ چیٚمپیَن — شُکریہ!",
    helped_toast_progress: "وَنِہٕ {n} کُنہٕ مَدَتھ • {next} بَنَنَس ہیٚنٛز {remain}",
    helped_toast_simple: "تُہٕ کوٚر {n} طٲلِبَن مَدَتھ۔ شُکریہ!",

    share_balance_title: "بیلَنس شیٲر",
    share_balance_desc: "دوستَس کُنہٕ کینٛہہ والٹ پؠسہٕ راوٕنٛو",
    share_recipient_phone: "وَصول کَرنہٕ والَس ہٕنٛد موبٲیل نَمبر",
    share_phone_placeholder: "مَثلن 9876543210",
    share_amount: "راوٕنَس ہٕنٛز رَقم",
    share_send_btn: "راوَو",
    share_success: "{phone} کُنہٕ {amount} راوَتھ",
    share_recipient_invalid: "دُرُست موبٲیل نَمبر داخِل کٔرِو",
    share_invalid_amount: "صٕفر کھۄتہٕ زیاد دُرُست رَقم داخِل کٔرِو",
    share_insufficient_balance: "تُہٕنٛد نَزدٕ چھُ نہٕ کٲفی بیلَنس",

    hourglass_view: "سیٚنٛد گَھٹیہِ منظر",
    hourglass_exit: "نیرِو",

    colour_guide: "کَلَر گَیڈ",
    colour_guide_desc: "پننٕ خاکسٕ منٛز روشنی، سایہ تہٕ رنگَن ہٕنٛد ترتیب سٕکِو",
    cg_coloring_order: "رنگ بھَرَنٕک ترتیب",
    cg_step_1_title: "پَس مَنظر",
    cg_step_1_desc: "ہَلٕک رنگ، کَم کَنٹراسٹ",
    cg_step_2_title: "دورٕ چیز",
    cg_step_2_desc: "شیٚل رنگ، نَرم کَنٹراسٹ",
    cg_step_3_title: "زَمین",
    cg_step_3_desc: "قُدرَتی بَس رنگ",
    cg_step_4_title: "بُنیٲدی موضوع",
    cg_step_4_desc: "گَٹھ رنگ، بَڈ کَنٹراسٹ",
    cg_step_5_title: "بییہٕ بٔڈ چیز",
    cg_step_5_desc: "برابر مَدھِم ٹون",
    cg_step_6_title: "تَفصیٖل تہٕ ہٲی لٲیٹ",
    cg_step_6_desc: "بارِک تَفصیٖل، تیز ہٲی لٲیٹ",
    cg_note_heading: "نوٹ",
    cg_note_1: "بُنیٲدی موضوع چھُ وۄزُل رنگ سٟتؠ چٹھمُت.",
    cg_note_2: "نیٖل سایہ مُقاماتَن منٛز گَٹھ شیڈ اِستٕعمال کٔرِو.",

    math_mental: "مینٹل میتھ",
    math_mental_desc: "خرَیدَری ہٕنٛز کَتھ بوز تہٕ صٕحیٖح جَوٲب چٲنِو",
    mm_start_practice: "مَشق شُرو کٔرِو",
    mm_replay_audio: "دوبارٕ بوز",
    mm_choose_answer: "صٕحیٖح جَوٲب چٲنِو",
    mm_correct: "دُرُست! بَرابَر.",
    mm_wrong: "غٕلَت! دوبارٕ کوٚشِش کٔرِو.",
    mm_practice_another: "بییہٕ سوٲل",
    mm_back: "واپَس",
    mm_home: "گَر",
    mm_generating: "تُہٕنٛد سوٲل چھُ تیار گَژھان...",
    mm_focus_now: "دِل بوز",
    mm_intro: "مینٹل میتھ مَشقَس ہٕنٛدی خٲطرٕ اَصلی خرَیدَری کیٚ پَہیٚلیاہ",
    use_cropped_area: "یہ ایریا اِستعمال کریو",
    another_problem: "بیاکھ سوال",
    hint_label: "یہ چھُ اَکھ اشارہ",
    audio_hint_label: "بوزنہٕ خٲطرٕ Play کریو",
    audio_unavailable: "آڈیو دستیاب چھُنہٕ — پتہٕ کوشش کریو۔",
    generating_hint: "اشارہ تیار گٔژھان...",
    generating_solution: "حل تیار گٔژھان...",
    generating_summary: "خلاصہ تیار گٔژھان...",
    generating_mcq: "کوئز تیار گٔژھان...",
    language_tagline: "اَکس پاسیجُک فوٹو ہیچھیو — خلاصہ یا کوئز حاصل کریو۔",
    lang_summary: "خلاصہ",
    lang_summary_desc: "تۄہنٛد زبان منٛز سہل خلاصہ، آڈیو ساتیٕ",
    lang_mcq: "کوئز",
    lang_mcq_desc: "مزیدار بہت چائسز والے سوال، فوری فیڈ بیک",
    pick_age_group: "پنُن عمرٕ گروپ ژأٹیو",
    age_6_10: "٦–١٠ ورٕی",
    age_10_14: "١٠–١٤ ورٕی",
    age_14_18: "١٤–١٨ ورٕی",
    age_18_plus: "١٨+ ورٕی",
    summary_label: "یہ چھُ اَکھ کھۄتہٕ خلاصہ",
    audio_summary_label: "بوزنہٕ خٲطرٕ Play کریو",
    no_content_title: "کانٛہہ پاسیج راوُک ناوٕ۔",
    no_content_desc: "کیمرہ کانٛہہ کہانی، سبق یا پاسیجس پیٹھ تَھٔویو۔",
    question: "سوال",
    multi_select_hint: "اَکس کھۄتہٕ زیٛادٕ جوابہٕ صحیح ٲسِتھ ہیٚکن۔",
    mcq_submit: "جواب پرکھیو",
    mcq_next: "اگلٕ سوال",
    mcq_see_score: "میٚن سکور وُچھیو",
    mcq_correct: "صحیح! 🎉",
    mcq_wrong: "یَتھ لٔٹہٕ نہٕ۔ اگلس کوشش کریو!",
    mcq_correct_feedback: "اعلیٰ — سٲری صحیح جوابہٕ دِتھ۔",
    mcq_wrong_feedback: "سَبزٕ رنگٕک آپشن چھ صحیح جواب۔",
    mcq_done_title: "بہترین کوشش!",
    mcq_all_correct: "مکمل سکور!",
    your_score: "تۄہنٛد سکور",
    no_math_found_title: "ریاضی سوال راوُک ناوٕ۔",
    no_math_found_desc: "کراپ ایریاس منٛز سوال صاف تَھٔویو۔",
    lang_check_answer: "جَواب چِک",
    lang_check_answer_desc: "لِکَتھ جَواب شیٹَس ہٕنٛد فوٹو نِیُک — نَمبَر، صحیح/غَلَط تہٕ درُسؠ جَواب",
    lang_learn_nature: "قُدرَتَس پؠٹھ ہیچھو",
    lang_learn_nature_desc: "قُدرَتِس ہٕنٛد فوٹو نِیُک — سائنس، زٕندَگی تہٕ بیٚ مَضامٕنَن ہِنٛد لۄکٹؠ سَبَق",
    generating_learn_nature: "قُدرَتَس پؠٹھ سَبَق ژھانڈان چھِ...",
    nature_lessons_label: "قُدرَتَس ہِنٛد سَبَق",
    generating_check_answer: "جَواب چِک کَران چھِ...",
    no_paper_found_title: "سوالی پَرچہٕ نہٕ مِلیو۔",
    no_paper_found_desc: "کیمرا طالِبَس سُنٛد جَوابَن سٕتؠ سوالی پَرچَس پؠٹھ تھَو۔",
    lang_speech_mentor: "سپیچ مینٹر",
    lang_speech_mentor_desc: "بہتر کَتھ کَرَنَس مَنٛز مَدَد کَران AI مینٹر۔",
    speech_mentor_tap_to_record: "مائیک تھَپھ کَرِتھ کَتھ شروٗع کَرِو",
    speech_mentor_tap_to_stop: "بَنٛد کَرَنَس بَپَتھ تھَپھ کَرِو",
    speech_mentor_recording: "بوزان چھِ...",
    speech_mentor_analyzing: "تُہٕنٛدِ کَتھ ہٕچھان چھِ...",
    speech_mentor_your_speech: "تُہٕنٛز کَتھ",
    speech_mentor_mic_denied: "مائیک ہٕنز اِجازَتھ نہٕ مِلی",
    speech_mentor_mic_unsupported: "یَتھ آلَتھ پؠٹھ مائیک چھُنہٕ",
    learn_another: "بیٚیِ ہٕچھِو",
    try_another: "دوبارٕ کَرِو",
    check_another: "بیٚیِ چِک کَرِو",
    practice_again: "دوبارٕ مَشِق کَرِو",
    speech_mentor_play_welcome: "سَواگَتہٕ بوزَنَس تھَپھ کَرِو",
    daily_reflection: "روزٕنِک غۆر",
    daily_reflection_desc: "اَنٛدَری تَرَقی خٲطرٕ ۱-مِنٹُک روزٕنُک چیک اِن",
    dr_start: "شُروع کٔرِو",
    dr_loading: "تُہٕنٛدُ غۆر تیار گَژھان چھُ...",
    dr_question_of: "سُوال {n} / {total}",
    dr_your_answer: "تُہٕنٛد جَواب",
    dr_best_answer: "بؠہتٔر جَواب",
    dr_lesson: "سَبَق",
    dr_growth_score: "اَز اُک گروتھ سکور",
    dr_encouragement_high: "زَبَرٕدَست! توہِہٕ چھِوہ ہَر دوہ اَگٕرِ گَژھان۔",
    dr_encouragement_mid: "روٚسؠ کوشِش! ہَر دوہ کینٛہہ غۆر بَنَوان چھُ زٕہنَس تاقَتہ۔",
    dr_encouragement_low: "ہَر غۆر چھُ اَکھ قَدَم اَگٕرِ۔ گَژھِو اَگٕرِ!",
    dr_next: "بیاکھ",
    dr_finish: "مؠون سکور وُچھِو",
    dr_try_again: "دوبارہ غۆر",
    dr_listen: "بۄزِو",
    coloring: "رَنٛگ کَرُن",
    coloring_desc: "کہٕنہِ ڈرائنٛگ ہُنٛد فَن بَنٲوِو — آئل پیسٹل، واٹَر کَلَر تہٕ زیادٕ",
    coloring_choose_style: "اَکھ رَنٛگہٕ ہٕنٛز طَرز چٲرِو",
    coloring_style_oil_pastel: "آئل پیسٹل",
    coloring_style_watercolor: "واٹَر کَلَر",
    coloring_style_graphite_shade: "پینسِل شیڈ",
    coloring_style_color_pencil_shade: "رَنٛگؠن پینسِل",
    coloring_style_oil_paint: "آئل پینٹ",
    time_master: "ٹائم ماسٹَر",
    time_master_desc: "کوٚتاہ جَلدی خَتَم کَرہٕو؟ مِثالی وَختہٕ سٕتؠ مُقابلہٕ کَرِو۔",
    time_master_class: "جَماتھ",
    time_master_subject: "مَضموٗن",
    time_master_marks: "نَمبَر",
    time_master_ideal: "مِثالی وَختھ",
    time_master_elapsed: "تُہٕنٛد وَختھ",
    time_master_start: "ٹائمَر شُروٗع",
    time_master_stop: "ٹائمَر بَنٛد",
    time_master_pick_class: "جَماتھ چٲرِو",
    time_master_pick_subject: "مَضموٗن چٲرِو",
    time_master_pick_marks: "نَمبَر چٲرِو",
    time_master_subj_numerical: "عَدَدی",
    time_master_subj_science: "سائنس",
    time_master_subj_technical: "تَکنیکی",
    time_master_subj_social: "سَماجی",
    time_master_subj_language: "زَبان",
    time_master_subj_other: "دیٚگَر",
  },
  brx: {
    app_name: "ड्रइं टुल्स",
    tagline: "नोंथांखौ बिसारबाय दैसा खालामनो दिनो!",
    enter_phone: "नोंथांनि मोबाइल नम्बर लिर",
    phone_placeholder: "१० अंकनि मोबाइल",
    send_otp: "OTP दैसिन",
    enter_otp: "६ अंकनि OTP लिर",
    verify: "जाँच खालाम",
    resend_otp: "OTP फिनै दैसिन",
    change_number: "नम्बर सोलाय",
    free_label: "गोदान",
    paid_label: "₹",
    blueprint: "ब्लुप्रिंट",
    blueprint_desc: "गिबिखौ रूपरेखा खालाम",
    pencil: "पेन्सिल स्केच",
    pencil_desc: "मोनसे मोजां पेन्सिल स्केच खालाम",
    story: "आंनि कहानी",
    story_desc: "मोनसे कमिक सोलो साथाय",
    wallet: "वालेट",
    recharge_wallet: "वालेट रिचार्ज खालाम",
    recharge_methods: "UPI · कार्ड · नेटबैंकिं · वालेट",
    pay_prefix: "पैसा राँ",
    processing: "मावनाय जायबाय दं…",
    recharge_unavailable: "रिचार्ज दानो मोननाय नङा",
    free_credit_title: "{amount} फ्री क्रेडिट",
    free_credit_desc: "जोंहा नोंखौ {amount} फ्री वालेट क्रेडिट होदोंहै — मोनसे फोन नाम्बारजों मोनसे बार।",
    recent_recharges: "जौबोद रिचार्ज",
    gallery: "गैलारी",
    take_photo: "फोटो ला",
    retake: "फिनै ला",
    use_photo: "बेखौ फोटो बाहाय",
    generating: "जादु खालामगासिनो दं...",
    almost_there: "थांखि-थांखि जायो!",
    download: "डाउनलोड",
    share: "रानजाब",
    share_whatsapp: "व्हाट्सऐप",
    share_email: "ईमेल",
    copy_link: "लिंक कपी खालाम",
    back: "उन्दै",
    logout: "लग आउट",
    your_creations: "नोंथांनि सोरजि",
    no_creations: "दिनै थार सोरजि गैया. जागायबाय!",
    insufficient_balance: "मोनब्ला बेलेन्स गैया",
    rate_limited: "थांखिमोनबा! उनाव फिनै नागिर।",
    welcome: "बरायनाय!",
    home: "नो",
    language: "राव",
    balance: "बेलेन्स",
    create: "सोरजि",
    platform_name: "सरल आइ",
    platform_tagline: "फोरोंनायखौ जोबोद गोरलै खालामनाय",
    module_drawing_title: "ड्रइं टुल्स",
    module_drawing_desc: "साथाय, रं होयो आरो सांथाय",
    module_language_title: "राव टुल्स",
    module_language_desc: "मोनसे मोनसे बिजाब सुला",
    module_math_title: "गणित टुल्स",
    module_math_desc: "सुला, सल्लाइ खालाम आरो मोजां खालाम",
    mind_master_title: "माइन्ड मास्टार",
    mind_master_desc: "ध्यान, आयदा आरो शान्ति",
    mind_master_audio_start: "सोदोब बुं",
    mind_master_audio_stop: "सोदोब थां",
    mind_master_back: "फैसो",
    life_intro_heading: "निजोराबो मिथिनोनि थाखाय माब्लाबा सम होनांगौ",
    privacy_policy: "गोगा निति",
    install_app: "एप इन्स्टल खालाम",
    app_installs: "एप इन्स्टल",
    coming_soon: "गोजोनै फैगोन",
    open_now: "खौल",
    make_another: "गुबुन मोनसे खालाम",
    upload_from_gallery: "गैलारीनिफ्राय अपलोड खालाम",
    math_tagline: "गणित सोंनायनि फोटो ला — सिग्नाल बा गासै सासन ला।",
    math_hint: "सिग्नाल",
    math_hint_desc: "नोंथांनि रावाव सरल सिग्नाल, अडियोजों",
    math_solution: "सासन",
    math_solution_desc: "नोटबुक खुगायाव गासै दिखौ-दिखौ सासन",

    share_confirm_prompt: "नोंथाङा व्हाट्सएप्पाव सान्थि रानबाय ना?",
    share_confirm_yes: "आयो, रानबाय",
    share_confirm_no: "आथिनगोन",

    help_a_friend: "लोगोनि मदद हो",
    help_a_friend_intro: "रानथाइनो जोबोद — लोगोखौ मोनसे थैनायाव फोसावो।",
    help_a_friend_msg_greeting: "मोनसेयाव फोसाव सोलों!",
    help_a_friend_msg_body: "आं फोसाबनि थाखाय Saral Eye बाहायगासिनो दं। नोंसोरनो लोगो जायो:",
    help_a_friend_msg_tagline: "सोलों • बांगथाय • मदद हो",
    share_on_whatsapp: "व्हाट्सएप्पाव रान",
    share_helper_line: "मोनसे रानाया = मोनसे फोसावगिरिनो मदद",
    join_sahaj_path: "सहज पाठआव लोगो जा",
    sahaj_path_hint: "व्हाट्सएप्पाव लोगोनि फोसाब हेल्प गुट",
    level_blaze: "लेवल ब्लेज",
    helped_label: "मदद",
    level_student: "फोसावगिरि",
    level_helper: "हेल्पगिरि",
    level_supporter: "समर्थकगिरि",
    level_mentor: "गुरु",
    level_champion: "चैम्पियन",
    progress_line: "नोंथाङा {n} फोसावगिरिखौ मदद खालामबाय • {next} जानो {remain} फिन",
    progress_line_top: "नोंथाङा {n}खौ मदद खालामबाय। चैम्पियन — साबायखर!",
    helped_toast_progress: "आथिन {n}खौ मदद • {next} जानो {remain} फिन",
    helped_toast_simple: "नोंथाङा {n} फोसावगिरिखौ मदद खालामबाय। साबायखर!",

    share_balance_title: "बालेन्स रानाय",
    share_balance_desc: "लोगोआव फिनाय वालेट रांआ रानगोन",
    share_recipient_phone: "मोनगिरिनि मोबाइल नमबर",
    share_phone_placeholder: "जेरै 9876543210",
    share_amount: "रानायनि बिबांआव",
    share_send_btn: "रान",
    share_success: "{phone}आव {amount} रानबाय",
    share_recipient_invalid: "जायगायो मोबाइल नमबर होन",
    share_invalid_amount: "जियोखौ बांसिन जायगायो बिबांआव होन",
    share_insufficient_balance: "नोंथाङहा गोबां बालेन्स गैया",

    hourglass_view: "बालु घंटा नुजायनाय",
    hourglass_exit: "गारो",

    colour_guide: "गुसुं गाइड",
    colour_guide_desc: "नोंथाङनि गिथिनाव सान्थि, फोयद आरो गुसुंनि खेब सोलों",
    cg_coloring_order: "गुसुं होनायनि खेब",
    cg_step_1_title: "गेजेराव",
    cg_step_1_desc: "गुबेरै गुसुं, गोहामैया कन्ट्रास्ट",
    cg_step_2_title: "गोजाननि थांखो",
    cg_step_2_desc: "गुजाम गुसुं, गोरब्रैव कन्ट्रास्ट",
    cg_step_3_title: "हाथाइ",
    cg_step_3_desc: "गुदि गुसुं",
    cg_step_4_title: "गुबै आयदा",
    cg_step_4_desc: "गोसा गुसुं, बांसिन कन्ट्रास्ट",
    cg_step_5_title: "गुबुन गेदेर थांखो",
    cg_step_5_desc: "सोमोन गेजेर टोन",
    cg_step_6_title: "गुबै आरो हाइलाइट",
    cg_step_6_desc: "गिदिर गुबै, गोहो हाइलाइट",
    cg_note_heading: "मिथिख",
    cg_note_1: "गुबै आयदाया गुजु गुसुंजों सिनायथिजायो।",
    cg_note_2: "नीलं फोयद जायगायाव गोसा गुसुं बाहायथाव।",

    math_mental: "मेण्टल मेथ",
    math_mental_desc: "बायनायनि खान्थि खोनाथ आरो थार सोमोन बासिख",
    mm_start_practice: "गोदान जागायना",
    mm_replay_audio: "फिन खोनाथ",
    mm_choose_answer: "थार सोमोन बासिख",
    mm_correct: "थार! मोजांदै.",
    mm_wrong: "फोसाय! फिन नागिर.",
    mm_practice_another: "गुबुन सोमोन",
    mm_back: "बिकौ",
    mm_home: "नो",
    mm_generating: "नोंथाङनि सोमोन बानायगासिनो दं...",
    mm_focus_now: "गोसो होनानै खोनाथ",
    mm_intro: "मेण्टल मेथ गोदाननि थाखाय थार बायनायनि आगोर",
    use_cropped_area: "बेखौ अंजोल बाहाय",
    another_problem: "गुबुन सोंनाय",
    hint_label: "बैनो मोनसे सिग्नाल",
    audio_hint_label: "खोनानो Play नौ",
    audio_unavailable: "अडियो जायखि — उनाव नागिर।",
    generating_hint: "सिग्नाल खालामगासिनो दं...",
    generating_solution: "सासन खालामगासिनो दं...",
    generating_summary: "सारांश खालामगासिनो दं...",
    generating_mcq: "क्विज खालामगासिनो दं...",
    language_tagline: "मोनसे पाठनि फोटो ला — सारांश बा क्विज ला।",
    lang_summary: "सारांश",
    lang_summary_desc: "नोंथांनि रावाव सरल सारांश, अडियोजों",
    lang_mcq: "क्विज",
    lang_mcq_desc: "मजादार मोनब्रै-राय सोंनाय, थार फिडबेक",
    pick_age_group: "नोंथांनि बैसो दलखौ सायख",
    age_6_10: "६–१० बोसोर",
    age_10_14: "१०–१४ बोसोर",
    age_14_18: "१४–१८ बोसोर",
    age_18_plus: "१८+ बोसोर",
    summary_label: "बैनो मोनसे फिसा सारांश",
    audio_summary_label: "खोनानो Play नौ",
    no_content_title: "जेबो पाठ मोनाखै।",
    no_content_desc: "केमेरा कहानी, फरायखु बा पाठ सायाव दोन।",
    question: "सोंनाय",
    multi_select_hint: "मोनसेनिख्रुई बेसि फिनदान्नाय थार जानो हाया।",
    mcq_submit: "फिनदान्नाय जाँच खालाम",
    mcq_next: "उनाव सोंनाय",
    mcq_see_score: "आंनि स्कोर नु",
    mcq_correct: "थार! 🎉",
    mcq_wrong: "बे लाँथ्रिआव नंखाय। उनावनो नागिर!",
    mcq_correct_feedback: "मोजां — गासैखौ थार फिनदान्नाय होखानाय।",
    mcq_wrong_feedback: "रांजागोनां ऑप्शन गावनो थार फिनदान्नाय।",
    mcq_done_title: "मोजां नागिरनाय!",
    mcq_all_correct: "गासै स्कोर!",
    your_score: "नोंथांनि स्कोर",
    no_math_found_title: "गणित सोंनाय मोनाखै।",
    no_math_found_desc: "क्रप अंजोलाव सोंनाय खुलि दोन।",
    lang_check_answer: "फिननाय गोनां",
    lang_check_answer_desc: "लिरखानाय फिननाय बिजाबनि फोटो ला — नम्बर, मोनथि/सोलो आरो थार फिननाय मोनबाय",
    lang_learn_nature: "प्रकृति निफ्राय सुला",
    lang_learn_nature_desc: "प्रकृतिनि फोटो ला — बिज्ञान, जीबौव्रो आरो गुबुन विषयनि गथ फुरा",
    generating_learn_nature: "प्रकृति निफ्राय फुरा नागिर बाय...",
    nature_lessons_label: "प्रकृतिनि फुरा",
    generating_check_answer: "फिननाय फरायदोंमोन...",
    no_paper_found_title: "सोंलाय बिजाब मोनाखै।",
    no_paper_found_desc: "फरायसा फिननाय गोनां सोंलाय बिजाबाव कैमरा फजों।",
    lang_speech_mentor: "स्पीच मेंटर",
    lang_speech_mentor_desc: "गोसो बुंनो हेफाजाब होयोब AI गुरु।",
    speech_mentor_tap_to_record: "माइक फिथाई नोंथाङा बुंनो हो",
    speech_mentor_tap_to_stop: "थाबखानो फिथाइ",
    speech_mentor_recording: "खोनाबाय...",
    speech_mentor_analyzing: "नोंथांनि रावखौ नुनाय आगान...",
    speech_mentor_your_speech: "नोंथांनि राव",
    speech_mentor_mic_denied: "माइकनि गनायथि मोनाखै",
    speech_mentor_mic_unsupported: "बे डिभाइसाव माइक गैया",
    learn_another: "गुबुनखौ फोरोंसार",
    try_another: "फिन नाजा",
    check_another: "गुबुनखौ फिननाय",
    practice_again: "फिन सोरजि",
    speech_mentor_play_welcome: "स्वागत खोनानो फिथाइ",
    daily_reflection: "सान्जायारि सानदाबथाय",
    daily_reflection_desc: "सिङाव बुलिनि थाखाय 1-मिनिट सान्जायारि साननाय",
    dr_start: "जागाय",
    dr_loading: "नोंनि सानथाय जिरायबाय दं...",
    dr_question_of: "सिगां {n} / {total}",
    dr_your_answer: "नोंनि फिननाय",
    dr_best_answer: "गोजोन फिननाय",
    dr_lesson: "फुरा",
    dr_growth_score: "दिनैनि गथ' स्कोर",
    dr_encouragement_high: "बांख्रुइ मोजां! नों सान्जायारि गोजोन जायो।",
    dr_encouragement_mid: "मोजां नाजाथाय! सान्जायारि सानथाय गोसो खौ थांखि खालामो।",
    dr_encouragement_low: "मोनसे सानथाय मोनसे थांगारि। गोजोन जायो!",
    dr_next: "उनाव",
    dr_finish: "आंनि स्कोर नाय",
    dr_try_again: "फैसे सानथाय",
    dr_listen: "खोनासोंख",
    coloring: "गुलुम खालामनाय",
    coloring_desc: "जायखि जाया चित्रखौ कलाआव सोलायनाय — ओइल पेस्टेल, वाटर कलर आरो थांखि",
    coloring_choose_style: "गुबुन गुलुम गोहोम बिसिन",
    coloring_style_oil_pastel: "ओइल पेस्टेल",
    coloring_style_watercolor: "वाटर कलर",
    coloring_style_graphite_shade: "पेन्सिल छाया",
    coloring_style_color_pencil_shade: "गुलुम पेन्सिल",
    coloring_style_oil_paint: "ओइल पेन्ट",
    time_master: "साम मास्टर",
    time_master_desc: "बेसे गोख्रों जोबनो हागोन? आइदेल सामजों नाजा नांगो।",
    time_master_class: "क्लास",
    time_master_subject: "बिसद",
    time_master_marks: "मार्क",
    time_master_ideal: "आइदेल साम",
    time_master_elapsed: "नोंथांनि साम",
    time_master_start: "टाइमार जागायनाय",
    time_master_stop: "टाइमार थांखिनाय",
    time_master_pick_class: "क्लास बिसिन",
    time_master_pick_subject: "बिसद बिसिन",
    time_master_pick_marks: "मार्क बिसिन",
    time_master_subj_numerical: "अनजिमानि",
    time_master_subj_science: "बिगियान",
    time_master_subj_technical: "तेकनिकाल",
    time_master_subj_social: "समाजारि",
    time_master_subj_language: "राव",
    time_master_subj_other: "गुबुन",
  },
  doi: {
    app_name: "ड्रॉइंग टूल्स",
    tagline: "तुसें चित्तर बनाने आस्तै प्रेरणा देंदा ऐ!",
    enter_phone: "अपना मोबाइल नंबर लिखो",
    phone_placeholder: "१० अंकें दा मोबाइल",
    send_otp: "OTP भेजो",
    enter_otp: "६ अंकें दा OTP लिखो",
    verify: "तस्दीक करो",
    resend_otp: "OTP बारी भेजो",
    change_number: "नंबर बदलो",
    free_label: "मुफ्त",
    paid_label: "₹",
    blueprint: "ब्लूप्रिंट",
    blueprint_desc: "पैह्ले रूपरेखा बनाओ",
    pencil: "पेंसिल स्केच",
    pencil_desc: "इक खूबसूरत पेंसिल स्केच बनाओ",
    story: "मेरी कहानी",
    story_desc: "इक कॉमिक कहानी बनाओ",
    wallet: "वॉलेट",
    recharge_wallet: "वालट रिचार्ज करो",
    recharge_methods: "UPI · कार्ड · नेटबैंकिं · वालट",
    pay_prefix: "अदा करो",
    processing: "प्रक्रिया चलै दी ऐ…",
    recharge_unavailable: "रिचार्ज हाली उपलब्ध नेईं",
    free_credit_title: "{amount} मुफ़्त क्रेडिट",
    free_credit_desc: "अस तुसेंगी {amount} मुफ़्त वालट क्रेडिट दित्ता ऐ — इक फ़ोन नंबर पर इक बार।",
    recent_recharges: "हालीयै रिचार्ज",
    gallery: "गैलरी",
    take_photo: "फोटो लैओ",
    retake: "बारी लैओ",
    use_photo: "ऐह् फोटो बरतो",
    generating: "जादू बनदा ऐ...",
    almost_there: "लगभग बनी गेआ!",
    download: "डाउनलोड",
    share: "शेयर करो",
    share_whatsapp: "व्हाट्सऐप",
    share_email: "ईमेल",
    copy_link: "लिंक कॉपी करो",
    back: "पिछ्छें",
    logout: "लॉग आउट",
    your_creations: "तुंदी रचना",
    no_creations: "हाल्ले कोई रचना नेईं। शुरू करो!",
    insufficient_balance: "पूरा बैलेंस नेईं",
    rate_limited: "थोड़ा आराम लैओ! बाद च बारी कोशिश करो।",
    welcome: "जी आयां नूं!",
    home: "घर",
    language: "बोली",
    balance: "बैलेंस",
    create: "बनाओ",
    platform_name: "सरल आई",
    platform_tagline: "सिक्खने दे सागर गी सरल बनान्दे होई",
    module_drawing_title: "ड्रॉइंग टूल्स",
    module_drawing_desc: "बनाओ, रंग करो ते कल्पना करो",
    module_language_title: "बोली टूल्स",
    module_language_desc: "हर बिशा सिक्खो",
    module_math_title: "गणित टूल्स",
    module_math_desc: "सिक्खो, हल करो ते सुधारो",
    mind_master_title: "माइंड मास्टर",
    mind_master_desc: "ध्यान, साह ते शांती",
    mind_master_audio_start: "आवाज़ चलाओ",
    mind_master_audio_stop: "आवाज़ रोको",
    mind_master_back: "वापस",
    life_intro_heading: "अपने आप गी पच्छानने आस्तै कुछ पल देओ",
    privacy_policy: "गोपनीयता नीति",
    install_app: "ऐप इंस्टॉल करो",
    app_installs: "ऐप इंस्टॉल",
    coming_soon: "छेती औंदा",
    open_now: "खोलो",
    make_another: "इक होर बनाओ",
    upload_from_gallery: "गैलरी थमां अपलोड करो",
    math_tagline: "गणित दे सवाल दी फोटो लैओ — संकेत जां पूरा हल पाओ।",
    math_hint: "संकेत",
    math_hint_desc: "तुंदी बोली च सौखा संकेत, ऑडियो दे नाल",
    math_solution: "हल",
    math_solution_desc: "नोटबुक शैली च पूरा कदम-दर-कदम हल",

    share_confirm_prompt: "क्या तुसें व्हाट्सएप पर संदेश सांझा कीता?",
    share_confirm_yes: "हाँ, कीता",
    share_confirm_no: "हुण नेईं",

    help_a_friend: "मित्तर दी मदद करो",
    help_a_friend_intro: "सांझा करना ऐ प्यार — मित्तर गी बी नाल पढ़ने आस्तै सद्दो।",
    help_a_friend_msg_greeting: "आओ रली-मिली सिक्खिये!",
    help_a_friend_msg_body: "में पढ़ाई आस्तै Saral Eye बरतां हां। तुस बी नाल जुड़ो:",
    help_a_friend_msg_tagline: "सिक्खो • बधो • मदद करो",
    share_on_whatsapp: "व्हाट्सएप पर सांझा करो",
    share_helper_line: "हर सांझा = इक विद्यार्थी दी मदद",
    join_sahaj_path: "सहज पाठ च शामल होओ",
    sahaj_path_hint: "व्हाट्सएप पर मित्तरां आळा पढ़ाई सपोर्ट समूह",
    level_blaze: "लेवल ब्लेज़",
    helped_label: "मदद",
    level_student: "विद्यार्थी",
    level_helper: "मददगार",
    level_supporter: "समर्थक",
    level_mentor: "मार्गदर्शक",
    level_champion: "चैम्पियन",
    progress_line: "तुसें {n} विद्यार्थियें दी मदद कीती • {next} बनने आस्तै होर {remain}",
    progress_line_top: "तुसें {n} दी मदद कीती। चैम्पियन — शुक्रिया!",
    helped_toast_progress: "हुण {n} दी मदद • {next} बनने आस्तै होर {remain}",
    helped_toast_simple: "तुसें {n} विद्यार्थियें दी मदद कीती। शुक्रिया!",

    share_balance_title: "बैलेंस सांझा करो",
    share_balance_desc: "दोस्त गी थोड़ा वालेट पैसा भेजो",
    share_recipient_phone: "पाने आह्ले दा मोबाइल नंबर",
    share_phone_placeholder: "जि'यां 9876543210",
    share_amount: "भेजने आह्ली रकम",
    share_send_btn: "भेजो",
    share_success: "{phone} गी {amount} भेजी दित्ती",
    share_recipient_invalid: "सही मोबाइल नंबर पाओ",
    share_invalid_amount: "सिफ़र थमां जादा सही रकम पाओ",
    share_insufficient_balance: "तुंदे कोल पूरा बैलेंस नेईं ऐ",

    hourglass_view: "रेत घड़ी दृश्य",
    hourglass_exit: "बाहर निकलो",

    colour_guide: "रंग गाइड",
    colour_guide_desc: "अपनी सकैच पर रोशनी, छाया ते रंग दा क्रम सिखो",
    cg_coloring_order: "रंग भरने दा क्रम",
    cg_step_1_title: "पिच्छे दा भाग",
    cg_step_1_desc: "हलके रंग, घट्ट कंट्रास्ट",
    cg_step_2_title: "दूरे दियां चीजां",
    cg_step_2_desc: "ठंडे रंग, नरम कंट्रास्ट",
    cg_step_3_title: "जमीन",
    cg_step_3_desc: "कुदरती बेस रंग",
    cg_step_4_title: "मुक्ख विशय",
    cg_step_4_desc: "गूढ़े रंग, उच्च कंट्रास्ट",
    cg_step_5_title: "होर बडियां चीजां",
    cg_step_5_desc: "संतुलित मध्यम टोन",
    cg_step_6_title: "ब्यौरे ते हाईलाइट",
    cg_step_6_desc: "बारीक ब्यौरे, चमकदार हाईलाइट",
    cg_note_heading: "टिप्पणी",
    cg_note_1: "मुक्ख विशय दी रूपरेखा लाल रंग च ऐ।",
    cg_note_2: "नीले छाया आह्ले हिस्से च गूढ़े शेड बरतो।",

    math_mental: "मानसिक गणित",
    math_mental_desc: "खरीददारी दी कहानी सुनो ते सही जवाब चुनो",
    mm_start_practice: "अभ्यास शुरू करो",
    mm_replay_audio: "फिरी सुनो",
    mm_choose_answer: "सही जवाब चुनो",
    mm_correct: "सही! बड़ी बधिया.",
    mm_wrong: "गलत! फिरी कोशिश करो.",
    mm_practice_another: "इक होर सवाल",
    mm_back: "पिच्छे",
    mm_home: "होम",
    mm_generating: "तुंदा सवाल त्यार होआ दा ऐ...",
    mm_focus_now: "ध्यान नै सुनो",
    mm_intro: "मानसिक गणित अभ्यास आस्तै असली खरीददारी दियां पहेलियां",
    use_cropped_area: "ऐह् हिस्सा बरतो",
    another_problem: "इक होर सवाल",
    hint_label: "ऐह् रेहा इक संकेत",
    audio_hint_label: "सुनने आस्तै Play दबाओ",
    audio_unavailable: "ऑडियो उपलब्ध नेईं — बाद च कोशिश करो।",
    generating_hint: "संकेत बनदा ऐ...",
    generating_solution: "हल बनदा ऐ...",
    generating_summary: "सार बनदा ऐ...",
    generating_mcq: "क्विज़ बनदी ऐ...",
    language_tagline: "इक पैरे दी फोटो लैओ — सार जां क्विज़ पाओ।",
    lang_summary: "सार",
    lang_summary_desc: "तुंदी बोली च सौखा सार, ऑडियो दे नाल",
    lang_mcq: "क्विज़",
    lang_mcq_desc: "मजेदार बहु-विकल्पीय सवाल, फटाफट जवाब",
    pick_age_group: "अपनी उमर ग्रुप चुनो",
    age_6_10: "६–१० साल",
    age_10_14: "१०–१४ साल",
    age_14_18: "१४–१८ साल",
    age_18_plus: "१८+ साल",
    summary_label: "ऐह् रेहा इक छोटा सार",
    audio_summary_label: "सुनने आस्तै Play दबाओ",
    no_content_title: "कोई पैरा नेईं मिल्या।",
    no_content_desc: "कैमरा कहानी, सबक जां पैरे पर रक्खो।",
    question: "सवाल",
    multi_select_hint: "इक तों मती जवाब सही होई सकदे न।",
    mcq_submit: "जवाब जाँचो",
    mcq_next: "अगला सवाल",
    mcq_see_score: "मेरा स्कोर दिक्खो",
    mcq_correct: "सही! 🎉",
    mcq_wrong: "इस बार नेईं। अगले दी कोशिश करो!",
    mcq_correct_feedback: "वाह — सब्भे सही जवाब दित्ते।",
    mcq_wrong_feedback: "हरे रंग आह्ले विकल्प सही जवाब न।",
    mcq_done_title: "बढ़िया कोशिश!",
    mcq_all_correct: "पूरा स्कोर!",
    your_score: "तुंदा स्कोर",
    no_math_found_title: "गणित दा सवाल नेईं मिल्या।",
    no_math_found_desc: "क्रॉप एरिया च सवाल साफ रक्खो।",
    lang_check_answer: "जुआब जाँच",
    lang_check_answer_desc: "लिखी दी उत्तर शीट दी फोटो लैओ — नंबर, ठीक/गलत ते सही जुआब लैओ",
    lang_learn_nature: "कुदरत कोला सिक्खो",
    lang_learn_nature_desc: "कुदरत दी फोटो लैओ — साइंस, जीवन ते होर विषयें दे छोटे सबक",
    generating_learn_nature: "कुदरत कोला सबक तोपने आं...",
    nature_lessons_label: "कुदरत दे सबक",
    generating_check_answer: "जुआब जांच दे आं...",
    no_paper_found_title: "प्रश्न पत्तर नेईं मिल्या।",
    no_paper_found_desc: "विद्यार्थी दे जुआबां आहले प्रश्न पत्तर उप्पर कैमरा रक्खो।",
    lang_speech_mentor: "स्पीच मैंटर",
    lang_speech_mentor_desc: "ठीक तरां गलाने च मदद करने आह्ला दोस्ताना AI गुरू।",
    speech_mentor_tap_to_record: "माइक टैप करो ते गलाना शुरू करो",
    speech_mentor_tap_to_stop: "रोकने आस्तै टैप करो",
    speech_mentor_recording: "सुनने आं...",
    speech_mentor_analyzing: "तुंदी गल्ल दा विश्लेषण करा दे आं...",
    speech_mentor_your_speech: "तुंदी गल्ल",
    speech_mentor_mic_denied: "माइक दी इजाज़त नेईं मिली",
    speech_mentor_mic_unsupported: "ऐ डिवाइस च माइक नेईं ऐ",
    learn_another: "होर सिक्खो",
    try_another: "फ्ही करो",
    check_another: "होर जांचो",
    practice_again: "फ्ही अभ्यास करो",
    speech_mentor_play_welcome: "स्वागत सुनने आस्तै टैप करो",
    daily_reflection: "रोज़ा चिंतन",
    daily_reflection_desc: "अंदरूनी विकास आस्तै 1-मिंट रोज़ा चेक-इन",
    dr_start: "शुरू करो",
    dr_loading: "तुंदा चिंतन त्यार होआं दा ऐ...",
    dr_question_of: "सुआल {n} / {total}",
    dr_your_answer: "तुंदा जुआब",
    dr_best_answer: "सोहणा जुआब",
    dr_lesson: "सबक",
    dr_growth_score: "अज्ज दा ग्रोथ स्कोर",
    dr_encouragement_high: "शानदार! तुस रोज़ अग्गें बधदे ओ।",
    dr_encouragement_mid: "चंगी कोशश! रोज़ा चिंतन मन गी मज़बूत बनांदा ऐ।",
    dr_encouragement_low: "हर चिंतन इक कदम अग्गें ऐ। बधदे रौ!",
    dr_next: "अगला",
    dr_finish: "मेरा स्कोर दिक्खो",
    dr_try_again: "फिरी चिंतन",
    dr_listen: "सुणो",
    coloring: "रंग भरना",
    coloring_desc: "कुसै बी चित्तर गी कला बनाओ — आइल पेस्टल, वाटर कलर ते होर",
    coloring_choose_style: "इक रंग शैली चुनो",
    coloring_style_oil_pastel: "आइल पेस्टल",
    coloring_style_watercolor: "वाटर कलर",
    coloring_style_graphite_shade: "पेन्सिल छाया",
    coloring_style_color_pencil_shade: "रंगदार पेन्सिल",
    coloring_style_oil_paint: "आइल पेंट",
    time_master: "टाइम मास्टर",
    time_master_desc: "कितनी छेत्ती खत्म करगे? आदर्श टैम कन्नै मुकाबला करो।",
    time_master_class: "कक्षा",
    time_master_subject: "विषा",
    time_master_marks: "अंक",
    time_master_ideal: "आदर्श टैम",
    time_master_elapsed: "तुंदा टैम",
    time_master_start: "टाइमर शुरू",
    time_master_stop: "टाइमर बंद",
    time_master_pick_class: "कक्षा चुनो",
    time_master_pick_subject: "विषा चुनो",
    time_master_pick_marks: "अंक चुनो",
    time_master_subj_numerical: "संख्यात्मक",
    time_master_subj_science: "विज्ञान",
    time_master_subj_technical: "तकनीकी",
    time_master_subj_social: "समाजिक",
    time_master_subj_language: "भाशा",
    time_master_subj_other: "होर",
  },
  mni: {
    app_name: "ড্ৰৱিং টুলস",
    tagline: "নঙদা চিত্ৰ শেমননবা পুকনিং থৌহন্নবগী!",
    enter_phone: "নশাগী মোবাইল নম্বৰ ইৰু",
    phone_placeholder: "১০ অংকগী মোবাইল",
    send_otp: "OTP থা",
    enter_otp: "৬ অংকগী OTP ইৰু",
    verify: "চেক তৌৰু",
    resend_otp: "OTP অমুক্কা থা",
    change_number: "নম্বৰ হোংদোকউ",
    free_label: "ফ্ৰি",
    paid_label: "₹",
    blueprint: "ব্লুপ্ৰিন্ট",
    blueprint_desc: "অহানবদা আউটলাইন শেমউ",
    pencil: "পেন্সিল স্কেচ",
    pencil_desc: "অমা ফজবা পেন্সিল স্কেচ শেমউ",
    story: "ঐগী ৱাৰী",
    story_desc: "কমিক ৱারী অমা শেম্বিয়ু",
    wallet: "ৱালেট",
    recharge_wallet: "ৱালেত রীচার্জ তৌবিয়ু",
    recharge_methods: "UPI · কার্দ · নেতবেঙ্কিং · ৱালেত",
    pay_prefix: "সেল পীবিয়ু",
    processing: "প্রসেস তৌরি…",
    recharge_unavailable: "রীচার্জ হৌজিক ফংদে",
    free_credit_title: "{amount} খুৎসেম্না ফংবা ক্রেদিত",
    free_credit_desc: "ঐখোয়না নংদা {amount} খুৎসেম্না ফংবা ৱালেত ক্রেদিত পীবিরে — ফোন নম্বর অমদা অমুক্তং।",
    recent_recharges: "নকসংবা রীচার্জশিং",
    gallery: "গেলেৰী",
    take_photo: "ফোটো লৌৱু",
    retake: "অমুক্কা লৌৱু",
    use_photo: "মসিগী ফোটো শিজিন্নউ",
    generating: "জাদু শেমলি...",
    almost_there: "ঐনৰিবা!",
    download: "ডাউনলোড",
    share: "শেয়াৰ তৌৰু",
    share_whatsapp: "হোৱাট্‌সঅ্যাপ",
    share_email: "ইমেইল",
    copy_link: "লিংক কপি তৌৰু",
    back: "মতুংদা",
    logout: "লগ আউট",
    your_creations: "নশাগী মশেমলবশিং",
    no_creations: "হৌজিক্কী ফাওবদা মশেমলবা লৈতে। হৌৰু!",
    insufficient_balance: "বেলেন্স লৈতে",
    rate_limited: "খৰা পোত্থাৰু! মতুংদা চেক তৌৰু।",
    welcome: "তৰাম্না!",
    home: "যুমদা",
    language: "লোন",
    balance: "বেলেন্স",
    create: "শেমউ",
    platform_name: "সরল আই",
    platform_tagline: "তম্বীবগী ইপাক অসি লায়ক-লায়না ওইহনবা",
    module_drawing_title: "ড্ৰৱিং টুলস",
    module_drawing_desc: "চিত্রাংগ্লু, মচু হাপ্লু, খল্লু",
    module_language_title: "লোন টুলস",
    module_language_desc: "মমাংগী পৌদমপুম্নমক তম্বিয়ু",
    module_math_title: "নাল্বি টুলস",
    module_math_desc: "তম্বিয়ু, শোয়শিন্বিয়ু অমসুং হেন্না ফহল্লু",
    mind_master_title: "মাইণ্ড মাস্টর",
    mind_master_desc: "ধ্যান, শোৱাশিং অমসুং ইংথৈ",
    mind_master_audio_start: "খোংথোক থাদো",
    mind_master_audio_stop: "খোংথোক লেংশিন",
    mind_master_back: "হন্দোরকপা",
    life_intro_heading: "নশাগীসু খংনবা মতম খরা পীয়ু",
    privacy_policy: "প্ৰাইভেসী পলিসী",
    install_app: "এপ ইনস্তল তৌৰু",
    app_installs: "এপ ইনস্তল",
    coming_soon: "থুনা লাকলি",
    open_now: "হাংউ",
    make_another: "অমুক্কা শেমউ",
    upload_from_gallery: "গেলেৰীদগী অপলোড তৌৰু",
    math_tagline: "নাল্বি ৱাহং ফোটো লৌৱু — হিন্ত নত্ৰগা ফুল সোলুসন ফংউ।",
    math_hint: "হিন্ত",
    math_hint_desc: "নশাগী লোনদা লাইবা হিন্ত, অডিঅ যাওনা",
    math_solution: "সোলুসন",
    math_solution_desc: "নোটবুক স্তাইলদা ফুল ষ্টেপ-বাই-ষ্টেপ পাউখুম",

    share_confirm_prompt: "ৱাত্সেপ্তা পাউচেপ শেয়র তৌখ্রবরা?",
    share_confirm_yes: "হোয়, তৌখ্রে",
    share_confirm_no: "হৌজিক্তী নত্তে",

    help_a_friend: "মরুপ কৈদৌংনবগী",
    help_a_friend_intro: "শেয়র তৌবা হায়বসি নুংশিবা — মরুপবু পুনা তম্মিন্নবা কৌবিয়ু।",
    help_a_friend_msg_greeting: "পুনা তম্মিন্নসি!",
    help_a_friend_msg_body: "ঐ Saral Eye তম্বদা শীজিন্নরি। নংনসু য়াউবিয়ু:",
    help_a_friend_msg_tagline: "তম্মু • হৌদোক • মতেং পাংবিয়ু",
    share_on_whatsapp: "ৱাত্সেপ্তা শেয়র তৌবিয়ু",
    share_helper_line: "শেয়র খুদিংমক = তম্লিবগী নংনা মতেং",
    join_sahaj_path: "সহজ পাঠতা য়াউবিয়ু",
    sahaj_path_hint: "ৱাত্সেপ্তা মরুপ ওইবা তম্বগী মতেং কাংবু",
    level_blaze: "লেভেল ব্লেজ",
    helped_label: "মতেং পাংবা",
    level_student: "তম্লিবা",
    level_helper: "মতেং পাংবা",
    level_supporter: "চথখুম্বা",
    level_mentor: "লম্বীথৌ",
    level_champion: "চেম্পিয়ন",
    progress_line: "নংনা তম্লিবা {n}দা মতেং পাংখ্রে • {next} ওইনবা অমুক {remain}",
    progress_line_top: "নংনা {n}দা মতেং পাংখ্রে। চেম্পিয়ন — থাগৎচরি!",
    helped_toast_progress: "হৌজিক্তী {n}দা মতেং • {next} ওইনবা অমুক {remain}",
    helped_toast_simple: "নংনা {n} তম্লিবদা মতেং পাংখ্রে। থাগৎচরি!",

    share_balance_title: "বেলেন্স শেয়র তৌ",
    share_balance_desc: "মরুপকী মৈথৌং কৈদৌংনবগী ৱালেৎ শেল থাদোক-উ",
    share_recipient_phone: "ফংগদবগী মোবাইল নম্বর",
    share_phone_placeholder: "খুদম 9876543210",
    share_amount: "থাদোকপগী চাং",
    share_send_btn: "থাদোক",
    share_success: "{phone}দা {amount} থাদোকখ্রে",
    share_recipient_invalid: "চুম্না মোবাইল নম্বর থিন্দোক-উ",
    share_invalid_amount: "শুন্যদগী হেন্না চুম্না চাং থিন্দোক-উ",
    share_insufficient_balance: "নংগী মথৌ চাবা বেলেন্স লৈতে",

    hourglass_view: "লৈচিং ৱালচী উবা",
    hourglass_exit: "থোকহল্লু",

    colour_guide: "কলর গাইড",
    colour_guide_desc: "নহাক্কী স্কেচকী মমাংদা মাংঙান, মমী অমসুং মচু কী মথং তম্মু",
    cg_coloring_order: "মচু হাপ্পগী মথং",
    cg_step_1_title: "লেংদাক",
    cg_step_1_desc: "লাইবা মচু, য়াম্না লিকদবা",
    cg_step_2_title: "লাপনা লৈবা পোৎলম",
    cg_step_2_desc: "ইশিং মচু, নুংশিবা লিকদবা",
    cg_step_3_title: "মৈথল",
    cg_step_3_desc: "মপুংফাবা মচু",
    cg_step_4_title: "মশক্না মথৌ",
    cg_step_4_desc: "মশক্না মচু, য়াম্না লিকদবা",
    cg_step_5_title: "অতোপ্পা অচৌবা পোৎলম",
    cg_step_5_desc: "ইনতৈনবা য়েংফম",
    cg_step_6_title: "মমান্না অমসুং হাইলাইত",
    cg_step_6_desc: "মমান্না তত্না তত্না, নুংশাবা হাইলাইত",
    cg_note_heading: "চেকশিন",
    cg_note_1: "মশক্না মথৌদা অংাংবা লাইন মশক-না চংহল্লি।",
    cg_note_2: "মশাংবা মমীদা মশক্না মচু ৎহাদ্রা।",

    math_mental: "মেণ্টেল ম্যাথ",
    math_mental_desc: "শাপ্পিং ৱারী তাবিয়ু অমসুং অচুম্বা পাউখুম খল্লু",
    mm_start_practice: "প্রেক্তিস হৌরে",
    mm_replay_audio: "অমুক্কা তাবিয়ু",
    mm_choose_answer: "অচুম্বা পাউখুম খল্লু",
    mm_correct: "অচুম্বা! য়াম্না ফৈ.",
    mm_wrong: "অরানবা! অমুক্কা হোৎনবিয়ু.",
    mm_practice_another: "অতোপ্পা ৱাহং অমা",
    mm_back: "হংলক্লু",
    mm_home: "হোম",
    mm_generating: "নহাক্কী ৱাহং শেম-শারি...",
    mm_focus_now: "পুক্নিং চংনা তাবিয়ু",
    mm_intro: "মেণ্টেল ম্যাথ প্রেক্তিস্কীদমক অচুম্বা শাপ্পিং য়াইশোন্নবগী পাউদম",
    use_cropped_area: "মসিগী এৰিয়া শিজিন্নউ",
    another_problem: "অমুক্কা ৱাহং",
    hint_label: "মসি অমা হিন্ত",
    audio_hint_label: "তাবা Play নম্ৰু",
    audio_unavailable: "অডিঅ ফংদে — মতুংদা চেক তৌৰু।",
    generating_hint: "হিন্ত শেমলি...",
    generating_solution: "সোলুসন শেমলি...",
    generating_summary: "শোৰোক শেমলি...",
    generating_mcq: "কুইজ্ শেমলি...",
    language_tagline: "প্যাছেজগী ফোটো লৌৱু — শোৰোক নত্ৰগা কুইজ্ ফংউ।",
    lang_summary: "শোৰোক",
    lang_summary_desc: "নশাগী লোনদা লাইবা শোৰোক, অডিঅ যাওনা",
    lang_mcq: "কুইজ্",
    lang_mcq_desc: "মফমগী খৰা-অপশন্ ৱাহংশিং, খুদক্তা ফিডবেক",
    pick_age_group: "নশাগী চহী গ্ৰুপ খল্লু",
    age_6_10: "৬–১০ চহী",
    age_10_14: "১০–১৪ চহী",
    age_14_18: "১৪–১৮ চহী",
    age_18_plus: "১৮+ চহী",
    summary_label: "মসি অমা অপীকপা শোৰোক",
    audio_summary_label: "তাবা Play নম্ৰু",
    no_content_title: "প্যাছেজ অমা ফংদে।",
    no_content_desc: "ক্যামেৰা ৱাৰী, লেসন নত্ৰগা প্যাছেজগী মথক্তা থম্মু।",
    question: "ৱাহং",
    multi_select_hint: "অমদগী হেন্না পাউখুম চুমজবা যায়।",
    mcq_submit: "পাউখুম চেক তৌৰু",
    mcq_next: "মখা ৱাহং",
    mcq_see_score: "ঐগী স্কোৰ য়েংউ",
    mcq_correct: "চুম্নী! 🎉",
    mcq_wrong: "ঐহাক্কী হায়দে। মখাদা হোৎনৰু!",
    mcq_correct_feedback: "ফজৈ — পুম্নমক চুম্না খল্লে।",
    mcq_wrong_feedback: "অশঙ্বা মচুগী অপশন্ চুমজবা পাউখুমনি।",
    mcq_done_title: "মফম ওইৰে!",
    mcq_all_correct: "ফুল স্কোৰ!",
    your_score: "নশাগী স্কোৰ",
    no_math_found_title: "নাল্বি ৱাহং ফংদে।",
    no_math_found_desc: "ক্ৰপ এৰিয়াদা ৱাহং চুম্না থম্মু।",
    lang_check_answer: "পাউখুম থিজিন",
    lang_check_answer_desc: "ই-জরবা পাউখুম শীটকী ফোটো লৌবিয়ু — মার্ক, অচুম্বা/অরাম্বা অমসুং অচুম্বা পাউখুম ফংবিয়ু",
    lang_learn_nature: "প্রকৃতিদগী তম্বিয়ু",
    lang_learn_nature_desc: "প্রকৃতিগী ফোটো লৌবিয়ু — সাইন্স, পুন্সি অমসুং অতৈ মতাংগী অপীক্পা পাউতাক",
    generating_learn_nature: "প্রকৃতিদগী পাউতাক থিরি...",
    nature_lessons_label: "প্রকৃতিগী পাউতাক",
    generating_check_answer: "পাউখুম থিজিনরি...",
    no_paper_found_title: "ৱাহং চেফোং ফংদে।",
    no_paper_found_desc: "মহৈরোয়গী পাউখুম য়াওবা ৱাহং চেফোংদা ক্যামেরা থম্বিয়ু।",
    lang_speech_mentor: "স্পীচ মেন্তর",
    lang_speech_mentor_desc: "ফজনা ৱাখল্লবা ফংহনবগী মপাঙ্গ ওইবা AI মেন্তর।",
    speech_mentor_tap_to_record: "মাইক নম্বীয়ু অমসুং ৱারী হৌরকপীয়ু",
    speech_mentor_tap_to_stop: "লেপ্পগীদমক নম্বীয়ু",
    speech_mentor_recording: "তারি...",
    speech_mentor_analyzing: "নহাক্কী ৱাহং য়েংশিল্লি...",
    speech_mentor_your_speech: "নহাক্কী ৱাহং",
    speech_mentor_mic_denied: "মাইক অয়াবা ফংদে",
    speech_mentor_mic_unsupported: "ডিভাইস অসিদা মাইক লৈতে",
    learn_another: "অতোপ্পা তম্বীয়ু",
    try_another: "অমুক হন্না হোৎনবীয়ু",
    check_another: "অতোপ্পা য়েংশিনবীয়ু",
    practice_again: "অমুক হন্না চঙবীয়ু",
    speech_mentor_play_welcome: "তরাম্না ওকপা তাবা মখাদা নম্বীয়ু",
    daily_reflection: "নুমিৎকী চিংনবা",
    daily_reflection_desc: "মনুংগী চাউখৎনবগীদমক নুমিৎ ১ মিনিতকী চিংনবা",
    dr_start: "হৌদোকপা",
    dr_loading: "নংগী চিংনবা সেমগৎলবা...",
    dr_question_of: "ৱাহঙ {n} / {total}",
    dr_your_answer: "নংগী পাউখুম",
    dr_best_answer: "খ্বাইদগী ফবা পাউখুম",
    dr_lesson: "পাউতাক",
    dr_growth_score: "ঙসিগী চাউখৎ স্কোর",
    dr_encouragement_high: "য়াম্না ফৈ! নহাক্না নুমিৎ খুদিং চাউখৎলি।",
    dr_encouragement_mid: "ফবা হোৎনজবা! নুমিৎ খুদিংগী খরা চিংনবনা পুক্নিং কল্লি।",
    dr_encouragement_low: "চিংনবা খুদিং অমা মমাংদা কতপা। চাউখৎলু!",
    dr_next: "মথং",
    dr_finish: "স্কোর য়েঙবিয়ু",
    dr_try_again: "অমুকহন্না চিংনবা",
    dr_listen: "তাবা",
    coloring: "মচু হাপ্পা",
    coloring_desc: "করিগুম্বা মচু-জর্বা লয়ৎ অমা কলা ওইহনবীয়ু — ওইল পেস্তেল, ৱাতর কলর অমসুং হেন্না",
    coloring_choose_style: "মচুগী মখল অমা খনবীয়ু",
    coloring_style_oil_pastel: "ওইল পেস্তেল",
    coloring_style_watercolor: "ৱাতর কলর",
    coloring_style_graphite_shade: "পেন্সিল হাংবা",
    coloring_style_color_pencil_shade: "মচু পেন্সিল",
    coloring_style_oil_paint: "ওইল পেইন্ত",
    time_master: "তম গোৎপা",
    time_master_desc: "করম্না য়াংনা লোয়শিন্গনি? মপুং ফাবা মতমগা লান্গৎনবিয়ু।",
    time_master_class: "ক্লাস",
    time_master_subject: "সব্জেক্ৎ",
    time_master_marks: "মার্ক",
    time_master_ideal: "মপুং ফাবা মতম",
    time_master_elapsed: "অদোম্গী মতম",
    time_master_start: "তাইমর হৌদোকপা",
    time_master_stop: "তাইমর লেপ্পা",
    time_master_pick_class: "ক্লাস খনবিয়ু",
    time_master_pick_subject: "সব্জেক্ৎ খনবিয়ু",
    time_master_pick_marks: "মার্ক খনবিয়ু",
    time_master_subj_numerical: "মশিং",
    time_master_subj_science: "সাইন্স",
    time_master_subj_technical: "তেক্নিকেল",
    time_master_subj_social: "সোসিএল",
    time_master_subj_language: "লোন",
    time_master_subj_other: "অতৈ",
  },
  sat: {
    app_name: "ᱰᱨᱮᱭᱤᱝ ᱴᱩᱞᱥ",
    tagline: "ᱟᱢᱟᱜ ᱪᱤᱛᱟᱹᱨ ᱵᱮᱱᱟᱣ ᱞᱟᱹᱜᱤᱫ ᱯᱨᱮᱨᱚᱱᱟ!",
    enter_phone: "ᱟᱢᱟᱜ ᱢᱳᱵᱟᱭᱤᱞ ᱱᱚᱢᱵᱚᱨ ᱚᱞ ᱢᱮ",
    phone_placeholder: "᱑᱐ ᱞᱮᱠᱷᱟ ᱢᱳᱵᱟᱭᱤᱞ",
    send_otp: "OTP ᱠᱩᱞ",
    enter_otp: "᱖ ᱞᱮᱠᱷᱟ OTP ᱚᱞ",
    verify: "ᱱᱤᱦᱚᱨ ᱠᱟᱱ",
    resend_otp: "OTP ᱫᱚᱦᱲᱟᱭ ᱠᱩᱞ",
    change_number: "ᱱᱚᱢᱵᱚᱨ ᱚᱱᱳᱲ",
    free_label: "ᱢᱩᱨᱚ",
    paid_label: "₹",
    blueprint: "ᱵᱞᱩᱯᱨᱤᱱᱴ",
    blueprint_desc: "ᱢᱟᱲᱟᱝ ᱨᱩᱯᱨᱮᱠᱷᱟ ᱵᱮᱱᱟᱣ",
    pencil: "ᱯᱮᱱᱥᱤᱞ ᱥᱠᱮᱪ",
    pencil_desc: "ᱢᱤᱫ ᱫᱷᱟᱱᱫᱷᱟ ᱯᱮᱱᱥᱤᱞ ᱥᱠᱮᱪ ᱵᱮᱱᱟᱣ",
    story: "ᱤᱧᱟᱜ ᱠᱟᱦᱱᱤ",
    story_desc: "ᱢᱤᱫ ᱠᱚᱢᱤᱠ ᱠᱟᱦᱟᱱᱤ ᱛᱮᱭᱟᱨ ᱢᱮ",
    wallet: "ᱣᱟᱞᱮᱴ",
    recharge_wallet: "ᱭᱩᱴᱟ ᱯᱩᱱᱚᱸ ᱯᱮᱨᱮᱡ ᱢᱮ",
    recharge_methods: "UPI · ᱠᱟᱨᱰ · ᱱᱮᱴᱵᱮᱨᱟᱠᱤᱸ · ᱭᱩᱴᱟ",
    pay_prefix: "ᱯᱟᱭ ᱢᱮ",
    processing: "ᱠᱟᱹᱢᱤ ᱠᱟᱱᱟ…",
    recharge_unavailable: "ᱨᱤᱪᱟᱨᱡ ᱱᱤᱛ ᱵᱟᱝ ᱧᱟᱢᱚᱜ ᱠᱟᱱᱟ",
    free_credit_title: "{amount} ᱟᱲᱟᱜ ᱠᱨᱮᱰᱤᱴ",
    free_credit_desc: "ᱟᱞᱮ ᱟᱢᱚᱜ {amount} ᱟᱲᱟᱜ ᱭᱩᱴᱟ ᱠᱨᱮᱰᱤᱴ ᱮᱢᱟᱜ ᱠᱟᱱᱟᱞᱮ — ᱢᱤᱫ ᱯᱷᱚᱱ ᱱᱟᱢᱵᱟᱨ ᱨᱮ ᱢᱤᱫ ᱫᱷᱟᱣ।",
    recent_recharges: "ᱱᱚᱶᱟ ᱨᱤᱪᱟᱨᱡ",
    gallery: "ᱜᱮᱞᱮᱨᱤ",
    take_photo: "ᱯᱷᱳᱴᱳ ᱮᱢᱮ",
    retake: "ᱫᱚᱦᱲᱟᱭ ᱮᱢᱮ",
    use_photo: "ᱱᱚᱣᱟ ᱯᱷᱳᱴᱳ ᱵᱮᱵᱷᱟᱨ",
    generating: "ᱡᱟᱫᱩ ᱵᱮᱱᱟᱣ ᱠᱟᱱᱟ...",
    almost_there: "ᱦᱟᱲᱮ ᱦᱚ ᱦᱩᱭ!",
    download: "ᱰᱟᱣᱱᱞᱳᱰ",
    share: "ᱦᱟᱴᱤᱧ",
    share_whatsapp: "ᱣᱷᱟᱴᱥᱟᱯ",
    share_email: "ᱤᱢᱮᱞ",
    copy_link: "ᱞᱤᱝᱠ ᱠᱚᱯᱤ",
    back: "ᱛᱟᱭᱚᱢ",
    logout: "ᱞᱚᱜ ᱟᱣᱴ",
    your_creations: "ᱟᱢᱟᱜ ᱵᱮᱱᱟᱣᱟᱱ",
    no_creations: "ᱱᱤᱛᱚᱜ ᱫᱷᱟᱹᱵᱤᱡ ᱪᱮᱫᱚ ᱵᱟᱹᱱᱩᱜ. ᱮᱦᱚᱵ!",
    insufficient_balance: "ᱵᱮᱞᱮᱱᱥ ᱵᱟᱹᱱᱩᱜ",
    rate_limited: "ᱴᱷᱚᱲᱟ ᱨᱟᱦᱟᱫ ᱢᱮ! ᱛᱟᱭᱚᱢᱛᱮ ᱠᱳᱥᱤᱥ",
    welcome: "ᱡᱳᱦᱟᱨ!",
    home: "ᱳᱲᱟᱜ",
    language: "ᱯᱟᱹᱨᱥᱤ",
    balance: "ᱵᱮᱞᱮᱱᱥ",
    create: "ᱵᱮᱱᱟᱣ",
    platform_name: "ᱥᱚᱨᱚᱞ ᱟᱭ",
    platform_tagline: "ᱪᱮᱫ ᱨᱮᱭᱟᱜ ᱫᱚᱨᱭᱟ ᱠᱚ ᱟᱭᱠᱟᱹᱡ ᱠᱟᱛᱮ",
    module_drawing_title: "ᱰᱨᱮᱭᱤᱝ ᱴᱩᱞᱥ",
    module_drawing_desc: "ᱠᱚᱲ ᱢᱮ, ᱨᱚᱝ ᱚᱲ ᱟᱨ ᱦᱟᱨᱡᱟᱛ ᱮᱢ ᱢᱮ",
    module_language_title: "ᱯᱟᱹᱨᱥᱤ ᱴᱩᱞᱥ",
    module_language_desc: "ᱡᱚᱛᱚ ᱯᱟᱹᱛᱷᱟᱸ ᱪᱮᱫ ᱢᱮ",
    module_math_title: "ᱜᱟᱱᱤᱛ ᱴᱩᱞᱥ",
    module_math_desc: "ᱪᱮᱫ ᱢᱮ, ᱴᱷᱮᱠ ᱟᱲᱟᱜ ᱢᱮ ᱟᱨ ᱦᱚᱸ ᱟᱲᱟᱜ ᱢᱮ",
    mind_master_title: "ᱢᱟᱭᱤᱸᱰ ᱢᱟᱥᱴᱟᱨ",
    mind_master_desc: "ᱫᱷᱮᱭᱟᱱ, ᱥᱟᱦᱟ ᱟᱨ ᱥᱟᱱᱛᱤ",
    mind_master_audio_start: "ᱟᱨᱩ ᱠᱚ",
    mind_master_audio_stop: "ᱴᱷᱟᱹᱣᱠᱟᱹᱣ",
    mind_master_back: "ᱦᱩᱭ ᱨᱩᱣᱟᱲ",
    life_intro_heading: "ᱟᱢᱟᱜ ᱟᱡ ᱠᱚ ᱵᱟᱰᱟᱭ ᱞᱟᱹᱜᱤᱫ ᱛᱤᱱᱟᱹᱜ ᱢᱚᱱᱚᱫ ᱮᱢ ᱢᱮ",
    privacy_policy: "ᱯᱨᱟᱭᱤᱣᱮᱥᱤ ᱱᱤᱛᱤ",
    install_app: "ᱮᱯ ᱤᱱᱥᱴᱚᱞ",
    app_installs: "ᱮᱯ ᱤᱱᱥᱴᱚᱞ",
    coming_soon: "ᱫᱚᱲ ᱦᱤᱡᱩᱜ",
    open_now: "ᱦᱟᱯᱟᱨ",
    make_another: "ᱢᱤᱫ ᱦᱚᱨ ᱵᱮᱱᱟᱣ",
    upload_from_gallery: "ᱜᱮᱞᱮᱨᱤ ᱠᱷᱚᱱ ᱟᱯᱞᱳᱰ",
    math_tagline: "ᱜᱟᱱᱤᱛ ᱢᱮᱱᱟᱝ ᱯᱷᱳᱴᱳ ᱮᱢᱮ — ᱥᱟᱝᱠᱮᱛ ᱵᱟ ᱮᱴᱟᱜ ᱦᱩᱱᱟᱨ ᱵᱟᱦᱟᱨ ᱢᱮ।",
    math_hint: "ᱥᱟᱝᱠᱮᱛ",
    math_hint_desc: "ᱟᱢᱟᱜ ᱯᱟᱹᱨᱥᱤᱨᱮ ᱵᱷᱟᱦᱟᱨ ᱥᱟᱝᱠᱮᱛ, ᱟᱭᱰᱤᱭᱳ ᱥᱟᱱᱟᱢ",
    math_solution: "ᱦᱩᱱᱟᱨ",
    math_solution_desc: "ᱱᱳᱴᱵᱩᱠ ᱱᱤᱭᱟᱢ ᱮᱴᱟᱜ ᱢᱟᱲᱝᱭᱮᱱ ᱦᱩᱱᱟᱨ",

    share_confirm_prompt: "ᱟᱢ ᱠᱷᱚᱱ ᱣᱷᱟᱴᱥᱟᱯᱨᱮ ᱨᱟᱨᱟᱭ ᱦᱟᱴᱤᱧ ᱠᱮᱫᱟᱢ ᱥᱮ?",
    share_confirm_yes: "ᱦᱚᱭ, ᱦᱟᱴᱤᱧ ᱠᱮᱫᱟ",
    share_confirm_no: "ᱱᱤᱛᱚᱜ ᱵᱟᱝ",

    help_a_friend: "ᱜᱚᱲᱚᱭᱟᱨ ᱮᱢ ᱢᱮ",
    help_a_friend_intro: "ᱦᱟᱴᱤᱧ ᱨᱮᱭᱟᱜ ᱠᱟᱛᱷᱟ ᱠᱟᱱᱟ ᱩᱭᱦᱟᱹᱨ — ᱜᱚᱲᱚᱭᱟᱨ ᱦᱚᱲᱟᱜ ᱛᱟᱞᱟ ᱨᱮ ᱯᱟᱲᱦᱟᱣ ᱞᱟᱹᱜᱤᱫ ᱦᱟᱠᱟᱣ ᱢᱮ᱾",
    help_a_friend_msg_greeting: "ᱟᱵᱚ ᱢᱤᱫᱛᱮ ᱪᱮᱫ ᱦᱩᱭᱩᱜᱼᱟᱼᱸ!",
    help_a_friend_msg_body: "ᱤᱧ ᱯᱟᱲᱦᱟᱣ ᱞᱟᱹᱜᱤᱫ Saral Eye ᱵᱮᱵᱷᱟᱨ ᱦᱩᱭᱩᱜ ᱠᱟᱱᱟᱸᱭ᱾ ᱟᱢᱚᱜᱭᱚᱜ ᱛᱟᱦᱮᱸᱠᱟᱛᱮ:",
    help_a_friend_msg_tagline: "ᱪᱮᱫ ᱢᱮ • ᱦᱟᱹᱴᱤᱧ ᱢᱮ • ᱜᱚᱲᱚ ᱢᱮ",
    share_on_whatsapp: "ᱣᱷᱟᱴᱥᱟᱯᱨᱮ ᱦᱟᱴᱤᱧ ᱢᱮ",
    share_helper_line: "ᱡᱚᱛᱚ ᱦᱟᱴᱤᱧ = ᱢᱤᱫ ᱪᱮᱛᱟᱱᱤᱭᱟᱹᱟᱜ ᱜᱚᱲᱚ",
    join_sahaj_path: "ᱥᱟᱦᱚᱡᱽ ᱯᱟᱴᱷ ᱨᱮ ᱛᱟᱦᱮᱸᱱ ᱢᱮ",
    sahaj_path_hint: "ᱣᱷᱟᱴᱥᱟᱯᱨᱮ ᱜᱚᱲᱚᱭᱟᱨ ᱡᱩᱴ",
    level_blaze: "ᱞᱮᱵᱷᱮᱞ ᱵᱞᱮᱡᱽ",
    helped_label: "ᱜᱚᱲᱚ",
    level_student: "ᱪᱮᱛᱟᱱᱤᱭᱟᱹ",
    level_helper: "ᱜᱚᱲᱚᱭᱟᱨ",
    level_supporter: "ᱛᱮᱭᱟᱹᱨᱤᱭᱟᱹ",
    level_mentor: "ᱜᱩᱨᱩ",
    level_champion: "ᱡᱤᱛᱠᱟᱹᱨ",
    progress_line: "ᱟᱢᱟᱜ ᱛᱮᱸ {n} ᱪᱮᱛᱟᱱᱤᱭᱟᱹ ᱜᱚᱲᱚ ᱦᱩᱭ ᱮᱱᱟ • {next} ᱦᱩᱭ ᱞᱟᱹᱜᱤᱫ ᱟᱹᱰᱤ {remain}",
    progress_line_top: "ᱟᱢᱟᱜ ᱛᱮᱸ {n} ᱦᱚᱲ ᱜᱚᱲᱚ ᱦᱩᱭ ᱮᱱᱟ᱾ ᱡᱤᱛᱠᱟᱹᱨ — ᱥᱟᱨᱦᱟᱣ!",
    helped_toast_progress: "ᱱᱤᱛᱚᱜ {n} ᱦᱚᱲ ᱜᱚᱲᱚ • {next} ᱦᱩᱭ ᱞᱟᱹᱜᱤᱫ ᱟᱹᱰᱤ {remain}",
    helped_toast_simple: "ᱟᱢᱟᱜ ᱛᱮᱸ {n} ᱪᱮᱛᱟᱱᱤᱭᱟᱹ ᱜᱚᱲᱚ ᱦᱩᱭ ᱮᱱᱟ᱾ ᱥᱟᱨᱦᱟᱣ!",

    share_balance_title: "ᱵᱟᱞᱮᱱᱥ ᱦᱟᱴᱤᱧ",
    share_balance_desc: "ᱜᱚᱲᱚᱭᱟᱨ ᱦᱚᱲ ᱛᱮ ᱴᱤᱠᱤᱱ ᱴᱟᱠᱟ ᱠᱩᱞ ᱮᱢ ᱢᱮ",
    share_recipient_phone: "ᱧᱟᱢᱚᱜ ᱦᱚᱲᱟᱜ ᱢᱚᱵᱟᱭᱤᱞ ᱱᱚᱢᱵᱚᱨ",
    share_phone_placeholder: "ᱡᱮᱢᱚᱱ 9876543210",
    share_amount: "ᱠᱩᱞ ᱞᱟᱹᱜᱤᱫ ᱴᱟᱠᱟ",
    share_send_btn: "ᱠᱩᱞ ᱢᱮ",
    share_success: "{phone} ᱠᱩ {amount} ᱠᱩᱞ ᱦᱩᱭ ᱮᱱᱟ",
    share_recipient_invalid: "ᱴᱷᱤᱠ ᱢᱚᱵᱟᱭᱤᱞ ᱱᱚᱢᱵᱚᱨ ᱟᱹᱛᱩ ᱢᱮ",
    share_invalid_amount: "ᱦᱟᱛᱟᱣ ᱠᱷᱚᱱ ᱨᱟᱹᱟᱹᱛ ᱴᱷᱤᱠ ᱴᱟᱠᱟ ᱟᱹᱛᱩ ᱢᱮ",
    share_insufficient_balance: "ᱟᱢᱟᱜ ᱵᱟᱞᱮᱱᱥ ᱠᱟᱛᱮᱡᱟ",

    hourglass_view: "ᱰᱷᱟᱨᱮ ᱜᱷᱚᱰᱤ ᱧᱮᱞ",
    hourglass_exit: "ᱚᱰᱚᱠ ᱢᱮ",

    colour_guide: "ᱨᱚᱝ ᱥᱮᱸᱫᱨᱟ",
    colour_guide_desc: "ᱟᱢᱟᱜ ᱪᱤᱛᱟᱹᱨᱨᱮ ᱢᱟᱨᱥᱟᱞ, ᱩᱢᱩᱞ ᱟᱨ ᱨᱚᱝ ᱨᱮᱭᱟᱜ ᱛᱟᱨᱮ ᱪᱮᱫᱚᱜᱼᱟ",
    cg_coloring_order: "ᱨᱚᱝ ᱟᱛᱮ ᱛᱟᱨᱮ",
    cg_step_1_title: "ᱛᱟᱭᱚᱢᱥᱟᱦᱟ",
    cg_step_1_desc: "ᱦᱟᱲᱮ ᱨᱚᱝ, ᱠᱟᱛᱮᱡ ᱠᱚᱱᱴᱨᱟᱥᱴ",
    cg_step_2_title: "ᱥᱟᱸᱜᱤᱱ ᱡᱤᱱᱤᱥ",
    cg_step_2_desc: "ᱨᱟᱵᱟᱝ ᱨᱚᱝ, ᱠᱟᱛᱮᱡ ᱠᱚᱱᱴᱨᱟᱥᱴ",
    cg_step_3_title: "ᱚᱛ",
    cg_step_3_desc: "ᱡᱚᱛᱚ ᱛᱮ ᱨᱚᱝ",
    cg_step_4_title: "ᱢᱩᱞ ᱡᱤᱱᱤᱥ",
    cg_step_4_desc: "ᱩᱛᱚᱲ ᱨᱚᱝ, ᱟᱰᱤ ᱠᱚᱱᱴᱨᱟᱥᱴ",
    cg_step_5_title: "ᱮᱴᱟᱜ ᱢᱟᱨᱟᱝ ᱡᱤᱱᱤᱥ",
    cg_step_5_desc: "ᱥᱚᱢᱟᱱᱟ ᱛᱟᱞᱟ ᱨᱚᱝ",
    cg_step_6_title: "ᱵᱮᱴᱨᱟ ᱟᱨ ᱦᱟᱭᱞᱟᱭᱴ",
    cg_step_6_desc: "ᱦᱟᱛᱟᱣ ᱵᱮᱴᱨᱟ, ᱚᱵᱩᱞ ᱦᱟᱭᱞᱟᱭᱴ",
    cg_note_heading: "ᱢᱚᱱᱮᱛᱮ ᱨᱟᱠᱟᱵ",
    cg_note_1: "ᱢᱩᱞ ᱡᱤᱱᱤᱥ ᱟᱨᱟᱜ ᱨᱚᱝ ᱛᱮ ᱪᱤᱱᱦᱟᱹ ᱟᱠᱟᱱᱟ ᱾",
    cg_note_2: "ᱞᱤᱞ ᱩᱢᱩᱞ ᱡᱟᱭᱜᱟᱨᱮ ᱩᱛᱚᱲ ᱨᱚᱝ ᱵᱮᱵᱷᱟᱨ ᱢᱮ ᱾",

    math_mental: "ᱢᱮᱱᱴᱟᱞ ᱢᱮᱛ",
    math_mental_desc: "ᱠᱤᱨᱤᱧᱚᱜ ᱟᱹᱰᱤ ᱟᱨ ᱚᱠᱟ ᱰᱚᱦᱚ ᱛᱟᱨᱮ ᱵᱟᱪᱷᱟᱣ ᱛᱟᱦᱮᱸᱱ",
    mm_start_practice: "ᱨᱚᱪᱚᱭ ᱮᱛᱚᱦᱚᱵ ᱢᱮ",
    mm_replay_audio: "ᱟᱹᱰᱤ ᱨᱩᱣᱟᱹᱲ ᱢᱮ",
    mm_choose_answer: "ᱠᱩᱨᱩᱢᱩᱴᱩ ᱵᱟᱪᱷᱟᱣ ᱢᱮ",
    mm_correct: "ᱴᱷᱤᱠ! ᱵᱮᱥ.",
    mm_wrong: "ᱚᱫᱚᱡ! ᱨᱩᱣᱟᱹᱲ ᱠᱩᱨᱩᱢᱩᱴᱩ ᱨᱮ ᱠᱩᱲᱟᱹ ᱢᱮ.",
    mm_practice_another: "ᱮᱴᱟᱜ ᱰᱚᱦᱚ",
    mm_back: "ᱛᱟᱭᱚᱢ",
    mm_home: "ᱚᱲᱟᱜ",
    mm_generating: "ᱟᱢᱟᱜ ᱰᱚᱦᱚ ᱛᱟᱭᱟᱨ ᱦᱟᱹᱴᱤᱧᱚᱜ ᱠᱟᱱᱟ...",
    mm_focus_now: "ᱟᱡ ᱟᱡ ᱛᱮ ᱟᱹᱰᱤ ᱢᱮ",
    mm_intro: "ᱢᱮᱱᱴᱟᱞ ᱢᱮᱛ ᱨᱮ ᱨᱚᱪᱚᱭ ᱞᱟᱹᱜᱤᱫ ᱠᱩᱨᱩᱢᱩᱴᱩ ᱠᱤᱨᱤᱧᱚᱜ ᱮᱨᱮᱞ ᱠᱚ",
    use_cropped_area: "ᱱᱚᱣᱟ ᱡᱟᱭᱜᱟ ᱵᱮᱵᱷᱟᱨ",
    another_problem: "ᱢᱤᱫ ᱦᱚᱨ ᱢᱮᱱᱟᱝ",
    hint_label: "ᱱᱚᱱᱰᱮ ᱢᱤᱫ ᱥᱟᱝᱠᱮᱛ",
    audio_hint_label: "ᱟᱧᱡᱚᱢ ᱞᱟᱹᱜᱤᱫ Play ᱫᱟᱵᱟᱣ",
    audio_unavailable: "ᱟᱭᱰᱤᱭᱳ ᱵᱟᱹᱱᱩᱜ — ᱛᱟᱭᱚᱢᱛᱮ ᱠᱳᱥᱤᱥ।",
    generating_hint: "ᱥᱟᱝᱠᱮᱛ ᱵᱮᱱᱟᱣ ᱠᱟᱱᱟ...",
    generating_solution: "ᱦᱩᱱᱟᱨ ᱵᱮᱱᱟᱣ ᱠᱟᱱᱟ...",
    generating_summary: "ᱥᱟᱨᱟᱝᱥ ᱵᱮᱱᱟᱣ ᱠᱟᱱᱟ...",
    generating_mcq: "ᱠᱩᱭᱡ ᱵᱮᱱᱟᱣ ᱠᱟᱱᱟ...",
    language_tagline: "ᱢᱤᱫ ᱯᱟᱭᱨᱟ ᱯᱷᱳᱴᱳ ᱮᱢᱮ — ᱥᱟᱨᱟᱝᱥ ᱵᱟ ᱠᱩᱭᱡ ᱵᱟᱦᱟᱨ ᱢᱮ।",
    lang_summary: "ᱥᱟᱨᱟᱝᱥ",
    lang_summary_desc: "ᱟᱢᱟᱜ ᱯᱟᱹᱨᱥᱤᱨᱮ ᱵᱷᱟᱦᱟᱨ ᱥᱟᱨᱟᱝᱥ, ᱟᱭᱰᱤᱭᱳ ᱥᱟᱱᱟᱢ",
    lang_mcq: "ᱠᱩᱭᱡ",
    lang_mcq_desc: "ᱢᱚᱡᱟᱫᱟᱨ ᱢᱟᱨᱮ-ᱵᱟᱪᱷᱟᱣ ᱢᱮᱱᱟᱝ, ᱫᱚᱲ ᱯᱷᱤᱰᱵᱮᱠ",
    pick_age_group: "ᱟᱢᱟᱜ ᱫᱷᱚᱨᱢᱮ ᱫᱚᱲ ᱵᱟᱪᱷᱟᱣ",
    age_6_10: "᱖–᱑᱐ ᱥᱮᱨᱢᱟ",
    age_10_14: "᱑᱐–᱑᱔ ᱥᱮᱨᱢᱟ",
    age_14_18: "᱑᱔–᱑᱘ ᱥᱮᱨᱢᱟ",
    age_18_plus: "᱑᱘+ ᱥᱮᱨᱢᱟ",
    summary_label: "ᱱᱚᱱᱰᱮ ᱢᱤᱫ ᱦᱩᱲᱤᱧ ᱥᱟᱨᱟᱝᱥ",
    audio_summary_label: "ᱟᱧᱡᱚᱢ ᱞᱟᱹᱜᱤᱫ Play ᱫᱟᱵᱟᱣ",
    no_content_title: "ᱪᱮᱫᱚ ᱯᱟᱭᱨᱟ ᱵᱟᱭ ᱧᱟᱢ ᱞᱮᱱᱟ।",
    no_content_desc: "ᱠᱮᱢᱨᱟ ᱠᱟᱦᱱᱤ, ᱯᱟᱲᱦᱟ ᱵᱟ ᱯᱟᱭᱨᱟ ᱪᱮᱛᱟᱱᱨᱮ ᱫᱚᱦᱚ।",
    question: "ᱢᱮᱱᱟᱝ",
    multi_select_hint: "ᱢᱤᱫ ᱠᱷᱚᱱ ᱵᱟᱲᱛᱤ ᱦᱩᱱᱟᱨ ᱴᱷᱤᱠ ᱦᱩᱭ ᱫᱟᱲᱮᱭᱟᱜᱼᱟ।",
    mcq_submit: "ᱦᱩᱱᱟᱨ ᱱᱤᱦᱚᱨ",
    mcq_next: "ᱱᱟᱯᱟᱭ ᱢᱮᱱᱟᱝ",
    mcq_see_score: "ᱤᱧᱟᱜ ᱥᱠᱳᱨ ᱧᱮᱞ",
    mcq_correct: "ᱴᱷᱤᱠ! 🎉",
    mcq_wrong: "ᱱᱚᱣᱟ ᱰᱟᱝᱨᱮ ᱵᱟᱝ। ᱱᱟᱯᱟᱭ ᱫᱚ ᱠᱳᱥᱤᱥ!",
    mcq_correct_feedback: "ᱢᱚᱡᱟ — ᱥᱟᱱᱟᱢ ᱴᱷᱤᱠ ᱦᱩᱱᱟᱨ ᱮᱢᱟᱫᱼᱟ।",
    mcq_wrong_feedback: "ᱫᱷᱚᱱᱪ ᱨᱚᱝᱨᱮ ᱢᱮᱱᱟᱜ ᱫᱚ ᱴᱷᱤᱠ ᱦᱩᱱᱟᱨᱼᱟ।",
    mcq_done_title: "ᱫᱷᱟᱱᱫᱷᱟ ᱠᱳᱥᱤᱥ!",
    mcq_all_correct: "ᱯᱩᱨᱟ ᱥᱠᱳᱨ!",
    your_score: "ᱟᱢᱟᱜ ᱥᱠᱳᱨ",
    no_math_found_title: "ᱜᱟᱱᱤᱛ ᱢᱮᱱᱟᱝ ᱵᱟᱭ ᱧᱟᱢ ᱞᱮᱱᱟ।",
    no_math_found_desc: "ᱠᱨᱚᱯ ᱡᱟᱭᱜᱟᱨᱮ ᱢᱮᱱᱟᱝ ᱯᱟᱨᱥᱟᱞ ᱫᱚᱦᱚ।",
    lang_check_answer: "ᱢᱮᱱᱟᱝ ᱯᱟᱨᱠᱷᱟ",
    lang_check_answer_desc: "ᱚᱞ ᱠᱟᱱᱟ ᱢᱮᱱᱟᱝ ᱯᱟᱹᱛᱷᱟᱸᱨ ᱨᱮᱭᱟᱜ ᱪᱷᱟᱨᱮ ᱤᱫᱤ ᱢᱮ — ᱢᱟᱨᱠ, ᱴᱷᱤᱠ/ᱵᱷᱩᱞ ᱟᱨ ᱴᱷᱤᱠ ᱢᱮᱱᱟᱝ ᱧᱟᱢ ᱢᱮ",
    lang_learn_nature: "ᱚᱛᱱᱚᱢᱟ ᱠᱷᱚᱱ ᱪᱮᱫ ᱢᱮ",
    lang_learn_nature_desc: "ᱚᱛᱱᱚᱢᱟ ᱨᱮᱭᱟᱜ ᱪᱷᱟᱨᱮ ᱤᱫᱤ ᱢᱮ — ᱥᱮᱸᱫᱽᱨᱟ, ᱡᱤᱭᱚᱱ ᱟᱨ ᱟᱨᱟᱜ ᱯᱟᱹᱛᱷᱟᱸ ᱨᱮᱭᱟᱜ ᱮᱛᱚᱦᱚᱵ ᱥᱮᱸᱫᱽᱨᱟ",
    generating_learn_nature: "ᱚᱛᱱᱚᱢᱟ ᱠᱷᱚᱱ ᱥᱮᱸᱫᱽᱨᱟ ᱯᱟᱸᱡᱮᱫ ᱠᱟᱱᱟ...",
    nature_lessons_label: "ᱚᱛᱱᱚᱢᱟ ᱨᱮᱭᱟᱜ ᱥᱮᱸᱫᱽᱨᱟ",
    generating_check_answer: "ᱢᱮᱱᱟᱝ ᱯᱟᱨᱠᱷᱟᱭᱮᱫᱼᱟ...",
    no_paper_found_title: "ᱯᱨᱚᱥᱱᱚ ᱯᱟᱹᱛᱷᱟᱸᱨ ᱵᱟᱝ ᱧᱟᱢᱞᱮᱱᱟ᱾",
    no_paper_found_desc: "ᱪᱮᱞᱮᱫ ᱨᱮᱭᱟᱜ ᱢᱮᱱᱟᱝ ᱢᱮᱱᱟᱜ ᱯᱨᱚᱥᱱᱚ ᱯᱟᱹᱛᱷᱟᱸᱨ ᱨᱮ ᱠᱮᱢᱨᱟ ᱫᱚᱦᱚ ᱢᱮ᱾",
    lang_speech_mentor: "ᱨᱚᱲ ᱜᱟᱹᱭᱠᱮ",
    lang_speech_mentor_desc: "ᱴᱷᱤᱠ ᱨᱚᱲ ᱞᱟᱹᱜᱤᱫ ᱜᱚᱲᱚ ᱮᱢᱚᱜ ᱠᱟᱱ AI ᱜᱟᱹᱭᱠᱮ᱾",
    speech_mentor_tap_to_record: "ᱢᱟᱭᱠ ᱚᱛᱟᱸ ᱮᱢᱟ ᱟᱨ ᱨᱚᱲ ᱮᱛᱚᱦᱚᱵ ᱢᱮ",
    speech_mentor_tap_to_stop: "ᱛᱷᱟᱢ ᱞᱟᱹᱜᱤᱫ ᱚᱛᱟᱸ ᱮᱢᱟ ᱢᱮ",
    speech_mentor_recording: "ᱟᱸᱡᱚᱢ ᱠᱟᱱᱟ...",
    speech_mentor_analyzing: "ᱟᱢᱟᱜ ᱠᱟᱛᱷᱟ ᱩᱭᱦᱟᱹᱨᱟᱜ ᱠᱟᱱᱟ...",
    speech_mentor_your_speech: "ᱟᱢᱟᱜ ᱨᱚᱲ",
    speech_mentor_mic_denied: "ᱢᱟᱭᱠ ᱮᱢ ᱟᱲᱟᱜᱟᱜ᱾",
    speech_mentor_mic_unsupported: "ᱱᱚᱣᱟ ᱛᱮᱭᱟᱨ ᱨᱮ ᱢᱟᱭᱠ ᱵᱟᱹᱱᱩᱜ᱾",
    learn_another: "ᱮᱴᱟᱜ ᱥᱮᱸᱫᱽᱨᱟᱭ ᱢᱮ",
    try_another: "ᱟᱨᱦᱚᱸ ᱠᱩᱨᱩᱢᱩᱴᱩ ᱢᱮ",
    check_another: "ᱮᱴᱟᱜ ᱯᱟᱨᱠᱷᱟᱭ ᱢᱮ",
    practice_again: "ᱟᱨᱦᱚᱸ ᱚᱛᱚᱲ ᱢᱮ",
    speech_mentor_play_welcome: "ᱡᱚᱦᱟᱨ ᱟᱸᱡᱚᱢ ᱞᱟᱹᱜᱤᱫ ᱚᱛᱟᱸ ᱮᱢᱟ ᱢᱮ",
    daily_reflection: "ᱢᱟᱦᱟᱸ ᱦᱟᱛᱟ ᱩᱭᱦᱟᱹᱨ",
    daily_reflection_desc: "ᱵᱷᱤᱛᱨᱤ ᱠᱮ ᱦᱟᱡᱟᱨ ᱞᱟᱹᱜᱤᱫ ᱨᱮᱭᱟᱜ ᱑-ᱢᱤᱱᱮᱴ ᱢᱟᱦᱟᱸ ᱦᱟᱛᱟ",
    dr_start: "ᱮᱛᱚᱦᱚᱵ",
    dr_loading: "ᱟᱢᱟᱜ ᱩᱭᱦᱟᱹᱨ ᱛᱮᱭᱟᱨ ᱠᱟᱱᱟ...",
    dr_question_of: "ᱠᱩᱠᱞᱤ {n} / {total}",
    dr_your_answer: "ᱟᱢᱟᱜ ᱛᱮᱞᱟ",
    dr_best_answer: "ᱵᱟᱹᱲᱛᱤ ᱛᱮᱞᱟ",
    dr_lesson: "ᱥᱮᱸᱫᱽᱨᱟ",
    dr_growth_score: "ᱛᱮᱦᱮᱧ ᱨᱮᱭᱟᱜ ᱦᱟᱡᱟᱨ ᱟᱸᱠ",
    dr_encouragement_high: "ᱵᱮᱥ! ᱟᱢ ᱢᱟᱦᱟᱸ ᱦᱟᱡᱟᱨ ᱠᱟᱛᱮ ᱠᱟᱱᱟᱢ.",
    dr_encouragement_mid: "ᱵᱮᱥ ᱠᱟᱹᱢᱤ! ᱢᱟᱦᱟᱸ ᱦᱟᱛᱟ ᱩᱭᱦᱟᱹᱨ ᱢᱚᱱ ᱟᱱᱛᱩᱨᱚ ᱛᱟᱦᱮᱸᱱ.",
    dr_encouragement_low: "ᱡᱚᱛᱚ ᱩᱭᱦᱟᱹᱨ ᱢᱤᱫ ᱡᱟᱹᱨᱩᱲ. ᱦᱟᱡᱟᱨᱚᱜ ᱛᱟᱦᱮᱸᱱᱟ!",
    dr_next: "ᱦᱟᱛᱟᱜ ᱟᱨ",
    dr_finish: "ᱟᱢᱟᱜ ᱟᱸᱠ ᱧᱮᱞ ᱢᱮ",
    dr_try_again: "ᱟᱨᱦᱚᱸ ᱩᱭᱦᱟᱹᱨ",
    dr_listen: "ᱟᱸᱡᱚᱢ ᱢᱮ",
    coloring: "ᱨᱚᱝ ᱨᱮᱭᱟᱜ",
    coloring_desc: "ᱡᱟᱦᱟᱸᱭ ᱛᱮᱭᱟᱨ ᱨᱮᱱ ᱠᱟᱞᱟ ᱛᱮ ᱠᱚᱛᱟᱭ ᱢᱮ — ᱚᱭᱤᱞ ᱯᱮᱥᱴᱚᱞ, ᱣᱟᱴᱚᱨ ᱠᱟᱞᱚᱨ ᱟᱨ ᱦᱚᱸ",
    coloring_choose_style: "ᱨᱚᱝ ᱨᱮᱭᱟᱜ ᱴᱷᱟᱨ ᱵᱟᱪᱷᱟᱣ ᱢᱮ",
    coloring_style_oil_pastel: "ᱚᱭᱤᱞ ᱯᱮᱥᱴᱚᱞ",
    coloring_style_watercolor: "ᱣᱟᱴᱚᱨ ᱠᱟᱞᱚᱨ",
    coloring_style_graphite_shade: "ᱯᱮᱱᱥᱤᱞ ᱪᱷᱟᱭᱟ",
    coloring_style_color_pencil_shade: "ᱨᱚᱝ ᱯᱮᱱᱥᱤᱞ",
    coloring_style_oil_paint: "ᱚᱭᱤᱞ ᱯᱮᱱᱴ",
    time_master: "ᱮᱸᱜᱛ ᱜᱚᱲᱚ",
    time_master_desc: "ᱛᱤᱱᱟᱜ ᱦᱚᱸ ᱡᱟᱦᱟᱸ ᱴᱚᱨᱟᱲ ᱛᱮ ᱪᱟᱵᱟᱭ ᱢᱮ? ᱠᱟᱹᱴᱤᱡ ᱮᱸᱜᱛ ᱥᱟᱶ ᱵᱟᱦᱩᱲ ᱢᱮ᱾",
    time_master_class: "ᱠᱞᱟᱥ",
    time_master_subject: "ᱵᱤᱥᱚᱭ",
    time_master_marks: "ᱢᱟᱨᱠ",
    time_master_ideal: "ᱠᱟᱹᱴᱤᱡ ᱮᱸᱜᱛ",
    time_master_elapsed: "ᱟᱢᱟᱜ ᱮᱸᱜᱛ",
    time_master_start: "ᱴᱟᱭᱢᱚᱨ ᱮᱛᱚᱦᱚᱵ",
    time_master_stop: "ᱴᱟᱭᱢᱚᱨ ᱚᱛᱟᱸᱭ",
    time_master_pick_class: "ᱠᱞᱟᱥ ᱵᱟᱪᱷᱟᱣ",
    time_master_pick_subject: "ᱵᱤᱥᱚᱭ ᱵᱟᱪᱷᱟᱣ",
    time_master_pick_marks: "ᱢᱟᱨᱠ ᱵᱟᱪᱷᱟᱣ",
    time_master_subj_numerical: "ᱮᱞᱮᱠ",
    time_master_subj_science: "ᱵᱤᱡᱟᱹᱱ",
    time_master_subj_technical: "ᱛᱮᱠᱱᱤᱠᱟᱞ",
    time_master_subj_social: "ᱥᱮᱱᱫᱽᱨᱟ",
    time_master_subj_language: "ᱯᱟᱨᱥᱤ",
    time_master_subj_other: "ᱮᱴᱟᱜᱟᱜ",
  },
};

export function t(lang, key) {
  return (dict[lang] && dict[lang][key]) || dict.en[key] || key;
}
